// Portugal
export const locale = {
	lang: 'pt',
	data: {
		WHAT_IF: {
			SIMULATION: { ACTUAL_VALUE: 'Valor real' },
			GRAPH: {
				BASELINE_TIMESTAMP: 'Carimbo de data/hora de referência',
				NO_DATA: 'Nenhum dado encontrado!',
				RUN_SIMULATION_TITLE: 'Execute uma simulação para ver os resultados do gráfico',
				RUN_SIMULATION_HINT: 'Clique em «Executar» depois de configurar os parâmetros da simulação.',
				RAW_TAG_DEPENDENCY: 'Dependência de tags brutas',
				BASELINE: 'Referência',
				SIMULATION: 'Simulação',
				SIMULATED: 'Simulado',
			},
			SEARCH: {
				PLACEHOLDER: 'Pesquisar instalação, sistema, unidade ou tag',
				SEARCHING: 'Pesquisando…',
				NO_RESULTS: 'Nenhuma correspondência encontrada',
				ERROR: 'A pesquisa falhou. Tente novamente.',
			},
			TABLE: {
				DELTA_TOOLTIP: 'Variação absoluta (Simulado − Linha de base)',
				DELTA_PERCENT_TOOLTIP: 'Variação percentual em relação à linha de base',
				IMPACT_PROGRESS: 'Progresso do Impacto',
				IMPACT: 'Impacto',
			},
			IMPACTED_KPI: {
				TITLE: 'KPIs Calculados Impactados ({{count}})',
				NO_IMPACTED_KPIS: 'Ainda não há KPIs impactados',
				EMPTY_HINT: 'Selecione tags brutas à esquerda para ver o impacto no KPI a jusante.',
				LOADING: 'Carregando tags calculadas...',
				SELECTION_HINT: '{{checked}} de {{total}} KPIs selecionados no sistema principal — desmarque para excluir da simulação. Os chips "Driven by" mostram quais tags brutas impactam cada KPI. Sistemas irmãos que compartilham a mesma assinatura de tag são listados abaixo como impactos entre sistemas somente leitura.',
				CROSS_SYSTEM_IMPACT: 'Impacto entre sistemas',
				KPI_COUNT: '{{count}} KPIs',
				TAG_PARAMETER: 'Tag / Parâmetro',
				CALCULATED_TAG: 'Tag Calculada',
				DRIVEN_BY: 'Impulsionado por:',
			},
			PAGE: {
				TITLE: 'What-If',
				SELECT_RAW_TAGS_TITLE: 'Selecionar tags brutas para simular',
				SELECT_RAW_TAGS_SUBTITLE: 'Escolha tags da hierarquia abaixo',
				SIMULATION_SETUP_TITLE: 'Configuração da Simulação',
				SIMULATION_SETUP_SUBTITLE: 'Selecione tags acima para começar',
				RUN: 'Executar',
				RESET: 'Redefinir',
				NO_TAGS_SELECTED: 'Nenhuma tag selecionada',
				NO_TAGS_SELECTED_DESC: 'Escolha tags brutas acima para definir alterações.',
				CLICK_TIMESTAMP_HINT: 'Clique em qualquer lugar do gráfico para selecionar um carimbo de data/hora do estado operacional.',
				CLICK_RANGE_HINT: 'Clique duas vezes no gráfico para selecionar o intervalo do estado operacional.',
				SELECTED_OPERATING_STATE: 'Estado Operacional Selecionado:',
				SELECTED_OPERATING_RANGE: 'Intervalo Operacional Selecionado:',
				FIRST_POINT_PREFIX: 'Primeiro ponto:',
				FIRST_POINT_SUFFIX: '— clique novamente para definir o final do intervalo.',
				SIMULATION_RESULTS: 'Resultados da Simulação',
				TABLE_VIEW: 'Visualização em Tabela',
				RUN_SIMULATION_TABLE_TITLE: 'Execute uma simulação para ver os resultados da tabela',
				TABLE_UNAVAILABLE_PERIOD: 'A visualização em tabela não está disponível para simulações de período',
				SWITCH_TO_SINGLE_POINT: 'Mude para o modo "Ponto único" ou use a aba Visualização em Gráfico.',
				NO_KPI_ROWS: 'Nenhuma linha de KPI para exibir',
				NO_KPI_ROWS_DESC: 'Todos os KPIs impactados estão desmarcados. Selecione KPIs na aba KPIs Impactados para vê-los aqui.',
				GRAPH_VIEW: 'Visualização em Gráfico',
				SIMULATION_TYPE_PERCENT: '% de variação',
				SIMULATION_TYPE_ABSOLUTE: 'Valor absoluto',
				TIME_CONTEXT_SINGLE: 'Ponto único',
				TIME_CONTEXT_PERIOD: 'Período',
			},
			IMPACTED_KPIS_TAB_LABEL: 'KPIs Impactados',
			IMPACTED_KPIS_TAB_LABEL_COUNT: 'KPIs Impactados ({{count}})',
			HIERARCHY_TOOLTIP: {
				TAG_NAME: 'Nome da Tag',
				TAG_ID: 'Id da Tag',
				TAG_DESCRIPTION: 'Descrição',
				ASSET_NAME: 'Nome do Ativo',
				SYSTEM_NAME: 'Nome do Sistema',
			},
		},
		TRANSLATOR: {
			SELECT: 'Selecione seu idioma',
		},
		VALIDATION: {
			REQUIRED: 'Este campo é obrigatório',
			PATTERN: 'Formato inválido',
			MIN: 'O valor é muito pequeno',
			MAX: 'O valor é muito grande',
			MIN_LENGTH: 'O valor é muito curto',
			MAX_LENGTH: 'O valor é muito longo',
			SELECT_AT_LEAST_ONE: 'Selecione pelo menos uma opção',
			INVALID: 'Valor inválido',
			FIELD_REQUIRED: '{{field}} é obrigatório',
		},
		COMMON: {
				NO_MATCHES: 'Nenhum resultado encontrado para "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Tente uma palavra-chave diferente ou limpe a pesquisa',
				SELECT_A_SYSTEM: 'Selecione um sistema.',
				SELECT_DIFF_UNIT: 'Selecione uma unidade ou instalação diferente',
				SELECT_DIFF: 'Selecione uma instalação, unidade ou sistema diferente',
				NO_TAGS_FOUND: 'Nenhuma tag encontrada',
				SELECT_FACILITY: 'Selecione uma instalação diferente',
				ADDED_FROM_ROOTY: 'Adicionado a partir do {{name}}',
		},
		COMMENT_POPUP: {
			TITLE: 'Deixar Comentário',
			ENTER_MESSAGE: 'Digite sua mensagem',
			COMMENT_PLACEHOLDER: 'Adicione um comentário, use @ para marcar membros da equipe',
			FILE_SIZE_LIMIT_ERROR: 'Falha ao enviar {{fileName}} devido ao limite de tamanho do arquivo.',
			UPLOAD_FAILED_ERROR: 'Falha ao enviar {{fileName}}.',
			INVALID_FILES_ERROR: 'Nenhum arquivo válido selecionado. Somente arquivos com as extensões {{extensions}} são permitidos',
		},
		REGENERATE_HYPOTHESES_POPUP: {
			TITLE: 'Regenerar hipóteses',
			DESCRIPTION: 'Todas as hipóteses serão regeneradas com base no feedback fornecido para a cadeia causal, recomendações e evidências propostas. A versão atual será salva no histórico.',
			REGENERATION_CONTEXT: 'Contexto de regeneração',
			TOTAL_FEEDBACKS: 'Total de feedbacks',
			ADDED_AS_EVIDENCE: 'Adicionado como evidência',
			APPROVED: 'Aprovado',
			RELEARNED: 'Reaprendido',
			SETTINGS: 'Configurações',
			DOCUMENT_INSIGHTS: 'Insights de documentos',
			SAP_INSIGHTS: 'Insights do SAP',
			CONNECTED_SYSTEMS_REVIEW: 'Revisão de sistemas conectados',
			ALERT_REVIEW_WINDOW: 'Janela de revisão de alertas',
			DAYS: 'Dias',
			RESET_AND_RERUN: 'Redefinir e executar novamente',
			RESET_AND_RERUN_INFO: 'As hipóteses, feedback, recomendações e evidências propostas anteriores serão ignorados. A RCA será gerada do zero, usando apenas os dados mais recentes disponíveis.',
			VERSION_HISTORY_NOTE: 'As hipóteses atuais serão salvas no histórico de versões. Você pode restaurar versões anteriores a qualquer momento.',
			USER_CONSENT: 'Entendo que o contexto de RCA anterior não será utilizado nesta execução.',
			CANCEL: 'Cancelar',
			REGENERATE_ALL: 'Regenerar tudo',
			REGENERATE_ALL_TOOLTIP: 'Melhorar a RCA atual usando o contexto existente',
			RESET_AND_RERUN_BTN: 'Redefinir e executar novamente',
			RESET_AND_RERUN_TOOLTIP: 'Gerar uma nova RCA do zero',
		},
		SHARE_REPORT_POPUP: {
			TITLE: 'Compartilhar relatório',
			ADD_PEOPLE: 'Adicionar pessoas',
			MESSAGE: 'Mensagem',
			MESSAGE_PLACEHOLDER: 'Digite sua mensagem (opcional)',
			COPY_LINK: 'Copiar link',
			CANCEL: 'Cancelar',
			SEND: 'Enviar',
		},
		FEEDBACK_POPUP: {
			PREVIOUSLY_APPROVED: 'Aprovado Anteriormente',
			PREVIOUSLY_RELEARNED: 'Retreinado Anteriormente',
			SEE_LESS: 'Ver Menos',
			SEE_MORE: 'Ver Mais...',
			FEEDBACK_LABEL: 'Feedback',
			FEEDBACK_TOOLTIP: 'Este feedback será usado durante a nova execução da RCA.',
			CANCEL: 'Cancelar',
			CONFIRM: 'Confirmar',
			RELEARNED_BY: 'Retreinado por:',
			NO_REASON_ADDED: 'Nenhum motivo adicionado',
		},
		ASK_ROOTY_POPUP: {
			ENTER_MESSAGE_TO_START: 'Digite sua mensagem para iniciar um chat',
			MESSAGE_PLACEHOLDER: 'Digite sua mensagem...',
		},
		ROOTY_CHAT: {
				FOLLOW_UP_SUGGESTIONS: 'Sugestões de acompanhamento',
				ASK_TITLE: 'Perguntar ao {{name}}',
				UPLOAD_TOOLTIP: 'Envie arquivos PDF, Word, Excel, PNG, JPG e JPEG para o {{name}} analisar.',
				DISCLAIMER: 'O {{name}} fornece respostas assistidas por IA que podem nem sempre ser precisas. Verifique antes de agir.',
				FEEDBACK_SUBTITLE: 'Selecione o problema principal para que possamos melhorar as futuras respostas do {{name}}.',
				POPUP_TITLE: 'Perguntar ao {{name}}',
				NOT_ENABLED: 'O {{name}} não está habilitado para o usuário atual.',
				SHARE: 'Compartilhar',
				RENAME: 'Renomear',
				DELETE: 'Excluir',
				HISTORY: 'Histórico',
				CLOSE: 'Fechar',
				SEARCH: 'Pesquisar...',
				UNSAVED: 'Não salvo',
				NO_HISTORY_HEADING: 'Nenhum histórico disponível.',
				NO_HISTORY_DESC: 'Não foi possível encontrar dados históricos.',
				START_NEW_CHAT: 'Iniciar novo chat',
				AGENT_CONTEXT_TOOLTIP: 'Contexto do Agente',
				CHAT_HISTORY_TOOLTIP: 'Histórico de chat',
				UNPIN: 'Desafixar',
				PIN: 'Fixar',
				FULL_SCREEN: 'Tela cheia',
				EXIT_FULL_SCREEN: 'Sair da tela cheia',
				EXPAND: 'Expandir',
				COLLAPSE: 'Recolher',
				INTRO_TITLE: 'Olá! Precisa de ajuda com o que está vendo?',
				INTRO_DESC: 'Pergunte-me qualquer coisa ou posso resumir esta tela, explicar tendências, comparar itens e sugerir próximos passos.',
				SUGGESTIONS: 'Sugestões',
				SUGGESTION_1: 'Resuma esta RCA em 30 segundos (o que aconteceu e por quê).',
				SUGGESTION_2: 'Qual hipótese é mais apoiada pelas evidências mostradas aqui?',
				SUGGESTION_3: 'Compare as hipóteses: qual é a evidência mais forte para cada uma?',
				CP_INTRO_TITLE: 'Olá! Precisa de ajuda com Otimização de Capacidade e Planejamento de Cenários?',
				CP_INTRO_DESC: 'Posso ajudá-lo a construir modelos de planejamento, testar contingências de desligamento de unidades, simular o crescimento da demanda de pico e analisar a viabilidade de energia e água.',
				CP_SUGGESTION_1: 'Resuma o custo total de geração, o consumo de combustível e o detalhamento por estação para esta execução.',
				CP_SUGGESTION_2: 'Qual é a nossa margem de reserva girante e há horas de déficit?',
				CP_SUGGESTION_3: 'E se a H5_GT desligar durante a demanda de pico?',
				CP_SUGGESTION_4: 'Simule um crescimento de +5% na demanda de pico de energia para este cenário.',
				LOADING_EARLIER: 'Carregando conversa anterior…',
				SHOW_EARLIER: 'Mostrar conversa anterior',
				RESPONSE_STOPPED: 'Geração de resposta interrompida',
				LOADING_ALT: 'Carregando',
				THINKING: 'Pensando',
				THOUGHT_FOR: 'Pensou por {{seconds}}s',
				DOWNLOAD_CSV: 'Baixar CSV',
				COPY_CSV: 'Copiar CSV',
				DOWNLOAD_IMAGE: 'Baixar imagem',
				COPY_IMAGE: 'Copiar imagem',
				WHAT_IF_SCENARIO_CREATED: 'Cenário What-If criado',
				CHANGE_APPLIED: 'Alteração aplicada:',
				NEW_SCENARIO: 'Novo cenário:',
				VIEW_CONFIGURATION: 'Ver configuração',
				RUN_OPTIMIZATION: 'Executar otimização',
				RESULTS_COMPARISON: 'Comparação de resultados',
				ALL_IMPROVED: 'Tudo melhorou',
				KPI: 'KPI',
				BASE: 'Base',
				WHAT_IF: 'What-If',
				YES: 'Sim',
				NO: 'Não',
				CHANGED: 'alterado',
				WHATIF_KPI_POWER_FEASIBLE: 'Energia viável',
				WHATIF_KPI_WATER_FEASIBLE: 'Água viável',
				WHATIF_KPI_EST_COST: 'Custo estimado',
				WHATIF_KPI_POWER_SHORTFALL: 'Déficit de energia',
				WHATIF_KPI_WATER_SHORTFALL: 'Déficit de água',
				WHATIF_KPI_AVG_GENERATION: 'Geração média',
				WHATIF_KPI_AVG_HEADROOM: 'Margem média',
				WHATIF_KPI_TOTAL_STARTS: 'Total de partidas',
				WHATIF_KPI_AVG_WATER_OUTPUT: 'Produção média de água',
				WHATIF_KPI_GAP_PERCENT: 'Diferença %',
				WHATIF_POWER_BALANCE: 'Balanço de energia (MW)',
				WHATIF_TIME_AXIS: 'Tempo',
				WHATIF_POWER_AXIS: 'Energia (MW)',
				WHATIF_WATER_OUTPUT: 'Produção de água (MIGD)',
				WHATIF_WATER_AXIS: 'Água (MIGD)',
				WHATIF_TRACE_DEMAND: 'Demanda',
				WHATIF_TRACE_GEN: 'Ger.',
				WHATIF_TRACE_WATER: 'Água',
				NO_MAJOR_DIFF: 'Nenhum KPI mudou mais de 5% entre os dois cenários.',
				VIEW_FULL_RESULTS: 'Ver resultados completos',
				APPLY_AS_EVIDENCE: 'Aplicar como evidência',
				ADDED_AS_EVIDENCE: 'Adicionado como evidência',
				ALREADY_ADDED_AS_EVIDENCE: 'Já adicionado como evidência',
				ADD_AS_EVIDENCE: 'Adicionar como evidência',
				BRANCH_VISIBILITY_NOTICE: 'Novas mensagens são visíveis apenas para você.',
				CONTINUE: 'Continuar',
				SEARCH_SCENARIOS: 'Pesquisar cenários...',
				FILTER_SCENARIOS: 'Filtrar cenários',
				SOURCE: 'Origem',
				ALL_SOURCES: 'Todas as origens',
				HUMAN_MANUAL: 'Manual (Humano)',
				AI_GENERATED: 'Gerado por IA',
				STRATEGY_AUTO: 'Estratégia (Automático)',
				DATE_MODIFIED: 'Data de modificação',
				ALL_TIME: 'Todo o período',
				TODAY: 'Hoje',
				LAST_7_DAYS: 'Últimos 7 dias',
				RECENT: 'Recente',
				OFFICIAL: 'Oficial',
				ALL_SCENARIOS: 'Todos os cenários',
				NO_SCENARIOS_MATCH: 'Nenhum cenário corresponde a "{{query}}"',
				DRAFT: 'Rascunho',
				DISMISS: 'Dispensar',
				CONTEXT_PREFIX: 'Contexto:',
				REMOVE_CONTEXT: 'Remover contexto',
				SELECT_A_SCENARIO: 'Selecionar um cenário',
				CLEAR_SCENARIO: 'Limpar cenário',
				LATEST_RUN_DEFAULT: 'Última execução (Padrão)',
				DROP_FILES_HERE: 'Solte os arquivos aqui',
				COMPOSER_PLACEHOLDER: 'Faça uma pergunta ou solicitação...',
				ADD_FILES_OR_IMAGES: 'Adicionar arquivos ou imagens',
				LANGUAGE: 'Idioma',
				MIC_BLOCKED: 'O acesso ao microfone está bloqueado. Permita a permissão do microfone',
				USE_VOICE_INPUT: 'Usar entrada de voz',
				VOICE_INPUT_ALT: 'Entrada de voz',
				STOP_RECORDING: 'Parar gravação',
				STOP_RECORDING_ALT: 'Parar gravação',
				STOP_GENERATION: 'Parar geração',
				SEND_ALT: 'Enviar',
				FEEDBACK_WHAT_WENT_WRONG: 'O que deu errado com esta resposta?',
				FEEDBACK_CATEGORY: 'Categoria de feedback',
				SELECT_AN_ISSUE: 'Selecione um problema',
				SELECT_CATEGORY_TO_CONTINUE: 'Selecione uma categoria para continuar',
				ADDITIONAL_DETAILS_OPTIONAL: 'Detalhes adicionais (Opcional)',
				FEEDBACK_COMMENT_PLACEHOLDER: 'Conte-nos mais sobre o que estava errado.',
				CANCEL: 'Cancelar',
				SUBMIT_FEEDBACK: 'Enviar feedback',
				ERROR: 'Erro',
				FEEDBACK_SUBMIT_ERROR: 'Não foi possível enviar o feedback. Tente novamente.',
				TRY_AGAIN: 'Tentar novamente',
				OPEN_LINK: 'Abrir link',
				OPEN_DOCUMENT: 'Abrir documento',
				PAGE_PREFIX: 'Página-{{page}}',
			FEEDBACK_CATEGORY_INCORRECT_ANSWER: 'Resposta incorreta',
			FEEDBACK_CATEGORY_DID_NOT_ANSWER: 'Não respondeu à minha pergunta',
			FEEDBACK_CATEGORY_MISSING_DATA: 'Dados relevantes ausentes',
			FEEDBACK_CATEGORY_INCORRECT_REASONING: 'Análise ou raciocínio incorreto',
			FEEDBACK_CATEGORY_POOR_CHART: 'Gráfico ou visualização ruim',
			FEEDBACK_CATEGORY_POOR_DOCUMENT: 'Resposta de documento ruim',
			FEEDBACK_CATEGORY_TOO_SLOW: 'A consulta foi muito lenta',
			FEEDBACK_CATEGORY_INCOMPLETE: 'A resposta foi incompleta',
			FEEDBACK_CATEGORY_OTHER: 'Outro',
			CHATBOT_PRIVATE: 'Privado',
			CHATBOT_INHOUSE_GPT: 'Inhouse GPT',
			LANGUAGE_ENGLISH_US: 'Inglês (EUA)',
			LANGUAGE_ARABIC: 'Árabe',
			MODE_AUTO: 'Automático',
			MODE_GENERAL: 'Geral',
			MODE_DOCS: 'Documentos',
			MODE_OPTIMIZER: 'Otimizador',
			DATE_TODAY: 'Hoje',
			DATE_YESTERDAY: 'Ontem',
			DATE_THIS_WEEK: 'Esta semana',
			DATE_LAST_WEEK: 'Semana passada',
			DATE_THIS_MONTH: 'Este mês',
			DATE_LAST_MONTH: 'Mês passado',
			DATE_OLDER: 'Mais antigo',
				CONTEXT: {
					FROM: 'Contexto de {{source}}',
					LAUNCHED_FROM: 'Rooty iniciado a partir de {{source}}',
					UPDATED: 'Contexto atualizado',
					REMOVED: 'Contexto removido',
					APPLIED: 'Contexto aplicado',
					GENERAL: 'agora usando o contexto geral do chat',
					MORE: 'Mais',
					SEE_LESS: 'Ver menos',
					LABEL: {
						ALERT: 'Alerta',
						RCA: 'RCA',
						SCOPE: 'Escopo',
						SYSTEM: 'Sistema',
						SCENARIO: 'Cenário',
						SIMULATION_TYPE: 'Tipo de simulação',
						PREVIOUS: 'Anterior',
						NEW: 'Novo',
						SOURCE: 'Origem',
					},
					SOURCE: {
						ALERT: 'Detalhes do alerta',
						RCA: 'RCA',
						SYSTEM: 'Visualização do sistema',
						WHAT_IF: 'Análise hipotética',
					},
					SUMMARY: {
						ALERT: 'Alerta {{value}}',
						RCA: 'RCA do alerta {{value}}',
						SYSTEM: 'Sistema {{value}}',
						WHAT_IF: 'Hipotético: {{value}}',
					},
				},
			TOAST_FEEDBACK_THANKS: 'Obrigado. Usaremos isso para melhorar o Rooty.',
			TOAST_FEEDBACK_POSITIVE_THANKS: 'Obrigado pelo feedback.',
			TOAST_COPIED_MESSAGE: 'Mensagem copiada.',
			TOAST_LINK_COPIED: 'Copiado',
			TOAST_CHAT_DELETED: 'Conversa excluída',
			TOAST_CHAT_DELETE_FAILED: 'Falha ao excluir a conversa.',
			TOAST_NEW_CHAT_STARTED: 'Nova conversa iniciada',
		},
		AGENT_CONTEXT: {
			CONSIDERED: 'Contexto do agente considerado',
			ITEMS: 'itens',
			ADD: 'Adicionar contexto do agente',
			UPDATED: 'Atualizado',
			DIALOG_DESC: 'Registre orientações operacionais reutilizáveis para o {{name}} e a RCA.',
			DIALOG_DISCLAIMER: 'Este contexto pode influenciar futuras respostas do {{name}} e da RCA para análises correspondentes. Não afeta a detecção de anomalias nem os modelos preditivos.',
			SIDEPANEL_DESC: 'Conhecimento operacional reutilizável disponível para o {{name}} e a RCA.',
			SIDEPANEL_EMPTY: 'Registre conhecimento operacional reutilizável para o {{name}} e a RCA, como orientações de raciocínio, guias de investigação e terminologia.',
			REMOVE_CONFIRM: '"<strong>{{title}}</strong>" será removido e não será mais considerado pelo {{name}} ou pela RCA.<br>Esta ação não pode ser desfeita.',
			TITLE: 'Contexto do Agente',
			READ_ONLY: 'Somente leitura',
			ADD_SHORT: 'Adicionar',
			CLOSE: 'Fechar',
			SEARCH_PLACEHOLDER: 'Pesquisar por título ou escopo...',
			EDIT: 'Editar',
			DELETE: 'Excluir',
			EMPTY_HEADING: 'Ainda não há Contexto de Agente',
			LAST_UPDATED_PREFIX: 'Última atualização',
			BY_PREFIX: 'Por',
			SECTION_CONTEXT_TYPE: '1. TIPO DE CONTEXTO',
			SECTION_SCOPE: '2. ESCOPO',
			SECTION_CONTEXT: '3. CONTEXTO',
			SELECT_SCOPE: 'Selecionar Escopo',
			CONTEXT_TITLE_LABEL: 'Título',
			CONTEXT_TITLE_PLACEHOLDER: 'Digite o título do contexto',
			GUIDANCE_LABEL: 'Descrição da orientação',
			GUIDANCE_PLACEHOLDER: 'Digite a descrição da orientação',
			PLAYBOOK_NAME_LABEL: 'Nome do playbook',
			PLAYBOOK_NAME_PLACEHOLDER: 'Digite o nome do playbook',
			INVESTIGATION_STEPS_LABEL: 'Etapas de investigação',
			STEP_PLACEHOLDER: 'Digite a descrição da etapa',
			ADD_STEP: '+ Adicionar Etapa',
			TERM_HEADER: 'Termo',
			MEANING_HEADER: 'Significado',
			TERM_PLACEHOLDER: 'Adicionar Termo',
			MEANING_PLACEHOLDER: 'Digite o significado',
			CANCEL: 'Cancelar',
			CARD_REASONING_GUIDANCE_TITLE: 'Orientação de Raciocínio',
			CARD_REASONING_GUIDANCE_DESC: 'Regras de interpretação específicas da planta que ajudam os agentes de IA a raciocinar sobre o comportamento.',
			CARD_INVESTIGATION_PLAYBOOK_TITLE: 'Playbook de Investigação',
			CARD_INVESTIGATION_PLAYBOOK_DESC: 'Fluxo de solução de problemas estruturado para um problema operacional recorrente.',
			CARD_TERMINOLOGY_TITLE: 'Terminologia',
			CARD_TERMINOLOGY_DESC: 'Apelidos, abreviações e convenções de nomenclatura específicos da planta.',
			SAVE_IN_PROGRESS: 'Salvamento em andamento. Aguarde.',
			SCOPE_REQUIRED: 'É necessária uma seleção de escopo antes de salvar.',
			TITLE_REQUIRED: 'É necessário um título antes de salvar.',
			GUIDANCE_DESC_REQUIRED: 'É necessária uma descrição de orientação antes de salvar.',
			PLAYBOOK_NAME_REQUIRED: 'É necessário um nome de playbook antes de salvar.',
			STEPS_REQUIRED: 'Todas as etapas de investigação devem ser preenchidas antes de salvar.',
			TERMINOLOGY_REQUIRED: 'Todas as entradas de terminologia devem ter um termo e um significado antes de salvar.',
			SOME_ERROR_OCCURRED: 'Ocorreu um erro',
			EDIT_TITLE: 'Editar Contexto do Agente',
			SAVE_CHANGES: 'Salvar Alterações',
			DELETE_CONTEXT_TITLE: 'Excluir este contexto?',
			DELETED_SUCCESSFULLY: 'Excluído com sucesso.',
		SECTION_GUIDANCE: 'Orientação',
		TERMS_LABEL: 'Termos',
		REASONING_LABEL: 'Raciocínio',
		PLAYBOOK_LABEL: 'Playbook',
		},
		MENU: {
			NEW: 'Novo',
			ACTIONS: 'Ações',
			CREATE_POST: 'Criar Novo Post',
			PAGES: 'Páginas',
			FEATURES: 'Recursos',
			APPS: 'Aplicativos',
			HOME: 'Início',
			SYSTEM: 'Sistema',
			ANALYSIS: 'Análise',
			CONFIGURATION: 'Configuração',
			ALERTS: 'Alertas',
			ALERT_TRIAGE: 'Triagem de Alertas',
			KNOWLEDGE_GRAPH: 'Grafo de Conhecimento',
			ASSET_EXPLORER: 'Explorador de Ativos',
			LIBRARY: 'Biblioteca',
			USER_MANAGEMENT: 'Gerenciamento de Usuários',
			MODEL_WIZARD: 'Assistente de Modelo',
			DASHBOARD_WIZARD: 'Assistente de Painel',
			IOW: 'IOW',
			PROCESS: 'Processo',
			GENAI: 'GenAI',
			MAINTENANCE_OPTIMIZATION: 'Otimização da Manutenção',
			RCM: 'RCM',
			SETTINGS: 'Configurações',
			HAZOP: 'Hazop',
			CASES: 'Casos',
			CAPACITY_OPTIMIZATION: 'Otimização da Capacidade',
			HEALTH_METRICS: 'Métricas de Saúde',
			PLATFORM_CONFIGURATION: 'Configuração da Plataforma',
			DATA_MANAGEMENT: 'Gerenciamento de Dados',
			PLATFORM_POLICIES: 'Políticas da Plataforma',
			CONNECTIONS_APIS: 'Conexões e APIs',
			MODULE_CONFIGURATION: 'Configuração do Módulo',
			AI_MANAGEMENT: 'Gerenciamento de IA',
			ROOTY: '{{name}}',
			NOTIFICATION: 'Notificação',
			HELP: 'Ajuda',
			PROFILE: 'Meu Perfil',
			LOGOUT: 'Terminar Sessão',
			LANGUAGE: 'Idioma',
			BASIC_USER_GUIDE: 'Guia Básico do Usuário',
			ADVANCED_USER_GUIDE: 'Guia Avançado do Usuário',
		},
		AUTH: {
			GENERAL: {
				OR: 'Ou',
				SUBMIT_BUTTON: 'Enviar',
				NO_ACCOUNT: 'Não tem uma conta?',
				SIGNUP_BUTTON: 'Criar Conta',
				FORGOT_BUTTON: 'Esqueceu a Senha?',
				BACK_BUTTON: 'Voltar',
				PRIVACY: 'Privacidade',
				LEGAL: 'Legal',
				CONTACT: 'Contato',
				VERIFY_BUTTON: 'Verificar',
				ENTER_OTP: 'Digite o OTP',
				HAVE_ACCOUNT: 'Já tenho uma conta',
			},
			LOGIN: {
				TITLE: 'Conta de Login',
				BUTTON: 'Iniciar Sessão',
				SIGN_IN_SAML: 'Entrar com SAML',
				REMEMBER_ME: 'Lembrar de mim',
				SIGNING_IN: 'Entrando. Por favor, aguarde...',
				BPCL_WELCOME: 'Bem-vindo à solução de desempenho de ativos baseada em IA da BPCL!',
			},
			RESET: {
				TITLE: 'Redefinir Senha',
				SUCCESS: 'Senha alterada com sucesso.',
				NEWPASSWORD: 'Nova Senha',
				REENTERNEWPASSWORD: 'Verificar Senha',
				VERIFICATION_CODE_SENT: 'Digite o código de verificação enviado para',
				NO_CODE_RECEIVED: 'Não recebeu o código?',
				RESEND: 'Reenviar',
				RESEND_IN: 'em',
			},
			FORGOT: {
				TITLE: 'Esqueceu sua senha?',
				DESC: 'Digite seu e-mail para redefinir sua senha',
				SUCCESS: 'Verifique seu e-mail para OTP.',
				REQUEST_RESET_BUTTON: 'Solicitar Redefinição de Senha',
				BACK_TO_SIGNIN: 'Voltar para o login',
			},
			REGISTER: {
				TITLE: 'Criar Conta',
				DESC: 'Digite seus detalhes para criar sua conta',
				SUCCESS: 'Sua conta foi registrada com sucesso.',
				ORGANIZATION_NAME: 'Nome da Organização',
				NAME: 'Nome',
				AGREE_PREFIX: 'Eu concordo com os',
				TERMS_CONDITIONS: 'termos e condições',
				EMAIL_ALREADY_REGISTERED: 'Este e-mail já está registrado.',
			},
			INPUT: {
				EMAIL: 'E-mail',
				FULLNAME: 'Nome Completo',
				PASSWORD: 'Senha',
				CONFIRM_PASSWORD: 'Confirmar Senha',
				USERNAME: 'Nome de usuário'
			},
			PLACEHOLDER:{
				EMAIL: 'Digite o E-mail',
				PASSWORD: 'Digite a Senha'
			},
			VERIFY:{
				VERIFY_EMAIL: 'Verificação de E-mail',
				BACK_TO_SIGNIN: 'Voltar para o login',
			},
			SUBSCRIPTION: {
				EXPIRED: 'Sua assinatura expirou.',
				RENEW: 'Renove agora ou entre em contato com o suporte para obter ajuda.',
			},
			VALIDATION: {
				INVALID: '{{name}} não é válido',
				REQUIRED: '{{name}} é obrigatório',
				MIN_LENGTH: '{{name}} comprimento mínimo é {{min}}',
				AGREEMENT_REQUIRED: 'Aceitar termos e condições é obrigatório',
				NOT_FOUND: 'O solicitado {{name}} não foi encontrado',
				INVALID_LOGIN: 'Os dados de login estão incorretos',
				INVALID_RESET: 'OTP está errado ou expirado.',
				REQUIRED_FIELD: 'Campo obrigatório',
				MIN_LENGTH_FIELD: 'Comprimento mínimo do campo:',
				MAX_LENGTH_FIELD: 'Comprimento máximo do campo:',
				INVALID_FIELD: 'Campo não é válido',
			},
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Registros selecionados: ',
				ALL: 'Todos',
				SUSPENDED: 'Suspenso',
				ACTIVE: 'Ativo',
				FILTER: 'Filtrar',
				BY_STATUS: 'por Status',
				BY_TYPE: 'por Tipo',
				BUSINESS: 'Negócio',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Pesquisar',
				IN_ALL_FIELDS: 'em todos os campos'
			},
			ECOMMERCE: 'comércio eletrônico',
			CUSTOMERS: {
				CUSTOMERS: 'Clientes',
				CUSTOMERS_LIST: 'Lista de clientes',
				NEW_CUSTOMER: 'Novo Cliente',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Excluir Cliente',
					DESCRIPTION: 'Tem certeza que deseja excluir permanentemente este cliente?',
					WAIT_DESCRIPTION: 'Cliente está sendo excluído...',
					MESSAGE: 'Cliente foi excluído'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Excluir Clientes',
					DESCRIPTION: 'Tem certeza que deseja excluir permanentemente os clientes selecionados?',
					WAIT_DESCRIPTION: 'Clientes estão sendo excluídos...',
					MESSAGE: 'Clientes selecionados foram excluídos'
				},
				UPDATE_STATUS: {
					TITLE: 'O status foi atualizado para clientes selecionados',
					MESSAGE: 'O status dos clientes selecionados foi atualizado com sucesso'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Cliente foi atualizado',
					ADD_MESSAGE: 'Cliente foi criado'
				}
			}
		},
		HEALTH_METRICS: {
			TITLE: 'Métricas de Saúde',
			SYSTEM_MODEL_METRICS: 'Métricas de Saúde do Sistema e do Modelo',
			DATA_FEED_HEALTH: 'Saúde do Fluxo de Dados',
			DATA_FEED: {
				TITLE: 'Data Feed Health (Historian Monitoring)',
				ALL_TAGS: 'Todas as Tags',
				GOOD_TAGS: 'Tags Boas',
				BAD_TAGS: 'Tags Ruins',
				GROUP_BY: 'Group by',
				DOWNLOAD: 'Transferir',
				NO_TAGS_FOUND_TITLE: 'Nenhuma Tag Encontrada',
				NO_TAGS_FOUND_DESC: 'Verifique seus filtros e intervalo de datas',
				TAGS: 'Tags',
				SHOW: 'Mostrar',
				MORE_TAGS: 'mais tags',
				NO_TAGS: 'No tags found.',
				SYSTEM_NAME: 'System Name',
				VALUE: 'Value',
				QUALITY: 'Qualidade',
				TIMESTAMP: 'Timestamp',
				TAG_NAME: 'Tag Name',
				TAG_ID: 'Tag ID',
			},
			MODEL_HEALTH: {
				TITLE: 'System & Model Health Metrics',
				ALL_SYSTEMS: 'Todos os Sistemas',
				PROBLEM_SYSTEMS: 'Sistemas com Problemas',
				NO_PROBLEM_SYSTEMS: 'Nenhum Sistema com Problemas encontrado',
				SEARCH: 'Search...',
				REFRESH: 'Atualizar Dados',
				DOWNLOAD: 'Transferir',
				SYSTEM_NAME: 'Nome do Sistema',
				STATUS: 'Estado',
				DEPLOYED_VERSION: 'Versão Implantada',
				LAST_DATA_PULL: 'Última Coleta de Dados',
				DATA_HEALTH: 'Saúde dos Dados',
				MODEL_HEALTH: 'Saúde do Modelo',
				PREDICTION_TIME: 'Tempo de Predição',
				LAST_PREDICTION: 'Última Predição',
				PREDICTIONS_OLDER_THAN_2_HOURS: 'Sistemas com predições com mais de 2 horas são marcados como Sistemas com Problemas',
				LAST_DATA_WRITTEN: 'Últimos Dados Registrados',
				LAST_ANOMALY_WRITTEN: 'Última Anomalia Registrada',
				FETCH_STATUS: 'Status da Coleta',
				FETCH_RATE: 'Taxa de Coleta',
				FETCH_SAMPLING_RATE: 'Taxa de Amostragem de Coleta',
				PREDICTION_STATUS: 'Status da Predição',
				PREDICTION_RATE: 'Taxa de Predição',
				SAMPLING_RATE: 'Taxa de Amostragem',
				ACTIONS: 'Ações',
				CUSTOMIZE_COLUMNS: 'Customize Columns',
				NO_DATA_MATCHING: 'Nenhum dado disponível para o ativo selecionado',
				DEPLOYED_DATE: 'Deployed Date',
				DEPLOYED_BY: 'Implantado Por',
				DEPLOYMENT_NOTE: 'Nota de Implantação',
				ACTIVE_ALERTS: 'Alertas Ativas',
				RETRAINING_RECOMMENDED: {
					TITLE: 'Retreinamento recomendado',
					DESCRIPTION: 'A avaliação recente sugere que o modelo pode não refletir mais o comportamento operacional atual. As seguintes tags contribuem mais para esta recomendação.',
					CONTRIBUTING_TAGS: 'Tags contribuintes (até 5)',
					TAG_NAME_AND_ID: 'Nome e ID da tag',
					TAG_TOOLTIP: 'Nome: {{tagName}}\nTagID: {{tagId}}',
					CONTRIBUTION_SCORE: 'Pontuação de contribuição',
					LAST_EVALUATED: 'Última avaliação',
					MODEL_VERSION: 'Modelo',
					COPY_TAGS: 'Copiar tags',
					COPY_FULL_DETAILS: 'Copiar detalhes completos',
					RETRAIN_MODEL: 'Retreinar modelo',
					RETRAIN: 'Retreinar',
					TIP_PREFIX: 'Dica: Clique no chip',
					TIP_SUFFIX: 'na coluna Saúde do Modelo para ver por que o retreinamento é recomendado.',
					NO_TAGS: 'Nenhuma tag contribuinte encontrada.',
					TAGS_COPIED: 'Tags copiadas.\nDisponíveis na área de transferência.',
					DETAILS_COPIED: 'Detalhes copiados.\nDisponíveis na área de transferência.',
					RECOMMENDED_DATE_RANGE: 'Intervalo de datas recomendado para retreinar',
					RECOMMENDED_DATE_RANGE_HINT: 'Use este intervalo de datas para revisar e retreinar o modelo com os dados mais relevantes.',
					NO_DATE_RANGE: 'Não há intervalo de datas disponível para retreinar o modelo',
					ADD_COMMENT: 'Adicionar comentário',
					ADD_COMMENT_PLACEHOLDER: 'Adicionar um motivo',
					START_RETRAINING: 'Iniciar retreinamento',
					BACK: 'Voltar',
					FORCE_INCLUDE_BANNER: 'As regiões recomendadas foram adicionadas automaticamente como intervalos Force Include.',
					TRAINING_PERIOD: 'Período de treinamento',
					EXISTING_TRAINING_REGION: 'Região de treinamento existente',
					CURRENT_MODEL_VERSION: 'Versão atual do modelo',
					RECOMMENDED_REGION: 'Região recomendada',
					FROM_MODEL_HEALTH_EVALUATION: 'Da avaliação de saúde do modelo',
					NO_TRAINING_RANGES: 'Nenhuma região de treinamento disponível.',
					LOADING_RANGES: 'Carregando regiões de treinamento...',
				},
				NO_DATA_HEADING: 'Nenhum Sistema Encontrado',
				NO_DATA_CONTENT: 'Não há modelos de sistema disponíveis para exibir.'
			},
			QC: {
				QC_CHECK_CONFIG: 'QC Check Configuration',
				ALL_TAGS: 'Todas as Tags',
				PROBLEM_TAGS: 'Tags com Problemas',
				UPLOAD: 'Upload Tags (Excel)',
				DOWNLOAD: 'Download Tags (Excel)',
				VIEW: 'Ver',
				EDIT: 'Editar',
				NO_TAGS_FOUND: 'Nenhuma tag encontrada',
				ADD_DESCRIPTION: 'Adicionar Descrição',
				ADD_UOM: 'Adicionar Unidade',
				COL_INDEX: '#',
				COL_SYSTEM_NAME: 'Nome do Sistema',
				COL_TAG_NAME: 'Nome da Tag',
				COL_TAG_ID: 'ID da Tag',
				COL_TAG_DESCRIPTION: 'Descrição da Tag',
				COL_UOM: 'UOM',
				COL_IR_UPPER: 'IR Upper',
				COL_TRIP_UPPER: 'Trip Upper',
				COL_ALARM_UPPER: 'Alarm Upper',
				COL_THRES_UPPER: 'Thres Upper',
				COL_OPS_UPPER: 'Ops Upper',
				COL_OPS_LOWER: 'Ops Lower',
				COL_THRES_LOWER: 'Thres Lower',
				COL_ALARM_LOWER: 'Alarm Lower',
				COL_TRIP_LOWER: 'Trip Lower',
				COL_IR_LOWER: 'IR Lower',
				COL_FLATLINE: 'Detecção de Linha Reta',
				COL_OUTLIER: 'Detecção de Outlier',
				COL_RANGE: 'Detecção de Fora de Alcance',
				COL_MISSING_DATA: 'Detecção de Dados Ausentes',
				COL_FLATLINE_ALERT: 'Geração de Alerta de Linha Reta',
				COL_OUTLIER_ALERT: 'Geração de Alerta de Outlier',
				COL_RANGE_ALERT: 'Geração de Alerta de Fora de Alcance',
				COL_MISSING_DATA_ALERT: 'Geração de Alerta de Dados Ausentes',
				COL_ATTENTION: 'Atenção',
				COL_THRES_NOT: 'Thres Not.',
				COL_KPI: 'KPI',
				COL_ACTIONS: 'Ações',
				COL_DESCRIPTION: 'Descrição',
				EDIT_TAG: 'Editar Tag',
				LOWER: 'Inferior',
				UPPER: 'Superior',
				INSTRUMENT_RANGE: 'Alcance do Instrumento',
			}
		},
		SHARED_MODULE: {
			COLUMN_CONFIG: {
				TITLE: 'Show Columns',
				SEARCH: 'Search...',
				SELECT_ALL: 'Select All',
				RESET_TO_DEFAULT: 'Restaurar Padrão',
			},
			CALCULATED_TAG_POPUP: {
				EXPRESSION: 'Expressão',
				EXPRESSION_DESCRIPTION: 'Descrição da Expressão'
			}
		},
		DATA_MANAGEMENT: {
			QC: {
				RUN_QC: 'Executar QC',
				RUN_QC_SELECTED: 'Executar QC nos selecionados',
				RUN_QC_TOOLTIP: 'Executar o agente de qualidade de dados sobre os registros atuais',
				RUNNING: 'Executando QC',
				DETAIL_TITLE: 'Registro de manutenção',
				TAB_DETAILS: 'Detalhes',
				TAB_REVIEW: 'Revisão',
				NO_DETAILS: 'Nenhum detalhe disponível.',
				VIEW_DETAILS: 'Ver detalhes',
				FIELDS: {
					NOTIFICATION_NO: 'N.º da nota',
					ORDER: 'Ordem',
					TYPE: 'Tipo',
					EQUIPMENT: 'Equipamento',
					EQUIPMENT_DESC: 'Descrição do equipamento',
					FUNCTIONAL_LOC: 'Local de instalação',
					PLAN_GROUP: 'Grupo planejador',
					PLAN_GROUP_DESC: 'Descrição do grupo planejador',
					MAINTENANCE_PLANT: 'Centro de manutenção',
					MAINTENANCE_PLANT_DESC: 'Descrição do centro de manutenção',
					PLANT_SECTION: 'Seção da planta',
					PRIORITY: 'Prioridade',
					DAMAGE: 'Dano',
					DESCRIPTION: 'Descrição',
					STATUS: 'Status',
					USER_STATUS: 'Status do usuário',
					CREATED_ON: 'Criado em',
					COMPLETED_ON: 'Concluído em',
					BREAKDOWN_DURATION: 'Duração da parada',
					INTERNAL_LABOUR: 'Custo de mão de obra interna',
					EXTERNAL_LABOUR: 'Custo de mão de obra externa',
					EXTERNAL_SERVICE: 'Custo de serviço externo'
				},
				LAST_RUN: 'Última execução de QC',
				VIEW_FINDINGS: 'Ver constatações',
				FINDINGS_TITLE: 'Constatações de qualidade de dados',
				NO_FINDINGS: 'Nenhum problema encontrado para este registro.',
				BLOCKERS: 'Bloqueadores',
				WARNINGS: 'Avisos',
				RULE: 'Regra',
				FIELD: 'Campo',
				EVIDENCE: 'Evidência',
				RECOMMENDATION: 'Recomendação',
				CONFIG_TITLE: 'Regras de qualidade de dados',
				SCOPE_GLOBAL: 'Global',
				SCOPE_SYSTEM: 'Este sistema',
				RULE_MANDATORY_FIELDS: 'Campos obrigatórios',
				MANDATORY_FIELDS_LABEL: 'Campos necessários',
				SEVERITY: 'Severidade',
				RULE_DESCRIPTION: 'Comprimento da descrição',
				MIN_LENGTH: 'Comprimento mínimo (caracteres)',
				RULE_DATES: 'Consistência de datas',
				ALLOW_COMPLETION_BEFORE_CREATION: 'Permitir data de conclusão anterior à de criação',
				RULE_DUPLICATES: 'Detecção de duplicados',
				WINDOW_DAYS: 'Janela de duplicados (dias)',
				RULE_PLANNING: 'Planejamento',
				REQUIRE_LABOR: 'Exigir mão de obra nas ordens de serviço',
				RULE_COMPLETION: 'Conclusão',
				REQUIRE_ROOT_CAUSE: 'Exigir causa raiz em registros concluídos',
				RULE_TEXT_QUALITY: 'Qualidade do texto (AI)',
				TEXT_QUALITY_HINT: 'Usa o modelo de linguagem para verificar ortografia e qualidade da descrição',
				CHECK_SPELLING: 'Verificar ortografia',
				CHECK_DESCRIPTION_MEANING: 'Verificar se a descrição é significativa',
				CHECK_ROOT_CAUSE: 'Verificar adequação da causa raiz',
				RULE_WORK_ORDER: 'Ordem de serviço obrigatória',
				WORK_ORDER_HINT: 'Sinaliza uma ordem de serviço ausente apenas quando a notificação está concluída e pertence aos tipos de notificação selecionados abaixo.',
				WORK_ORDER_TYPES_LABEL: 'Tipos de notificação que exigem ordem de serviço',
				RULE_SLA: 'SLA / Data exigida',
				SLA_CHECK_OVERDUE: 'Sinalizar notificações em atraso em relação à data de conclusão exigida',
				SLA_CHECK_LATE: 'Sinalizar notificações concluídas após a data de conclusão exigida',
				RULE_BREAKDOWN_CONSISTENCY: 'Consistência do indicador de quebra',
				BREAKDOWN_CONSISTENCY_HINT: 'Verifica o indicador de quebra (Effect) em relação ao tempo de parada registrado. Selecione os valores de Effect que indicam quebra neste site.',
				BREAKDOWN_EFFECT_VALUES_LABEL: 'Valores de Effect que indicam quebra',
				RULE_AGING: 'Envelhecimento / Atraso acumulado',
				MAX_OPEN_DAYS: 'Número máximo de dias que uma notificação pode permanecer aberta',
				RULE_STATUS_CONSISTENCY: 'Consistência de fechamento de status',
				STATUS_CONSISTENCY_HINT: 'Verifica a data de conclusão em relação ao status de fechamento do fluxo de trabalho. Selecione os códigos de status que significam \'fechado\' neste site.',
				CLOSED_KEYWORDS_LABEL: 'Códigos de status que significam fechado',
				RULE_COST_SANITY: 'Sanidade de custo',
			},
			TABS: {
				DOCUMENTS: 'Documentos',
				TAGS: 'Tags',
				MAINTENANCE: 'Manutenção',
				PIDS: 'P&IDs',
				RELIABILITY: 'Reliability'
			},
			COMMON: {
				PROCESSING: 'Processando',
				READY: 'Pronto',
				REVIEW: 'Revisão',
				BLOCKED: 'Bloqueado',
				PENDING: 'Pendente',
				SEARCH: 'Search...',
				SEARCH_RECORDS: 'Pesquisar registros...',
				ADD_DOCUMENT: 'Adicionar Documento',
				NO_MATCHING: 'Nenhum documento correspondente encontrado.',
				LOADING: 'Loading data...',
				LOADING_MORE: 'Carregando mais documentos...',
				LOADING_MORE_RECORDS: 'Carregando mais registros...',
				CANCEL: 'Cancelar',
				EDIT: 'Editar',
				SAVE: 'Guardar',
				SAVING: 'Saving...',
				ASK_ROOTY: 'Perguntar ao Rooty',
				DOWNLOAD: 'Transferir',
				IMPORT_DATA: 'Import Data',
				REPLACE_FILE: 'Substituir Arquivo',
				UPLOAD: 'Carregar'
			},
			FILTERS: {
				ALL_ISSUES: 'Todas as Questões',
				CHOOSE_ISSUES: 'Escolha as Questões para exibir',
				ALL_CLASSES: 'Todas as Classes',
				CHOOSE_CLASSES: 'Escolha as Classes para exibir',
				GROUP_BY: 'Group by',
				ALL_TYPES: 'Todos os Tipos',
				EVENT_TYPES: 'Tipos de Evento',
				FILTER_ISSUE_TYPE: 'Tipo de Questão'
			},
			IMPORT_BANNER: {
				IMPORTING: 'Importando {{ count }} Documentos',
				IMPORTING_AUTO: 'Importando {{ uploaded }} documentos, {{ remaining }} restantes (Total: {{ total }})',
				INITIALIZING_AUTO: 'Inicializando a sincronização de documentos...',
				AUTO_TAKE_MINS: 'Por favor, aguarde enquanto sincronizamos seus documentos em segundo plano...',
				TAKE_30_MINS: 'Isso pode levar até 30 minutos.',
				IMPORTED_SUCCESS: '{{ count }} documentos importados',
				SUMMARY: 'Import summary:',
				NEEDS_REVIEW: 'Precisa de Revisão',
				ALREADY_PRESENT: 'Já Presente',
				REMOVED_AT_SOURCE: 'Removido na origem',
				SYNC_FAILED: 'Falha na sincronização'
			},
			TABLE_COLUMNS: {
				DOCUMENT: 'Documento',
				CLASS: 'Class',
				DOC_TYPE: 'Doc Type',
				STATUS: 'Estado',
				SOURCE: 'Fonte',
				ISSUES: 'Questões',
				LAST_UPDATED: 'Last Updated',
				ACTIONS: 'Ações',
				NOTIFICATION: 'Notificação',
				EQUIPMENT: 'Equipamento',
				DESCRIPTION: 'Descrição',
				TYPE: 'Tipo',
				MAINTENANCE_PLANT: 'Planta de Manutenção',
				FAILURE_MODE: 'Failure Mode',
				SECTION: 'Seção',
				DATES: 'Datas',
				CONTEXT: 'Contexto',
				TIME_HRS: 'Tempo (em horas)',
				RCA: 'RCA',
				SOURCE_NAME: 'Nome da Fonte',
				PATH: 'Caminho',
				SYNC_FREQUENCY: 'Frequência de Sincronização',
				LAST_SYNCED: 'Última Sincronização',
			},
			EMPTY_STATE: {
				NO_DOCS_TITLE: 'Nenhum documento importado ainda',
				NO_DOCS_SUBTITLE: 'Adicione Documentos Manualmente ou use a ferramenta de upload por IA.',
				NO_MAINT_TITLE: 'Nenhum Dado de Manutenção importado ainda.',
				NO_MAINT_SUBTITLE: "Select 'Import Data' to start adding maintenance data."
			},
			ADD_DOC_DIALOG: {
				FILE_UPLOAD: 'Upload de Arquivo',
				UPLOAD_MANUALLY: 'Fazer upload de arquivos manualmente',
				BULK_UPLOAD_TITLE: 'Upload em massa com modelo de pastas',
				BULK_UPLOAD_DESC: 'Baixe a estrutura de pastas, coloque seus documentos nas pastas correspondentes e envie a pasta inteira.',
				DOWNLOAD_TEMPLATE: 'Baixar Modelo',
				DRAG_DROP: 'Arraste e solte seu arquivo aqui ou',
				BROWSE: 'procurar',
				SUPPORTS: 'Suporta PDF, Word, Excel, imagens ou um ZIP de upload em massa.',
				SELECTED_FILES: 'Arquivos selecionados',
				APPLY_TO_ALL: 'Aplicar a Todos:',
				CLASS: 'Classe',
				DOC_TYPE: 'Doc Type',
				LINKED_TO: 'Linked to',
				SELECT_CLASS: 'Selecionar Classe',
				SELECT_DOC_TYPE: 'Selecionar Tipo de Documento',
				CHOOSE_LINK: 'Escolha onde vincular',
				FILE_SELECTED: 'Arquivo Selecionado',
				FILES_SELECTED: 'Arquivos Selecionados',
				CONFIRM_IMPORT: 'Confirmar / Importar',
				REPLACE_HINT: 'Envie o arquivo de substituição correto para este documento. Idealmente, deve ser o mesmo arquivo originalmente pretendido.',
				DUPLICATE_BADGE: 'Duplicado',
				DUPLICATES_SKIPPED_BANNER: '{{count}} arquivo(s) duplicado(s) detectado(s). Eles foram excluídos e não serão enviados.',
				DUPLICATES_SKIPPED_INLINE: '({{count}} duplicado ignorado)',
				REMOVE_DUPLICATES: 'Remover duplicados'
			},
			DOC_VIEWER: {
				DOC_DETAILS: 'Detalhes do Documento',
				PREVIEW: 'Visualizar',
				FULL_SCREEN: 'Tela Cheia',
				NO_PREVIEW: 'Nenhuma Pré-visualização Disponível',
				NO_PREVIEW_DESC: 'Este tipo de arquivo não pode ser pré-visualizado no navegador.',
				METADATA: 'Metadados',
				DOC_IDENTIFICATION: 'Identificação do Documento',
				DOC_NAME: 'Nome do Documento',
				DOC_ID: 'ID do Documento',
				DOC_CLASS: 'Classe do Documento',
				DOC_TYPE: 'Tipo de Documento',
				MISSING: 'Faltando',
				DOC_SOURCE: 'Origem do Documento',
				FILE_SIZE: 'Tamanho do Arquivo',
				FILE_UPLOAD_SOURCE: 'Upload de Arquivo',
				EXTERNAL_SOURCE: 'Externo (Sharepoint, Google Drive etc.)',
				VERSIONING: 'Versionamento',
				UPLOADED_ON: 'Enviado em',
				LAST_MODIFIED: 'Última Modificação',
				EFFECTIVE_DATE: 'Data de Vigência',
				EXPIRY_DATE: 'Data de Expiração',
				REVISION: 'Revisão',
				VERSION_1: 'Versão 1',
				VERSION_2: 'Versão 2',
				STATUS: 'Estado',
				STATUS_UPLOADING: 'Enviando',
				STATUS_QUEUED: 'Na Fila',
				STATUS_PROCESSING: 'Processando',
				STATUS_READY: 'Ready',
				STATUS_PENDING: 'Pendente',
				LINKED_TO: 'Vinculado a',
				FACILITIES: 'Instalações',
				UNITS: 'Units',
				SYSTEMS: 'Systems',
				CHOOSE_LINK_DESC: 'Escolha onde vincular (Você pode vincular o documento a uma Instalação, Unidade ou Sistema)',
				EXTRACTED_DATA: 'Dados Extraídos',
				NO_EXTRACTED_DATA: 'Nenhum dado extraído disponível.'
			},
			TOOLTIPS: {
				ISSUE_FILTER: 'Filtro de Questões',
				CLASS_FILTER: 'Filtro de Classe',
				CUSTOMIZE_COLUMNS: 'Personalizar Colunas',
				VIEW_DETAILS: 'Ver Detalhes',
				DELETE_FILE: 'Excluir Arquivo',
				STATUS_QUEUED_PROCESSING: 'Seu documento está na fila e será processado em breve.',
				STATUS_READY: 'Your document is processed and is ready to use.'
			},
			DEDUP_MENU: {
				TRIGGER_LABEL: 'Duplicados',
				TITLE: 'Duplicados resolvidos',
				SUMMARY: '{{dupes}} de {{total}} arquivo(s) selecionado(s) têm duplicados',
				DESCRIPTION: 'Os originais são mantidos. Os outros {{unaffected}} arquivo(s) não são alterados.',
				MERGE_TAGS: 'Remover duplicados, mesclar tags ({{count}})',
				NO_MERGE_TAGS: 'Remover duplicados, NÃO mesclar tags ({{count}})',
				FAILURE: 'Falha ao remover alguns duplicados',
				TOAST_MERGED: '{{count}} arquivo(s) duplicado(s) removido(s). As tags foram mescladas com os arquivos originais.',
				TOAST_NOT_MERGED: '{{count}} arquivo(s) duplicado(s) removido(s). As tags do arquivo original permaneceram inalteradas.'
			},
			CONNECTED_SOURCES: {
				CLOSE: 'Fechar',
				DISCONNECT_MSG: 'Desconectar o {{provider}} interromperá a sincronização de documentos e impedirá que o UptimeAI acesse arquivos da conta do {{provider}} conectada.<br/>Os documentos já importados para o UptimeAI permanecerão disponíveis, mas não receberão mais atualizações do {{provider}}.',
				DISCONNECT_TITLE: 'Desconectar a integração do {{provider}}?',
				DISCONNECT_OK: 'Desconectar {{provider}}',
				FETCH_SOURCES_FAILED: 'Falha ao buscar fontes conectadas.',
				SOURCE_UPDATED_SUCCESS: 'Fonte atualizada com sucesso.',
				SOURCE_CONNECTED_SUCCESS: 'Fonte conectada com sucesso.',
				TRIGGERING_SYNC: 'Iniciando sincronização...',
				SYNC_STARTED_SUCCESS: 'Sincronização iniciada com sucesso.',
				FAILED_TRIGGER_SYNC: 'Falha ao iniciar sincronização.',
				INACTIVE_REASON_COVERED: 'Coberto pela fonte pai ativa \'{{name}}\' ({{path}})',
				REAL_TIME: 'Tempo real',
				ONE_TIME: 'Uma vez',
				DAILY: 'Diário',
				HOURLY: 'De hora em hora',
				WEEKLY: 'Semanal',
				MONTHLY: 'Mensal',
				NA: 'N/A',
				PAUSED: 'Pausado',
				INACTIVE: 'Inativo',
				UNKNOWN: 'Desconhecido',
				TITLE: 'Fontes Conectadas',
				ACTIVE: 'Ativo',
				CONNECT_SOURCE: 'Conectar Fonte',
				NO_SOURCES_HEADING: 'Nenhuma fonte conectada ainda.',
				NO_SOURCES_CONTENT: 'Conecte uma fonte para navegar e importar arquivos.',
				NEVER: 'Nunca',
				SYNC_NOW: 'Sincronizar agora',
				MONITOR: 'Monitorar',
				SETTINGS: 'Configurações',
				DISCONNECT: 'Desconectar',
				SYNC_ACTIVITY: 'Atividade de Sincronização',
				NO_RECENT_ACTIVITY: 'Nenhuma atividade recente encontrada.',
				STATUS_SUCCESS: 'Sucesso',
				STATUS_PARTIAL: 'Parcial',
				STATUS_FAILED: 'Falha',
				STATUS_RUNNING: 'Executando',
				SYNC_FAILED_ERROR: 'A sincronização falhou devido a um erro.',
				SYNC_STATS: '+ {{new}} novos · {{updated}} atualizados · {{skipped}} inalterados',
				SYNC_STATS_PARTIAL: '+ {{new}} novos · {{updated}} atualizados · {{skipped}} inalterados · {{failed}} falhados',
			},
			CONNECT_SOURCE: {
				PROVIDERS: {
					DOCUMENT_LOCATOR: {
						NAME: 'Document Locator',
						DESC: 'Conecte-se a um banco de dados do Document Locator para sincronizar documentos continuamente.'
					}
				},
				PROVIDER_FIELDS: {
					DOCUMENT_LOCATOR: {
						DIALECT: 'Tipo de banco de dados',
						HOST: 'Host do servidor',
						PORT: 'Porta',
						DATABASE: 'Nome do banco de dados',
						USER: 'Nome de usuário',
						PASSWORD: 'Senha',
						ENCRYPT: 'Criptografar conexão',
						TRUST_CERT: 'Confiar no certificado do servidor',
						SP_FILE_INFO: 'Procedimento de informações do arquivo',
						SP_FILE_CONTENT: 'Procedimento de conteúdo do arquivo',
						SP_PLACEHOLDER: 'Informe o nome do procedimento armazenado'
					}
				},
				TITLE: 'Connect Source',
				STEP_1: 'Conectar à Origem',
				STEP_2: 'Autenticar na Origem',
				STEP_3: 'Detalhes da Origem',
				SHAREPOINT: 'SharePoint',
				SHAREPOINT_DESC: 'Conecte-se a bibliotecas do SharePoint para sincronizar documentos continuamente.',
				CONNECT_TO_SHAREPOINT: 'Conectar ao SharePoint',
				CONNECT_TO_PROVIDER: 'Conectar ao {{provider}}',
				CONNECTION_VERIFIED: 'Conexão verificada.',
				DESCRIPTOR_LOAD_FAILED: 'Não foi possível carregar a configuração desta fonte.',
				TEST_CONNECTION_REQUIRED: 'Por favor, teste a conexão com sucesso antes de conectar.',
				API_INTEGRATION: 'Integração de API',
				API_DESC: 'Conecte-se a APIs de gerenciamento de documentos para sincronizar arquivos automaticamente.',
				CMMS: 'CMMS',
				CMMS_DESC: 'Conecte-se ao seu CMMS (SAP PM, Maximo, etc.) para sincronização contínua de documentos.',
				COMING_SOON: 'Em breve',
				OAUTH_TAB: 'Entrar com Microsoft (OAuth)',
				TOKEN_TAB: 'Token de Acesso (manual)',
				SIGN_IN_MICROSOFT: 'Entrar com Microsoft',
				OAUTH_DESC: 'Conecte sua conta Microsoft para navegar pelas bibliotecas do SharePoint e importar documentos.',
				SECURE_AUTH: 'Autenticação segura',
				SECURE_AUTH_DESC: 'Usa o OAuth da Microsoft. Suas credenciais nunca são armazenadas neste aplicativo.',
				READ_ONLY: 'Acesso somente leitura',
				READ_ONLY_DESC: 'O aplicativo apenas lê documentos. Nenhum arquivo será modificado ou excluído no SharePoint.',
				TOKEN_PLACEHOLDER: 'Cole seu Token de Acesso do SharePoint',
				TOKEN_WARNING: 'Os tokens de acesso expiram. Considere usar OAuth para sincronização ininterrupta.',
				MANUAL_AUTH_DESC: 'Insira suas credenciais de Registro de Aplicativo do Azure. Elas são armazenadas com segurança no servidor.',
				TENANT_ID_LABEL: 'ID do Inquilino',
				TENANT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_ID_LABEL: 'ID do Cliente (ID do Aplicativo)',
				CLIENT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_SECRET_LABEL: 'Segredo do Cliente',
				CLIENT_SECRET_PLACEHOLDER: 'Cole o valor do segredo do cliente',
				SAVE_CREDENTIALS: 'Salvar e Continuar',
				STEP_CONNECTION_CONFIG: 'Configuração de Conexão',
				APP_CONNECTION_CONFIG: 'Configuração de Conexão do Aplicativo',
				NEW_CONNECTION: 'Nova Conexão',
				ACTIVE_CONNECTION_CONFIG: 'Configuração de Conexão Ativa',
				PROVIDER: 'Provedor',
				MICROSOFT_SHAREPOINT: 'Microsoft SharePoint',
				APP_ID: 'ID do Aplicativo (ID do Cliente)',
				REGISTER_CONFIG_DESC: 'Insira os detalhes para registrar uma nova configuração de credenciais de cliente/registro de aplicativo.',
				CONFIG_NAME_LABEL: 'Nome da Configuração',
				CONFIG_NAME_PLACEHOLDER: 'ex: SharePoint Production',
				BACK_TO_SELECTION: 'Voltar para a seleção',
				SAVE_CONNECTION_BTN: 'Salvar Conexão',
				PLEASE_SELECT_CONNECTION: 'Selecione ou registre uma configuração de conexão primeiro.',
				RESTORED_SESSION_FOR: 'Sessão autenticada restaurada para: {{user}}',
				PLEASE_COMPLETE_SIGNIN: 'Por favor, conclua primeiro o login da Microsoft.',
				SELECT_APP_REGISTRATION: 'Selecione ou registre primeiro uma conexão de Registro de Aplicativo.',
				FAILED_AUTH_URL: 'Falha ao obter o URL de autorização da Microsoft.',
				ERROR_REQ_AUTH_LINK: 'Erro ao solicitar o link de autorização.',
				FILL_ALL_FIELDS: 'Preencha todos os campos de configuração de conexão.',
				APP_REG_SAVED: 'Configuração de registro de aplicativo salva com sucesso.',
				FAILED_SAVE_CONFIG: 'Falha ao salvar a configuração.',
				SITE_URL_LABEL: 'URL do Site do SharePoint (A URL completa da coleção do seu site SharePoint)',
				SITE_URL_PLACEHOLDER: 'https://company.sharepoint.com/sites/engineering',
				LIBRARY_PATH_LABEL: 'Caminho da Biblioteca',
				LIBRARY_PATH_DESC: '(Caminho para a biblioteca de documentos, ex. /Shared Documents/Equipment)',
				LIBRARY_PATH_PLACEHOLDER: '/Shared Documents/Equipment',
				FILE_TYPE_LABEL: 'Filtro de Tipo de Arquivo (Importe apenas arquivos correspondentes a estes tipos; deixe vazio para todos)',
				SYNC_FREQUENCY: 'Frequência de Sincronização',
				SYNC_AUTO: 'Automática (Tempo real)',
				SYNC_HOURLY: 'A cada hora',
				SYNC_DAILY: 'Diária',
				SYNC_DAILY_DESC: 'Sincroniza a cada 24 horas em um horário programado',
				SYNC_WEEKLY: 'Semanal',
				SYNC_BIWEEKLY: 'Quinzenal',
				SYNC_MONTHLY: 'Mensal',
				CONFLICT_LABEL: 'Resolução de Conflitos (Como tratar documentos que já existem no sistema)',
				CONFLICT_KEEP_NEWEST: 'Manter Versão Mais Recente',
				TEST_CONNECTION: 'Testar Conexão',
				TEST_SUCCESS: 'Conexão bem-sucedida - {{count}} documentos correspondentes encontrados',
				CANCEL: 'Cancelar',
				CONNECT_AND_SYNC: 'Conectar e Iniciar Sincronização',
				AUTH_SUCCESS: 'Você se autenticou com sucesso. Clique em Avançar abaixo para configurar os detalhes da fonte.',
				APP_ONLY_SYNC_DESC: 'A sincronização apenas de aplicativo é executada em segundo plano usando a configuração de registro de aplicativo selecionada. Nenhum login de usuário individual é necessário.',
				FILE_TYPE_FILTER_DESC: 'Importe apenas arquivos correspondentes a esses tipos; deixe desmarcado para importar todos os arquivos.',
				NEXT: 'Avançar',
				AUTHENTICATED_PROFILE: 'Perfil Autenticado da Microsoft',
				USER_NAME: 'Nome de Usuário',
				EMAIL_ADDRESS: 'Endereço de e-mail',
				SIGN_IN_DIFFERENT_ACCOUNT: 'Entrar com uma conta diferente'
			}
		},
		MODULE_CONFIGURATION: {
			TABS: {
				TRIAGE: 'Alert Triage', MAINTENANCE: 'Manutenção', COMING_SOON: 'Coming Soon' },
			COMMON: { CANCEL: 'Cancelar', SAVE: 'Guardar', EDIT: 'Editar', DOWNLOAD: 'Transferir', UPLOAD: 'Carregar', DELETE: 'Eliminar', SELECT_ALL: 'Select all', SEARCH: 'Search Activity...', EDIT_CONFIGURATION: 'Edit Configuration', SAVE_CONFIGURATION: 'Save Configuration', APPLY_TEMPLATE: 'Apply Template', TEMPLATE_MANAGER: 'Template Manager', SAVED_CONFIGURATION: 'Saved Configuration', CONFIGURE: 'Configure', BETA_ANALYTICS: 'β Analytics', UPDATE_TEMPLATE: 'Update Template', SAVE_TEMPLATE: 'Save Template', FINISH_SAVE_PACKAGE: 'Finish & Save Package', DONE: 'Concluído', RE_GENERATE: 'Re-Generate', YES: 'Sim', NO: 'Não', LOADING: 'Loading...', COPY: 'Copiar', APPLYING_TEMPLATE: 'Applying Template', LOADING_TEMPLATE: 'Loading Template', TO: 'to' },
			HEADER: { CONFIG_FOR: 'Configure PM, FMEA, CM for:', SELECT_EQUIPMENT: 'Please select an equipment' },
			EQUIPMENT_EMPTY: { TITLE: 'Select Equipment', DESC: 'Select an equipment from the hierarchy panel to configure', ACTIVITIES: 'PM activities, FMEA, CM.', NO_TEMPLATE_TITLE: 'Nenhum Modelo Aplicado', NO_TEMPLATE_DESC: 'Aplique um modelo para configurar atividades de PM, FMEA e CM para este equipamento.' },
			COMING_SOON: { TITLE: 'Coming Soon', DESC: 'This feature is currently under development and will be available in a future update.' },
			MANAGER: { TITLE: 'Template Manager', EDIT_TEMPLATE: 'Edit Template', LINKED_ASSETS: 'linked assets', SUB_HEADER: 'Manage reusable PM, CM, and Failure Mode templates', COL_NAME: 'Template Name', COL_DESC: 'Descrição', COL_TYPE: 'Tipo', COL_ASSETS: 'Linked Assets', COL_ASSET: 'Assets', COL_CREATOR: 'Created By', COL_DATE: 'Last Modified', EMPTY_TITLE: 'No templates found', EMPTY_DESC: 'Saved PM, CM, and Failure Mode templates will appear here.', SELECT_DESC: 'Select a pre-built template to apply to your equipment.', SEARCH_TEMPLATE: 'Search Template...', EQ_TEMPLATE_LIBRARY: 'Equipment Template Library', COL_STATUS: 'Estado', STATUS_IN_PROGRESS: 'Em andamento', STATUS_READY: 'Pronto para uso', STATUS_DEPRECATED: 'Descontinuado', LIFECYCLE: 'Mais ações', LOCK: 'Bloquear e marcar como pronto', LOCK_HINT: 'Conclua o modelo a 100% para poder bloqueá-lo.', UNLOCK: 'Desbloquear', DEPRECATE: 'Descontinuar', REACTIVATE: 'Reativar', DUPLICATING: 'Criando modelo duplicado de {{name}}...' },
			UPLOAD: { TITLE_PM: 'Upload PM Template', TITLE_CM: 'Upload CM Template', TITLE_FM: 'Upload Failure Modes Template', TEMPLATE_NAME: 'Template Name', ENTER_TEMPLATE: 'Enter Template Name', DRAG_DROP: 'Drag and drop your file here or', BROWSE: 'browse', REMOVE_FILE: 'Remove file' },
			PM: { TITLE: 'PM Configuration', CONFIG_FOR: 'Configuring PM Checklist for:', SELECT_HOW: 'Select how you want to configure PM activities', APPLY_TEMPLATE: 'Apply template', IMPORT_SAP: 'Import from SAP', UPLOAD_TEMPLATE: 'Upload Template', DOWNLOAD_TEMPLATE: 'Download Template', CHECKLIST_TEMPLATE: 'PM Checklist Template', SAVE_TEMPLATE: 'Save Template', EDIT_TEMPLATE: 'Edit Template', OVERALL_VARS: 'Overall PM Level Variables', OVERALL_TIME: 'Overall Time (in hours)', MUST_BE_POSITIVE: 'Insira um número maior que 0', OVERALL_MANNING: 'Overall Manning', TECH_COUNT: 'Technician (in Count)', HELPER_COUNT: 'Helper (in Count)', COST_PARTS: 'Cost of Parts (if any) (in USD)', COST_CONS: 'Cost of Consumables (in USD)', PM_INTERVAL: 'Current PM Interval (in days)', PROD_LOSS: 'Production Loss (in USD)', TAB_CHECKLIST: 'PM Checklist', ACTIVITIES_CHECKLIST: 'PM Activities Checklist', ACTIVITIES_CHECKLIST_DESC: 'List of all PM activities defined in this checklist template', ENRICH_ROOTY: 'Enrich Checklist with Rooty', ROOTY_LOADING: 'Rooty is analysing your PM activities...', ROOTY_BUNDLE_TITLE: 'Activity Bundle Suggestions', ROOTY_BUNDLE_DESC: 'Review the suggested bundles below. Confirm to proceed and generate Flags.', ROOTY_CONFIRM_BUNDLES: 'Looks good — Generate Flags', ROOTY_CONFIRM_FLAGS: 'Looks good — Generate Time per activity', ROOTY_FLAGS_READY: 'Build Flags generated. Review the tabs below.', ROOTY_FLAGS_OUTPUT: 'Build Flags Analysis', ROOTY_NO_SYSTEM: 'Guarde a Atividade de PM para ativar o enriquecimento', TAB_BUNDLES: 'Activity Bundles', BUN_TITLE: 'PM Activity Bundles', BUN_DESC: 'Group PM activities into logical bundles for efficient scheduling', TAB_FLAGS: 'Build Flags', FLAG_TITLE: 'Build Flags', FLAG_DESC: 'Classify activities as regulatory, procedural, or operational', TAB_TIME: 'Time per Activity', TIME_TITLE: 'Time per Activity', TIME_DESC: 'Estimate time required for each PM activity', TAB_BETA: 'Define β', BETA_TITLE: 'Define β', BETA_DESC: 'Set sensitivity of CM/failures on PM frequency for each activity', RE_GENERATE: 'Re-Generate', CHECKLIST_CONFIG: 'PM Checklist Configuration', CONFIG_CHECKLIST_FOR: 'Configuring checklist for:', ROOTY_CANNED_1: 'Lendo a lista de verificação...', ROOTY_CANNED_2: 'Analisando atividades de PM...', ROOTY_CANNED_3: 'Preparando sugestões...' },
			PM_APPLY: { TITLE: 'PM Checklist Template Library', STEP_1: 'Select Template', STEP_2: 'Select Equipment', STEP_1_DESC: 'Select a pre-built PM Checklist template to apply to your equipment. Templates contain configured pm activities sequences from best practices.', EMPTY: 'No Templates found.', CONFIG_FOR: 'Configured PM Template for', EXEC_SUCCESS: 'executing across interval boundaries successfully.', PM_ACTIVITIES: 'PM Activities', INTERVAL: 'Interval:', APPLIES_TO: 'Applies to:', EQ_TITLE: 'Select Equipment to Apply Template', EQ_SELECTED: 'Equipments Selected', SELECT_TEMPLATE: 'Select Template', APPLY_TEMPLATE: 'Apply Template' },
			CM: { TITLE: 'CM Configuration', CONFIG_FOR: 'Configuring CM activities for:', SELECT_HOW: 'Select how you want to configure CM activities', APPLY_TEMPLATE: 'Apply template', UPLOAD_TEMPLATE: 'Upload Template', DOWNLOAD_TEMPLATE: 'Download Template', CM_VARS: 'CM Level Variables', EQ_REDUNDANCY: 'Equipment Redundancy', PROD_LOSS: 'Production Loss', TECH_COUNT: '# of Technicians Needed', HELP_COUNT: '# of Helpers Needed', COST_CONS: 'Cost of Consumables (if any)', SPARES_COST: 'Consider Spares Cost', YES: 'Sim', NO: 'Não', LABOUR_VARS: 'Labour Variables', WRENCH_TIME_VARS: 'Wrench Time Variables', WRENCH_WARNING: 'Breakdown durations may include wait time — wrench time estimates preferred over duration-based values', COL_FAILURE_MODE: 'Failure Mode', COL_ACTIVITY: 'Activity', COL_CM_COUNT: 'CM Count', COL_WRENCH_TIME: 'Est. Wrench Time (hrs)', COL_CONFIDENCE: 'Confidence', COL_OVERRIDE: 'Override (hrs)' },
			FM: { TITLE: 'Failure Modes Configuration', CONFIG_FOR: 'Configuring Failure modes for:', SELECT_HOW: 'Select how you want to configure Failure Modes', SAVED_CONF: 'Saved Configuration', RCM_ANALYSIS: 'RCM Analysis', APPLY_LIB: 'Apply from Template Library', APPLY_LIB_DESC: 'Use pre-built failure mode templates for your equipment class', APPLY_LIB_AVAIL: 'Template available: ACW Pump Template', UPLOAD_RCM: 'Upload Previous RCM Analysis', UPLOAD_RCM_DESC: 'Import failure modes from an existing RCM study file (Excel/CSV)', NEW_STUDY: 'Create New FMEA Study', NEW_STUDY_DESC: 'Start a new FMEA using the guided study wizard', APPLY_TEMPLATE: 'Apply template', CREATE_ROOTY: 'Create via ROOTY', UPLOAD_EXCEL: 'Upload from Excel', DOWNLOAD_TEMPLATE: 'Download template', COL_FM_ID: 'FM ID', COL_SUBSYSTEM: 'Subsystem', COL_COMPONENT: 'Componente', COL_FUNCTION: 'Function', COL_FUNC_FAIL: 'Functional Failure', COL_FAILURE_MODE: 'Failure Mode', COL_CONSEQUENCE_CAT: 'Consequence Category', COL_FAILURE_BEHAVIOR: 'Failure Behavior', COL_PDM_APPLICABILITY: 'PdM Applicability', COL_LIKELY_CAUSES: 'Likely Causes', COL_SYMPTOMS: 'Symptoms / Indicators', COL_LOCAL_EFFECTS: 'Local Effects', COL_SYSTEM_EFFECTS: 'System Effects', COL_PLANT_EFFECTS: 'Plant Effects', COL_EFFECTS: 'Effects', COL_IMPACTS: 'Impacts', COL_EFFECT: 'Effect', COL_TYPE: 'Tipo', COL_STATUS: 'Estado', COL_EVIDENCES: 'Evidences', COL_TOTAL_COST: 'Total Cost', COL_CATEGORY: 'Categoria', COF_RATING: 'CoF Rating', COF_CATEGORY: 'CoF Category', COST_SUMMARY: 'Cost Summary', REPAIR_COST: 'Repair Cost (in USD)', SAFETY_RISK_COST: 'Safety Risk Cost (in USD)', PROD_LOSS: 'Production Loss (in USD)', OUTAGE_DURATION: 'Outage Duration (in Hours)', TOTAL_COST_USD: 'Total Cost (in USD)', CONSEQUENCE_RATING: 'Consequence Rating', SAFETY: 'Safety', OPERATIONAL: 'Operational', ENVIRONMENTAL: 'Environmental', REPUTATIONAL: 'Reputational', CLASSIFICATION_HIDDEN: 'Classification: Hidden Failure', SUPPORTING_EVIDENCE: 'Supporting Evidence', VIEW_EVIDENCE: 'View Full Evidence panel', NO_FM_FOUND: 'No Failure Modes config found...', EXPAND_ADDITIONAL_INFO: 'Additional Information', PERF_STANDARD: 'Performance Standard', FM_ANCHOR_LEVEL: 'FM Anchor Level', FM_TYPE: 'FM Type', SYMPTOM_CHILDREN: 'Symptom Children', CURRENT_CONTROLS: 'Current Controls', EVIDENCE_SOURCE: 'Evidence Source', WO_EVIDENCE_REFS: 'WO Evidence References', VALIDATION_OUTCOME: 'Validation Outcome', UNVALIDATED_JUSTIFICATION: 'Unvalidated Justification', CONFIDENCE: 'Confidence', PF_INTERVAL: 'P-F Interval Estimate' },
			EDITOR: {
				SAVING: 'Salvando...',
				SAVE_TEMPLATE: 'Salvar Modelo',
				SAVE_ACTIVITY: 'Salvar Atividade',
				SAVE_PACKAGE: 'Salvar Pacote de Equipamento',
				CREATE_TEMPLATE: 'Criar Modelo',
				EMPTY_TEMPLATE: 'Modelo Vazio',
				CREATE_VIA_ROOTY: 'Criar via Rooty',
				SAVE_CONTINUE: 'Guardar e continuar',
				SAVE_TO_CONFIGURE: 'Guarde o modelo para começar a configurar PM, FMEA e CM.',
				DOWNLOAD: 'Download Template',
				UPLOAD: 'Upload Template',
				PM_CHECKLIST: 'Checklist de PM',
				FMEA_CONFIG: 'Configuração de Modos de Falha',
				CM_CHECKLIST: 'Checklist de CM (Em breve)',
				DESC: 'Descrição',
				TEMPLATE_NAME: 'Template Name',
				OVERALL_PM_VARS: 'Variáveis Gerais de Nível de PM',
				SAVE_PM_ACTIVITY: 'Salvar Atividade de PM',
				SAVE_FMEA_CONFIG: 'Salvar Configuração FMEA',
				SAVE_CM_CONFIG: 'Salvar Configuração de CM',
				RE_GENERATE: 'Regerar',
				SAVED_INTERNALLY: 'salvo internamente com sucesso:',
				DEFINE_PM: 'Definir Checklist de PM',
				DEFINE_FM: 'Definir Configuração FMEA',
				DEFINE_CM: 'Definir Configuração de CM',
				DEFINE_WRENCH_TIME: 'Definir Variáveis de Tempo de Chave',
				DEFINE_DESC: 'Baixe um exemplo ou envie um modelo preenchido para gerar.',
				NO_PM_ATTACHED: 'Nenhuma configuração de PM anexada',
				NO_FM_ATTACHED: 'Nenhuma Configuração de Modos de Falha anexada',
				NO_CM_ATTACHED: 'Nenhuma configuração de CM anexada',
				PM_CONFIG_TAB: 'Configuração de PM',
				FM_CONFIG_TAB: 'Configuração FMEA',
				CM_CONFIG_TAB: 'Configuração de CM',
				PM_FM_MAPPING_TAB: 'Mapeamento PM -> FM',
				DEFINE_PM_FM: 'Definir Mapeamento PM-FM',
				DEFINE_PM_FM_DESC: 'Configure quais atividades de PM mitigam os modos de falha deste equipamento.',
				PM_FM_MAPPING_MATRIX: 'Matriz de Mapeamento PM-FM',
				PM_FM_MAPPING_SUBHEADER: 'Configure quais atividades de PM mitigam os modos de falha para {{equipment}}',
				PM_FM_SEARCH_PM: 'Pesquisar Atividade de PM...',
				PM_FM_SHOW_ALL: 'Mostrar Todos',
				PM_FM_SHOW_MAPPED: 'Mapeados',
				PM_FM_SHOW_UNMAPPED: 'Não Mapeados',
				PM_FM_SHOW_ZERO_COVERAGE: 'Cobertura Zero',
				PM_FM_LEGEND_FULL: '1 = Totalmente mapeado',
				PM_FM_LEGEND_PARTIAL: '0.1-0.9 = Relação parcial',
				PM_FM_LEGEND_EMPTY: 'Vazio = Não mapeado',
				PM_FM_CONFIRM_ALL: 'Confirmar Todos os Restantes',
				PM_FM_CONFIRM_ROW: 'Confirmar Mapeamento',
				PM_FM_UNMAP: 'Remover Mapeamento',
				PM_FM_NO_PM_ATTACHED: 'Nenhuma atividade de PM configurada',
				PM_FM_NO_FM_ATTACHED: 'Nenhum modo de falha configurado',
				PM_FM_STALE_BANNER: 'O PM ou a FMEA foi alterado desde que este mapeamento foi gerado. Atividades novas ou alteradas aparecem sem mapeamento abaixo — mapeie-as diretamente, ou use Regerar para que o Rooty reanalise tudo do zero (isso substituirá os mapeamentos já revisados).',
				PM_FM_REGENERATE: 'Regerar',
				PM_FM_UNMAPPED_COUNT: '{{count}} sem mapeamento',
				PM_FM_ZERO_COVERAGE_HEADING: 'Modos de Falha com Cobertura Zero',
				PM_FM_NEW_PM_PROPOSALS: 'Novas Propostas de PM',
				PM_FM_ACCEPT_PROPOSAL: 'Aceitar Proposta'
			}
		},
		CONFIGURATION: {
			CASES: {
				TITLE: 'Configuração de casos',
				LAST_UPDATED_BY: 'Última atualização por {{name}} - {{date}}',
				MATRIX_TITLE: 'Matriz de probabilidade e impacto',
				MATRIX_SUBTITLE: '(constante M1 — utilizável em cálculos)',
				VALUE_INPUT_TITLE: 'Entrada de valores',
				VALUE_INPUT_SUBTITLE: '(valores que os usuários podem inserir nos campos de valor para um caso)',
				CALCULATIONS_TITLE: 'Cálculos',
				CALCULATIONS_SUBTITLE: '(cálculos de valor configurados pelo usuário dentro de um caso)',
				OPTIONAL_TITLE: 'Opcional',
				OPTIONAL_SUBTITLE: '(campos adicionais que podem ser adicionados a um caso para fins de rastreamento)',
				COL_CONSTANT: 'Constante',
				COL_UNIT_FIELD: 'Campo de unidade',
				COL_FIELD_UOM: 'UoM do campo',
				COL_DEFAULT_VALUE: 'Valor por padrão',
				COL_ACTIONS: 'Ações',
				COL_CALCULATION: 'Cálculo',
				COL_UOM: 'UoM',
				COL_FORMULA: 'Fórmula',
				COL_FIELD: 'Campo',
				COL_VALUE: 'Valor',
				COL_UNIT_OF_MEASURE: 'Unidade de medida',
				ADD: 'Adicionar',
				ADD_ROW: 'Adicionar linha',
				CANCEL: 'Cancelar',
				SAVE: 'Salvar',
				SAVE_SUCCESS: 'Configuração de casos salva com sucesso',
				IMPACT: 'IMPACTO',
				LIKELIHOOD: 'PROBABILIDADE',
				DELETE_ROW: 'Excluir linha',
				PLACEHOLDER_UNIT_FIELD: 'Inserir campo de unidade',
				PLACEHOLDER_FIELD_UOM: 'Inserir UoM do campo',
				PLACEHOLDER_DEFAULT_VALUE: 'Inserir valor padrão',
				PLACEHOLDER_CALCULATION: 'Inserir nome do cálculo',
				PLACEHOLDER_UOM: 'Inserir UoM',
				PLACEHOLDER_FORMULA: 'Inserir fórmula',
				PLACEHOLDER_FIELD_NAME: 'Inserir nome do campo',
				DUPLICATE_FIELD_NAME: 'O nome do campo deve ser único',
				PLACEHOLDER_VALUE: 'Inserir valor',
				PLACEHOLDER_UNIT_OF_MEASURE: 'Inserir unidade de medida',
				RESET_TO_DEFAULTS: 'Restaurar padrões',
				RESET_MATRIX_CONFIRM_TITLE: 'Restaurar para o padrão?',
				RESET_MATRIX_CONFIRM_DESC: 'Isso irá redefinir a <strong>Matriz de Probabilidade e Impacto</strong> para seus valores padrão originais. Quaisquer alterações personalizadas feitas serão perdidas.',
				RESET_MATRIX_CONFIRM_OK: 'Confirmar',
				LOAD_ERROR: 'Falha ao carregar a configuração de casos',
				SAVE_ERROR: 'Falha ao salvar a configuração de casos',
				RESET_ERROR: 'Falha ao restaurar a configuração de casos',
				CONSTANT_USED_IN_FORMULA: 'Esta constante foi usada em uma fórmula',
				FORMULA: {
					UNDEFINED_CONSTANT: 'A constante "{{constant}}" não está definida',
					INVALID_CHARACTER: 'A fórmula contém um caractere ou operador não suportado',
					UNBALANCED_PARENTHESES: 'A fórmula tem parênteses desbalanceados',
					EMPTY_PARENTHESES: 'A fórmula tem parênteses vazios',
					MISSING_OPERATOR: 'Falta um operador entre valores na fórmula',
					INVALID_OPERATOR_POSITION: 'A fórmula tem um operador em uma posição inválida',
					TRAILING_OPERATOR: 'A fórmula não pode terminar com um operador'
				}
			},
			FILTER: {
				TITLE: 'Filters',
				SEARCH: 'Pesquisar'
			},
			ASSET_TEMPLATE: {
				TITLE: 'Asset Template list',
				SEARCH: 'Pesquisar',
				TOOLTIP_ADD: 'Add New Asset',
				TOOLTIP_DELETE: 'Delete Asset',
				TOOLTIP_SYNC: 'Sincronizar',
				TOOLTIP_SYNC_PROGRESS: 'Sincronização em andamento',
				SYNC_STARTED_TOAST: 'Sincronização do modelo de ativo iniciada.',
				SYNC_COMPLETED_TOAST: 'Sincronização do modelo de ativo concluída.',
				SYNC_FAILED_TOAST: 'Falha na sincronização do modelo de ativo{{errorSuffix}}.',
				COL_INDEX: 'Sl. No.',
				COL_TEMPLATE_NAME: 'Nome do Modelo',
				COL_APPLICATION: 'Application',
				COL_CREATED_ON: 'Created On',
				COL_ACTIONS: 'Ações',
				NO_RECORDS: 'Nenhum registro encontrado',
				LOADING: 'Loading...'
			},
			TAGS: {
				TOOLTIP_UPLOAD_SCADA: 'Enviar Mapeamento de Tag SCADA',
				TITLE: 'Tag list',
				SEARCH: 'Pesquisar',
				TOOLTIP_ADD: 'Add New Tag',
				TOOLTIP_UPLOAD: 'Upload Tags',
				TOOLTIP_DOWNLOAD: 'Download Tag List',
				TOOLTIP_TAG_MAPPING: 'Visitar para Mapeamento de Tag',
				TOOLTIP_DELETE: 'Delete Tag',
				TOOLTIP_NO_FAILURE_MODES: 'Nenhum Modo de Falha Associado',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				COL_INDEX: 'Sl. No.',
				COL_NAME: 'Nome',
				COL_TAG_ID: 'Tag Id',
				COL_SHARED: 'Shared',
				COL_UNIT: 'Unidade',
				COL_FAILURE_MODES: 'Failure Mode(s)',
				COL_MODELLING: 'Usado para Modelagem',
				COL_CALCULATED: 'Calculated',
				COL_DESCRIPTION: 'Descrição',
				COL_ASSET: 'Ativo',
				COL_ACTIONS: 'Ações',
				NO_TAGS: 'No tags found'
			},
			FAILURE_MODE: {
				TITLE: 'Failure Mode list',
				SEARCH: 'Pesquisar',
				TOOLTIP_UPLOAD: 'Upload Failure Modes',
				TOOLTIP_ADD: 'Add New Failure Mode',
				TOOLTIP_EDIT: 'Edit Failure Mode',
				TOOLTIP_FILTER: 'Filtrar',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_EDIT_DIRECTIONALITY: 'Editar Direcionalidade da Tag',
				COL_INDEX: 'Sl. No.',
				COL_NAME: 'Nome',
				COL_DESCRIPTION: 'Descrição',
				COL_TAG: 'Tag',
				COL_ASSET: 'Ativo',
				COL_RECOMMENDATIONS: 'Recommendations',
				COL_ACTIONS: 'Ações',
				NO_RECORDS: 'Nenhum registro encontrado'
			},
			DIGITIZATION: {
				TITLE: 'Digitization list',
				SEARCH: 'Pesquisar',
				TOOLTIP_ADD: 'Add new digitalization',
				TOOLTIP_DELETE: 'Delete Digitization',
				COL_INDEX: 'Sl. No.',
				COL_MANUFACTURER: 'Fabricante',
				COL_MODEL: 'Model',
				COL_INDUSTRY_TYPE: 'Tipo de Indústria',
				COL_MODIFIED_ON: 'Modificado em',
				COL_CREATED_ON: 'Created On',
				NO_RECORDS: 'Nenhum registro encontrado'
			},
			TABS: {
				ASSET_TEMPLATE: 'Modelo de Ativo',
				ASSETS: 'Assets',
				DIGITIZATION: 'Digitalização',
				SETTINGS: 'Configurações',
				CASES: 'Casos'
			},
			SETTINGS: {
				TITLE: 'Update Settings',
				COL_INDEX: '#',
				COL_PAGE_NAME: 'Nome da Página',
				COL_LAST_UPDATED: 'Last Updated',
				COL_UPDATED_BY: 'Atualizado por',
				TOOLTIP_SETTINGS: 'Configurações',
				LOADING: 'Loading settings...',
				NO_SETTINGS: 'Nenhuma configuração encontrada'
			},
			ASSETS: {
				TITLE: 'Assets list',
				SEARCH: 'Pesquisar',
				TOOLTIP_FILTER: 'Filtrar Ativo',
				TOOLTIP_DELETE: 'Delete Asset',
				TOOLTIP_VIEW_CHANGES: 'Ver Alterações',
				COL_INDEX: 'Sl. No.',
				COL_NAME: 'Asset Name',
				COL_TYPE: 'Tipo de Ativo',
				COL_UNIT: 'Unidade',
				COL_SYSTEM: 'Sistema',
				COL_APPLICATION: 'Aplicação',
				COL_CONFIGURATION: 'Configuração',
				COL_INDUSTRY: 'Industry',
				COL_AUTHOR: 'Autor',
				COL_MAKE_MODEL: 'Marca e Modelo',
				COL_MAINTENANCE: 'Dados de Manutenção',
				NO_RECORDS: 'Nenhum registro encontrado'
			},
			FM_MAPPING_MENU: {
				HIGH: 'Alto',
				LOW: 'Baixo',
				STABLE: 'Estável',
				REFERENCE: 'Referência',
				UNMAPPED: 'Não Mapeado',
				TOOLTIP_HIGH_PRIMARY: 'Alto - Modo de Falha Primário',
				TOOLTIP_HIGH_SECONDARY: 'Alto - Modo de Falha Secundário',
				TOOLTIP_LOW_PRIMARY: 'Baixo - Modo de Falha Primário',
				TOOLTIP_LOW_SECONDARY: 'Baixo - Modo de Falha Secundário',
				TOOLTIP_STABLE_PRIMARY: 'Estável - Modo de Falha Primário',
				TOOLTIP_STABLE_SECONDARY: 'Estável - Modo de Falha Secundário',
				TOOLTIP_REFERENCE: 'Modo de Falha de Referência',
				FM_LOGIC: 'Lógica do Modo de Falha',
				HIGH_INCREASING: 'Alto/Crescente',
				LOW_DECREASING: 'Baixo/Decrescente',
				RULE_BASED: 'Baseado em Regra',
				UNMAP: 'Desvincular',
				RULE_BASED_CONDITION: 'Condição Baseada em Regra',
				OPERATOR: 'Operador',
				COMPARE_TO: 'Comparar Com',
				ENTER_VALUE: 'Inserir Valor',
				NUMERIC_INPUT_ONLY: 'Somente entrada numérica',
				PREFERENCE: 'Preferência',
				APPLY: 'Aplicar'
			},
			QUICK_FILTER: {
				CLOSE: 'Fechar',
			},
			DIGITIZATION_POPUP: {
				FORM_ERROR: 'Oh snap! Manufacturer and Model Name already taken. Change a few things up and try submitting again.',
				MANUFACTURER: 'Fabricante',
				MANUFACTURER_NAME: 'Nome do Fabricante',
				MODEL: 'Modelo',
				MODEL_NAME: 'Nome do Modelo',
				INDUSTRY_TYPE: 'Tipo de Indústria',
				ENTER: 'Enter',
				SELECT: 'Select',
				IS: 'is',
				CUT_IN_SPEED: 'Velocidade de Entrada(m/s)',
				CUT_IN_SPEED_LABEL: 'Velocidade de Entrada',
				CUT_OFF_SPEED: 'Velocidade de Corte(m/s)',
				CUT_OFF_SPEED_LABEL: 'Velocidade de Corte',
				CAPACITY_KWH: 'Insira o valor em KWH',
				CAPACITY: 'Capacity',
				IS_REQUIRED: 'é obrigatório',
				SMALLER_THAN_CUTOFF: 'deve ser menor que a velocidade de corte',
				GREATER_THAN_CUTIN: 'deve ser maior que a velocidade de entrada',
				GREATER_THAN_ZERO: 'deve ser maior que 0',
				POWER_CURVE: 'Curva de Potência',
				REQUIRED: 'Obrigatório',
				UPLOAD_POWER_CURVE: 'Enviar Curva de Potência',
				DOWNLOAD_SAMPLE: 'Baixar Exemplo/Arquivo Enviado Anteriormente',
				VIEW_POWER_CURVE: 'Ver Dados da Curva de Potência Enviada',
				ERROR_CODE_MAP: 'Mapa de Código de Erro',
				UPLOAD_SCADA: 'Enviar Código de Evento SCADA',
				VIEW_SCADA: 'Ver Dados de Código de Evento SCADA Enviados',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			FAILURE_MODE_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				NAME: 'Nome',
				IS: 'is',
				PRIORITY: 'Prioridade',
				REQUIRED: 'Obrigatório',
				START_TIME: 'Start Time (in hrs)',
				START_TIME_LABEL: 'Start Time',
				END_TIME: 'End Time (in hrs)',
				END_TIME_LABEL: 'End Time',
				IS_REQUIRED: 'é obrigatório',
				TIME_RANGE: 'o intervalo deve estar entre 0,1 e 48 horas',
				DESCRIPTION: 'Descrição',
				RELIABILITY_SAVINGS: 'Reliability Savings (Potential)',
				MAINTENANCE_SAVINGS: 'Maintenance Savings (Potential)',
				PERFORMANCE_SAVINGS: 'Performance Savings (Potential)',
				REMARK: 'Remark',
				REMARK_TO_EDIT: 'Remark to Edit',
				ENTER: 'Enter',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			TAG_DIRECTIONALITY_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				TAG_NAME: 'Tag Name',
				DIRECTIONALITY: 'Directionality',
				SELECT: 'Select',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			FM_RECOMMENDATION_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				RECOMMENDATION: 'Recommendation',
				IS: 'is',
				CATEGORY: 'Categoria',
				SELECT: 'Select',
				SELECT_FAILURE: 'Select Failure',
				FAILURE: 'Failure',
				REMARK: 'Remark',
				REMARK_TO_EDIT: 'Remark to Edit',
				ENTER: 'Enter',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			TAGS_POPUP: {
				FORECASTING: 'Previsão',
				PERFORMANCE_DEGRADATION: 'Degradação de Desempenho',
				PERFORMANCE_DEGRADATION_HINT: '(Ativar a previsão de tempo até a intervenção para esta tag)',
				DYNAMIC_DEVIATION_THRESHOLD: 'Limite de Desvio Dinâmico',
				DEVIATION_LOW: 'Baixo',
				DEVIATION_MEDIUM: 'Médio',
				DEVIATION_HIGH: 'Alto',
				ERRATIC_DETECTION: 'Detecção errática',
				ERRATIC_ALERT: 'Alerta errático',
				MISSING_DATA_DETECTION: 'Detecção de dados ausentes',
				OUTLIER_DETECTION: 'Detecção de valores atípicos',
				OUT_OF_RANGE_DETECTION: 'Detecção de fora de faixa',
				DATA_QUALITY_ALERT_GENERATION: 'GERAÇÃO DE ALERTA DE QUALIDADE DE DADOS',
				DATA_QUALITY_ALERT_DESC: 'Escolha quais problemas de DQ detectados devem gerar alertas. Desativar a geração de alertas não interrompe o cálculo de DQ. Os valores ainda aparecerão nas tabelas de DQ.',
				FLATLINE_ALERT: 'Alerta de estagnação',
				MISSING_DATA_ALERT: 'Alerta de dados ausentes',
				OUTLIER_ALERT: 'Alerta de valor atípico',
				OUT_OF_RANGE_ALERT: 'Alerta de fora de faixa',
				ALERTS_NOTIFICATIONS_KPI: 'Alertas, notificações e KPI',
				OPERATIONAL_LIMITS: 'Limites operacionais',
				ADDITIONAL_SETTINGS: 'Configurações Adicionais',
				NO_TAGS_WITH_TAGID_MAPPED: 'Nenhum Tag mapeado encontrado.',
				FUNCTION_NAME: 'Nome da Função',
				DATA_QUALITY_DETECTION: 'Detecção de qualidade de dados',
				SELECT_TAG_TO_ADD_MORE: 'Selecione a primeira tag para habilitar a adição de mais tags',
				ENTER_FORMULA: 'Inserir Fórmula*',
				LOWER: 'Lower',
				UPPER: 'Upper',
				START: 'Iniciar',
				END: 'Fim',
				DEADLINE: 'Prazo',
				FORMULA_PLACEHOLDER: 'Write the formula. e.g (t1+t2)*t3',
				SELECT_TAG: 'Select Tag',
				SELECT_KEY: 'Selecionar Chave',
				VALUE: 'Value',
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				TAG_NAME: 'Tag Name',
				DESCRIPTION: 'Descrição',
				TAG_ID: 'Id da Tag',
				UNIT: 'Unidade',
				INSTRUMENT_RANGE: 'Instrument Range',
				TRIP_LIMITS: 'Trip Limits',
				THRESHOLD_ALERT: 'Threshold Alert',
				THRESHOLD_ALERT_DELAY: 'Threshold Alert Delay',
				IOW_CRITICALITY: 'IOW Criticality',
				DIRECTIONALITY: 'Directionality',
				DIRECTION: 'Direction',
				FLATLINE_DETECTION: 'Flatline Detection',
				ATTENTION: 'Attention',
				THRESHOLD_NOTIFICATION: 'Threshold Notification',
				KPI: 'KPI',
				STRING_CURRENT: 'Corrente da String',
				STRING_CAPACITY: 'Capacidade da String',
				SCADA_ERROR_CODES: 'Códigos de Erro SCADA',
				COMMA_SEPARATED_ERROR_CODES: 'Adicione códigos de erro separados por vírgula',
				ASSET: 'Ativo',
				CALCULATED_FLAG: 'Calculated Flag',
				REMARK: 'Observação',
				REMARK_TO_EDIT: 'Observação para Editar',
				FUNCTION_TABLE: 'Tabela de Função',
				PARAMETERS: 'Parameters',
				CONSTANTS: 'Constants',
				PLOT_CONTINUOUS: 'Plotar como linha de tendência contínua (ignorar valores faltantes)',
				ENTER: 'Enter',
				SELECT: 'Select',
				WRITE_CUSTOM_CODE: 'Escrever Código Personalizado',
				UPLOAD_TAGS: 'Upload Tags',
				DOWNLOAD_CORRELATION_CSV: 'Baixar Formato CSV de Correlação',
				UPLOAD_CORRELATION_CSV: 'Enviar CSV de Correlação',
				DELETE: 'Eliminar',
				ADD: 'Adicionar',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes',
				ALARM_LIMITS: 'Limites de Alarme',
				THRESHOLD_LIMITS: 'Limites de Limiar',
				CORRELATION_CSV_UPLOAD_LABEL: 'Enviar CSV de Correlação',
				TRIAL_RUN: 'Execução de Teste',
				SELECT_PYTHON_FUNCTION: 'Selecionar Função Python',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Buscar funções...',
				NO_MATCHING_FUNCTION_FOUND: 'Nenhuma função correspondente encontrada',
				SELECT_FUNCTION_ERROR: 'Selecione uma função Python',
				DEPRECATED: 'Obsoleta',
				DEPRECATED_FORMULA_TOOLTIP: 'Esta fórmula está obsoleta. Selecione a fórmula atualizada.',
				DEPRECATED_FORMULA_ERROR: 'Esta fórmula está obsoleta. Selecione a fórmula atualizada.',
				CUSTOM_FORMULA_INVALID_VARS: 'Variável(is) inválida(s) utilizada(s)',
				CUSTOM_FORMULA_INVALID_SYNTAX: 'Variável(is)/expressão matemática inválida',
				CUSTOM_FORMULA_REQUIRED: 'A fórmula é obrigatória',
				SEARCH_ASSETS_PLACEHOLDER: 'Buscar ativos...',
				NO_MATCHING_ASSET_FOUND: 'Nenhum ativo correspondente encontrado',
				SEARCH_DOTS: 'Buscar...',
				NO_MATCHING_TAG_FOUND: 'Nenhuma tag correspondente encontrada',
				NO_TAGS_FOUND_WITH_TAGID_MAPPED: 'Nenhuma tag encontrada com TagId mapeada.',
				SEARCH_PLAIN: 'Buscar',
				NO_MATCHING_KEY_FOUND: 'Nenhuma chave correspondente encontrada',
				PARAMETER_NAME_HINT: 'Nome do Parâmetro',
				CONSTANT_NAME_HINT: 'Nome da Constante',
				DISPLAY_EXPRESSION: 'Expressão de Exibição',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Digite a expressão',
				EXPRESSION_DESCRIPTION: 'Descrição da Expressão',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Digite a descrição da expressão'
			},
			ASSET_TEMPLATE_DELETE: {
				TITLE: 'Asset Delete Confirmation',
				CONFIRM_MSG: 'Are you sure you want to delete the asset?',
				ASSOCIATED_ITEMS_MSG: 'Do you also want to delete the following items associated with the asset?',
				DELETE_TAGS: 'Delete Associated Tags',
				DELETE_FAILURE_MODES: 'Delete Associated Failure Modes',
				DELETING: 'Deleting...',
				CANCEL: 'Cancelar',
				DELETE: 'Eliminar'
			},
			FM_INFO: {
				TITLE: 'Failure Mode Information',
				TOOLTIP_ADD: 'Adicionar',
				TOOLTIP_EDIT: 'Editar',
				TOOLTIP_UPLOAD: 'Carregar',
				TOOLTIP_DOWNLOAD: 'Transferir',
				TOOLTIP_EDIT_MAPPING: 'Edit Mapping',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				UPLOAD_FAILURE_MODES: 'Upload Failure Modes',
				UPLOAD_FM_TAG_MAPPINGS: 'Upload Failure-to-Tag Mappings',
				DOWNLOAD_FAILURE_MODES: 'Download Failure Modes',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Download Failure-to-Tag Mappings',
				COL_FAILURE_MODE: 'Failure mode',
				COL_START_TIME: 'Start Time',
				COL_END_TIME: 'End Time',
				COL_PRIORITY: 'Prioridade',
				COL_ACTIONS: 'Ações',
				PRIORITY_DESCRIPTION: 'Impact priority description',
				NO_RECORDS: 'No Failure Mode Information'
			},
			RECOMMENDATIONS: {
				TITLE: 'Recommendations',
				TOOLTIP_ADD: 'Adicionar',
				TOOLTIP_EDIT: 'Editar',
				TOOLTIP_UPLOAD: 'Carregar',
				TOOLTIP_DOWNLOAD: 'Transferir',
				TOOLTIP_EDIT_MAPPING: 'Edit Mechanisms to Recommendations Mapping',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_VIEW_CHANGES: 'Ver Alterações',
				UPLOAD_RECOMMENDATIONS: 'Upload Recommendations',
				UPLOAD_REC_FM_MAPPINGS: 'Upload Recommendation-to-FM Mappings',
				DOWNLOAD_RECOMMENDATIONS: 'Download Recommendations',
				DOWNLOAD_REC_FM_MAPPINGS: 'Download Recommendation-to-FM Mappings',
				COL_RECOMMENDATIONS: 'Recommendations',
				COL_CATEGORY: 'Categoria',
				NO_RECORDS: 'No Recommendations'
			},
			ASSET_TEMPLATE_SYNC: {
				SYNC_MSG: 'As seguintes alterações foram feitas no Modelo de Ativo. Verifique e decida se elas devem ser sincronizadas com os Ativos criados usando este modelo.',
				ASSETS: 'Assets',
				SELECT_ALL: 'Selecionar tudo',
				TAGS: 'Tags',
				FAILURES: 'Falhas',
				RECOMMENDATIONS: 'Recomendações',
				CLOSE_TOOLTIP: 'Fechar Popup',
				CANCEL: 'Fechar',
				DONT_SYNC: 'Não Sincronizar',
				DONT_SYNC_TOOLTIP: 'Não sincronizar alterações',
				SYNC: 'Sincronizar',
				SYNC_TOOLTIP: 'Sincronizar alterações'
			},
			TAG_TEMPLATE_LIST: {
				TITLE: 'Tag list',
				SEARCH: 'Pesquisar',
				TOOLTIP_SEARCH: 'Pesquisar',
				TOOLTIP_ADD: 'Add New Tag',
				TOOLTIP_UPLOAD: 'Upload Tags',
				TOOLTIP_DOWNLOAD: 'Download Tag List',
				TOOLTIP_CLONE: 'Clonar Tag',
				TOOLTIP_DELETE: 'Delete Tag',
				TOOLTIP_VIEW_CHANGES: 'Ver Alterações',
				COL_INDEX: 'Nº',
				COL_TAG_TYPE: 'Tipo de Tag',
				COL_NAME: 'Nome',
				COL_DESCRIPTION: 'Tag Description',
				COL_UNIT: 'Unidade',
				COL_FAILURE_MODES: 'Modo(s) de Falha',
				COL_DIRECTIONALITY: 'Directionality',
				COL_CALCULATED: 'Calculado',
				COL_ACTIONS: 'Ações',
				NO_RECORDS: 'Nenhum registro encontrado',
				TOOLTIP_NO_FM: 'Nenhum Modo de Falha Associado',
				LOADING: 'Loading...'
			},
			SUBSYSTEMS: {
				TITLE: 'Subsystems',
				SEARCH: 'Pesquisar'
			},
			ASSET_TEMPLATE_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				NAME: 'Nome',
				IS: 'is',
				ALREADY_TAKEN: 'Já utilizado',
				TEMPLATE_NAME: 'Nome do Modelo',
				APPLICATION: 'Aplicação',
				TEMPLATE_APPLICATION: 'Aplicação do Modelo',
				PLEASE_ENTER: 'Por favor, insira',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			ASSETS_FM_INFO: {
				TITLE: 'Failure Mode Information',
				TOOLTIP_ADD: 'Adicionar',
				TOOLTIP_EDIT: 'Editar',
				TOOLTIP_UPLOAD: 'Carregar',
				TOOLTIP_DOWNLOAD: 'Transferir',
				TOOLTIP_EDIT_MAPPING: 'Edit Tag to Mechanisms',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_VIEW_CHANGES: 'View Changes',
				UPLOAD_FAILURE_MODES: 'Enviar Modos de Falha',
				UPLOAD_FM_TAG_MAPPINGS: 'Enviar Mapeamentos de Falha-para-Tag',
				DOWNLOAD_FAILURE_MODES: 'Baixar Modos de Falha',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Baixar Mapeamentos de Falha-para-Tag',
				COL_STATUS: 'Estado',
				COL_FAILURE_MODE: 'Modo de Falha',
				COL_PRIORITY: 'Prioridade',
				COL_START_TIME: 'Hora de Início',
				COL_END_TIME: 'Hora de Término',
				COL_ACTIONS: 'Ações',
				PRIORITY_DESCRIPTION: 'Descrição da prioridade de impacto',
				NO_RECORDS: 'No Failure Mode Information'
			},
			TAG_FM_POPUP: {
				TITLE: 'Tag to Mechanisms',
				TAG_NAME: 'Tag Name',
				SEARCH_TAG: 'Search Tag',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			ASSETS_RECOMMENDATIONS: {
				TITLE: 'Recommendations',
				TOOLTIP_ADD: 'Adicionar',
				TOOLTIP_EDIT: 'Editar',
				TOOLTIP_UPLOAD: 'Carregar',
				TOOLTIP_DOWNLOAD: 'Transferir',
				TOOLTIP_EDIT_MAPPING: 'Editar Mapeamento de Mecanismos para Recomendações',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_VIEW_CHANGES: 'Ver Alterações',
				UPLOAD_RECOMMENDATIONS: 'Enviar Recomendações',
				UPLOAD_REC_FM_MAPPINGS: 'Enviar Mapeamentos de Recomendação-para-Modo de Falha',
				DOWNLOAD_RECOMMENDATIONS: 'Baixar Recomendações',
				DOWNLOAD_REC_FM_MAPPINGS: 'Baixar Mapeamentos de Recomendação-para-Modo de Falha',
				COL_RECOMMENDATIONS: 'Recomendações',
				COL_CATEGORY: 'Categoria',
				COL_ACTIONS: 'Ações',
				NO_RECORDS: 'No Recommendations'
			},
			REC_FM_POPUP: {
				TITLE: 'Mechanisms to Recommendations',
				RECOMMENDATION: 'Recommendation',
				CATEGORY: 'Categoria',
				OFFLINE: 'Offline',
				ONLINE: 'Online',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			ASSET_DELETE: {
				TITLE: 'Asset Delete Confirmation',
				CONFIRM_MSG: 'Tem certeza de que deseja excluir o ativo?',
				ASSOCIATED_ITEMS_MSG: 'Você também deseja excluir os seguintes itens associados ao ativo?',
				DELETE_TAGS: 'Excluir Tags Associadas',
				DELETE_FAILURE_MODES: 'Excluir Modos de Falha Associados',
				DELETING: 'Excluindo...',
				CANCEL: 'Cancelar',
				DELETE: 'Eliminar'
			},
			ASSET_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				ASSET_NAME: 'Nome do Ativo',
				ASSET_MODEL: 'Modelo do Ativo',
				ASSET_ID: 'Id do Ativo',
				DEPLOYED_DATE: 'Data de Implantação',
				SYSTEM: 'Sistema',
				MAINTENANCE_DATA: 'Dados de Manutenção',
				PROVIDER_DATA: 'Dados do Provedor',
				ENTER: 'Enter',
				SELECT: 'Select',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			NAME_MAPPING: {
				TITLE_TAG_FM: 'Upload de Tag para Mecanismos',
				TITLE_REC_FM: 'Upload de Recomendação para Mecanismos',
				TAG_NAME_MAPPING: 'Tag Name Mapping',
				REC_NAME_MAPPING: 'Mapeamento de Nome de Recomendação',
				TAG_NAME: 'Tag Name',
				RECOMMENDATION_NAME: 'Nome da Recomendação',
				TAG_NAME_OPTIONS: 'Tag Name Options',
				REC_NAME_OPTIONS: 'Opções de Nome de Recomendação',
				OPTIONS_PLACEHOLDER: 'Opções',
				NO_TAG_SUGGESTIONS: 'Nenhuma sugestão encontrada. Esta tag não será usada no mapeamento final.',
				TAG_DELETED_FROM_MAPPING: 'Tag removida do mapeamento',
				NO_REC_SUGGESTIONS: 'Nenhuma sugestão encontrada. Esta recomendação não será usada no mapeamento final.',
				REC_DELETED_FROM_MAPPING: 'Recomendação removida do mapeamento',
				FM_DELETED_FROM_MAPPING: 'Modo de falha removido do mapeamento',
				ACTIONS: 'Ações',
				FM_MAPPING: 'Failure Mode Mapping',
				FM_NAME: 'FailureMode Name',
				FM_OPTIONS: 'Failure Mode Options',
				TOOLTIP_CLEAR: 'Clear Selection',
				TOOLTIP_DELETE_TAG: 'Delete Tag',
				TOOLTIP_UNDO_TAG: 'Undo Tag delete',
				TOOLTIP_DELETE_FM: 'Delete Failure mode',
				TOOLTIP_UNDO_FM: 'Undo FailureMode delete',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			TAG_TEMPLATE_POPUP: {
				ERRATIC_DETECTION: 'Detecção errática',
				ERRATIC_ALERT: 'Alerta errático',
				MISSING_DATA_DETECTION: 'Detecção de dados ausentes',
				OUTLIER_DETECTION: 'Detecção de valores atípicos',
				OUT_OF_RANGE_DETECTION: 'Detecção de fora de faixa',
				DATA_QUALITY_ALERT_GENERATION: 'GERAÇÃO DE ALERTA DE QUALIDADE DE DADOS',
				DATA_QUALITY_ALERT_DESC: 'Escolha quais problemas de DQ detectados devem gerar alertas. Desativar a geração de alertas não interrompe o cálculo de DQ. Os valores ainda aparecerão nas tabelas de DQ.',
				FLATLINE_ALERT: 'Alerta de estagnação',
				MISSING_DATA_ALERT: 'Alerta de dados ausentes',
				OUTLIER_ALERT: 'Alerta de valor atípico',
				OUT_OF_RANGE_ALERT: 'Alerta de fora de faixa',
				ALERTS_AND_NOTIFICATIONS: 'Alertas e notificações',
				OPERATIONAL_LIMITS: 'Limites operacionais',
				DATA_QUALITY_DETECTION: 'Detecção de qualidade de dados',
				SELECT_TAG_TO_ADD_MORE: 'Selecione a primeira tag para habilitar a adição de mais tags',
				LOWER_RANGE: 'Faixa Inferior',
				UPPER_RANGE: 'Faixa Superior',
				LOWER: 'Inferior',
				UPPER: 'Superior',
				ALARM_LIMITS: 'Limites de Alarme',
				THRESHOLD_LIMITS: 'Limites de Limiar',
				START: 'Iniciar',
				END: 'Fim',
				FORMULA_PLACEHOLDER: 'Write the formula. e.g (t1+t2)*t3',
				SELECT_TAG: 'Select Tag',
				VALUE: 'Value',
				DELETE: 'Eliminar',
				ADD: 'Adicionar',
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				TAG_TYPE: 'Tipo de Tag',
				TAG_NAME: 'Tag Name',
				TAG_DESCRIPTION: 'Descrição da Tag',
				DESCRIPTION: 'Descrição',
				UNIT: 'Unidade',
				INSTRUMENT_RANGE: 'Instrument Range',
				TRIP_LIMITS: 'Limites de Trip',
				THRESHOLD_ALERT: 'Alerta de Limite',
				THRESHOLD_ALERT_DELAY: 'Atraso do Alerta de Limite',
				DESIGN_VALUE: 'Valor de Projeto',
				DIRECTIONALITY: 'Direcionalidade',
				DIRECTION: 'Direção',
				IOW_CRITICALITY: 'Criticidade IOW',
				FLATLINE_DETECTION: 'Detecção de Estagnação',
				ATTENTION: 'Atenção',
				THRESHOLD_NOTIFICATION: 'Notificação de Limite',
				CALCULATED_FLAG: 'Indicador Calculado',
				PARAMETERS: 'Parâmetros',
				CONSTANTS: 'Constantes',
				UPLOAD_TAGS: 'Enviar Tags',
				ENTER: 'Inserir',
				SELECT: 'Select',
				SELECT_PYTHON_FUNCTION: 'Selecionar Função Python',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Buscar funções...',
				NO_MATCHING_FUNCTION_FOUND: 'Nenhuma função correspondente encontrada',
				SELECT_FUNCTION_ERROR: 'Selecione uma função Python',
				SEARCH_TAG_TYPE_PLACEHOLDER: 'Buscar tipo de tag...',
				NO_MATCHING_TAG_TYPE_FOUND: 'Nenhum tipo de tag correspondente encontrado',
				SEARCH_DOTS: 'Buscar...',
				NO_MATCHING_TAG_FOUND: 'Nenhuma tag correspondente encontrada',
				PARAMETER_NAME_HINT: 'Nome do Parâmetro',
				CONSTANT_NAME_HINT: 'Nome da Constante',
				DISPLAY_EXPRESSION: 'Expressão de Exibição',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Digite a expressão',
				EXPRESSION_DESCRIPTION: 'Descrição da Expressão',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Digite a descrição da expressão',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			TEMPLATE_NAME_MAPPING: {
				TITLE: 'Tag to Mechanisms',
				TAG_NAME_MAPPING: 'Mapeamento de Nome de Tag',
				TAG_NAME: 'Nome da Tag',
				TAG_NAME_OPTIONS: 'Opções de Nome de Tag',
				OPTIONS_PLACEHOLDER: 'Opções',
				NO_TAG_SUGGESTIONS: 'Nenhuma sugestão encontrada. Esta tag não será usada no mapeamento final.',
				TAG_DELETED_FROM_MAPPING: 'Tag removida do mapeamento',
				FM_DELETED_FROM_MAPPING: 'Modo de falha removido do mapeamento',
				ACTIONS: 'Ações',
				FM_MAPPING: 'Mapeamento de Modo de Falha',
				FM_NAME: 'Nome do Modo de Falha',
				FM_OPTIONS: 'Opções de Modo de Falha',
				TOOLTIP_CLEAR: 'Limpar Seleção',
				TOOLTIP_DELETE_TAG: 'Excluir Tag',
				TOOLTIP_UNDO_TAG: 'Desfazer exclusão de Tag',
				TOOLTIP_DELETE_FM: 'Excluir Modo de Falha',
				TOOLTIP_UNDO_FM: 'Desfazer exclusão de Modo de Falha',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			FM_INFO_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				NAME: 'Nome',
				PRIORITY: 'Prioridade',
				START_TIME: 'Start Time (in hrs)',
				START_TIME_LABEL: 'Hora de Início',
				END_TIME: 'End Time (in hrs)',
				END_TIME_LABEL: 'Hora de Término',
				IS: 'is',
				REQUIRED: 'Obrigatório',
				DESCRIPTION: 'Descrição',
				RELIABILITY_SAVINGS: 'Economia de Confiabilidade (Potencial)',
				MAINTENANCE_SAVINGS: 'Economia de Manutenção (Potencial)',
				PERFORMANCE_SAVINGS: 'Economia de Desempenho (Potencial)',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			TAG_FM_INFO_POPUP: {
				TITLE: "Tag Template Failure Mode Mapper",
				TAG_NAME: "Tag Name",
				SEARCH_TAG: "Search Tag",
				NAME: "Name",
				TAG_ID: "Tag ID",
				CANCEL: "Cancel",
				CANCEL_TOOLTIP: "Cancel changes",
				SAVE: "Save",
				SAVE_TOOLTIP: "Save changes",
			},
			RECOMMENDATIONS_POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				RECOMMENDATION: 'Recommendation',
				IS: 'é',
				CATEGORY: 'Categoria',
				SELECT: 'Select',
				SELECT_FAILURE: 'Selecionar Falha',
				FAILURE: 'Falha',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			REC_TEMPLATE_FM_POPUP: {
				TITLE: 'Mechanisms to Recommendations',
				RECOMMENDATION: 'Recomendação',
				CATEGORY: 'Categoria',
				OFFLINE: 'Offline',
				ONLINE: 'Online',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			},
			SUBSYSTEM_TEMPLATE: {
				TITLE: 'Lista de Modelos de Subsistema',
				SEARCH: 'Pesquisar',
				TOOLTIP_ADD: 'Adicionar Novo Modelo de Subsistema',
				TOOLTIP_EDIT: 'Editar Modelo de Subsistema',
				TOOLTIP_DELETE: 'Excluir Modelo de Subsistema',
				COL_INDEX: 'Nº',
				COL_NAME: 'Nome',
				COL_DESCRIPTION: 'Descrição',
				COL_CREATED_ON: 'Criado em'
			},
			SUBSYSTEM_TEMPLATE_DELETE: {
				TITLE: 'Confirmação de Exclusão do Modelo de Subsistema',
				CONFIRM_MSG: 'Tem certeza de que deseja excluir o Modelo de Subsistema?',
				DELETING: 'Excluindo...',
				CANCEL: 'Cancelar',
				DELETE: 'Excluir'
			},
			SUBSYSTEM_TEMPLATE_POPUP: {
				ADD_TITLE: 'Adicionar Modelo de Subsistema',
				EDIT_TITLE_PREFIX: 'Editar Modelo de Subsistema',
				NAME: 'Nome',
				DESCRIPTION: 'Descrição',
				NAME_TAKEN_ERROR: 'Nome já está em uso',
				NAME_REQUIRED_ERROR: 'Nome é obrigatório',
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancel changes',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Save changes'
			}

		},
		ADVANCED_ANALYSIS: {
			TABS: {
				ADVANCED_ANALYSIS: 'Análise Avançada',
				RENEWABLES: 'Renováveis',
				SUMMARY: 'Summary',
				DOWNTIME: 'Tempo de Inatividade',
				UNDERPERFORMANCE: 'Baixo Desempenho',
				CURTAILMENT: 'Restrição',
				SOILING_LOSS: 'Perda por Sujeira',
				LOSS_BUCKETING: 'Categorização de Perdas',
				MAINTENANCE: 'Manutenção'
			},
			TOOLBAR: {
				SELECT_ANALYSIS: 'Selecionar Análise',
				SEARCH_ANALYSIS: 'Pesquisar análise...',
				NO_MATCHING_ANALYSIS: 'Nenhuma análise correspondente encontrada',
				PUBLIC: 'Public',
				SAVE_ALL: 'Salvar Tudo',
				TOOLTIP_SAVE_ALL: 'Salvar Todas as Alterações',
				TOOLTIP_DOWNLOAD: 'Download Stats For All Analysis',
				ANALYSIS_TYPE: 'Tipo de Análise'
			},
			HEADER: {
				CREATED_BY: 'Por',
				CREATED_ON: 'Created on:'
			},
			EMPTY_STATE: {
				HEADING: 'Nenhuma Análise Selecionada',
				CONTENT: 'Selecione ou adicione uma Análise.'
			},
			DESCRIPTION_LABEL: 'Descrição:',
			POPUP: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				NAME_PLACEHOLDER: 'Nome',
				NAME_ERROR_TAKEN: 'Já utilizado',
				NAME_HINT: 'Please enter',
				NAME_HINT_STRONG: 'Analysis Name',
				DESC_PLACEHOLDER: 'Descrição',
				DESC_ERROR_PREFIX: 'Descrição é',
				DESC_HINT: 'Por favor, insira',
				DESC_HINT_STRONG: 'descrição da análise',
				SELECT_FACILITY: 'Select Facility',
				SEARCH_FACILITY: 'Pesquisar',
				NO_MATCHING_FACILITY: 'Nenhuma instalação correspondente encontrada',
				TOOLTIP_CANCEL: 'Cancel changes',
				TOOLTIP_SAVE: 'Save changes',
				BTN_CANCEL: 'Cancelar',
				BTN_SAVE: 'Guardar'
			},
			SAVE_CONFIRMATION: {
				TITLE: 'Unsaved Changes',
				MESSAGE: 'Há alterações não salvas. Deseja continuar?',
				BTN_CANCEL: 'Cancelar',
				BTN_SAVE_CONTINUE: 'Salvar e Continuar',
				BTN_DISCARD: 'Descartar alterações e Continuar'
			},
			COMMON: {
				BTN_OK: 'Ok',
				BTN_CANCEL: 'Cancelar',
				BTN_CLOSE: 'Fechar',
				BTN_RESET: 'Redefinir',
				BTN_SAVE: 'Guardar',
				LOADING: 'Loading...',
				NO_RECORDS: 'Nenhum registro encontrado',
				SEARCH: 'Pesquisar',
				SEARCH_PLACEHOLDER: 'Search...',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_ADD: 'Adicionar',
				TOOLTIP_DOWNLOAD: 'Transferir',
				TOOLTIP_CANCEL: 'Cancel changes',
				TOOLTIP_SAVE: 'Save changes',
				TOOLTIP_REMOVE_CARD: 'Remover Cartão',
				DATE_RANGE: 'Date Range'
			},
			FILTER: {
				TITLE: 'Filtrar',
				UNIT: 'Unidade',
				SYSTEM: 'Sistema',
				SEARCH_SYSTEM: 'Search System...',
				NO_MATCHING_SYSTEM: 'No matching system found'
			},
			BUCKETING_FILTER: {
				FACILITY_TYPE: 'Tipo de Instalação',
				SELECT_FACILITY: 'Select Facility',
				TOOLTIP_CARD_VIEW: 'Visualização em Cartões',
				TOOLTIP_TABLE_VIEW: 'Visualização em Tabela',
				SEARCH_SYSTEM: 'Search System...',
				NO_SYSTEM_FOUND: 'No system found',
				GROUP_BY: 'Group By:',
				ENABLE_CLUSTERING: 'Ativar Agrupamento',
				SELECT_CLUSTER: 'Selecionar Cluster',
				WIND_DIRECTION: 'Direção do Vento',
				SELECTED_DATE_RANGE: 'Intervalo de Datas Selecionado',
				START_DATE: 'Start date',
				END_DATE: 'End date',
				CONFIGURE_LOSS: 'Configurar Perda',
				SAP_FILTER_TITLE: 'Filtro de Campo(s) SAP:'
			},
			BUCKETING_TABLE: {
				SEARCH: 'Pesquisar',
				SORT_BY: 'Sort By',
				SORT_NONE: 'Nenhum',
				SORT_ASC: 'Ascending',
				SORT_DESC: 'Descending',
				COL_NAME: 'Nome',
				COL_GENERATION: 'Geração (em MWh)',
				COL_EFFICIENCY: 'Eficiência DESEMP.(%)',
				COL_BREAKDOWN_COUNT: 'Contagem de Quebras',
				COL_NOTIFICATION_COUNT: 'Contagem de Notificações',
				COL_CLOSED: 'Fechado',
				COL_OPEN: 'Aberto',
				COL_BLOCK: 'Bloco',
				COL_EFF_LOSS: 'Perda EFIC.',
				COL_INV: 'Inv',
				COL_TIME: 'Tempo (hh:mm)',
				COL_CURTAILMENT_LOSS: 'Perda por Restrição(MWh)',
				COL_GEN_LOSS: 'Perda de Geração(MWh)',
				COL_GEN_LOSS_NET: 'Perda de GER. (MWh)',
				COL_GEN_LOSS_MWH: 'PERDA DE GER. (MWh)',
				COL_AVAILABILITY: 'disponibilidade',
				COL_REV_LOSS: 'Perda de Receita',
				COL_MAINTENANCE_COST: 'Custo de Manutenção',
				COL_DOWNTIME: 'tempo de inatividade',
				COL_DURATION_PCT: 'Duração %',
				COL_MTTR: 'mttr (hh:mm)',
				COL_ASSET: 'Ativo',
				COL_MTBF: 'mtbf (hh:mm)',
				COL_IDEAL_GEN: 'Geração Ideal (KWH)',
				COL_SOILING_LOSS: 'Perda por Sujeira (KWH)',
				COL_SOILING_LOSS_PCT: 'Perda por Sujeira(% da Ger. Ideal)',
				COL_SCHEDULED_DATE: 'Data Agendada(A ser limpo)',
				COL_LAST_CLEANED: 'Última Limpeza',
				COL_LAST_CLEANED_DAYS: '(dias atrás)',
				COL_NOTIFICATION_NO: 'Nº da Notificação',
				COL_EQUIPMENT_ID: 'ID do Equipamento',
				COL_FUNCTIONAL_LOC: 'LocalFuncional',
				COL_EQUIPMENT: 'Equipamento',
				COL_DESCRIPTION: 'Descrição',
				COL_CREATED_BY: 'Criado Por',
				COL_CREATED_ON: 'CREATED ON',
				COL_MAINTENANCE_PLANT: 'Planta de Manutenção',
				COL_PLAN_GROUP: 'GrupoPlanejamento',
				COL_COMPLETED_ON: 'Concluído em',
				COL_COMPLETED_BY: 'Concluído Por',
				COL_COMPONENT: 'Componente'
			},
			POWER_CURVE: {
				TITLE_PREFIX: 'Power Curve Settings for',
				OEM: 'Curva de Potência OEM',
				CALCULATED: 'Curva de Potência Calculada',
				START_DATE: 'Start Date',
				STOP_DATE: 'Data de Parada',
				DATE_RANGE_ERROR: 'A data de início deve ser menor que a data de término.',
				ADD_COMMENT: 'Adicionar Comentário',
				COMMENT_ERROR: 'Por favor, insira um comentário válido.'
			},
			FILTER_MIN_MAX: {
				TOOLTIP: 'Filtrar Mín Máx',
				GREATER_THAN: 'Greater than',
				LESS_THAN: 'Less than'
			},
			TAG_FILTER: {
				SELECT_TAG: 'Select Tag',
				NO_MATCHING_TAG: 'No matching Tag found'
			},
			LIST_CARD: {
				NO_MATCHING_TAG: 'No matching Tag found'
			},
			LIST_XY_CARD: {
				X_AXIS: 'X-Axis',
				Y_AXIS: 'Y-Axis',
				SEARCH_X: 'Pesquisar X...',
				SEARCH_Y: 'Pesquisar Y...',
				NO_MATCHING_X: 'Nenhum X correspondente encontrado',
				NO_MATCHING_Y: 'Nenhum Y correspondente encontrado'
			},
			CHART: {
				TOOLTIP_DOWNLOAD_TAG: 'Baixar Dados da Tag',
				TOOLTIP_NO_ACCESS: 'Você não tem acesso às unidades e sistemas usados neste item de análise. Por isso, ele foi desativado.',
				TOOLTIP_REMOVE_FILTER: 'Remover Filtro',
				LOCK_X_AXIS: 'Bloquear eixo x (Data)',
				MULTI_AXIS: 'Multi-eixo',
				TRIP_LIMIT: 'Trip Limit',
				ALARM_LIMIT: 'Limite de Alarme',
				THRESHOLD_LIMIT: 'Threshold Limit',
				INSTRUMENT_RANGE: 'Instrument Range',
				LOCK_X_AXIS_ALERT_TOOLTIP: 'Você não pode desbloquear na Comparação de Alertas',
				TYPE_SIGNAL_VS_TIME: 'Sinal Vs Tempo @ Tempos Diferentes',
				TYPE_SIGNAL_VS_SIGNAL: 'Sinal Vs Sinal @ Tempos Diferentes',
				TYPE_STATE_SIGNAL: 'Análise de Sinal para um Estado Operacional',
				TYPE_STATE_SIGNAL_VS_SIGNAL: 'Sinal Vs Sinal Sobre Estados Operacionais',
				TYPE_MULTISIGNAL: 'Análise Multi-Sinal Sobre Estados Operacionais',
				TYPE_MULTISIGNAL_VS_SIGNAL: 'Análise Multi-Sinal vs Sinal Sobre Estados Operacionais',
				TYPE_FULL_SYSTEM: 'Comparação de Sistema/Equipamento',
				TYPE_ALERT_COMPARISON: 'Comparação de Alertas'
			},
			TAG_DIALOG: {
				TITLE_PLACEHOLDER: 'Título',
				DESC_PLACEHOLDER: 'Descrição',
				PLOT_TYPE_LABEL: 'Tipo de Gráfico',
				QUICK_PLOT: 'Gráfico Rápido',
				AXIS_TYPE_LABEL: 'Tipo de Eixo',
				AXIS_MULTI: 'Múltiplo',
				AXIS_SINGLE: 'Único'
			},
			SUMMARY: {
				LOADING: 'Crunching data like a data-saurus! Hold tight!',
				NO_DATA: 'Ah, an empty vessel, no data to be found.'
			},
			AVAILABILITY: {
				TIME_BASED: 'Disponibilidade Baseada em Tempo',
				ENERGY_BASED: 'Disponibilidade Baseada em Energia',
				TARGET_SUFFIX: 'Meta',
				TOTAL_LOSS_TITLE: 'Total Loss (MWh)',
				ROW_DOWNTIME: 'Tempo de Inatividade (HH:MM)',
				ROW_LOST_PRODUCTION: 'Produção Perdida (MWh)',
				ROW_LOST_REVENUE: 'Receita Perdida',
				ROW_MTBF: 'MTBF (Tempo Médio Entre Falhas - HH:MM)',
				ROW_MTTR: 'MTTR (Tempo Médio de Reparo - HH:MM)',
				COL_NAME: 'Nome',
				COL_VALUE: 'Value'
			},
			PERFORMANCE: {
				LOST_GENERATION: 'Lost Generation (MWh)',
				LOST_REVENUE: 'Lost Revenue',
				BEST_PERFORMING: 'Melhor Desempenho',
				WORST_PERFORMING: 'Pior Desempenho',
				SHOW_TOP: 'Show Top :',
				TOTAL_LOSS_TITLE: 'Total Loss (MWh)',
				PERF_CURVE_TITLE: 'Curva de Desempenho',
				WIND_ROSE_TITLE: 'Rosa dos Ventos'
			},
			CURTAILMENT: {
				LOST_GENERATION: 'Lost Generation (MWh)',
				LOST_REVENUE: 'Lost Revenue',
				SHOW_TOP: 'Mostrar Top :',
				TOTAL_LOSS_TITLE: 'Total Loss (MWh)'
			},
			SOILING: {
				TOTAL_LOSS_TITLE: 'Perda Total (MWh)',
				SOILING_CURVE_SUFFIX: 'Curva de Perda por Sujeira',
				TOOLTIP_SAVE: 'Guardar',
				TOOLTIP_CANCEL: 'Cancelar',
				SECTION_SOILING: 'Sujeira',
				SECTION_TEMPERATURE: 'Temperatura',
				SECTION_OTHERS: 'Outros',
				REF_SETTING: 'Configuração de Referência',
				CRS: 'CRS',
				SRS: 'SRS',
				SELECT_UNIT: 'Select Unit',
				SELECT_SYSTEM: 'Select System',
				SELECT_ASSET: 'Selecionar ativo',
				SELECT_TAG: 'Select tag',
				SEARCH: 'Pesquisar',
				SEARCH_SYSTEM: 'Search system...',
				NO_MATCHING_UNIT: 'No matching unit found',
				NO_MATCHING_SYSTEM: 'No matching system found',
				NO_MATCHING_ASSET: 'No matching asset found',
				NO_MATCHING_TAG: 'No matching tag found',
				APPLY_ON: 'Aplicar em',
				CLEANING_CYCLE: 'Ciclo de Limpeza',
				CLEANING_CYCLE_HINT: '(em dias)',
				BTN_START_EXPERIMENT: 'Iniciar Experimento',
				TOOLTIP_FORCE_STOP: 'Forçar parada do experimento em andamento',
				TOOLTIP_UPLOAD_SOILING: 'Enviar Taxa de Sujeira',
				CLEANING_UPDATE: 'Atualização de Limpeza',
				TOOLTIP_UPLOAD_CLEANING: 'Enviar Cronograma de Limpeza',
				TOOLTIP_DOWNLOAD_CLEANING: 'Baixar relatório de atualização de limpeza',
				CHOOSE_DATE: 'Escolha uma data',
				DATE_HINT: 'MM/DD/AAAA',
				BTN_UPDATE: 'Atualizar'
			},
			LOSS: {
				LOST_GENERATION: 'Geração Perdida (MWh)',
				LOST_REVENUE: 'Receita Perdida',
				EFFECTIVE_PR: 'PR Efetivo',
				HIGHEST_LOSS_BUCKET: 'Maior Categoria de Perda',
				LOSS_BUCKETING_TITLE: 'Categorização de Perdas (MWh)'
			},
			MAINTENANCE: {
				CHART_TITLE: 'Tempo de Manutenção (HH:MM)',
				BAD_ACTORS_TITLE: 'Principais Maus Atores',
				NOTIFICATION_STATUS: 'Status da Notificação',
				SHDJ_DISTRIBUTION: 'Distribuição de SHDJ por unidade',
				PENDING_DEFECTS_TITLE: 'Defeitos Pendentes e Relatórios de Envelhecimento',
				COL_GROUP_SECTION: 'Grupo/Seção',
				COL_0_30: '0 - 30 Dias',
				COL_31_90: '31 - 90 Dias',
				COL_91_180: '91 - 180 Dias',
				COL_181_365: '181 - 365 Dias',
				COL_365_500: '365 - 500 Dias',
				COL_GRAND_TOTAL: 'Total Geral',
				MONTHLY_DEFECTS_PREFIX: 'Status Mensal de Defeitos -',
				TOTAL_MTD: 'Total de Defeitos no Mês (MTD)',
				YEARLY_DEFECTS_PREFIX: 'Status Anual de Defeitos - AF',
				TOTAL_YTD: 'Total de Defeitos no Ano (YTD)',
				PM_COMPLIANCE_PREFIX: 'Relatório de Conformidade de PM -',
				COL_EQUIPMENT: 'Equipamento',
				COL_SCHEDULED: 'Agendado',
				COL_PENDING: 'Pendente',
				COL_COMPLETED: 'Concluído',
				COL_COMPLIANCE: 'Conformidade (%)'
			},
			MESSAGES: {
				SERVER_ERROR: 'Erro interno do servidor',
				SAVE_SUCCESS: 'A análise foi salva com sucesso.',
				UPDATE_SUCCESS: 'A análise foi atualizada.',
				ADD_SUCCESS: 'A análise foi adicionada.',
				COPY_SUCCESS: 'A análise foi copiada.',
				CARD_GENERATED: 'Um novo cartão de análise foi gerado com sucesso',
				POWER_CURVE_STARTED: 'Cálculo da curva de potência iniciado para',
				POWER_CURVE_FAILED: 'Falha no cálculo da curva de potência para'
			}
		},
		NOTIFICATION_WIZARD: {
			HEADER_TITLE: 'Notifications',
			MARK_ALL_READ: 'Marcar todas como lidas',
			SETTINGS: 'Configurações',
			TAB_ALL: 'Todos',
			TAB_UNREAD: 'Novas Não Lidas',
			TAB_ASSIGNED: 'Atribuídas a mim',
			NOTIFICATIONS_SUFFIX: 'notificações',
			TOOLTIP_MARK_READ: 'Marcar como lida',
			TOOLTIP_MARK_UNREAD: 'Marcar como não lida',
			TOOLBAR_ITEM: 'item',
			TOOLBAR_ITEMS: 'itens',
			TOOLBAR_SELECTED: 'selecionado(s)',
			TOOLBAR_MARK_READ: 'Marcar como lida',
			TOOLBAR_MARK_UNREAD: 'Marcar como não lida',
			TOOLBAR_CLEAR: 'Limpar Mensagens',
			ERROR_TITLE: 'Não foi possível carregar as notificações',
			ERROR_DESC: 'Algo deu errado ao buscar as notificações. Por favor, tente novamente.',
			NOTIF_OFF_TITLE: 'As notificações estão desativadas',
			NOTIF_OFF_DESC: 'Ative as notificações para receber atualizações aqui.',
			EMPTY_DEFAULT_TITLE: 'Nenhuma Notificação',
			EMPTY_DEFAULT_DESC: 'Você ainda não tem notificações. Quando receber notificações, elas aparecerão aqui.',
			EMPTY_CAUGHT_UP_TITLE: 'Você está em dia.',
			EMPTY_UNREAD_DESC: 'Novas notificações de alertas e atualizações aparecerão aqui.',
			EMPTY_ASSIGNED_DESC: 'Notificações atribuídas a você aparecerão aqui.',
			EMPTY_ALL_TITLE: 'Nenhuma notificação ainda',
			EMPTY_ALL_DESC: 'as atualizações aparecerão aqui',
			GROUP_TODAY: 'Hoje',
			GROUP_YESTERDAY: 'Ontem',
			GROUP_THIS_WEEK: 'Mais cedo esta semana',
			GROUP_THIS_MONTH: 'Mais cedo este mês',
			GROUP_LAST_MONTH: 'Mês passado',
			GROUP_OLDER: 'Mês anterior',
			SETTINGS_HEADER: 'Configuração de Preferências do Usuário',
			SETTINGS_TAB_NOTIFICATIONS: 'Notificações',
			SETTINGS_TAB_AUDIBLE: 'Alarmes Sonoros',
			SETTINGS_COL_TYPE: 'Tipo',
			SETTINGS_COL_EMAIL: 'E-mail',
			SETTINGS_COL_PLATFORM: 'Plataforma',
			SETTINGS_COL_AUDIBLE: 'Sonoro',
			SETTINGS_ALERTS_HEADER: 'Alertas',
			SETTINGS_ALERTS_DESC: 'Notificações acionadas quando um novo alerta é gerado.',
			SETTINGS_AUDIBLE_ALERTS_DESC: 'Tocar um alarme sonoro quando esses alertas forem criados.',
			SETTINGS_NEW_ANOMALY: 'Novos Alertas de Anomalia',
			SETTINGS_NEW_HIGH_ANOMALY: 'Novos Alertas de Anomalia Alta',
			SETTINGS_NEW_LOW_ANOMALY: 'Novos Alertas de Anomalia Baixa',
			SETTINGS_NEW_THRESHOLD: 'Novos Alertas de Limite',
			SETTINGS_OWNERSHIP_HEADER: 'Propriedade e Atribuição de Alertas',
			SETTINGS_OWNERSHIP_DESC: 'Notificações relacionadas à responsabilidade do alerta.',
			SETTINGS_ALERT_OWNER: 'Atribuído como Responsável pelo Alerta',
			SETTINGS_ALERT_WATCHER: 'Atribuído como Observador do Alerta',
			SETTINGS_ACTIVITY_HEADER: 'Atividade do Alerta',
			SETTINGS_ACTIVITY_DESC: 'Controla se os usuários recebem atualizações contínuas após a atribuição.',
			SETTINGS_OWNED_ALERTS: 'Atualizações sobre Alertas Próprios',
			SETTINGS_WATCHED_ALERTS: 'Atualizações sobre Alertas Observados',
			SETTINGS_SYSTEM_HEADER: 'Atualizações do Sistema',
			SETTINGS_SYSTEM_DESC: 'Notificações relacionadas a operações de IA / sistema.',
			SETTINGS_MODEL_RETRAINING: 'Retreinamento do Modelo Concluído',
			SETTINGS_AUDIBLE_FOOTER_NOTE: 'O alarme sonoro tocará uma vez ou continuará notificando na frequência selecionada até que você clique no alarme para ver os detalhes.',
			PDF_HEADER: 'Gestão de Casos - PDF gerado',
			PDF_GENERATED_BEFORE: 'O PDF de gestão de casos foi gerado com sucesso.',
			PDF_DOWNLOAD_LINK: 'Baixar PDF',
			PDF_GENERATED_AFTER: 'ou acesse pelo link enviado ao seu e-mail. O link de download expira em {{expiry}}.',
			PDF_LINK_EXPIRED_TOOLTIP: 'Este link de download expirou. Gere o PDF novamente para baixar.',
			ASSET_TEMPLATE_SYNC_STARTED_TITLE: 'Sincronização do modelo de ativo iniciada – {{templateName}}',
			ASSET_TEMPLATE_SYNC_COMPLETED_TITLE: 'Sincronização do modelo de ativo concluída – {{templateName}}',
			ASSET_TEMPLATE_SYNC_FAILED_TITLE: 'Falha na sincronização do modelo de ativo – {{templateName}}'
		},
		MAINTENANCE_OPTIMIZATION: {
			// Main component
			HEADER_TITLE: 'Otimização da Manutenção',
			TAB_RESULTS: 'Resultados e Valor',
			TAB_SCHEDULES: 'Cronogramas de PM',
			TAB_RUN_HISTORY: 'Histórico de Execuções',

			// Run History
			RH_COL_SL_NO: 'N.º',
			RH_COL_RUN_DATE: 'Data de Execução',
			RH_COL_NAME: 'Nome',
			RH_COL_CREATOR: 'Criador',
			RH_COL_SCOPE: 'Escopo',
			RH_COL_STATUS: 'Status',
			RH_COL_TOTAL_VALUE: 'Valor Total',
			RH_COL_APPROVED: 'Aprovado',
			RH_COL_ACTIONS: 'Ações',
			RH_VIEW: 'Ver',
			RH_EQUIPMENTS: 'equipamentos',
			RH_SEARCH_PLACEHOLDER: 'Buscar execuções...',
			RH_EMPTY: 'Nenhuma execução de otimização encontrada para a seleção atual.',
			RH_STATUS_PENDING: 'Pendente',
			RH_STATUS_RUNNING: 'Em execução',
			RH_STATUS_PROCESSING: 'Processando',
			RH_STATUS_COMPLETED: 'Concluído',
			RH_STATUS_FAILED: 'Falhou',
			BTN_RUN_OPTIMIZATION: 'Executar Otimização',
			LAST_RUN_PREFIX: 'Última execução de otimização:',

			// PM Schedules
			PM_DOWNLOAD_TITLE: 'Opções de download',
			PM_DOWNLOAD_SUBTITLE: 'Use os botões abaixo para exportar os cronogramas de PM em um formato que pode ser enviado para o SAP ou seu CMMS:',
			PM_DOWNLOAD_ALL_TITLE: 'Baixar TUDO (CSV)',
			PM_DOWNLOAD_ALL_DESC: 'Lista consolidada de todas as atividades de PM',
			PM_DOWNLOAD_PER_EQ_TITLE: 'Relatórios por Equipamento',
			PM_DOWNLOAD_PER_EQ_DESC: 'Filtrado para o ativo selecionado na hierarquia',
			PM_DOWNLOAD_CONSOLIDATED_TITLE: 'Cronogramas Consolidados',
			PM_DOWNLOAD_CONSOLIDATED_DESC: 'Agrupado por novo intervalo',
			PM_SEARCH_PLACEHOLDER: 'Pesquisar...',
			PM_GROUP_BY_INTERVAL: 'Agrupar por: Intervalo',
			PM_FILTER: 'Filtrar',
			PM_COL_ID: 'ID',
			PM_COL_NAME: 'Nome do Cronograma de PM',
			PM_COL_ACCESS_CLASS: 'Classe de Acesso',
			PM_COL_BUNDLE_NAME: 'Nome do Pacote',
			PM_COL_BUNDLE_ID: 'ID do Pacote',
			PM_COL_PREV_INTERVAL: 'Intervalo de PM Anterior',
			PM_COL_CURR_INTERVAL: 'Intervalo de PM Atual',
			PM_EACH: 'Cada',
			PM_DAYS: 'dias',

			// Results & Values
			RV_TOTAL: 'Total',
			RV_POTENTIAL_VALUE: 'Valor potencial',
			RV_PM_SCHEDULING: 'Agendamento de PM',
			RV_CM_REDUCTION: 'Redução de CM',
			RV_FAILURE_REDUCTION: 'Redução de Falha / Quebra',
			RV_BY_REC_TYPE: 'Por Tipo de Recomendação',
			RV_TOTAL_ACTIVITIES: 'Total de Atividades Inspecionadas',
			RV_INCREASES: 'Aumentos',
			RV_DECREASES: 'Diminuições',
			RV_NO_CHANGES: 'Sem Alterações',
			RV_REMOVE: 'Remover',
			RV_ADD: 'Adicionar',
			RV_WHERE_VALUE: 'Onde Está o Valor',
			RV_BY_STATUS: 'Por Status',
			RV_TOTAL_SCHEDULES: 'Total de Cronogramas',
			RV_PENDING: 'Pendente',
			RV_APPROVED: 'Aprovado',
			RV_REJECTED: 'Rejeitado',
			RV_SEARCH_PLACEHOLDER: 'Pesquisar...',
			RV_GROUP_BY_SYSTEM: 'Agrupar por: Sistema',
			RV_FILTER: 'Filtrar',
			RV_COL_FREQ_REC: 'Recomendação de Frequência',
			RV_COL_HIERARCHY: 'Hierarquia / Nomes de PM',
			RV_COL_REC_INTERVAL: 'Intervalo Recomendado (dias)',
			RV_COL_SAVINGS: 'Economia Total ($/ano)',
			RV_COL_PM: 'PM ($/ ano)',
			RV_COL_CM: 'CM ($/ ano)',
			RV_COL_FAILURE_RISK: 'Risco de Falha ($/ ano)',
			RV_COL_APPROVE: 'Aprovar /Rejeitar',
			RV_COL_PM_ID: 'PM ID',
			RV_COL_ACTIVITY: 'Atividade',
			RV_COL_ROLE: 'Função',
			RV_COL_STANDALONE: 'Independente',
			RV_COL_EFFECTIVE: 'Efetivo',
			RV_COL_EVIDENCE: 'Evidência',
			RV_COL_VALUE: 'Valor',
			RV_COL_STATUS: 'Status',
			RV_BH_CURRENT: 'Atual',
			RV_BH_EFFECTIVE: 'Efetivo',
			RV_BH_OUTCOME: 'Resultado',
			RV_BH_DRIVER: 'Direcionador(es)',
			RV_BH_VALUE: 'Valor',
			RV_BH_CONFIDENCE: 'Confiança',
			RV_BH_STATUS: 'Status',
			RV_BH_ACTIVITIES: 'atividades',
			RV_BH_DRIVERS: 'direcionadores',
			RV_BH_OVERRIDES: 'substituições',
			RV_BH_UNCHANGED: 'inalterado',
			RV_BH_NONE: 'Nenhum',
			RV_BH_NO_CHANGE: 'Sem alteração',
			RV_BH_NA: 'n/a',
			RV_DEEP_DIVE: 'Análise detalhada',
			RV_BUNDLE_SUMMARY: 'Resumo do pacote',
			RV_LAST_RUN: 'Última execução',
			RV_NO_RESULTS: 'Nenhum resultado de otimização para esta seleção.',
			RV_SELECT_NODE: 'Selecione uma instalação, unidade ou sistema para ver os resultados.',
			RV_LOADING: 'Carregando resultados...',

			// MC Recommendation panel
			MC_PANEL_TITLE: 'Painel de Aprofundamento — Recomendação',
			MC_ASK_ROOTY: 'Perguntar ao Rooty',
			MC_APPROVE: 'Aprovar',
			MC_REJECT: 'Rejeitar',
			MC_CURRENT_FREQ: 'Frequência Atual',
			MC_REC_FREQ: 'Frequência Recomendada',
			MC_SHOW: 'Mostrar',
			MC_COMPACT: 'Compacto',
			MC_ADVANCED: 'Avançado',
			MC_TAB_DECISION: 'Decisão',
			MC_TAB_OBSERVATIONS: 'Observações',
			MC_TAB_FAILURE_MODES: 'Modos de Falha',
			MC_DECISION_TITLE: 'Decisão',
			MC_WHY_NOW: 'POR QUE AGORA',
			MC_EXPECTED_VALUE: 'VALOR ESPERADO',
			MC_SECONDARY_ACTION: 'AÇÃO SECUNDÁRIA',
			MC_REC_CONFIDENCE: 'Confiança da Recomendação',
			MC_SAVINGS_BREAKDOWN: 'Detalhamento da Economia',
			MC_TOTAL_ANNUAL_SAVINGS: 'Economia anual total',
			MC_PREDICTIONS: 'Predições',
			MC_EXPECTED_OUTCOME: 'Resultado esperado se a recomendação for aceita',
			MC_INTERVAL_SENSITIVITY: 'Sensibilidade do Intervalo (β / η)',
			MC_ANNUAL_CM_COUNT: 'Contagem Anual de CM',
			MC_CURRENT_CM_COUNT: 'Contagem atual de CM:',
			MC_PREDICTED_CM_COUNT: 'Nova contagem prevista de CM:',
			MC_ANNUAL_BD_COUNT: 'Contagem Anual de Quebras',
			MC_CURRENT_BD_COUNT: 'Contagem atual de quebras:',
			MC_PREDICTED_BD_COUNT: 'Nova contagem prevista de quebras:',
			MC_PM_FREQUENCY: 'Frequência de PM',
			MC_CURRENT: 'Atual:',
			MC_RECOMMENDED: 'Recomendado:',
			MC_FM_LINK: 'aba Modos de Falha',
			MC_OBS_REACTIVE_VS_PREVENTIVE: 'Relação de Custo Reativo vs Preventivo',
			MC_OBS_CM_TIMING: 'Análise de Tempo de Eventos de CM',
			MC_OBS_EARLY: 'Início',
			MC_OBS_MID: 'Meio',
			MC_OBS_LATE: 'Fim',
			MC_OBS_POST_PM: 'Recorrência Pós-PM',
			MC_OBS_EVIDENCE_LOG: 'Abrir Registro de Evidências completo →',
			MC_FM_SERVED_BY: 'atendido por este PM',
			MC_FM_SORT: 'Ordenar',
			MC_FM_BY_ROLE: 'Por Função',
			MC_FM_EXPAND_ALL: 'Expandir Tudo',
			MC_FM_PRIMARY: 'Primário',
			MC_FM_SUPPORTING: 'Suporte',
			MC_FM_INCIDENTAL: 'Incidental',
			MC_FM_AGG_B: 'Agregado B',
			MC_FM_CM_COUNT: 'Contagem de CM /ANO',
			MC_FM_BREAKDOWNS: 'Quebras / ANO',
			MC_FM_DIAGNOSIS: 'Diagnóstico',
			MC_FM_TIMING: 'Tempo',
			MC_FM_SENSITIVITY: 'Sensibilidade (β)',
			MC_FM_IMPACT: 'Impacto',
			MC_FM_EVENTS: 'Eventos',
			MC_FM_DATE_COL: 'Data',
			MC_FM_EVENT_COL: 'Evento',
			MC_FM_COST_COL: 'Custo',
			MC_FM_CLASS_COL: 'Classe',
			MC_TAG_INCREASE_FREQ: 'Aumentar Frequência',
			MC_TAG_TIMING: 'orientado por tempo',
			MC_TAG_CASE2: 'Caso 2',
			MC_TAG_CBM: '+ rede de segurança CBM',
			MCB_OPEN_EVIDENCE_LOG: 'Abrir registro de evidências',
			MCB_DECISION_STANDALONE: 'Recomendação independente',
			MCB_DECISION_EFFECTIVE: 'Recomendação efetiva do pacote',
			MCB_EFFECTIVE_IS_STANDALONE: 'O resultado independente também é o resultado efetivo',
			MCB_EXPECTED_IMPACT: 'Impacto esperado',
			MCB_EFFECTIVE_BUNDLE_RESULT: 'Resultado efetivo do pacote',
			MCB_PM_COST: 'Custo de PM',
			MCB_PM_COST_SUB: 'Gasto anual adicional de PM',
			MCB_CM_SAVINGS: 'Economia de CM',
			MCB_CM_SAVINGS_SUB: 'Redução anual esperada',
			MCB_BD_SAVINGS: 'Economia por falhas',
			MCB_BD_SAVINGS_SUB: 'Redução anual esperada',
			MCB_NET_VALUE: 'Valor anual líquido',
			MCB_NET_VALUE_SUB: 'Após propagação do pacote',
			MCB_CONFIDENCE: 'Confiança',
			MCB_DRIVER_BASED: 'Baseado no direcionador',
			MCB_WHY: 'Por que esta recomendação',
			MCB_ADVANCED_PENDING: 'Detalhes avançados em breve.',
			MCB_OBS_WHAT: 'O que o mecanismo observou',
			MCB_OBS_ECONOMIC: 'Triagem econômica',
			MCB_OBS_TIMING: 'Momento',
			MCB_OBS_POSTPM: 'Recorrência pós-PM',
			MCB_TIMING_DISTRIBUTION: 'Distribuição temporal',
			MCB_EARLY: 'Cedo',
			MCB_MIDDLE: 'Meio',
			MCB_LATE: 'Tarde',
			MCB_FM_BUILDUP: 'Formação de modos de falha',
			MCB_FM_BUILDUP_SUB: 'A visão compacta mostra a conclusão. A avançada expõe o diagnóstico, a previsão, a confiança e o rastro de evidências de cada FM.',
			MCB_DETAILS: 'Detalhes',
			MCB_FM_DIAGNOSIS: 'Diagnóstico',
			MCB_FM_EVIDENCE: 'Evidência',
			MCB_FM_TIMING: 'Momento',
			MCB_FM_CONTRIBUTION: 'Contribuição',
			MCB_FM_STANDALONE: 'Independente',
			MCB_FM_EFFECTIVE: 'Efetivo',
			MCB_FM_ROUTE: 'Rota',
			MCB_FM_INTERVAL_CONTRIB: 'Contribuição ao intervalo',
			MCB_FM_VALUE: 'Valor',
			MCB_FM_STATUS: 'Status',
			MCB_FM_ADMIN_INTERPRETATION: 'Interpretação do administrador',
			MCB_FM_INTERVAL_DRIVER: 'Direcionador de intervalo',
			MCB_FM_OVERRIDDEN: 'FM substituído',
			MCB_FM_NON_INTERVAL: 'Não relativo ao intervalo',
			MCB_STANDALONE_NOT_REALIZED: 'A economia independente de {{code}} não é realizada e não deve ser somada aos totais do equipamento ou do portfólio.',
			MCB_CONF_DATA_SUFFICIENCY: 'Suficiência de dados',
			MCB_CONF_TIMING_QUALITY: 'Qualidade temporal',
			MCB_CONF_MAPPING_QUALITY: 'Qualidade de mapeamento',
			MCB_CONF_PRIOR_CONFIRMATION: 'Confirmação prévia',
			MCB_OBS_ACTIONABILITY: 'Acionabilidade',
			MCB_OBS_CONDITION_MODIFIER: 'Modificador de condição',
			MCB_OBS_DATA_GATE: 'Portão de dados',
			MCB_PRED_DETAILS: 'Detalhes de previsão',
			MCB_PRED_B_BASE: 'Base B',
			MCB_PRED_ASSET_MODIFIER: 'Modificador de ativo',
			MCB_PRED_B_OPTIMIZATION: 'Otimização B',
			MCB_PRED_CM: 'Previsão CM',
			MCB_PRED_BD: 'Previsão BD',
			MCB_D_SEC_A: 'A. Portão de dados e classificação',
			MCB_D_SEC_B: 'B. Padrão temporal',
			MCB_D_SEC_C: 'C. Carga, condição e acionabilidade',
			MCB_D_SEC_D: 'D. Triagem econômica e diagnóstico',
			MCB_D_SEC_E: 'E. Construção de B',
			MCB_D_SEC_F: 'F. Previsão e valor',
			MCB_D_SEC_G: 'G. Evidência de eventos',
			MCB_D_ROUTE: 'Rota',
			MCB_D_PM_CYCLES: 'Ciclos de PM',
			MCB_D_QUALIFYING_EVENTS: 'Eventos qualificados',
			MCB_D_MAPPING_CONFIDENCE: 'Confiança de mapeamento',
			MCB_D_MEAN_MX: 'Média Mx',
			MCB_D_SPREAD: 'Dispersão Σx',
			MCB_D_EML: 'E/M/L',
			MCB_D_POSTPM: 'PostPM',
			MCB_D_RWCM_RAW: 'RWCM bruto',
			MCB_D_EFF_CM_BURDEN: 'Carga CM efetiva',
			MCB_D_HM: 'Hm',
			MCB_D_GM: 'Gm',
			MCB_D_PM_BURDEN: 'Carga de PM',
			MCB_D_CM_BD_BURDEN: 'Carga CM + BD',
			MCB_D_RA_COST: 'Custo Ra',
			MCB_D_DIAGNOSIS: 'Diagnóstico',
			MCB_D_B_BASE: 'Base B',
			MCB_D_DIRECTION: 'Direção',
			MCB_D_CONCENTRATION: 'Concentração',
			MCB_D_B_OPT: 'B Opt',
			MCB_D_INTERVAL: 'Intervalo',
			MCB_D_CM_PREDICTION: 'Previsão CM',
			MCB_D_STANDALONE_NET: 'Líquido independente',
			MCB_D_EFF_BUNDLE_NET: 'Líquido efetivo do pacote',
			MCB_D_COL_EVENT: 'Evento',
			MCB_D_COL_DATE: 'Data',
			MCB_D_COL_CLASS: 'Classe',
			MCB_D_COL_BD: 'BD',
			MCB_D_COL_XE: 'x<sub>e</sub>',
			MCB_D_COL_COST: 'Custo',

			// Run Configuration Dialog
			RC_TITLE: 'Configuração de Execução',
			RC_TAB_SCOPE: 'Escopo',
			RC_TAB_CONFIGURE: 'Configurar',
			RC_TAB_IMPORT: 'Importar Dados',
			RC_TAB_DATA_QC: 'QC de Dados',
			RC_TAB_MAPPING: 'Mapeamento',
			RC_SAVE: 'Guardar',
			RC_CANCEL: 'Cancelar',
			RC_PREVIOUS: 'Anterior',
			RC_NEXT: 'Próximo',
			RC_RUN: 'Executar',
			RC_CONFIGURE_TITLE: 'Configurar Análise',
			RC_CONFIGURE_DESC: 'Defina o perfil de análise, limites e parâmetros de ajuste. A maioria dos usuários deve escolher um perfil e ajustar apenas os parâmetros principais. Parâmetros avançados controlam o comportamento interno do algoritmo.',
			RC_ASSET_CLASS_TITLE: 'Substituições por Classe de Ativo',
			RC_ASSET_CLASS_DESC: 'Entradas A/B/C por classe para parâmetros de tolerância a risco',
			RC_ANALYSIS_WINDOW_TITLE: 'Janela de Análise',
			RC_ANALYSIS_WINDOW_DESC: 'Defina o período de tempo para análise de dados do CMMS',
			RC_DURATION: 'Duração',
			RC_INITIAL_DATE: 'Data Inicial',
			RC_END_DATE: 'Data Final',
			RC_ANALYSIS_PERIOD_PREFIX: 'Período de Análise:',
			RC_MONTHS: 'meses',
			RC_SAP_NOTIFICATIONS: 'Notificações SAP:',
			RC_FETCHING: 'Buscando...',
			RC_RECORDS: 'registros',
			RC_ANALYSIS_PROFILE_TITLE: 'Perfil de Análise',
			RC_ANALYSIS_PROFILE_DESC: 'Define todos os parâmetros para valores padrão pré-calibrados. Você pode substituir valores individuais abaixo.',
			RC_DATA_SUFFICIENCY_TITLE: 'Requisitos de Suficiência de Dados',
			RC_DATA_SUFFICIENCY_DESC: 'Quanta evidência é necessária antes que o algoritmo atue',
			RC_MIN_PM_CYCLES: 'Ciclos Mínimos de PM',
			RC_MIN_FM_EVENTS: 'Eventos Mínimos de Modo de Falha',
			RC_RECENCY_HALF_LIFE: 'Meia-Vida de Recência (h)',
			RC_POST_PM_WINDOW: 'Janela Pós-PM (d)',
			RC_CYCLES: 'ciclos',
			RC_RESET_TO_BASE: 'Redefinir para base',
			RC_PM_CM_RATIO_TITLE: 'Limites de Relação PM/CM (Ra)',
			RC_PM_CM_RATIO_DESC: 'Quando o gasto com PM está muito alto ou muito baixo em relação à carga de falhas? Ambas as relações são sempre calculadas e reportadas.',
			RC_PRIMARY_RATIO_LABEL: 'Relação primária para a lógica de diagnóstico',
			RC_OVER_MAINTAINED: 'Sobre-mantido (Caso 1)',
			RC_UNDER_MAINTAINED: 'Sub-mantido (Caso 2)',
			RC_INTERVAL_ADJ_TITLE: 'Limites de Ajuste de Intervalo',
			RC_INTERVAL_ADJ_DESC: 'Mudança máxima de intervalo por ciclo de recomendação. Limites separados para extensão vs redução.',
			RC_INTERVAL_ROUNDING: 'Arredondamento de Intervalo',
			RC_ROUND_TO: 'Arredondar para',
			RC_DIRECTION: 'Direção',
			RC_ADJ_MODE: 'Modo de Ajuste: Percentual',
			RC_ADVANCED_PARAMS_TITLE: 'Parâmetros Avançados',
			RC_ADVANCED_PARAMS_DESC: 'Ajuste interno do algoritmo — análise de tempo, roteamento, sensibilidade, níveis de confiança',
			RC_ADVANCED_WARNING: 'Esses parâmetros controlam o processamento interno de sinais. Alterá-los sem entender as fórmulas pode produzir resultados enganosos. O seletor de perfil acima define padrões sensatos para cada um. Substitua apenas se tiver um motivo específico.',
			RC_PARAM_COL_PARAM: 'Parâmetro',
			RC_PARAM_COL_DESC: 'Descrição',
			RC_PARAM_COL_EFFECT: 'EFEITO',
			RC_PARAM_COL_VALUE: 'Valor',
			RC_GOAL_SEEKER_TITLE: 'Modo Busca de Meta',
			RC_GOAL_SEEKER_DESC: 'Otimizar para atingir uma meta específica de redução de orçamento',
			RC_GOAL_SEEKER_CURRENT: 'Atual',
			RC_GOAL_SEEKER_TARGET: 'Meta de Redução:',
			RC_CONSTRAINTS: 'Restrições',
			RC_EXCLUDE_CRITICALITY: 'Excluir Criticidades de Ativo',
			RC_EXCLUDE_EQ_TYPES: 'Excluir Tipos de Equipamento',
			RC_SCOPE_TITLE: 'Escopo',
			RC_SCOPE_DESC: 'Defina o escopo da execução de otimização.',
			RC_IMPORT_TITLE: 'Importar Dados',
			RC_IMPORT_DESC: 'Notificações SAP para o sistema selecionado durante a janela de análise configurada.',
			RC_PM_EVENTS: 'Eventos de PM',
			RC_CM_EVENTS: 'Eventos de CM',
			RC_FAILURE_EVENTS: 'Eventos de Falha',
			RC_CM_FM_MAPPING: 'Mapeamento CM-Modo de Falha',
			RC_NO_RECORDS: 'Nenhum registro encontrado para este tipo de evento na janela selecionada',
			RC_COL_NOTIFICATION: 'Notificação',
			RC_COL_EQUIPMENT: 'Equipamento',
			RC_COL_DESCRIPTION: 'Descrição',
			RC_COL_TYPE: 'Tipo',
			RC_COL_CREATED_ON: 'Criado em',
			RC_COL_COMPLETED_ON: 'Concluído em',
			RC_COL_PLAN_GROUP: 'Grupo de Planejamento',
			RC_DATA_QC_TITLE: 'QC de Dados',
			RC_DATA_QC_DESC: 'Revise as verificações de qualidade de dados.',
			RC_MAPPING_TITLE: 'Mapeamento',
			RC_MAPPING_DESC: 'Configurar o mapeamento CM-FM.',
			RC_MAPPING_GROUP_BY: 'Agrupar por',
			RC_MAPPING_GROUP_FM: 'Modo de Falha',
			RC_MAPPING_GROUP_PREVENTABILITY: 'Prevenibilidade',
			RC_MAPPING_SEARCH_PLACEHOLDER: 'Pesquisar notificação, ordem, equipamento, descrição',
			RC_MAPPING_LOW_CONFIDENCE: 'Baixa confiança',
			RC_MAPPING_EDITED: 'Editado',
			RC_MAPPING_REGENERATE: 'Regerar',
			RC_MAPPING_DOWNLOAD: 'Baixar',
			RC_MAPPING_UPLOAD: 'Enviar',
			RC_MAPPING_RESET_ALL: 'Redefinir tudo',
			RC_MAPPING_COL_ORDER: 'Ordem Nº',
			RC_MAPPING_COL_EQUIPMENT_ID: 'ID do Equipamento',
			RC_MAPPING_COL_WO_DESC: 'Descrição da OT',
			RC_MAPPING_COL_WO_TYPE: 'Tipo de OT',
			RC_MAPPING_COL_MAPPED_FM: 'Modo de Falha Mapeado',
			RC_MAPPING_COL_PREVENTABILITY: 'Prevenibilidade',
			RC_MAPPING_EVENT: 'evento',
			RC_MAPPING_EVENTS: 'eventos',
			RC_MAPPING_AVG_FM_CONF: 'Confiança média de FM',
			RC_MAPPING_AVG_PREV_CONF: 'Confiança média Prev',
			RC_MAPPING_NO_RECORDS: 'Nenhuma notificação de CM/Quebra disponível para mapeamento',
			RC_MAPPING_GENERATING: 'Mapping CM/BD notifications to failure modes...',
			RC_MAPPING_GENERATION_ERROR: 'Falha ao gerar o mapeamento de CM/Quebra → modo de falha.',
			RC_MAPPING_UNMAPPED: 'Não Mapeado',
			RC_MAPPING_SYMPTOM_ONLY: 'Apenas sintoma',
			RC_MAPPING_SYMPTOM_ONLY_TOOLTIP: 'Não pôde ser reatribuído a um modo de falha de causa raiz — excluído dos cálculos de otimização.',
			RC_MAPPING_UNMAPPED_CONF_TOOLTIP: 'Confiança na própria determinação de "sem correspondência", não em um modo de falha específico.',
			RC_MAPPING_NO_RATIONALE: 'Nenhuma justificativa fornecida.',
			RC_MAPPING_DETAIL_IDENTITY_SOURCE: 'Identidade e Origem',
			RC_MAPPING_DETAIL_WO_CONTENT: 'Conteúdo da OT',
			RC_MAPPING_DETAIL_DURATION: 'Duração',
			RC_MAPPING_DETAIL_FM_MAPPING: 'Mapeamento de Modo de Falha',
			RC_MAPPING_DETAIL_PREVENTABILITY: 'Prevenibilidade',
			RC_MAPPING_DETAIL_AUDIT: 'Auditoria',
			RC_MAPPING_DETAIL_EVENT_CLASS: 'Tipo de Ordem / Classe de Evento',
			RC_MAPPING_DETAIL_SCHED_START: 'Início Programado',
			RC_MAPPING_DETAIL_SCHED_FINISH: 'Término Programado',
			RC_MAPPING_DETAIL_ACTIVITY_CODE: 'Código de Atividade',
			RC_MAPPING_DETAIL_DAMAGE_CODE: 'Código de Dano',
			RC_MAPPING_DETAIL_CAUSE_CODE: 'Código de Causa',
			RC_MAPPING_DETAIL_MATERIAL_COST: 'Custo de Material',
			RC_MAPPING_DETAIL_PERMIT_ISSUED: 'Permissão Emitida',
			RC_MAPPING_DETAIL_PERMIT_CLOSED: 'Permissão Encerrada',
			RC_MAPPING_DETAIL_CM_DURATION: 'Duração de CM (h)',
			RC_MAPPING_DETAIL_DURATION_SOURCE: 'Origem da Duração',
			RC_MAPPING_DETAIL_FM_ID_NAME: 'ID / Nome do Modo de Falha',
			RC_MAPPING_DETAIL_FM_TYPE: 'Tipo de Modo de Falha',
			RC_MAPPING_DETAIL_FAILURE_MODE_TYPE: 'Tipo de Modo de Falha',
			RC_MAPPING_DETAIL_CONFIDENCE: 'Confiança',
			RC_MAPPING_DETAIL_SOURCE: 'Origem',
			RC_MAPPING_DETAIL_RE_ATTRIBUTED_FROM: 'Reatribuído De',
			RC_MAPPING_DETAIL_SYMPTOM_ONLY: 'Apenas Sintoma',
			RC_MAPPING_DETAIL_RATIONALE: 'Justificativa',
			RC_MAPPING_DETAIL_CLASS: 'Classe',
			RC_MAPPING_DETAIL_KEY_SIGNALS: 'Sinais-Chave',
			RC_MAPPING_DETAIL_EDITED_BY: 'Editado Por',
			RC_MAPPING_DETAIL_EDITED_AT: 'Editado Em',
			RC_MAPPING_DETAIL_FM_AGENT_RUN: 'Execução do Agente de FM',
			RC_MAPPING_DETAIL_PREVENTABILITY_AGENT_RUN: 'Execução do Agente de Prevenibilidade',
			RC_MAPPING_DETAIL_EXISTING: 'Existente',
			RC_MAPPING_DETAIL_NOT_AVAILABLE: 'Não disponível',
			RC_MAPPING_REGEN_CONFIRM_TITLE: 'Regerar mapeamento?',
			RC_MAPPING_REGEN_CONFIRM_MESSAGE: '{{count}} linha(s) editada(s) manualmente será(ão) regenerada(s), usando suas correções como orientação para a nova execução.',

			// Select option labels
			OPT_6_MONTHS: '6 Meses',
			OPT_12_MONTHS: '12 Meses',
			OPT_15_MONTHS: '15 Meses',
			OPT_24_MONTHS: '24 Meses',
			OPT_36_MONTHS: '36 Meses',
			OPT_1_CYCLE: '1 Ciclo (Agressivo)',
			OPT_2_CYCLES: '2 Ciclos (Base)',
			OPT_3_CYCLES: '3 Ciclos (Conservador)',
			OPT_WEEKLY: 'Semanal (7 Dias)',
			OPT_BIWEEKLY: 'Quinzenal (14 Dias)',
			OPT_MONTHLY: 'Mensal (30 Dias)',
			OPT_NEAREST: 'Mais Próximo',
			OPT_UP: 'Acima',
			OPT_DOWN: 'Abaixo',
			OPT_CRIT_A: 'A (Crítico)',
			OPT_CRIT_B: 'B (Importante)',
			OPT_CRIT_C: 'C (Padrão)',
			OPT_CRIT_D: 'D (Baixo)',
			OPT_PROFILE_BASE_NAME: 'Base',
			OPT_PROFILE_BASE_SUBTITLE: 'Equilibrado, padrão',
			OPT_PROFILE_CONSERVATIVE_NAME: 'Conservador',
			OPT_PROFILE_CONSERVATIVE_SUBTITLE: 'Menos recomendações, maior confiança',
			OPT_PROFILE_AGGRESSIVE_NAME: 'Agressivo',
			OPT_PROFILE_AGGRESSIVE_SUBTITLE: 'Mais recomendações, maior economia potencial',
			OPT_PCT_SHORTER_10: '10% mais curto',
			OPT_PCT_SHORTER_20: '20% mais curto',
			OPT_PCT_SHORTER_25: '25% mais curto',
			OPT_PCT_SHORTER_50: '50% mais curto',
			OPT_PCT_LONGER_10: '10% mais longo',
			OPT_PCT_LONGER_20: '20% mais longo',
			OPT_PCT_LONGER_25: '25% mais longo',
			OPT_PCT_LONGER_50: '50% mais longo'
		},
		USER_MANAGEMENT: {
			FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
			CANCEL: 'Cancelar',
			SAVE: 'Guardar',
			CANCEL_CHANGES: 'Cancel changes',
			SAVE_CHANGES: 'Save changes',
			NO_RECORDS: 'Nenhum registro encontrado',
			PLEASE_WAIT: 'Por favor, aguarde....',
			SEARCH: 'Pesquisar',
			ACTIONS: 'Ações',
			NAME: 'Nome',
			EMAIL: 'E-mail',
			PHONE: 'Telefone',
			FACILITY: 'Facility',
			UNITS: 'Units',
			SYSTEMS: 'Sistemas',
			SYSTEM: 'Sistema',
			UNIT: 'Unidade',
			USER: 'User',
			SELECT_FACILITY: 'Select Facility',
			SELECT_FACILITIES: 'Selecionar Instalações',
			SELECT_UNITS: 'Select Units',
			SELECT_SYSTEMS: 'Select Systems',
			SELECT_SYSTEM: 'Select System',
			SELECT_UNIT: 'Select Unit',
			SELECT_USER: 'Selecionar Usuário',
			SEARCH_UNIT: 'Search unit...',
			NO_MATCHING_UNIT: 'Nenhuma unidade correspondente encontrada',
			SEARCH_SYSTEM: 'Search system...',
			NO_MATCHING_SYSTEM: 'No matching system found',
			ROLES: {
				LIST_TITLE: 'Lista de funções',
				NEW_ROLE: 'Nova Função',
				CREATE_ROLE_TOOLTIP: 'Criar nova função',
				SEARCH_USER: 'Search user',
				FETCH_SELECTED: 'Buscar Selecionados',
				FETCH_SELECTED_TOOLTIP: 'Buscar funções selecionadas',
				COL_TITLE: 'Título',
				VIEW_ROLE: 'Ver',
				EDIT_ROLE: 'Editar',
				ROLE_SUFFIX: 'Função',
				DELETE_ROLE: 'Excluir função',
				PERMISSIONS_HEADING: 'Permissões:',
				ENTER_TITLE: 'Inserir Título',
				TITLE_REQUIRED: 'Title is',
				TITLE_REQUIRED_STRONG: 'Obrigatório',
				TITLE_HINT: 'Por favor, insira',
				TITLE_HINT_STRONG: 'Título',
			},
			USERS: {
				TAB_USERS: 'Usuários',
				TAB_USER_GROUPS: 'Grupos de Usuários',
				USER_LIST: 'Lista de Usuários',
				FILTERED_USER_LIST: 'Lista de Usuários Filtrada',
				SHOW_DEACTIVATED: 'Mostrar Desativados',
				DOWNLOAD_TOOLTIP: 'Download User List',
				DOWNLOAD: 'Transferir',
				NEW_USER: 'Novo usuário',
				NEW_USER_TOOLTIP: 'Criar novo Usuário',
				UPLOAD_USER: 'Enviar Usuário',
				UPLOAD_USER_TOOLTIP: 'Criar Múltiplos Usuários',
				SEARCH_USER: 'Search user',
				COL_SL_NO: 'Sl. No.',
				COL_USERNAME: 'Nome de usuário',
				COL_EMAIL: 'E-mail',
				COL_NAME: 'Nome',
				COL_ROLES: 'Funções',
				COL_ADMIN: 'Admin',
				COL_ENTERPRISE_ADMIN: 'Admin da Empresa',
				COL_PHONE: 'Telefone',
				COL_LAST_ACTIVE: 'Última Atividade em',
				COL_STATUS: 'Estado',
				STATUS_ACTIVE: 'Ativo',
				STATUS_DEACTIVATED: 'Desativado',
				EDIT_USER: 'Editar usuário',
				DELETE_USER: 'Excluir usuário',
			},
			USER_GROUPS: {
				TITLE: 'Users Group',
				ADD_TOOLTIP: 'Add User Group',
				NEW_GROUP: 'Novo Grupo de Usuários',
				COL_SL_NO: 'Nº',
				EDIT_TOOLTIP: 'Editar usuário',
				DELETE_TOOLTIP: 'Excluir usuário',
				NAME_REQUIRED: 'Name is',
				NAME_REQUIRED_STRONG: 'Obrigatório',
				NAME_HINT: 'Please enter',
				NAME_HINT_STRONG: 'Nome',
			},
			USER_EDIT: {
				USER_INFO_HEADING: 'Informações do usuário',
				SYSTEM_ACCESS_HEADING: 'Acesso ao Sistema',
				FACILITY_ADMIN_HEADING: 'Acesso de Admin de Instalação',
				MODULE_ACCESS_HEADING: 'Acesso ao Módulo',
				EMAIL_LABEL: 'E-mail',
				EMAIL_HINT: 'Digite o E-mail',
				PASSWORD_LABEL: 'Senha',
				PASSWORD_HINT: '(Min 8 chars, atleast one special char, atleast one UPPERCASE char & atleast one number)',
				PASSWORD_REQUIRED: 'Password is',
				PASSWORD_REQUIRED_STRONG: 'Obrigatório',
				NAME_LABEL: 'Nome',
				NAME_HINT: 'Enter Name',
				PHONE_LABEL: 'Telefone',
				PHONE_HINT: 'Enter Phone',
				PHONE_REQUIRED: 'Phone no. is',
				PHONE_REQUIRED_STRONG: 'Obrigatório',
				ENTERPRISE_ADMIN: 'Admin da Empresa',
				OPT_WHATSAPP: 'Optar por Whatsapp',
				INTERNAL: 'Interno',
				MODEL_RETRAINING: 'Retreinamento do Modelo',
				FACILITIES_LABEL: 'Instalações',
				SELECT_ALL: 'Select All',
				MODULE_LABEL: 'Módulo',
				SELECT_MODULES_HINT: 'Selecionar Módulos',
				SEARCH_MODULES: 'Pesquisar módulos...',
				NO_MATCHING_MODULE: 'Nenhum módulo correspondente encontrado',
				MODULE_REQUIRED: 'Pelo menos um módulo deve ser selecionado.',
				SAVE_TOOLTIP: 'Guardar',
				CANCEL_TOOLTIP: 'Cancelar',
			},
			UPLOAD_USERS: {
				TITLE: 'Upload User List',
				SELECT_CSV: 'Selecionar Arquivo CSV',
				CSV_REQUIRED: 'O arquivo CSV é',
				CSV_REQUIRED_STRONG: 'Obrigatório',
				SELECT_FILE: 'Selecionar Arquivo',
				DOWNLOAD_FORMAT_TOOLTIP: 'Baixar Formato CSV',
				SUBMIT: 'Enviar',
			},
			USER_POPUP: {
				EMAIL_REQUIRED: 'O e-mail é',
				EMAIL_REQUIRED_STRONG: 'Obrigatório',
				EMAIL_HINT: 'Por favor, insira',
				EMAIL_HINT_STRONG: 'E-mail',
				PASSWORD_REQUIRED: 'Password is',
				PASSWORD_REQUIRED_STRONG: 'Obrigatório',
				PASSWORD_HINT: 'Enter',
				PASSWORD_HINT_STRONG: 'Senha',
				NAME_REQUIRED: 'Name is',
				NAME_REQUIRED_STRONG: 'Obrigatório',
				NAME_HINT: 'Inserir',
				NAME_HINT_STRONG: 'Nome',
				PHONE_REQUIRED: 'O telefone é',
				PHONE_REQUIRED_STRONG: 'Obrigatório',
				PHONE_HINT: 'Por favor, insira',
				PHONE_HINT_STRONG: 'Telefone',
				FACILITY_HINT: 'Selecionar',
				SYSTEM_HINT: 'Selecionar',
				SYSTEMS_PLACEHOLDER: 'Sistemas',
				SYSTEM_HINT_STRONG: 'Sistema',
				FACILITY_HINT_STRONG: 'Instalação',
			},
			CONFIRMATION: {
				REASON_REQUIRED: 'O motivo é obrigatório.',
			},
			USER_ROLES: {
				SELECT_ROLE: 'Selecionar Função',
				ASSIGN_TOOLTIP: 'Atribuir função',
				ASSIGN: 'Atribuir',
				ASSIGNED_ROLES: 'Funções atribuídas:',
				REMOVE_TOOLTIP: 'Remove role',
			},
			ADDRESS: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				ADDRESS_LINE: 'Inserir Endereço',
				ADDRESS_LINE_REQUIRED: 'O endereço é',
				ADDRESS_LINE_REQUIRED_STRONG: 'Obrigatório',
				ADDRESS_LINE_HINT: 'Por favor, insira',
				ADDRESS_LINE_HINT_STRONG: 'Endereço',
				CITY: 'City',
				CITY_REQUIRED: 'A cidade é',
				CITY_REQUIRED_STRONG: 'Obrigatório',
				CITY_HINT: 'Por favor, insira',
				CITY_HINT_STRONG: 'Cidade',
				STATE: 'Enter State Line',
				STATE_REQUIRED: 'O estado é',
				STATE_REQUIRED_STRONG: 'Obrigatório',
				STATE_HINT: 'Por favor, insira',
				STATE_HINT_STRONG: 'Estado',
				POSTCODE: 'Inserir CEP',
				POSTCODE_REQUIRED: 'O CEP é',
				POSTCODE_REQUIRED_STRONG: 'Obrigatório',
				POSTCODE_HINT: 'Por favor, insira',
				POSTCODE_HINT_STRONG: 'CEP',
			},
			SOCIAL: {
				FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
				LINKEDIN: 'Inserir endereço do LinkedIn',
				LINKEDIN_HINT: 'Por favor, insira',
				LINKEDIN_HINT_STRONG: 'LinkedIn',
				FACEBOOK: 'Inserir endereço do Facebook',
				FACEBOOK_HINT: 'Por favor, insira',
				FACEBOOK_HINT_STRONG: 'Facebook',
				TWITTER: 'Inserir endereço do Twitter',
				TWITTER_HINT: 'Por favor, insira',
				TWITTER_HINT_STRONG: 'Twitter',
				INSTAGRAM: 'Inserir endereço do Instagram',
				INSTAGRAM_HINT: 'Por favor, insira',
				INSTAGRAM_HINT_STRONG: 'Instagram',
				ADDRESS_SUFFIX: 'endereço',
			},
			CHANGE_PASSWORD: {
				FORM_ERROR: 'Ops! As senhas não coincidem.',
				PASSWORD: 'Digite a Senha',
				PASSWORD_REQUIRED: 'A senha é',
				PASSWORD_REQUIRED_STRONG: 'Obrigatório',
				PASSWORD_HINT: 'Por favor, insira',
				PASSWORD_HINT_STRONG: 'Senha',
				CONFIRM_PASSWORD: 'Confirmar senha',
				CONFIRM_REQUIRED: 'A confirmação da senha é',
				CONFIRM_REQUIRED_STRONG: 'Obrigatório',
				CONFIRM_HINT: 'Por favor, confirme',
				CONFIRM_HINT_STRONG: 'Senha',
				CHANGE_BUTTON: 'Alterar senha',
				SAVE_CHANGES: 'Save changes',
			},
		},
		SYSTEM_VIEW: {
			PARTS: 'PEÇAS',
			ACTIVE: 'Ativo',
			UNIT: 'Unidade',
			SYSTEM: 'Sistema',
			SEARCH_SYSTEM: 'Search System...',
			NO_MATCHING_SYSTEM: 'Nenhum sistema correspondente encontrado',
			OPEN_ALERTS: 'ALERTAS ABERTOS',
			ACTIVE_ALERTS: 'ALERTAS ATIVOS',
			UNACK_ALERTS: 'ALERTAS NÃO RECONHECIDOS',
			RELIABILITY: 'CONFIABILIDADE',
			MEAN_TIME_BETWEEN_ALERTS: 'TEMPO MÉDIO ENTRE ALERTAS',
			UPTIME: 'DISPONIBILIDADE',
			DAYS: 'days',
			PERFORMANCE_CURVES: 'CURVAS DE DESEMPENHO',
			OPEN_IN_NEW_TAB: 'Open In New Tab',
			TAB_ANOMALY: 'Anomalia',
			TAB_SYSTEM_DETAILS: 'Detalhes do Sistema',
			TAB_DATA_QUALITY: 'Qualidade dos Dados',
			TAB_PERFORMANCE: 'Desempenho',
			CLEAR_SIMULATION: 'Limpar Simulação',
			SIMULATION: 'Simulation',
			CLICK_TO_START_PREDICTION: 'Clique para iniciar a predição',
			PREDICTION_RUNNING: 'Predição em Execução',
			NO_OF_DAYS: 'Nº de Dias',
			OK: 'Ok',
			RESET: 'Redefinir',
			RETRAINING: 'Retreinando',
			MORE: 'More',
			TAGS: 'Tags',
			SEARCH_TAG: 'Search Tag...',
			NO_MATCHING_TAG: 'Nenhuma tag correspondente encontrada',
			ASSET_LABEL: 'Ativo:',
			NAME_LABEL: 'Nome:',
			TAG_ID_LABEL: 'Id da Tag:',
			CANCEL: 'Cancelar',
			ASSETS: 'ATIVOS',
			SEARCH_ASSET: 'Search Asset...',
			NO_MATCHING_ASSET: 'Nenhum ativo correspondente encontrado',
			RESET_ASSET_SELECTION: 'Redefinir Seleção de Ativo',
			DATA_QUALITY: {
				SEARCH_TAG: 'Search tag',
				DOWNLOAD_TOOLTIP: 'Baixar Relatório de Qualidade de Dados da Tag',
				DOWNLOAD: 'Transferir',
				COL_TAG_NAME: 'Tag Name',
				COL_MISSING_DATA: 'Dados Faltantes',
				COL_FLAT_LINE: 'Linha Reta',
				COL_OUTLIER: 'Outlier',
				COL_OUT_OF_RANGE: 'Out of Range',
				COL_TOTAL_INVALID_DATA: 'Total Invalid Data',
				COL_ACTIONS: 'Ações',
				MORE_ACTIONS: 'Mais ações',
				NO_RECORDS: 'Nenhum registro encontrado',
				LOADING: 'Loading...',
				SHUTDOWN_TAG: 'Tag de Desligamento',
				TRIP: 'Trip',
				TRIP_LIMIT: 'Limite de Trip',
				ALARM: 'Alarme',
				ALARM_LIMIT: 'Limite de Alarme',
				THRESHOLD: 'Limite',
				THRESHOLD_LIMIT: 'Limite de Threshold',
				INSTRUMENT: 'Instrumento',
				INSTRUMENT_RANGE: 'Faixa do Instrumento',
			},
			SYSTEM_DETAILS: {
				NO_IMAGE_FOUND: 'Nenhuma Imagem Encontrada',
				ASSET_DETAILS: 'Detalhes do Ativo',
				CURRENT_ALERTS_EQUIPMENT: 'Alertas Atuais/Equipamento',
				EQUIPMENT_DISTRIBUTION: 'Distribuição por equipamento',
				TOP_FAILURE_MODES: 'Principais Modos de Falha por Equipamento',
				CUSTOM_INPUTS: 'Entradas Personalizadas',
				SELECT_TAG: 'Select Tag',
				UPDATE: 'Atualizar',
				SPECIFY_VALUE: 'Especificar Valor',
				TIMESTAMP: 'Registro de Tempo',
				LAB_DATA: 'Dados de Laboratório',
				NO_DATA_FOUND: 'Nenhum Dado Encontrado',
			},
			ALERT_SETTINGS: {
				TITLE: 'Alert Settings',
				CANCEL: 'Cancelar',
				FAILURE_MODE: 'Modo de Falha',
				AGGREGATED_ANOMALY_SCORE: 'Pontuação de Anomalia Agregada',
				INSTRUMENT_HEALTH: 'Saúde do Instrumento/Qualidade dos Dados',
				FLATLINE: '1: Linha Reta',
				MISSING_DATA: '2: Dados Faltantes',
				OUT_OF_RANGE: '3: Fora do Intervalo',
				OUTLIERS: '4: Valores Atípicos',
			},
			DIAGNOSTICS: {
				TITLE: 'System Diagnostics',
				CANCEL: 'Cancelar',
				ROOT_CAUSE_ICON_ALT: 'Ícone de Causa Raiz',
				NOT_GENERATED_YET: "You haven't generated System Diagnostics yet.",
				RUN_TO_PROCEED: 'Execute o diagnóstico para continuar.',
				GENERATION_FAILED: 'A última geração de Diagnóstico do Sistema falhou.',
				RUN_AGAIN: 'Execute o diagnóstico novamente para continuar.',
				GENERATE_NOW: 'Gerar Agora',
				REGENERATE: 'Regerar',
				FAILED_AT: 'Geração de Diagnóstico do Sistema falhou em',
				LAST_GENERATED: 'Última geração',
				GENERATING: 'Gerando Diagnóstico do Sistema',
				SEVERITY: 'Severidade:',
				ISSUE: 'Questão:',
				IMPACT: 'Impacto:',
				ACTION: 'Ação:',
				PRIORITY: 'Prioridade:',
			},
			PERFORMANCE_CURVE: {
				TAG: 'Tag',
				FILTER_TAG_VALUE: 'Filtrar valor da Tag',
				SEARCH_TAG: 'Search Tag...',
				NO_TAG_FOUND: 'No Tag found',
				GREATER_THAN: 'Greater than',
				LESS_THAN: 'Less than',
				OK: 'Ok',
				DATE_RANGE: 'Date Range',
				START_DATE: 'Start Date',
				END_DATE: 'End Date',
				SELECT: 'Select',
			},
		},
		PLATFORM_CONFIGURATION: {
			HEADER_TITLE: 'Configuração da Plataforma',
			TABS: {
				ORGANISATION_SETUP: 'Configuração da Organização',
				ASSET_REGISTRY: 'Registro de Ativos',
				MODULE_HIERARCHY: 'Hierarquia de Módulos',
				PROPERTY_TEMPLATES: 'Modelos de Propriedades',
			},
			COMING_SOON: 'Em breve',
		},
		CUSTOMER_SETUP: {
			TABS: {
				CLIENT_SETUP: 'Detalhes da Organização',
				FACILITY_SETUP: 'Instalações',
				PLANT_ECONOMICS: 'Parâmetros Econômicos',
			},
			COMMON: {
				SAVE_CHANGES: 'Save Changes',
				CANCEL: 'Cancelar',
				CONFIRM: 'Confirmar',
				EDIT: 'Editar',
				DELETE: 'Eliminar',
				LOADING: 'Loading...',
				SEARCH: 'Search...',
				CLOSE: 'Fechar',
				SAVED_SUCCESSFULLY: 'Salvo com Sucesso',
				ERROR_SAVING: 'Erro ao salvar alterações',
				TIMEZONE: 'Timezone',
				LATITUDE: 'Latitude',
				LONGITUDE: 'Longitude',
				SELECT_TIMEZONE: 'Selecionar Fuso Horário',
			},
			CLIENT: {
				TITLE: 'Detalhes da Organização',
				SUBTITLE: 'Configure os detalhes da organização',
				LOGO: 'Logotipo',
				UPLOAD_LOGO: 'Enviar Logotipo',
				HQ_ADDRESS: 'Endereço da Matriz',
				ENTERPRISE_NAME: 'Enterprise Name',
				INDUSTRY_SECTOR: 'Setor da Indústria',
				STREET_ADDRESS: 'Street Address',
				CITY: 'City',
				STATE: 'State',
				COUNTRY: 'Country',
				ZIP_CODE: 'ZIP Code',
				ZOOM_LEVEL: 'Nível de Zoom',
				BUSINESS: 'Negócio',
				NOTES: 'Notes',
				SELECT_INDUSTRY_SECTOR: 'Selecionar Setor da Indústria',
				PLACEHOLDER_BUSINESS: 'Insira os detalhes do negócio',
				PLACEHOLDER_NOTES: 'Insira notas',
			},
			FACILITY: {
				TITLE: 'Instalações',
				SUBTITLE: 'Define facility locations and parameters',
				ADD_FACILITY: 'Adicionar Instalação',
				GROUP_BY: 'Group by',
				COL_NAME: 'Nome',
				COL_LOCATION: 'Localização',
				COL_CAPACITY: 'Capacidade (MW)',
				COL_REGION: 'Região',
				COL_INDUSTRY: 'Indústria',
				NO_FACILITIES_SEARCH: 'Nenhuma instalação encontrada.',
				TRY_ADJUSTING: 'Tente ajustar sua consulta de pesquisa.',
				NO_FACILITIES_YET: 'Nenhuma instalação configurada ainda.',
				CLICK_TO_GET_STARTED: "Click 'Add Facility' to get started.",
				DELETE_TITLE: 'Excluir Instalação',
				DELETE_DESCRIPTION: 'Tem certeza de que deseja excluir permanentemente a instalação "{{name}}"?',
				DELETE_WAIT: 'Excluindo instalação...',
				DELETED_SUCCESS: 'Instalação excluída com sucesso',
				DELETE_ERROR: 'Erro ao excluir instalação',
			},
			ADD_FACILITY_DIALOG: {
				TITLE_ADD: 'Adicionar Instalação',
				TITLE_EDIT: 'Editar Instalação',
				UPDATED_SUCCESS: 'Facility updated successfully',
				UPDATE_ERROR: 'Error updating facility',
				CREATED_SUCCESS: 'Instalação criada com sucesso',
				CREATE_ERROR: 'Erro ao criar instalação',
				FACILITY_NAME: 'Nome da Instalação',
				FACILITY_CODE: 'Código da Instalação',
				LOCATION: 'Localização',
				REGION: 'Região',
				CURRENCY: 'Moeda',
				INSTALLED_CAPACITY: 'Capacidade Instalada (MW)',
				INDUSTRY: 'Industry',
				GIS_LOCATION: 'Localização GIS',
				PLACEHOLDER_FACILITY_NAME: 'Nome da planta',
				PLACEHOLDER_LOCATION: 'Cidade, Estado',
				SELECT_REGION: 'Selecionar Região',
				SELECT_CURRENCY: 'Selecionar Moeda',
				SELECT_INDUSTRY: 'Selecionar Indústria',
			},
			FACILITY_FORM: {
				TAB_FACILITY_INFO: 'Informações da Instalação',
				TAB_HISTORIAN_INFO: 'Informações do Historian',
				TAB_SAP_INFO: 'Informações do SAP',
				ENTERPRISE: 'Empresa',
				ADDRESS: 'Endereço',
				CITY: 'Cidade',
				STATE: 'Estado',
				COUNTRY: 'País',
				ZIP: 'CEP',
				ZOOM_LEVEL: 'Nível de Zoom',
				APPLICATION: 'Aplicação',
				NOTES: 'Notas',
				CUSTOMER_ADVOCATE: 'Representante do Cliente',
				HISTORIAN_TYPE: 'Tipo de Historian',
				ACCESS_METHOD: 'Método de Acesso',
				ACCESS_URL: 'URL de Acesso',
				RESOURCE_URL: 'URL do Recurso',
				DATA_FETCH_SETTINGS: 'Configurações de Obtenção de Dados',
				FORWARD_AGGREGATE: 'Encaminhar Agregado',
				FETCH_RATE: 'Taxa de Obtenção',
				FETCH_RATE_UNIT: 'Unidade da Taxa de Obtenção',
				ENABLE_SAMPLING: 'Habilitar Amostragem',
				SAMPLING_RATE: 'Taxa de Amostragem',
				SAMPLING_RATE_UNIT: 'Unidade da Taxa de Amostragem',
				PREDICTION_SETTINGS: 'Configurações de Previsão',
				PREDICTION_RATE: 'Taxa de Previsão',
				PREDICTION_RATE_UNIT: 'Unidade da Taxa de Previsão',
				DQ_ALERTS: 'Alertas de Qualidade de Dados',
				START_DELAY: 'Atraso Inicial (em horas)',
				END_DELAY: 'Atraso Final (em horas)',
				FUNCTIONAL_LOC_MAPPING: 'Mapeamento de Local Funcional/ID do Equipamento',
				UPLOAD_FUNCTIONAL_LOC: 'Enviar Dados de Local Funcional/ID do Equipamento',
				DOWNLOAD_FUNCTIONAL_LOC: 'Baixar Mapeamento de Local Funcional/ID do Equipamento',
				SAP_DATA: 'Dados do SAP',
				UPLOAD_SAP_DATA: 'Enviar Dados do SAP',
				DOWNLOAD_SAP_FORMAT: 'Baixar Formato de Dados do SAP',
				UPDATE_SAP_DATA: 'Atualização de Dados de Permissão do SAP',
				UPLOAD_UPDATE_SAP_DATA: 'Enviar Atualização de Dados de Permissão do SAP',
				DOWNLOAD_UPDATE_SAP_FORMAT: 'Baixar Formato de Atualização de Dados de Permissão do SAP',
				CMMS_WRITE_INTEGRATION: 'Integração de Escrita CMMS',
				CMMS_LAST_DATA_PULL: 'Última Extração de Dados CMMS',
				IP_ADDRESS: 'Endereço IP',
				USER_NAME: 'Nome de Usuário',
				PASSWORD: 'Senha',
				TEST: 'Testar',
				TEST_WRITE_INTEGRATION: 'Testar Integração de Escrita',
			},
			PLANT_ECONOMICS: {
				TITLE: 'Parâmetros Econômicos',
				SUBTITLE: 'Setup economic factors and cost parameters',
				SELECT_FACILITY_MSG: 'Selecione uma instalação para gerenciar seus parâmetros econômicos.',
				SECTION_TITLE: 'Parâmetros de Economia da Produção',
				CHOOSE_FACILITY: 'Escolha uma instalação...',
				PRODUCTION_DETAILS: 'Detalhes da Produção',
				LABOR_SALARY: 'Parâmetros de Salário de Mão de Obra (por hora)',
				UPDATED_SUCCESS: 'Economia da Planta atualizada com sucesso',
				UPDATE_ERROR: 'Erro ao atualizar Economia da Planta',
				COST_PER_UNIT: 'Cost/Unit of Production',
				CAPACITY_HOUR: 'Capacidade/hora (ex. MWh)',
				REVENUE_HOUR: 'Receita/hora',
				MARGIN_PERCENT: 'Margem (%)',
				OTHER_COSTS: 'Outros Custos Fixos de Inatividade',
				TECHNICIAN: 'Técnico',
				HELPER: 'Ajudante',
				SUPERVISOR: 'Supervisor',
				MANAGER: 'Gerente',
			},
		},
		MODEL_EXPLAIN: {
			TITLE: 'Explicar tags',
			SELECTED_TAG: 'Tag selecionado',
			CAUSAL_TAGS: 'Tags causais',
			TAG_SINGULAR: 'tag',
			TAG_PLURAL: 'tags',
			CONTRIBUTOR_SCORE: 'Pontuação',
			NO_CONTRIBUTORS: 'Nenhum tag contribuinte encontrado para este carimbo de data/hora.',
			LOADING_CAUSAL_TAGS: 'Carregando tags causais...',
			CLOSE: 'Fechar',
			ASSET: 'Ativo',
			FULLSCREEN: 'Tela cheia',
			EXIT_FULLSCREEN: 'Sair da tela cheia',
			EXPAND: 'Expandir',
			COLLAPSE: 'Recolher',
			EXPLAIN: 'Explicar',
		},
		FILE_PREVIEW: {
			LOADING_REPORT: "Carregando relatório…",
			REPORT_IN_PROGRESS: "O relatório está sendo gerado. Volte em 5 minutos.",
			REPORT_FAILED: "Não foi possível gerar o relatório. Compartilhe-o novamente.",
		},
		ALERT_V2: {
			FORECAST: {
				TTF_SHORT: 'TTF',
				TTI_SHORT: 'TTI',
				DETAILS: 'Detalhes de {{kind}}',
				NO_VALUES: 'Nenhum valor de {{kind}} válido disponível.',
				ON_DEMAND_NO_FORECAST: 'Nenhuma previsão disponível a partir do ponto selecionado. Arraste o marcador para outro ponto e tente novamente.',
				MIN: 'Mín =',
				CURRENT_VALUE: 'Valor atual',
				VS_BASELINE: 'vs. linha de base',
				ACTIVE_DURATION: 'Duração ativa',
				SAMPLE_DENSITY: 'Densidade da amostra',
				FORECAST: 'Previsão {{kind}} =',
				TTF: {
					ALERT: {
						TITLE: 'TTF a nível de alerta',
						DESCRIPTION: 'TTF = mín (TTF de cada tag contribuinte). A violação prevista mais próxima determina o valor consolidado exibido abaixo.',
					},
					ALERT_LIST: {
						TITLE: 'TTF a nível de alerta',
						DESCRIPTION: 'TTF = mín (TTF de cada modo de falha). A violação prevista mais próxima determina o valor consolidado exibido abaixo.',
					},
					FAILURE_MODE: {
						TITLE: 'TTF do modo de falha',
						DESCRIPTION: 'TTF = mín (TTF de cada tag contribuinte). A violação prevista mais próxima determina o valor consolidado exibido abaixo',
					},
					TAG: {
						TITLE: 'Nível de tag TTF',
						DESCRIPTION: 'Previsão de dias até que o valor projetado da tag ultrapasse o seu limite operacional, com base na taxa de variação recente extrapolada.',
					},
				},
				TTI: {
					ALERT_LIST: {
						TITLE: 'Tempo até a intervenção — nível de alerta',
						DESCRIPTION: 'A previsão de intervenção mais próxima entre os modos de falha deste alerta.',
					},
					ALERT: {
						TITLE: 'Tempo até a intervenção — nível de alerta',
						DESCRIPTION: 'A previsão de intervenção mais próxima deste alerta entre as métricas de degradação de desempenho monitorizadas.',
					},
					FAILURE_MODE: {
						TITLE: 'Modo de Falha — Tempo até a intervenção',
						DESCRIPTION: 'Intervenção operacional prevista mais próxima com base nos indicadores de desempenho associados a este modo de falha.',
					},
					TAG: {
						TITLE: 'Nível de tag — Tempo até a intervenção',
						DESCRIPTION: 'Intervenção operacional prevista mais próxima para esta tag.',
					},
				},
			},
			DQ_SETTINGS: {
				TITLE: "Configurações de Qualidade de Dados",
				DETECTION_TITLE: "Detecção de Qualidade de Dados",
				ALERT_GEN_TITLE: "Geração de Alertas de Qualidade de Dados",
				ALERT_GEN_DESC: "Escolha quais problemas de DQ detectados devem gerar alertas. Desativar a geração de alertas não interrompe o cálculo de DQ.",
				FLATLINE_DETECTION: "Detecção de Estagnação",
				MISSING_DATA_DETECTION: "Detecção de Dados Ausentes",
				OUTLIER_DETECTION: "Detecção de Outliers",
				OUT_OF_RANGE_DETECTION: "Detecção Fora de Faixa",
				ERRATIC_DETECTION: "Detecção Errática",
				FLATLINE_ALERT: "Alerta de Estagnação",
				MISSING_DATA_ALERT: "Alerta de Dados Ausentes",
				OUTLIER_ALERT: "Alerta de Outlier",
				OUT_OF_RANGE_ALERT: "Alerta Fora de Faixa",
				ERRATIC_ALERT: "Alerta Errático",
				CLOSE_TOOLTIP: "Fechar"
			},
			DETAIL: {
				NO_DATA_URL: "No data found for the provided URL.",
				NO_DATA_URL_DESC: "Please verify the entered URL and try again.",
				FAILURE_MODES: "Failure Modes",
				SEARCH: "Search...",
				SORT_FAILURE_SCORE: "Sort by failure score",
				SORT_CREATION_DATE: "Sort by creation date",
				OTHER_ACTIVE_ALERTS: "Other Active Alerts",
				NEW_FAILURE: "New Failure added",
				ALERT_TITLE_PLACEHOLDER: "Alert Title",
				SEARCH_OWNER: "Search Owner...",
				SEARCH_WATCHERS: "Search Watchers..",
				ASSIGN_OWNER: "Assign Owner",
				ADD_WATCHERS: "Add Watchers",
				VERSION_HISTORY: "Version History",
				COPY_LINK: "Copy alert link",
				BOOKMARK: "Bookmark alert",
				REMOVE_BOOKMARK: "Remove bookmark",
				FETCHING_SYSTEM_DETAILS: "Fetching System Details",
				RESTORE_VERSION: "Restore Version",
				CANNOT_DELETE_VERSION: "Cannot delete versions while RCA is in progress",
				DELETE_VERSION: "Delete Version",
				EDIT: "Edit",
				CLOSE: "Close",
				DOWNLOAD: "Download",
				SHARE: "Share",
				ANOMALY_SCORE: "Anomaly Score",
				TIMELINE: "Timeline",
				VERSIONS: "Versões",
				NO_DATA_AVAILABLE: "Nenhum dado disponível",
				EXPORT_REPORT: "Exportar Relatório",
				TIME_TO_FAILURE_IN: "Tempo até a falha em {{unit}}",
				TIME_TO_INTERVENTION_IN: "Tempo até a intervenção em {{unit}}",
				SWITCH_TO_FM_VIEW: 'Mudar para visualização FM',
				SWITCH_TO_RCA_VIEW: 'Mudar para visualização RCA',
				CREATED_ON: 'Criado em',
				MENU_CREATED_ON: 'Criado em',
				STATE: 'Estado',
				DUE_DATE: 'Data de vencimento',
				STATUS: 'Status',
				OWNER: 'Proprietário',
				WATCHERS: 'Observadores',
				WATCHER: 'Observador',
				LAST_RUN_PREFIX: 'Última execução:',
				MENU_LAST_RUN: 'Última execução',
				RUN_NOW: 'Executar agora',
				MENU_RUN_NOW: 'Executar agora',
				MORE: 'Mais',
				REPORT_ISSUE: 'Reportar problema',
				NAV: {
					THRESHOLD: 'Limite',
					DATA_QUALITY: 'Qualidade dos Dados',
					ACTIVITY_LOGS: 'Registros de Atividade',
					DISCUSSION: 'Discussão',
					ANALYSIS_VIEWS: 'Análise e Visualizações',
					RETRAIN_MODEL: 'Retreinar Modelo',
					FEEDBACK: 'Feedback',
					DISPLAY_TAGS: 'Exibir Tags',
					PREFERRED_SETTINGS: 'Configurações Preferidas',
					DOCUMENTS: 'Documentos',
					WORK_ORDERS: 'Ordens de Serviço',
					ROOT_CAUSE_ANALYSIS: 'Análise de causa raiz',
				},
				TAGS_TOOLTIP: "Tags",
				TIME_TO_TRIP: "Time to Trip",
				DAYS: "days",
				CMMS_NUMBER: "CMMS Number",
				STACKED_VIEW: "Stacked View",
				OVERLAY_VIEW: "Overlay View",
				GRID_VIEW: "Grid View",
				NO_RECOMMENDATIONS: "No Recommendations to Show",
				RECOMMENDATIONS: "Recommendations",
				RECOMMENDATION_POPUP: {
					ADD_PLACEHOLDER: "Adicionar recomendação",
					ADD: "Adicionar",
					CANCEL: "Cancelar",
					UPDATE: "Atualizar",
					EMPTY_TITLE: "Nenhuma recomendação disponível",
					EMPTY_HINT: "Adicione uma recomendação para exibi-la aqui.",
				},
				SEARCH_CATEGORY: "Search Category...",
				NO_CATEGORY: "No matching category found",
				SELECT_CATEGORY: "Select Category",
				SEARCH_COMPONENT: "Search Component...",
				NO_COMPONENT: "No matching component found",
				SELECT_COMPONENT: "Select Component",
				SEARCH_ERROR: "Search Error...",
				NO_ERROR_FOUND: "No matching error found",
				SELECT_ERROR: "Select Error",
				ALERT_DETAILS_TITLE: "Detalhes do alerta",
				EMPTY_DATA_ALT: "Sem dados",
				NO_OPEN_FAILURE_MODES: "Nenhum modo de falha aberto.",
				RELATED_ALERTS: "Alertas relacionados",
				TOP_CONTRIBUTING_TAGS: "Principais tags que contribuem para a pontuação de anomalia",
				NO_TAGS_TO_DISPLAY: "Nenhuma tag para exibir.",
				NO_DATA_ALT: "Sem dados",
				SELECT_FM_OR_ADD_TAGS: "Selecione um modo de falha ou adicione tags para visualizar os gráficos.",
				BREAKDOWN_CATEGORY_LABEL: "Categoria de avaria",
				BREAKDOWN_COMPONENT_LABEL: "Componente de avaria",
				BREAKDOWN_ERROR_LABEL: "Erro",
				SAVE: "Save",
				FILTER_TAGS: "Filter tags",
				NO_MATCHING_RESULT: "No matching result",
				START_TYPING: "Start typing to see matching tags.",
				NO_MATCHING_RESULTS: "No matching results",
				CLOSE_TOOLTIP: "Close",
				EDIT_DISABLED: "You're in view-only mode for this facility",
				MULTI_SELECT_DISABLED: "Only the alert owner can multi-select failure modes",
				SPLIT_MERGE_OWNER: "Only an owner of the alert can separate out failure mode(s).",
				SPLIT_MERGE_STATUS: "Only alerts with the status \"In Process,\" \"On Watch,\" \"No Action Planned,\" or \"Pending Defect Raised\" can be separated into a new alert or merged with an existing one.",
				SPLIT_MERGE_APPROVED: "Only approved or unactioned failure mode(s) can be separated to a new alert or merged with an existing alert.",
				SPLIT_MERGE_ACTION: "Move failure mode(s) to a new alert or merge with an existing alert.",
				TITLE_EMPTY: "Enter a title to proceed.",
				TITLE_TOO_LONG: "Title cannot exceed 60 characters.",
				MAINTENANCE_RECORDS_DIALOG: "Existing maintenance records detected.<br>Do you want to delete them to proceed with relearning?",
				FAILURE_DELETED: "Failure Mode \"{{name}}\" deleted successfully",
				FAILURE_DELETE_ERROR: "Something went wrong while deleting \"{{name}}\". Please try again.",
				FAILURE_ADDED: "Failure Mode \"{{name}}\" added successfully",
				USED_IN_MODEL: "Used in model and calculated tag",
				ONGOING: "Ongoing",
				FAILURE_TIMELINE: {
					TITLE: "Timeline de \"{{name}}\"",
					SORT_BY: "Ordenar por",
					SORT_TIMELINE: "Timeline",
					SORT_ASSETS: "Ativos",
					LIMIT_TO_SYSTEM: "Limitar resultados a este sistema",
					ASSET: "Ativo",
					REASON: "Motivo",
					RECOMMENDATIONS: "Recomendações",
					NOT_AVAILABLE: "NA",
					NO_DATA: "Nenhum dado encontrado.",
					MENU_LABEL: "Timeline de falhas",
				},
			},
			RCA: {
				CREATE_WORK_ORDER: "Criar ordem de serviço",
				GENERATING: "Generating Root Cause Analysis",
				GENERATE: "Generate Root Cause Analysis",
				PERCENT_COMPLETED: "% Completed",
				GO_BACK: "Go back",
				RUN_NOW: "Run now",
				CANCEL: "Cancel",
				NOTIFY_ME: "Notify Me",
				ALREADY_IN_PROGRESS: "RCA generation is already in progress",
				RERUN: "Re-run",
				VIEW_TRACES: "View Traces",
				TITLE: "Root Cause Analysis",
				HYPOTHESES: "Hypotheses",
				COMMENTS: "comments",
				EVIDENCE_POINTS: "evidence points",
				DISCUSSION_TOOLTIP: "For internal discussion with your team",
				APPROVED: "Approved",
				APPROVE: "Approve",
				EDIT: "Edit",
				RELEARNED: "Relearned",
				RELEARN: "Relearn",
				SUSPECTED_CAUSE: "Suspected cause",
				CAUSAL_CHAIN: "Causal Chain",
				STEPS: "steps",
				RECOMMENDATIONS: "Recommendations",
				CHART_TAGS: "Chart Tags",
				EXPORT_AS_PDF: "Export as PDF",
				PROPOSED_EVIDENCE: "Proposed Evidence",
				ADD_TO_EVIDENCE: "Add to Evidence",
				EVIDENCE_ADDED_BY: "Added on {{date}} at {{time}} by {{user}}",
				EVIDENCE_ADDED: "Added on {{date}} at {{time}}",
				ALREADY_ADDED: "Already added as evidence",
				DRAG_TO_REORDER: "Click and drag to reorder",
				TABS: {
					TAGS: "Tags",
					WORK_ORDERS: "Work Orders",
					DOCUMENTS: "Documents",
					SYSTEM_DETAILS: "System Details",
				},
				EMPTY: {
					NO_TAGS_EVIDENCE: "No tags added as evidence",
					NO_TAGS_EVIDENCE_DESC: "Tag charts and supporting details will appear here when tags are proposed as evidence.",
					NO_WORK_ORDERS: "No work orders linked",
					NO_WORK_ORDERS_DESC: "Work orders will appear here when maintenance records are associated with this root cause.",
					NO_DOCUMENT_EVIDENCE: "No document evidence",
					NO_DOCUMENT_EVIDENCE_DESC: "Add an existing document or upload a new one to use as evidence.",
					UPLOAD_NEW_DOCUMENT: "Enviar novo documento",
					NO_PROPOSED_EVIDENCE: "No proposed evidence yet",
					NO_PROPOSED_EVIDENCE_DESC: "Add tags, work orders, documents, or P&ID references to support this hypothesis.",
					NO_TAGS_LINKED: "No tags linked",
					NO_TAGS_LINKED_DESC: "Tag charts and supporting details will appear here when tags are added to this hypothesis.",
					NO_DOCUMENTS: "No documents available",
					NO_DOCUMENTS_DESC: "Related technical manuals, reports, and PDFs will appear here when linked to this hypothesis.",
					NO_SYSTEM_DETAILS: "No system details available",
					NO_SYSTEM_DETAILS_DESC: "Associated P&IDs, system specifications, and technical details will appear here when equipment data is linked.",
				},
				WO: {
					WORK_ORDER: "Work Order",
					MANUALLY_ADDED: "Manually Added",
					DESCRIPTION: "Description",
					NOTIFICATION_NO: "Notification #",
					TYPE: "Type",
					EQUIPMENT: "Equipment",
					PLANNING_GROUP: "Planning Group",
					STATUS: "Status",
					USER_STATUS: "User Status",
					CREATED_BY: "Created By",
					COMPLETED_BY: "Completed By",
					CREATED_ON: "Created on",
					COMPLETED_ON: "Completed on",
					CAUSE: "Cause",
					CAUSE_DESC: "Cause Desc.",
					ACTIVITY_GROUP: "Activity Group",
					ACTIVITY_DESC: "Activity Desc.",
					SEE_LESS: "See Less",
					SEE_MORE: "See More",
					ADDED_WITH_ROOTY: "Adicionado com {{name}}",
					ADDED_MANUALLY: "Manually added",
				},
				PDF: {
					ALERT_REPORT: "Alert Report",
					HYPOTHESIS: "Hypothesis",
					TITLE_LABEL: "Title",
					SYSTEM: "System",
					TYPE: "Type",
					CREATED_ON: "Created on",
					OWNER: "Owner",
					STATE: "State",
					DUE_DATE: "Due Date",
					STATUS: "Status",
					WATCHERS: "Watchers",
					HYPOTHESES_PREFIX: "Hypotheses",
					PAGE: "Page",
					ZOOM: "Zoom:",
					SIZE: "Size:",
				},
				FEEDBACK: {
					APPROVE_HEADER: "Approve Hypotheses",
					RELEARN_HEADER: "Relearn Hypotheses",
					COMMENT_PLACEHOLDER: "Add your feedback or notes...",
					REVISION_INFO: "Required for revision",
				},
				SNACKBAR: {
					REPORT_QUEUED: "Relatório solicitado. Enviaremos um link de download para {{email}} quando estiver pronto.",
					RCA_COMPLETED: "RCA generation completed successfully.",
					RCA_NOTIFY: "You will be notified once the RCA generation is complete.",
					RCA_FAILED: "Generating RCA failed.",
					REPORT_REQUEST_FAILED: "Não foi possível solicitar o relatório. Tente novamente.",
					REMOVE_WO_ERROR: "Error while removing work order from evidence.",
					NO_RCA_DATA_AVAILABLE: "Nenhum dado de RCA disponível. Execute a RCA para gerar insights.",
				},
				POPUP: {
					APPROVE_HYPOTHESES: "Approve Hypotheses",
					APPROVE_CAUSAL: "Approve Causal Chain Step",
					APPROVE_RECOMMENDATION: "Approve Recommendation",
					RELEARN_HYPOTHESES: "Relearn Hypotheses",
					RELEARN_CAUSAL: "Relearn Causal Chain Step",
					RELEARN_RECOMMENDATION: "Relearn Recommendation",
				},
				DIALOG: {
				ADD_TAG_EVIDENCE: "Add this tag as proposed evidence?",
				ADD_DOCS_EVIDENCE: "Add {{count}} document(s) as proposed evidence?",
				ADD_WOS_EVIDENCE: "Add this work order as evidence?",
				REMOVE_RC_EVIDENCE_DESC: "Remove this Root Cause Evidence? This can't be undone.",
					REMOVE_EVIDENCE_TITLE: "Confirmation",
					REMOVE_EVIDENCE_DESC: "Remove this evidence? This can’t be undone.",
					ERROR_TITLE: "Erro!",
					OK: "OK",
					CONFIRM: "Confirm",
					CANCEL: "Cancel",
					EVIDENCE_LOCKED: "RCA evidence cannot be moved to the Proposed Evidence section.",
				},
				EVIDENCE_CONTEXT: {
					ADD_TITLE: "Adicionar contexto para esta evidência",
					EDIT_TITLE: "Editar contexto desta evidência",
					CLOSE: "Fechar",
					SUBTITLE: "Ajude a RCA a entender por que esta evidência é relevante e como deve ser usada na próxima execução.",
					FIELD_LABEL: "Por que esta evidência é relevante?",
					FIELD_LABEL_OPTIONAL: "Por que esta evidência é relevante? (Opcional)",
					FIELD_PLACEHOLDER: "Ex.: Esta ordem de serviço menciona vazamento na vedação antes do desarme da bomba.",
					FIELD_ERROR: "Forneça um contexto para continuar",
					CANCEL: "Cancelar",
					UPDATE_CONTEXT: "Atualizar Contexto",
					ADD_EVIDENCE: "Adicionar Evidência",
					ABORT_TITLE: "A evidência não será adicionada",
					ABORT_DESC: "A RCA precisa de uma breve descrição para entender como esta evidência deve ser usada. Se você cancelar agora, esta evidência não será considerada na próxima execução da RCA.",
					ABORT_CANCEL: "Cancelar adição de evidência",
					ABORT_GO_BACK: "Voltar",
				},
			},
			METRICS2: {
				PENDING_DEFECT: "Pending Defect",
			},
			METRICS: {
				HEALTH_SCORE: "Health Score",
				TOTAL_ALERTS: "Total Alerts",
				UNACKNOWLEDGED: "Unacknowledged",
				REVIEWING: "Reviewing",
				PENDING: "Pending",
				UNKNOWN: "Unknown",
			},
			OVERVIEW: {
				SYSTEM_OVERVIEW: "System Overview",
				SYSTEM_HEALTH_INDICATORS: "System Health Indicators",
				PRIORITY_ACTIONS: "Priority Actions",
				PRIORITY_TOOLTIP: "What needs your attention now. Anomaly Alerts that are Unacknowledged and Pending - Defect Raised.",
				NO_PRIORITY_ACTIONS: "No Priority Actions",
				ALL_CAUGHT_UP: "All caught up - nothing need immediate attention ",
				MONITORING_TRACKING: "Monitoring & Tracking",
				MONITORING_TOOLTIP: "Lower priority items being tracked. Anomaly Alerts with Status In Process and On Watch.",
				IN_PROCESS: "In Process",
				ON_WATCH: "On Watch",
				RUNNING_STATE: "Running State",
				AT_RISK: "At Risk",
				REVIEW: "Review",
				HEALTHY: "Healthy",
				CURRENT: "Current",
				THRESHOLD: "Threshold",
				NO_DATA_FOUND: "No Data Found",
				VIEW_ALL: "View all →",
				NO_ALERTS_ARE: "No alerts are {{title}}",
				NO_DATA: "No data",
			},
			TABLE: {
				HEADERS: {
					STATUS: "Status",
					ALERT_NAME: "Alert Name",
					SYSTEM_NAME: "System name",
					TYPE: "Type",
					LOSS: "Loss (kWh)",
					START: "Start",
					STOP: "Stop",
					DURATION: "Duration",
					LAST_ACTIVE: "Last Active",
					CREATED_ON: "Created on",
					STATE: "State",
					OWNER: "Owner",
					WATCHERS: "Watchers",
					FORECAST: "Previsão",
					CATCH: "Catch",
					UPPER_LIMIT: "Upper Limit",
					VALUE: "Value",
					LOWER_LIMIT: "lower limit",
					LAST_SYSTEM_UPDATE: "Last System Update",
					LAST_USER_UPDATE: "Last User Update",
					DISCUSSION: "Discussion",
					TOTAL_VALUE: "Total Value",
					RELIABILITY_SAVING: "Reliability Saving",
					MAINTENANCE_SAVING: "Maintenance Saving",
					PERFORMANCE_SAVING: "Performance Saving",
					ALERT_DRIVEN_MAINTENANCE: "Alert Driven Maintenance",
					COMMENTS: "Comments",
				},
				NEW_FAILURE_ADDED: "New Failure added",
				TIME_TO_TRIP_DAYS: "Time to Trip {{n}} days",
				OPEN_IN_NEW_TAB: "Open in new tab",
				RCA_AVAILABLE: "Análise de causa raiz disponível",
				ASSIGN_OWNER: "Assign Owner",
				ADD_WATCHERS: "Add Watchers",
				SEARCH_OWNER: "Search Owner...",
				SEARCH_WATCHERS: "Search Watchers...",
				NO_APPROVED_FM: "No approved failure modes found",
				EXTRA_MORE: "+ {{count}} more",
				CUSTOMIZE_COLUMNS: "Customize Columns",
				BOOKMARK_ALERT: "Bookmark alert",
				REMOVE_BOOKMARK: "Remove bookmark",
				VIEW_ONLY_MODE: "You're in view-only mode for this facility",
				SYSTEM_TOOLTIP: "System: {{system}}\nUnit: {{unit}}\nFacility: {{facility}}",
			},
			UTILS: {
				STATUS: {
					UNACK: "Unacknowledged",
					IN_PROCESS: "In Process",
					ON_WATCH: "On Watch",
					PENDING_DEFECT: "Pending - Defect Raised",
					CLOSED_MAINT_DEFERRED: "Closed - Maint. Deferred",
					CLOSED_NO_ACTION: "Closed - No Action Planned",
					CLOSED_RESOLVED: "Closed - Resolved",
					REJECTED: "Rejected",
				},
				STATE: {
					TENTATIVE: "Tentative",
					ACTIVE: "Active",
					RETURNED_TO_NORMAL: "Returned to Normal",
					CLOSED: "Closed",
					NOISE_DISCARDED: "Noise/Discarded",
				},
				TYPE: {
					H_ANOMALY: "H. Anomaly",
					L_ANOMALY: "L. Anomaly",
					DATA_QUALITY: "Data Quality",
					USER_REPORTED: "User Reported",
					THRESHOLD: "Threshold",
					DIAGNOSIS: "Diagnosis",
					DIGITAL: "Digital",
				},
				SUBTYPE: {
					OUTLIER: "Outlier",
					OUT_OF_RANGE: "Out of Range",
					FLATLINE: "Flatline",
					MISSING: "Missing",
					UNKNOWN: "Unknown",
					PAINT_BRUSHING: "Paint Brushing",
				},
				THRESHOLD_ALERT: "Threshold Alert",
				DATA_QUALITY_ALERT: "Data Quality Alert",
				TITLE_TOOLTIP: "Title: {{title}}",
				TITLE_ID_TOOLTIP: "Title: {{title}}\nAlert ID: {{id}}",
				DAYS: "{{n}} Days",
				HOURS: "{{n}} Hours",
				DAYS_SHORT: "{{n}}d",
				HOURS_SHORT: "{{n}}h",
				POTENTIAL: "(Potential)",
			},
			DOC_PREVIEW: {
				PREVIEW_DOCUMENT: "Preview Document",
				CLOSE: "Close",
				DOWNLOAD_FILE: "Download File",
			},
			LIST: {
				ALERTS_COUNT: "{{count}} alerts",
				SHOW_MORE_ALERTS: "Show {{count}} more alerts",
				COLUMN_SAVED: "Column view has been saved",
				SOMETHING_WENT_WRONG: "Something went wrong, Please try again",
				TAKES_FEW_SECONDS: "This may take a few seconds...",
				BULK_RESULT: "{{msg}} for {{success}} out of {{total}} alerts.",
				STATUS_CLOSED_NO_ACTION: "Status set to Closed - No action planned",
				ACTION_UPDATED: "{{action}} updated",
				ACTION_STATUS: "Status",
				ACTION_BOOKMARK: "Bookmark",
				ACTION_SUBSCRIBERS: "Subscribers",
			},
			DIALOG: {
				ADD_COMMENT: "Add Comment*",
				COMMENT_REQUIRED: "Please add a comment to continue",
				ADD_A_REASON: "Add a reason",
				SELECTED_FAILURE_MODES: "Selected Failure modes",
				SELECT_ALL: "Select All",
				CANCEL: "Cancel",
				CLOSE: "Close",
				ADD: "Add",
				MARK_AS_CATCH: "Marcar como detectado",
			},
			APPROVE: {
				TITLE: "Approve Failure Mode",
				EDIT_TITLE: "Edit - Approve Failure Mode",
				RECOMMENDATIONS_FOR: "Recommendations for {{name}}",
				ADD_RECOMMENDATION_PLACEHOLDER: "Add recommendation...",
				APPROVE: "Approve",
				UPDATE: "Update",
			},
			RELEARN: {
				TITLE: "Relearn Failure Mode",
				RELEARN: "Relearn",
			},
			BULK_UPDATE: {
				PROCESSING: "Processing",
				COMPLETED: "Bulk Update Completed!",
				DOWNLOAD_REPORT: "Download Report",
				SELECT_DUE_DATE: "Select Due Date",
				DUE_DATE_HINT: "The due date defaults to 28 days from today and can be adjusted if required.",
				DUE_DATE_TOOLTIP: "Select a due date for the selected alert",
				UPDATED_SUCCESSFULLY: "Updated Successfully",
				UPDATE_FAILED: "Update Failed",
				SHOWING: "Showing {{shown}}/{{total}}",
			},
			SPLIT_MERGE: {
				TITLE: "Split/Merge Failure Mode",
				SUBTITLE: "Move approved or unactioned failure mode(s) to a new alert or merge with an existing alert.",
				APPROVED: "Approved",
				APPROVED_ON: "Approved on {{date}}",
				APPROVED_FAILURE_MODES: "Approved Failure Modes",
				FAILURE_MODES: "Failure Modes",
				TAB_CREATE: "Create New Alert",
				TAB_MERGE: "Merge to Existing",
				ALERT_TITLE: "Alert Title",
				SYSTEM: "System",
				UNIT: "Unit",
				SEVERITY: "Severity",
				SELECT_SEVERITY: "Select Severity",
				OWNER: "Owner",
				CREATED_ON: "Created On",
				STATUS: "Status",
				SELECT_TARGET_ALERT: "Select Target Alert",
				SEARCH_PLACEHOLDER: "Search...",
				LOADING: "Loading...",
				NOT_OWNER_MESSAGE: "You are not the owner of the alert with a status of 'In Process', 'On Watch', 'No Action Planned', or 'Pending Defect Raised'.",
				PROCESSING_TOOLTIP: "Processing, please wait!",
				PROCESSING: "Processing...",
				SUBMIT_CREATE: "Create New Alert",
				SUBMIT_MERGE: "Merge to Alert",
				VIEW_CREATE: "Open New Alert",
				VIEW_MERGE: "Open Alert",
				GO_BACK: "Go Back",
				SUCCESS_CREATE: "New alert successfully created.",
				SUCCESS_MERGE: "Successfully merged with the existing alert.",
				FAILED_CREATE: "Alert creation was unsuccessful. Please try again.",
				FAILED_MERGE: "Alert merge failed. Please try again.",
				TITLE_PLACEHOLDER_EXAMPLE: 'CESR-C-20250807-IPNK',
				SYSTEM_PLACEHOLDER_EXAMPLE: 'GAS TURBINE TRAIN D',
				UNIT_PLACEHOLDER_EXAMPLE: 'COGEN',
				OWNER_PLACEHOLDER_EXAMPLE: 'Ronald Richards',
				CREATED_ON_PLACEHOLDER_EXAMPLE: '25 de ago. de 2025',
			},
			FILTER: {
				FILTER_BY: "Filter by",
				SEARCH_BY_ALERT_NAME: "Search by Alert Name...",
				CLEAR_SEARCH: "Clear search",
				STATE: "State",
				ANOMALY: "Anomaly",
				ACTIVE: "Active",
				RETURNED_TO_NORMAL: "Returned to Normal",
				OTHER_ALERT_TYPES: "Other Alert Types",
				CATCH: "Catch",
				TRUE: "True",
				FALSE: "False",
				AGENTS: "Agentes",
				HAS_RCA: "Com análise de causa raiz",
				NO_RCA: "Sem análise de causa raiz",
				BOOKMARK_AND_CASES: "Bookmark and Cases",
				ONLY_TRACKED_CASES: "Only alerts with tracked cases",
				DIAGNOSIS_CONDITIONS: "Diagnosis Conditions",
				TRIP_BREAKDOWN: "Trip/Breakdown",
				UNDER_PERFORMANCE: "Under Performance",
				SMB_DOWN: "SMB Down",
				SMB_UNDER_PERF: "SMB Under Perf",
				CURTAILMENT: "Curtailment",
				OUT_OF_ENV_SCOPE: "Out of Env Scope",
				DATA_QUALITY_TYPE: "Data Quality Type",
				OUTLIER: "Outlier",
				OUT_OF_RANGE: "Out of Range",
				FLATLINE: "Flatline",
				MISSING: "Missing",
				TAG_STATUS: "Status da tag",
				TAG_STATUS_INFO: "Aplicável apenas para alertas de DQ",
				USED_IN_MODEL: "Usado no modelo",
				DROPPED_TAGS: "Tags descartadas",
				WATCHERS: "Watchers",
				SEARCH_PLACEHOLDER: "Start typing to search",
				CLEAR_ALL: "Clear All",
			},
			COLUMNS: {
				NUMBER: "Number",
				ALERT_NAME: "Alert Name",
				STATUS: "Status",
				SYSTEM: "System",
				TYPE: "Type",
				DATE: "Date",
				CREATED_ON: "Created on",
				STATE: "State",
				OWNER: "Owner",
				WATCHERS: "Watchers",
				CATCH: "Catch",
				FORECAST: "Previsão",
				UPPER_LIMIT: "Upper Limit",
				VALUE: "Value",
				LOWER_LIMIT: "Lower Limit",
				LAST_SYSTEM_UPDATE: "Last System Update",
				LAST_USER_UPDATE: "Last User Update",
				TOTAL_VALUE: "Total Value",
				RELIABILITY_SAVINGS: "Reliability Savings",
				MAINTENANCE_SAVINGS: "Maintenance Savings",
				PERFORMANCE_SAVINGS: "Performance Savings",
				ALERT_DRIVEN_MAINTENANCE: "Alert Driven Maintenance",
				DISCUSSION: "Discussion",
				COMMENTS: "Comments",
				LOSS: "Loss (kWh)",
				START: "Start",
				STOP: "Stop",
				DURATION: "Duration",
			},
			NO_ALERTS: {
				TITLE: "No alerts found",
				SUBTITLE: "Check your filters and date range",
			},
			COLUMN_CONFIG: {
				SHOW_COLUMNS: "Show columns",
				SEARCH_PLACEHOLDER: "Start typing to search",
				SELECT_ALL: "Select All",
				RESET_TO_DEFAULT: "Reset to default",
			},
			PAGE_TITLE: "Alerts",
			OVERVIEW_TAB: "Overview",
			SEARCH_PLACEHOLDER: "Search...",
			NO_MATCHING_RESULTS: "No matching results",
			SEARCH_OWNER_PLACEHOLDER: "Search Owner...",
			SELECT_OWNERS: "Select Owners",
			ALL_STATUSES: "All Statuses",
			STATUS_FILTER: "Status Filter",
			CHOOSE_STATUSES: "Choose statuses to display",
			FILTERS: "Filters",
			GROUP_BY: "Group by",
			MORE: "More",
			SELECT_ALERTS_FOR_CASE: "Select the Alert(s) you want to tag in this case",
			SHOWING_RESULTS_FOR: 'Mostrando resultados para "{{term}}"',
			CHIP: {
				THRESHOLD: "Threshold",
				HIGH_ANOMALY_SHORT: "H. Anomaly",
				LOW_ANOMALY_SHORT: "L. Anomaly",
				DATA_QUALITY: "Data Quality",
				DIAGNOSIS: "Diagnosis",
			},
			TYPE: {
				THRESHOLD: "Threshold",
				HIGH_ANOMALY: "High Anomaly",
				LOW_ANOMALY: "Low Anomaly",
				DATA_QUALITY: "Data Quality",
				DIAGNOSIS: "Diagnosis",
			},
			AUTO_REFRESH: {
				LABEL: "Atualização automática",
				OFF: "Desativado",
				LIVE: "Ao vivo",
				MIN_5: "5 minutos",
				MIN_15: "15 minutos",
				MIN_30: "30 minutos",
				HOUR_1: "1 hora",
			},
			MORE_MENU: {
				EXPORT_DATA: "Export Data",
				EXPAND_ALL_GROUPED: "Expand all grouped items",
				COLLAPSE_ALL_GROUPED: "Collapse all grouped items",
				EXPAND_ALL_WITHIN_GROUP: "Expand all items within group",
				COLLAPSE_ALL_WITHIN_GROUP: "Collapse all items within group",
				SWITCH_TO_CLASSIC: "Switch to Classic View",
			},
			TOOLTIP: {
				TYPE_NEW_EVENTS: "{{type}} new events",
				TYPE_ALERTS: "{{count}} {{type}} alerts",
				COUNT_NEW_EVENTS: "{{count}} new events",
				COUNT_TYPE_NEW_EVENTS: "{{count}} {{type}} new events",
				SYSTEM_OPEN_ALERTS: "System: {{name}}\nOpen Alerts: {{count}}",
				UNIT_OPEN_ALERTS: "Unit: {{name}}\nOpen Alerts: {{count}}",
				FACILITY_OPEN_ALERTS: "Facility: {{name}}\nOpen Alerts: {{count}}",
			},
		},
		MODEL_WIZARD: {
			ESCALATION_CONFIG: {
				TITLE: 'Configuração de Escalonamento',
				DELAY_LABEL: 'Atraso de Escalonamento (em Dias)',
				LEVEL_LABEL: 'Nível',
				LEVEL_PLACEHOLDER: 'Digite o nível',
				SELECT_USERS: 'Selecionar Usuários',
				SEARCH_USERS_PLACEHOLDER: 'Buscar por ID de E-mail',
				NO_MATCHING_EMAIL: 'Nenhum ID de e-mail correspondente encontrado',
				EMAILS_LABEL: 'Adicionar IDs de e-mail separados por vírgula',
				EMAILS_PLACEHOLDER: 'abc@gmail.com, def@gmail.com',
				ADD_LEVEL: '+ Adicionar nível',
				ADD_LEVEL_TOOLTIP: 'Adicionar nível',
				REMOVE_TOOLTIP: 'Remover',
				CONFIG_TYPE_UNIT: 'Usar Configuração da Unidade',
				CONFIG_TYPE_CUSTOM: 'Usar Configuração Personalizada',
				CONFIG_TYPE_NONE: 'Nenhuma Configuração de Escalonamento',
			},
			NO_ASSET_TAGS_FOUND: 'Nenhuma tag de ativo disponível',
			NO_MAPPED_TAGS_FOUND: 'Nenhuma tag mapeada disponível',
		ASSET_INFORMATION: "Asset Information",
		NO_ASSET_FOUND: "Nenhum ativo encontrado",
		EQUIPMENT: "Equipment",
		TEMPLATE: "Template",
		APPLICATION: "Application",
		INDUSTRY: "Industry",
		CONFIGURATION_COL: "Configuration",
		MODEL_CONFIGURATION: "Model Configuration",
		MODELING_TECHNIQUE: "Modeling Technique",
		SCALER: "Scaler",
		SMOOTHING: "Smoothing",
		SELECT_SMOOTHING_FUNCTION: "Select Smoothing Function",
		SMOOTHING_FUNCTION: "Smoothing Function",
		WINDOW_SIZE: "Window Size",
		IN_HOURS: "in hours",
		IN_DAYS: "(in days)",
		SIGMA: "Sigma",
		POLYNOMIAL_ORDER: "Polynomial Order",
		VALUE_REQUIRED: "Value is required",
		VALUE_MIN_1: "Value must be greater than or equal to 1",
		NONE: "None",
		ANOMALY_SCORE_CALC_METHOD: "Anomaly Score Calculation Method",
		ANOMALY_CALC_DEFAULT: "Default(RMS of all tags)",
		ANOMALY_CALC_NEW: "New(Sum of RMS of Asset tags)",
		PREDICTION_TIME_PERIOD: "Prediction Time Period",
		TRAINING_TIME_PERIOD: "Training Time Period",
		CALENDAR_SELECTION: "Calendar Selection",
		CHART_BASED_SELECTION: "Chart-based Selection",
		START_TIME: "Start Time",
		END_TIME: "End Time",
		START_TIME_REQUIRED: "Start time required",
		END_TIME_REQUIRED: "End time required",
		STARTUP_TRAINING_BUFFER: "Startup Training Buffer",
		SHUTDOWN_TRAINING_BUFFER: "Shutdown Training Buffer",
		TRAINING_BUFFER_GROUP: "Training Buffer",
		TRAINING_BUFFER_STARTUP_SHORT: "Startup (in days)",
		TRAINING_BUFFER_SHUTDOWN_SHORT: "Shutdown (in days)",
		TRAINING_CONDITIONS: "Training Conditions",
		METHOD1_RANGE_FILTER: "Method 1: Range Filter",
		METHOD2_CONDITION_FILTER: "Method 2: Condition Filter",
		LOAD_TAG: "Load Tag",
		REFERENCE_TAG: "Reference Tag",
		NUM_OF_BINS: "Num of Bins",
		QUANTILE_CONDITION: "Quantile Condition",
		LESS_THAN: "Less Than",
		GREATER_THAN: "Greater Than",
		EQUAL_TO: "Equal To",
		VALUE: "Value",
		TAG: "Tag",
		MIN: "Min",
		MAX: "Max",
		CONDITION: "Condition",
		AND: "And",
		OR: "Or",
		ADD: "Add",
		CLOSE: "Close",
		ADD_NOTE: "Add Note",
		VIEW_NOTE: "View Note",
		VIEW_EDIT_NOTE: "View / Edit Note",
		NOTE_FOR_DATE_RANGE: "for Date Range {{range}}",
		ENTER_NOTES: "Enter notes here",
		SEARCH_TAGS: "Search Tags...",
		NO_MATCHING_TAGS: "No matching tags found",
		SELECT_TRAINING_REGIONS: "Select training regions for me",
		ADD_TRAINING_RANGE: "Add Training Range",
		DELETE_TRAINING_RANGE: "Delete Training Range",
		NAME: "Name",
		TAG_ID: "TagId",
		UNIT_SETUP: "Unit Setup",
		SCHEMATIC: "Schematic",
		EQUIPMENT_LIST: "Equipment List",
		UNITS: 'Unidades',
		CAPACITY: 'Capacidade',
		SYSTEM_INFORMATION: 'Informações do Sistema',
		DESCRIPTION: 'Descrição',
		CRITICALITY: 'Criticidade',
		COMMENTS: 'Comentários',
		SEARCH: 'Pesquisar',
		NO_UNIT_FOUND: 'Nenhuma unidade encontrada',
		NO_SYSTEM_FOUND: 'Nenhum sistema encontrado',
		CUSTOMER: 'Cliente',
		FACILITY: 'Facility',
		UNIT: 'Unidade',
		SYSTEM: 'Sistema',
		ORIGINAL_AUTHOR: 'Autor Original',
		TRAINING_DATASET: 'Conjunto de Dados de Treinamento',
		VALIDATION_LOSS: 'Perda de Validação',
		LAST_DEPLOYED: 'Última Implantação',
		ON: 'Em',
		SELECTED_VERSION: 'Versão Selecionada',
		DEPLOYED_PERIOD: 'Período Implantado',
		STATUS: 'Estado',
		MARK_AS_IMPORTANT: 'Marcar como Importante',
		DISABLE: 'Desativar',
		DELETE: 'Eliminar',
		DELETE_VERSION_TOOLTIP: 'Excluir a versão',
		TAB_FACILITY_SETUP: 'Configuração da Instalação',
		TAB_TAG_MAPPING: 'Mapeamento de Tag',
		TAB_DATA_SYNC: 'Sincronização de Dados',
		TAB_DATA_IMPORT: 'Importação e Processamento de Dados',
		TAG_MAPPING_REQUIRED_TOOLTIP: 'O mapeamento de tags precisa ser concluído para que esta aba seja habilitada.',
		TAB_MODEL_BUILDING: 'Construção do Modelo',
		RECALCULATING_TOOLTIP: 'Recálculo em Andamento',
		CUSTOMER_TAG_LIST: 'Lista de Tags do Cliente',
		TAGS_BTN: 'Tags',
		MODEL_BUILDING_CONFIG_TOOLTIP: 'Configuração da Etapa de Construção do Modelo',
		// model-tag-mapping
		TAGS_TO_BE_MAPPED: 'Tags a Serem Mapeadas',
		UPLOAD_SYSTEM_TAGS: 'Enviar Tags do Sistema',
		DOWNLOAD_FACILITY_TAGS: 'Baixar Tags da Instalação',
		ASSETS_PLACEHOLDER: 'ATIVOS',
		SEARCH_IN_ALL_FIELDS: 'Pesquisar em todos os campos',
		COL_NAME: 'Nome',
		COL_DESCRIPTION: 'Descrição',
		COL_UNIT: 'Unidade',
		CUSTOMER_TAGS: 'Tags do Cliente',
		UPLOAD_TAGS_TOOLTIP: 'Enviar Tags',
		DOWNLOAD_TAGS_TOOLTIP: 'Baixar Tags',
		TAG_MAPPING_NO_ASSET_TOOLTIP: 'É necessário criar pelo menos 1 ativo para realizar o Mapeamento de Tags',
		MAP_SELECTED: 'Mapear Selecionados',
		IMPORT_WO_MAPPING: 'Importar Mapeamento de OT',
		TAGS_MAPPED: 'Tags Mapeadas',
		SAVE_CHANGES: 'Save Changes',
		UNMAP_SELECTED: 'Desvincular Selecionados',
		UNMAPPED_TAGS: 'Tags Não Mapeadas',
		COL_TAG_NAME: 'Nome da Tag',
		COL_ASSET: 'Ativo',
		COL_TAG_ID: 'Id da Tag',
		COL_THRESHOLD_HIGH: 'Limite Alto',
		COL_THRESHOLD_LOW: 'Limite Baixo',
		COL_TRIP_HIGH: 'Trip Alto',
		COL_TRIP_LOW: 'Trip Baixo',
		COL_ALARM_HIGH: 'Alarme Alto',
		COL_ALARM_LOW: 'Alarme Baixo',
		COL_DIRECTIONALITY: 'Direcionalidade',
		COL_FLATLINE_DETECTION: 'Detecção de Estagnação',
		COL_MISSING_DATA_DETECTION: 'Detecção de dados ausentes',
		COL_OUTLIER_DETECTION: 'Detecção de valores atípicos',
		COL_RANGE_DETECTION: 'Detecção de fora de faixa',
		COL_FLATLINE_ALERT_GENERATION: 'Geração de alerta de estagnação',
		COL_MISSING_DATA_ALERT_GENERATION: 'Geração de alerta de dados ausentes',
		COL_OUTLIER_ALERT_GENERATION: 'Geração de alerta de valor atípico',
		COL_RANGE_ALERT_GENERATION: 'Geração de alerta de fora de faixa',
		COL_ATTENTION: 'Atenção',
		COL_THRESHOLD_NOTIFICATION: 'Notificação de Limite',
		COL_KPI: 'KPI',
		SHOW_COLUMNS_TOOLTIP: 'Mostrar colunas',
		VIEW_CHANGES_TOOLTIP: 'Ver Alterações',
		EDIT_TAG_TOOLTIP: 'Editar Tag',
		VIEW_PIDS_TOOLTIP: 'Ver P&IDs',
		// bulk-tag-upload-alert
		IN_PROGRESS: 'Em Andamento',
		CORRECT_RECORDS_MSG: 'Corrija os registros com erros e envie.',
		DOWNLOAD_ERROR_RECORDS: 'Baixar registros com erro',
		// tim-configuration-panel
		RELEVANT_INFORMATION: 'Informações Relevantes',
		PIDS_PANEL: 'P&IDs',
		IMAGES_PANEL: 'Imagens',
		TEST_REPORTS_PANEL: 'Relatórios de Teste',
		PROCEDURES_PANEL: 'Procedimentos',
		// model-data-import
		TAG_DATA: 'Dados da Tag',
		SEARCH_TAG: 'Search Tag',
		SEARCH_ASSET: 'Pesquisar Ativo',
		EXPORT_DQ_METRICS_TOOLTIP: 'Exportar Métricas de QD',
		EXPORT: 'Exportar',
		TAG_SELECTION_PLACEHOLDER: 'Seleção de Tag',
		PREPROCESSING_STATS_PLACEHOLDER: 'Estatísticas de Pré-processamento',
		TAG_MAPPING_PLACEHOLDER: 'Mapeamento de Tag',
		TAG_TYPE_PLACEHOLDER: 'Tipo de Tag',
		OPERATING_REGION_PLACEHOLDER: 'Região Operacional',
		COL_PLOT: 'Gráfico',
		COL_CORR: 'Corr',
		COL_MODEL: 'Modelo',
		COL_TAGS: 'Tags',
		SHUTDOWN_TAG_TOOLTIP: 'Tag de Desligamento',
		COL_MAX: 'Máx',
		COL_MIN: 'Mín',
		COL_STD_DEV: 'Desv. Padrão',
		COL_AGGREGATE_TAG: 'Tag Agregada',
		COL_MEAN_SHIFT: 'Mudança da Média',
		COL_VARIANCE: 'Variância',
		COL_MEAN: 'Média',
		COL_DEVIATION_SCORE: 'Pontuação de Desvio',
		COL_OP_UPPER: 'Op. Superior',
		COL_OP_LOWER: 'Op. Inferior',
		COL_NANS: 'NaNs',
		COL_OUTLIERS: 'Valores Atípicos',
		COL_FLATLINE: 'Linha Reta',
		COL_OUT_OF_RANGE: 'Fora do Intervalo',
		COL_TOTAL_INVALID_DATA: 'Total de Dados Inválidos',
		NO_RECORDS_FOUND: 'Nenhum registro encontrado',
		CHOOSE_MODEL_VERSION_MSG: 'Escolha uma versão do modelo para ver os gráficos das tags',
		SELECT_PLOT_CHECKBOX_MSG: 'Selecione a caixa de seleção Gráfico de uma tag para ver o gráfico',
		TAG_CORRELATION_TITLE: 'Correlação de Tags',
		TAG_CORRELATION_CONDITION_PLACEHOLDER: 'Condição de Correlação de Tags',
		CORR_GREATER_THAN_OPTION: 'Mostrar Tags com Correlações Maiores que',
		CORR_LESS_THAN_OPTION: 'Mostrar Tags com Correlações Menores que',
		CORR_VALUE_PLACEHOLDER: 'Valor de Corr',
		SELECT_RANGE_LABEL: 'Selecionar Intervalo',
		SELECT_RANGE_TOOLTIP: 'Arraste pelo gráfico para escolher um intervalo de datas',
		REMOVE_RANGE_LABEL: 'Remover Intervalo',
		REMOVE_RANGE_TOOLTIP: 'Arraste pelo gráfico para excluir um intervalo de datas da modelagem',
		SYSTEM_DATA_FILTER_LABEL: 'Filtro de Dados do Sistema',
		SELECTED_DATE_RANGES_LABEL: 'Intervalo(s) de Data Selecionado(s):',
		CONFIRM_SELECTION: 'Confirmar Seleção',
		REMOVED_DATE_RANGES_LABEL: 'Intervalo(s) de Data Removido(s):',
		// edit-model-popup
		EDIT_MODEL_TITLE: 'Editar Modelo',
		FORM_ERROR_MSG: 'Ops! Altere algumas coisas e tente enviar novamente.',
		OP_LOWER_PLACEHOLDER: 'Op. Inferior',
		OP_UPPER_PLACEHOLDER: 'Op. Superior',
		REQUIRED: 'Obrigatório',
		CANCEL_CHANGES_TOOLTIP: 'Cancelar alterações',
		CANCEL: 'Cancelar',
		SAVE_DATA_TOOLTIP: 'Salvar Dados',
		SAVE: 'Guardar',
		// model-building
		SIMULATION: 'Simulation',
		SHOW_FAILURE_INFO: 'Mostrar Informações de Falha',
		OK: 'Ok',
		RESET_ASSET_SELECTION_TOOLTIP: 'Redefinir Seleção de Ativo',
		CLOSE_CROSSHAIR_TOOLTIP: 'Fechar Mira',
		CROSSHAIR: 'Mira',
		LOADING: 'Loading...',
		NO_FAILURE_MODE_FOUND: 'Nenhum modo de falha encontrado.',
		// mb-configuration-panel
		MODEL_PARAMETERS_PANEL: 'Parâmetros do Modelo',
		BOILER_HEALTH_PANEL: 'Saúde da Caldeira',
		ALERT_PARAMETERS_PANEL: 'Parâmetros de Alerta',
		FAILURE_PARAMETERS_PANEL: 'Parâmetros de Falha',
		APPLY_SOURCE_VERSION_FEEDBACK: 'Aplicar Feedback da Versão de Origem',
		COMMENT_PLACEHOLDER: 'Comentário',
		SAVE_MODEL: 'Salvar Modelo',
		SAVE_MODEL_TOOLTIP: 'Salvar Modelo',
		RESAVE: 'Salvar Novamente',
		RESAVE_TOOLTIP: 'Salvar Modelo Novamente',
		DEPLOY_MODEL_TOOLTIP: 'Implantar Modelo',
		DEPLOY_TAG_UNMAPPED_TOOLTIP: 'A implantação não é permitida, pois o modelo {{version}} contém tag(s) que foram desmapeadas do sistema',
		DEPLOY: 'Implantar',
		GO_LIVE_CSV_TOOLTIP: 'Entrar em Produção com Streaming de CSV/Historian',
		GO_LIVE: 'ENTRAR EM PRODUÇÃO',
		// go-live-popup
		GO_LIVE_OPTIONS_TITLE: 'Opções de Entrada em Produção',
		DATA_SOURCE_TYPE_PLACEHOLDER: 'Tipo de Fonte de Dados',
		HISTORIAN_OPTION: 'Historian',
		START_PREDICTION_FROM: 'Iniciar Predição A Partir De',
		FROM_DATE_REQUIRED: 'Data Inicial é',
		GO_LIVE_BTN: 'Entrar em Produção',
		GO_LIVE_TOOLTIP: 'Entrar em Produção',
		// alert-form
		THRESHOLD_PLACEHOLDER: 'Limite',
		AUTOMATIC_OPTION: 'Automático',
		MANUAL_OPTION: 'Manual',
		RISK_PROFILE_PLACEHOLDER: 'Perfil de Risco',
		CREATE_CONDITION: 'Criar Condição',
		RETURN_CONDITION: 'Condição de Retorno',
		EXCEED_FOR_PLACEHOLDER: 'Excede Por',
		OUT_OF_PLACEHOLDER: 'Fora de',
		DOWN_FOR_PLACEHOLDER: 'Abaixo Por',
		ALARM_THRESHOLD_PLACEHOLDER: 'Limite de Alarme',
		ADD_TOOLTIP: 'Adicionar',
		GENERATE_ALERT_TOOLTIP: 'Gerar Alerta',
		UPDATE: 'Atualizar',
		// boiler-form
		SELECT_DATE_PLACEHOLDER: 'Selecionar Data',
		DATE_REQUIRED_ERROR: 'A data é',
		HEALTH_PLACEHOLDER: 'Saúde',
		REMOVE_TOOLTIP: 'Remover',
		GENERATE_BOILER_HEALTH_TOOLTIP: 'Gerar Saúde da Caldeira',
		// failure-form
		ANOMALY_WT_THRESHOLD_PLACEHOLDER: 'Limite de Peso de Anomalia',
		LOW_OPTION: 'Baixo',
		MEDIUM_OPTION: 'Médio',
		HIGH_OPTION: 'Alto',
		CUTOFF_PARTIAL_MATCH: 'Corte para correspondência parcial',
		IN_PERCENTAGE_HINT: 'em Porcentagem',
		CUTOFF_FULL_MATCH: 'Corte para correspondência total',
		UPDATE_FAILURE_TOOLTIP: 'Atualizar Falha',
		// v2-alert-form
		START_DELAY_PLACEHOLDER: 'Atraso Inicial',
		NO_OF_HOURS_HINT: '(nº de horas)',
		END_DELAY_PLACEHOLDER: 'Atraso Final',
		GROUPING: 'Agrupamento',
		DOWN_CONDITION_PLACEHOLDER: 'Condição de Inatividade',
		ANOMALY_SCORE_THRESHOLD: 'Limite de Pontuação de Anomalia',
		FILTER_FAILURE_PLACEHOLDER: 'Filtrar Falha',
		VALUE_BETWEEN_0_1: 'Insira um valor entre 0 e 1',
		FEEDBACKS: 'Feedbacks',
		LIVE_FEEDBACKS: 'Feedbacks em Tempo Real',
		PREVIOUS_FEEDBACKS: 'Feedbacks Anteriores',
		BAND_LEARNING_BEHAVIOUR: 'Comportamento de Aprendizado de Faixa',
		CONSERVATIVE: 'Conservador',
		CONSERVATIVE_TOOLTIP: 'Cria faixas mais estreitas em torno da região de treinamento selecionada',
		MODERATE: 'Moderado',
		MODERATE_TOOLTIP: 'Cria faixas equilibradas em torno da região de treinamento selecionada',
		AGGRESSIVE: 'Agressivo',
		AGGRESSIVE_TOOLTIP: 'Cria faixas mais amplas em torno da região de treinamento selecionada',
		UPDATE_FEEDBACK: 'Atualizar Feedback',
		UPDATE_PARAMETERS_TOOLTIP: 'Atualizar Parâmetros',
		// di-configuration-panel
		DATA_IMPORT_PANEL: 'Importação de Dados',
		PRE_PROCESSING_PANEL: 'Pré-Processamento',
		// data-import-form
		CSV_OPTION: 'CSV',
		UPLOADED_CSV_OPTION: 'CSV Enviado',
		SELECT_SOURCE_HINT: 'Selecionar Origem para importar dados',
		SAMPLING_RATE_PLACEHOLDER: 'Taxa de Amostragem',
		SAMPLING_RATE_REQUIRED: 'Taxa de Amostragem',
		IN_MINUTES_HINT: '(em minutos)',
		SELECT_CSV_FILE_PLACEHOLDER: 'Selecionar Arquivo CSV',
		CSV_FILE_REQUIRED: 'O arquivo CSV é',
		SELECT_FILE_BTN: 'Selecionar Arquivo',
		DATA_SYNC_MORE_DATA_TOOLTIP: 'Para obter mais dados, vá para a aba Sincronização de Dados e faça uma solicitação de coleta de dados.',
		DATA_SET_NAME_PLACEHOLDER: 'Nome do Conjunto de Dados',
		IMPORT_TOOLTIP: 'Importar',
		IMPORT_DATA: 'Importar Dados',
		// pre-processing-form
		STATE_IDENTIFICATION_PANEL: 'Identificação de Estado',
		EXCLUDE_REGION_PANEL: 'Excluir Região',
		PRE_PROCESSING_CONFIG_PANEL: 'Configuração de Pré-Processamento',
		MODEL_TAG_SELECTION_PANEL: 'Seleção de Tags do Modelo',
		PROCESS_TOOLTIP: 'Processo',
		PROCESS_DATA: 'Processar Dados',
		// state-identification-form
		SHUTDOWN_TAG_PLACEHOLDER: 'Tag de Desligamento',
		CONDITION_PLACEHOLDER: 'Condição',
		LESS_THAN_OPTION: 'Menor Que',
		GREATER_THAN_OPTION: 'Maior Que',
		EQUAL_TO_OPTION: 'Igual A',
		VALUE_PLACEHOLDER: 'Valor',
		SHUTDOWN_CONDITION_PLACEHOLDER: 'Condição de Desligamento',
		AND_OPTION: 'E',
		OR_OPTION: 'Ou',
		SHUTDOWN_SPAN_PLACEHOLDER: 'Duração do Desligamento',
		IN_HOURS_HINT: '(em horas)',
		SHUTDOWN_TRANSITION_PLACEHOLDER: 'Transição de Desligamento',
		STARTUP_TRANSITION_PLACEHOLDER: 'Transição de Início',
		// exclude-region-form
		EXCLUDE_REGION_TAG_PLACEHOLDER: 'Tag de Região Excluída',
		EXCLUDE_CONDITION_PLACEHOLDER: 'Condição de Exclusão',
		// pre-processing-configuration-form
		OUTLIER_DETECTION_METHOD: 'Método de Detecção de Outliers',
		OUTLIER_DETECTION_THRESHOLD: 'Limite de Detecção de Outliers',
		SIGMA_HINT: 'Sigma',
		INTERPOLATION_METHOD: 'Método de Interpolação',
		INTERPOLATION_CONFIG: 'Configuração de Interpolação',
		FLATLINE_THRESHOLD_TIME: 'Tempo Limite de Estagnação',
		FLATLINE_TIME_BASE: 'Base de Tempo de Estagnação',
		HOURS_OPTION: 'Horas',
		MINUTES_OPTION: 'Minutos',
		SECONDS_OPTION: 'Segundos',
		CROSS_CORRELATION: 'Correlação Cruzada',
		// pre-processing-configuration-form: row group titles + short field labels
		OUTLIER_DETECTION_GROUP: 'Detecção de Outliers',
		INTERPOLATION_GROUP: 'Interpolação',
		FLATLINE_GROUP: 'Estagnação',
		LABEL_METHOD: 'Método',
		LABEL_THRESHOLD: 'Limite',
		LABEL_CONFIGURATION: 'Configuração',
		FLATLINE_DETECTION_SHORT: 'Detecção',
		FLATLINE_THRESHOLD_TIME_SHORT: 'Tempo Limite',
		FLATLINE_TIME_BASE_SHORT: 'Base de Tempo',
		// model-tag-selection-form
		DATA_DENSITY_THRESHOLD: 'Limite de Densidade de Dados para Seleção de Tag',
		DATA_DENSITY_REQUIRED: 'O Limite de Densidade de Dados é',
		GLOBAL_PREPROCESSING: 'Pré-processamento global',
		RANGE_PREPROCESSING: 'Pré-processamento por intervalo',
		DENSITY_HINT: 'Densidade',
		// data-sync
		REFRESH_TABLE_DATA_TOOLTIP: 'Atualizar Dados da Tabela',
		LAST_DATA_PULL_LABEL: 'Última Coleta de Dados:',
		UPLOAD_CSV_TOOLTIP: 'Enviar CSV',
		NO_RAW_TAGS_TOOLTIP: 'Não há tags brutas neste sistema, portanto o arquivo não pode ser enviado',
		UPLOAD_BTN: 'Carregar',
		ANOTHER_PROCESS_RUNNING_TOOLTIP: 'Outro processo está em execução',
		NO_RAW_TAG_MAPPED_TOOLTIP: 'Nenhuma tag bruta está mapeada com este sistema',
		NEW_DATA_PULL_REQUEST: 'Nova Solicitação de Coleta de Dados',
		ADD_NEW_DATA_PULL_TOOLTIP: 'Adicionar Nova Solicitação de Coleta de Dados',
		DELETE_SYSTEM_DATA_TOOLTIP: 'Excluir Dados do Sistema',
		STOP_DATA_PULL_TOOLTIP: 'Parar Coleta de Dados',
		COL_SERIAL_NO: 'Nº',
		COL_DATA_REQUESTED_FOR: 'Dados Solicitados Para',
		COL_REQUESTED_ON: 'Solicitado em',
		COL_ACCESS_METHOD: 'Método de Acesso',
		COL_REQUEST_TYPE: 'Tipo de Solicitação',
		COL_FILE_NAME: 'Nome do Arquivo',
		COL_PULLED_BY: 'Coletado por',
		COL_DATA_RECEIVED: 'Dados Recebidos',
		COL_ACTIONS: 'Ações',
		DATA_REPULL_TOOLTIP: 'Nova Coleta de Dados',
		TAG_PULL_REQUEST: 'Solicitação de Coleta de Tag',
		COL_VALUE: 'Valor',
		COL_MISSING: 'Faltante',
		COL_OUTLIER: 'Outlier',
		TRIP_LIMIT_TOOLTIP: 'Limite de Trip',
		TRIP_LABEL: 'Trip',
		ALARM_LIMIT_TOOLTIP: 'Limite de Alarme',
		ALARM_LABEL: 'Alarme',
		THRESHOLD_LIMIT_TOOLTIP: 'Limite de Threshold',
		THRESHOLD_LABEL: 'Limite',
		INSTRUMENT_RANGE_TOOLTIP: 'Faixa do Instrumento',
		INSTRUMENT_LABEL: 'Instrumento',
		HIGH_LABEL: 'Alto:',
		LOW_LABEL: 'Baixo:',
		AVG_LABEL: 'Média:',
		// data-sync-popup
		DATA_PULL_REQUEST: 'Solicitação de Coleta de Dados',
		SELECT_TAGS_PLACEHOLDER: 'Selecionar Tags',
		FROM_DATE_PLACEHOLDER: 'Data Inicial',
		SELECT_FROM_DATE_HINT: 'Data Inicial',
		TO_DATE_PLACEHOLDER: 'Data Final',
		TO_DATE_REQUIRED: 'Data Final é',
		SELECT_TO_DATE_HINT: 'Data Final',
		PULL_DATA_TOOLTIP: 'Coletar Dados',
		PULL_DATA: 'Coletar Dados',
		// upload-csv-popup
		STATUS_PANEL: {
			SUMMARY: 'Resumo',
			TAG_SUMMARY: 'Resumo de tags',
			RECORDS: 'Registros',
			TOTAL_TAGS: 'Total de tags',
			TAGS_IN_MODEL: 'Tags no modelo',
			TAGS_MAPPED_TO_FM: 'Tags mapeadas para MF',
			TAGS_WITH_NO_FM: 'Tags sem MF',
			PROCESSING_TIME: 'Tempo de processamento',
			TRAINING_TIME: 'Tempo de treinamento',
			TOTAL_TAGS_DROPPED: 'Total de tags removidas',
			ALERTS_GENERATED: 'Alertas gerados',
			PRECISION_PREVIOUS: 'Precisão anterior',
			PRECISION_CURRENT: 'Precisão atual',
			PHASE_DATA_IMPORT: 'Importação de dados',
			PHASE_PREPROCESSING: 'Pré-processamento de dados',
			PHASE_MODELING: 'Modelagem',
			PHASE_ALERT_FEEDBACK: 'Feedback de alertas',
			PHASE_READY_TO_DEPLOY: 'Pronto para implantar',
			DROPPED_TAGS: 'Tags removidas',
			CALCULATED_TAGS_DROPPED: 'Tags calculadas removidas',
			RAW_TAGS_DROPPED: 'Tags brutas removidas',
			TAGS_DROPPED_PREPROCESSING: 'Removidas no pré-processamento',
			TAGS_DROPPED_MANUALLY: 'Removidas manualmente',
			HIGH_DEVIATION_TAGS: 'Tags de alta desvio',
			EXPORT: 'Exportar',
			COL_TAG_NAME: 'Nome da tag',
			COL_TAG_ID: 'ID da tag',
			COL_DESCRIPTION: 'Descrição',
			COL_UNIT: 'Unidade',
			COL_CALCULATED: 'Calculada',
			COL_DROPPED_DUE_TO: 'Removida devido a',
			COL_REASON: 'Motivo',
			YES: 'Sim',
			NO: 'Não',
			DROPPED_DUE_IMPORT: 'Importação',
			DROPPED_DUE_PREPROCESSING: 'Pré-processamento',
			DROPPED_DUE_MANUAL: 'Manual',
			DROPPED_DUE_UNKNOWN: '—',
			NO_TAGS_DROPPED: 'Nenhuma tag removida ainda',
			NO_HIGH_DEVIATION: 'Execute a construção do modelo para preencher tags de alta desvio',
			NO_HIGH_DEVIATION_EMPTY: 'Nenhuma tag de alta desvio encontrada',

			PHASE_DEPLOYED: 'Implantado',
			DROPPED_DUE_CALCULATED: 'Calculada',
			STEP_STATUS: 'Status',
			STEP_STATUS_COMPLETED: 'Concluído',
			STEP_PREPROCESSING_TIME: 'Tempo de pré-processamento',
			STEP_TRAINING_TIME: 'Tempo de treinamento',
			STEP_PREDICTION_TIME: 'Tempo de previsão',
			STEP_ALERTS_GENERATED: 'Alertas gerados',
			STEP_PRECISION_CURRENT: 'Precisão atual',
			STEP_PRECISION_PREVIOUS: 'Precisão anterior',
			REASON_UNSELECTED_FROM_MODEL: 'Não selecionado do modelo',
			REASON_INVALID_DATA: '{{percent}}% de dados inválidos',
			STEP_SECONDS_VALUE: '{{value}} s',
		},
		UPLOAD_CSV_TITLE: 'Enviar CSV',
		},
		IOW: {
			FACILITY: 'Facility',
			SELECT_FACILITY: 'Select Facility',
			SEARCH_FACILITY: 'Pesquisar Instalação...',
			NO_FACILITY_FOUND: 'Nenhuma Instalação correspondente encontrada',
			UNIT: 'Unidade',
			SELECT_UNIT: 'Select Unit',
			SEARCH_UNIT: 'Search Unit...',
			NO_UNIT_FOUND: 'No matching Unit found',
			SYSTEM: 'Sistema',
			SELECT_SYSTEM: 'Selecionar Sistema',
			SEARCH_SYSTEM: 'Search System...',
			NO_SYSTEM_FOUND: 'No matching System found',
			TAGS: 'Tags',
			SELECT_TAGS: 'Selecionar Tags',
			SEARCH_TAG: 'Search Tag...',
			NO_TAG_FOUND: 'No matching Tag found',
			CASE_STATUS: 'Status do Caso',
			EXCEEDANCE_TYPE: 'Tipo de Excedência',
			SELECT_EXCEEDANCE_TYPE: 'Selecionar Tipo de Excedência',
			SELECT_ALL: 'Selecionar Tudo',
			ANALYSE_TOP_TRENDS: 'Analisar as 20 Principais Tendências',
			SAVE: 'Guardar',
			COPY: 'Copiar',
			ADD_NEW: 'Adicionar Novo',
			EDIT: 'Editar',
			DELETE: 'Eliminar',
			DOWNLOAD: 'Transferir',
			ACTIVE_EXCEEDANCES: 'Excedências Ativas',
			DATE_RANGE_DISABLED_TOOLTIP: 'A seleção de intervalo de datas não se aplica quando o filtro de excedência ativa está selecionado.',
			SELECT_DATE_RANGE: 'Selecionar Intervalo de Datas',
			ENTER_DATE_RANGE: 'Enter a date range',
			START_DATE: 'Start date',
			END_DATE: 'End date',
			APPLY_TIME_CHANGE: 'Apply Time change',
			SUMMARY: 'Resumo',
			SELECT_SYSTEM_MESSAGE: 'Selecione um sistema para ver as excedências.',
			LOADING: 'Loading...',
			NO_EXCEEDANCE_FOUND: 'Ah, um recipiente vazio, nenhuma excedência encontrada.',
			NO_ACTIVE_EXCEEDANCE_FOUND: 'Nenhuma excedência ativa encontrada.',
			CRUNCHING_DATA: 'Processando dados como um data-saurus! Aguarde firme!',
			TOTAL_EXCEEDANCES: 'Número Total de Excedências do Sistema',
			GROUP_TRENDS: 'Agrupar Tendências',
			TRENDS_PER_CHART: 'Tendências / Gráfico (até 8)',
			CANCEL: 'Cancelar',
			PROCEED: 'Continuar',
			SELECT: 'Select',
			SELECT_DATE_RANGE_LABEL: 'Selecionar intervalo de datas',
			DATE_RANGE: 'Intervalo de datas',
			DATE_RANGE_REQUIRED: 'O intervalo de datas é obrigatório.',
			REGROUP_EXCEEDENCES: 'Reagrupar Excedências',
			DURATION_MINUTES: 'Duração (em min.)',
			DURATION_REQUIRED: 'A duração é obrigatória.',
			ENTER_VALID_NUMBER: 'Por favor, insira um número válido.',
			DOWNLOAD_TITLE: 'Baixar Relatório IOW',
			GROUP_BY_SYSTEM: 'Agrupar por Sistema',
			GROUP_BY_UOM: 'Agrupar por Unidade de Medida',
			GROUP_COUNT_REQUIRED: 'A Contagem de Grupo é obrigatória.',
			MIN_VALUE_2: 'O valor mínimo é 2.',
			MAX_VALUE_8: 'O valor máximo é 8.',
			GROUP_COUNT_INVALID: 'A Contagem de Grupo é inválida.',
			WATCHERS: 'Observadores',
			CLOSE: 'Fechar',
		},
		CAPACITY_OPTIMIZATION: {
			COMMON: {
				SAVE: 'Guardar',
				CANCEL: 'Cancelar',
				DELETE: 'Eliminar',
				EDIT: 'Editar',
				CLOSE: 'Fechar',
				LOADING: 'Loading...',
				SEARCH: 'Search...',
				ACTIONS: 'Ações',
				NAME: 'Nome',
				DESCRIPTION: 'Descrição',
				STATUS: 'Estado',
				TYPE: 'Tipo',
				CREATED: 'Criado',
				LAST_UPDATED: 'Last Updated',
				DOWNLOAD: 'Transferir',
				UPLOAD: 'Carregar',
				IMPORT: 'Importar',
				EXPORT: 'Exportar',
				RUN: 'Executar',
				STOP: 'Parar',
				YES: 'Sim',
				NO: 'Não',
				APPLY: 'Aplicar',
				RESET: 'Redefinir',
				CONFIRM: 'Confirmar',
				BACK: 'Voltar',
				NEXT: 'Próximo',
			},
			NAV: {
				SCENARIOS: 'Cenários',
				DASHBOARD: 'Painel',
				COMPARISON: 'Comparação',
				SETTINGS: 'Configurações',
				MODELS: 'Modelos',
				SIMULATION: 'Simulação',
				REALTIME: 'Tempo Real',
				TOPOLOGY: 'Topology',
				STRATEGIC: 'Estratégico',
			},
			LANDING: {
				TITLE: 'Otimização da Capacidade',
				SUBTITLE: 'Otimize a geração de energia e água em toda a sua frota',
			},
			SCENARIO: {
				TITLE: 'Scenario Library',
				NEW_SCENARIO: 'Novo Cenário',
				SEARCH_SCENARIO: 'Search scenario',
				DUPLICATE: 'Duplicate',
				RUN_OPTIMIZATION: 'Executar Otimização',
				FORCE_STOP: 'Forçar Parada',
				VIEW_RESULTS: 'Ver Resultados',
				SCENARIO_NAME: 'Scenario Name',
				CLASSIFICATION: 'Classificação',
				SOLVER: 'Solver',
				RUN_MODE: 'Modo de Execução',
				STATUS_READY: 'Pronto',
				STATUS_RUNNING: 'Executando',
				STATUS_COMPLETED: 'Concluído',
				STATUS_FAILED: 'Falhou',
				PROMOTE: 'Promover',
				ALTERNATIVE_SOLVER: 'Solver Alternativo',
			},
			CONFIG: {
				TITLE: 'Scenario Configuration',
				TABS: {
					AVAILABILITY: 'Disponibilidade de Ativos',
					DEMAND: 'Previsão de Demanda',
					CONSTRAINTS: 'Restrições',
					SOLVER: 'Solver & Run',
					TESTING: 'Perfis de Teste',
					GROWTH_FACTOR: 'Fator de Crescimento',
					SWRO_AVAILABILITY: 'Disponibilidade SWRO',
				},
				HORIZON: 'Horizon (hrs)',
				STEP: 'Step (min)',
				START_HOUR: 'Start Hour',
				TARGET_DATE: 'Data Alvo',
				LATITUDE: 'Latitude',
				LONGITUDE: 'Longitude',
				PERF_CURVE: 'Performance Curve Source',
				OEM_CURVES: 'Curvas de Projeto OEM',
				HISTORICAL_ML: 'Dados Históricos (ML)',
				PLANNING_OFFLINE: 'Planejamento (Offline)',
				LIVE_REALTIME: 'Em Tempo Real',
				UPLOAD_CSV: 'Enviar CSV',
				DOWNLOAD_CSV: 'Baixar CSV',
				POWER_MW: 'Energia (MW)',
				WATER_MIGD: 'Água (MIGD)',
				POWER_IMPORT: 'Importação de Energia',
				POWER_EXPORT: 'Exportação de Energia',
				WATER_IMPORT: 'Importação de Água',
				WATER_EXPORT: 'Exportação de Água',
				INITIAL_STATUS: 'Status Inicial',
				DURATION_IN_STATE: 'Duração no Estado (Horas)',
				ON: 'Em',
				OFF: 'DESLIGADO',
			},
			CONSTRAINTS: {
				TITLE: 'Constraints Configuration',
				ANCILLARY_SERVICES: 'Serviços Auxiliares',
				MIN_UP_DOWN_TIME: 'Tempo Mín. de Ativo/Inativo',
				RAMP_LIMITS: 'Ramp Limits',
				FIXED_LOADS: 'Cargas Fixas',
				AGC_DISPATCH: 'Despacho AGC',
				ALLOW_LOAD_SHEDDING: 'Permitir Corte de Carga',
				ALLOW_WATER_SHORTAGE: 'Permitir Escassez de Água',
				ENFORCE_FUEL_LIMITS: 'Aplicar Limites de Combustível',
				SPINNING_RESERVE: 'Reserva Girante (MW)',
				OPERATING_RESERVE: 'Reserva Operacional (MW)',
				WATER_RESERVE: 'Reserva de Água (MIGD)',
			},
			GROWTH_FACTOR: {
				TITLE: 'Growth Factor Configuration',
				ADJUSTMENT_TYPE: 'Tipo de Ajuste',
				VALUE: 'Growth Factor Value',
				TARGET_METRIC: 'Métrica Alvo',
				START_TIME: 'Hora de Início',
				END_TIME: 'Hora de Término',
			},
			SWRO: {
				TITLE: 'SWRO Availability Configuration',
				SELECT_PLANTS: 'Selecionar Plantas SWRO',
				FLAT_VALUE: 'Valor de Disponibilidade Fixo',
			},
			DASHBOARD: {
				TITLE: 'Optimization Results',
				STATION_FILTER: 'Filtro de Estação',
				ALL_STATIONS: 'Todas as Estações',
				TOTAL_COST: 'Custo Total',
				POWER_GENERATION: 'Geração de Energia',
				WATER_PRODUCTION: 'Produção de Água',
				FUEL_CONSUMPTION: 'Consumo de Combustível',
			},
			COMPARISON: {
				TITLE: 'Scenario Comparison',
				SEARCH_SCENARIO: 'Pesquisar cenário',
				BASELINE: 'Referência',
				SELECT_BASELINE: 'Selecionar Referência',
			},
			SETTINGS: {
				TITLE: 'Configurações',
				PLATFORM: 'Configuração da Plataforma',
				DATA_MGMT: 'Gerenciamento de Dados',
				MODULE_CONFIG: 'Configuração do Módulo',
				TAGS: 'Tags',
				TEMPLATES: 'Modelos',
				TOPOLOGY: 'Topologia',
				TRAINING: 'Treinamento',
				USERS: 'Users',
			},
			PLATFORM_SETUP: {
				TITLE: 'Platform & Facility Setup',
				ENTERPRISE_NAME: 'Nome da Empresa',
				STREET_ADDRESS: 'Endereço',
				CITY: 'Cidade',
				STATE: 'Estado',
				COUNTRY: 'País',
				ZIP_CODE: 'CEP',
				LATITUDE: 'Latitude',
				LONGITUDE: 'Longitude',
				INDUSTRY: 'Indústria',
				TIMEZONE: 'Fuso Horário',
				BUSINESS: 'Negócio',
				NOTES: 'Notas',
				COST_PER_UNIT: 'Custo por Unidade ($)',
				CAPACITY_PER_HOUR: 'Capacidade por Hora',
				REVENUE_PER_HOUR: 'Receita por Hora ($)',
				OPERATIONAL_MARGIN: 'Margem Operacional (%)',
				TECHNICIAN_SALARY: 'Salário do Técnico ($/h)',
				HELPER_SALARY: 'Salário do Ajudante ($/h)',
			},
			USER_MGMT: {
				TITLE: 'Gerenciamento de Usuários',
				ADD_USER: 'Adicionar Usuário',
				USERNAME: 'Nome de usuário',
				DISPLAY_NAME: 'Nome de Exibição',
				PASSWORD: 'Senha',
				ROLE: 'Função',
				ADMIN: 'Admin',
				SUPER_USER: 'Super Usuário',
				USER: 'Usuário',
				NO_PERMISSION: 'Você não tem permissão para acessar esta seção.',
			},
			SIMULATION: {
				TITLE: 'Sensitivity Simulation',
				TARGET_EQUIPMENT: 'Equipamento Alvo',
				SWEEP_PARAMETER: 'Parâmetro de Varredura',
				START_VALUE: 'Valor Inicial',
				END_VALUE: 'Valor Final',
				STEPS: 'Etapas',
				RUN_SWEEP: 'Executar Varredura',
			},
			REALTIME: {
				TITLE: 'Realtime Dashboard',
				CONFIRMED_TARGET: 'Alvo Confirmado',
				SELECT_DATE: 'Selecionar Data',
				SCENARIO_NAME: 'Nome do Cenário',
				HORIZON_HOURS: 'Horizonte (horas)',
				SOLVER: 'Solver',
				PERF_CURVE: 'Curva de Desempenho',
				START_MODE: 'Modo de Início',
				RAMP_LIMITS: 'Limites de Rampa',
				MIN_UP_DOWN: 'Tempo Mín. de Ativo/Inativo',
				ANCILLARY: 'Serviços Auxiliares',
				IMPORT_SCENARIO: 'Importar de Cenário',
			},
			TOPOLOGY: {
				TITLE: 'SCADA Topology',
				POWER_VIEW: 'Energia',
				WATER_VIEW: 'Água',
				AUTO_CORRECT: 'Autocorreção',
				FLEET_OVERVIEW: 'Visão Geral da Frota',
			},
		DEMAND: {
			HORIZON: 'Horizonte (h)',
			STEP: 'Etapa (min)',
			START_HOUR: 'Hora de Início',
			UPDATE_PLAN: 'Atualizar plano de demanda',
			UPDATE_PLAN_TOOLTIP: 'Reamostrar todas as tabelas de programação na nova grade de tempo, interpolando os valores já inseridos.',
			UPDATE_PLAN_HINT: 'Parâmetros de programação alterados — clique em Atualizar plano de demanda para reamostrar as tabelas.',
			SOLAR_INPUT: 'Entrada solar',
			SOLAR_PHASES_ACTIVE: 'fases ativas',
		},
			TAG_EXPLORER: {
				TITLE: 'Explorador de tags',
				SUBTITLE: 'Trace valores históricos de qualquer tag mapeado. Os pontos são agregados no servidor para que um intervalo longo continue fluido.',
				TAGS: 'Tags',
				TAGS_PLACEHOLDER: 'Selecione até 10 tags',
				TAGS_SEARCH_PLACEHOLDER: 'Pesquisar por parâmetro ou nome do tag...',
				START_DATE: 'Data de início',
				END_DATE: 'Data de fim',
				PLOT: 'Traçar',
				LOADING_TAGS: 'Carregando lista de tags...',
				QUERYING: 'Consultando dados históricos...',
				NO_DATA_FOR: 'Sem dados neste intervalo para:',
				UNITS_DROPPED: 'O gráfico mostra duas unidades por vez; as séries em {{units}} não foram traçadas.',
				BUCKET_HINT: 'Agregado em intervalos de {{bucket}}.',
				COL_PARAMETER: 'Parâmetro',
				COL_TAG: 'Tag',
				COL_UNIT: 'Unidade',
				COL_POINTS: 'Pontos',
				COL_MIN: 'Mín.',
				COL_MAX: 'Máx.',
				COL_AVERAGE: 'Média',
				GROUP_SYSTEM_DEMAND: 'Demanda do sistema',
				GRID_POWER_DEMAND: 'Demanda elétrica da rede',
				GRID_WATER_DEMAND: 'Demanda de água da rede',
				AXIS_TIME: 'Tempo',
				AXIS_VALUE: 'Valor',
				REQUEST_FAILED: 'Falha na solicitação ({{status}})',
				SERVER_UNREACHABLE: 'Não foi possível conectar ao servidor.',
			},
		},
		DISPLAY_TAGS: {
			HEADER: 'Exibir Outras Tags',
			CLOSE: 'Fechar',
			SEARCH_PLACEHOLDER: 'Buscar...',
			FILTER_TOOLTIP: 'Filtrar tags',
			SELECT_SYSTEM: 'Selecionar Sistema',
			ALL_SYSTEMS: 'Todos os Sistemas',
			FILTER_BY: 'Filtrar por',
			ALL_TAGS: 'Todas as Tags',
			MODELED_TAGS: 'Tags modeladas',
			SHOW_CALCULATED_TAGS: 'Mostrar tags calculadas',
			NO_MATCHING_RESULTS: 'Nenhum resultado encontrado',
			START_TYPING: 'Comece a digitar para ver as tags correspondentes.',
		},
		PROCESS: {
			LIST: {
				PAGE_TITLE: 'Processo',
				SEARCH_PLACEHOLDER: 'Search by Batch ID',
				CURRENT_BATCHES_TAB: 'Lotes Atuais',
				PAST_BATCHES_TAB: 'Lotes Anteriores',
				FILTER: {
					SYSTEM: 'Sistema',
					SEARCH_SYSTEM: 'Search System',
					CREATED_BETWEEN: 'Criado entre',
					STARTED_ON: 'Iniciado em',
					CLEAR_DATE: 'Limpar Data',
					OWNER: 'Proprietário',
					SEARCH_OWNER: 'Pesquisar Proprietário',
				},
			},
			TABLE: {
				COL_BATCH_NAME_ID: 'Nome / ID do Lote',
				COL_START_DATE_TIME: 'Data / Hora de Início',
				COL_END_DATE_TIME: 'Data / Hora de Término',
				COL_LAST_UPDATED: 'Última Atualização',
				COL_DURATION: 'Duração',
				COL_RUN_TIME: 'Tempo de Execução',
				COL_STATUS: 'Estado',
				COL_OWNER: 'Proprietário',
				COL_WATCHERS: 'Observadores',
				COL_PERCENT_COMPLETE: 'Percentual Concluído',
				COL_PROJECTED_PRODUCT: 'Produto Projetado',
				COL_FINAL_PRODUCT: 'Produto Final',
				SELECT_COLUMNS: 'Selecionar Colunas',
				SAVE_VIEW: 'Salvar Visualização',
				APPLY: 'Aplicar',
				LOADING: 'Loading...',
				NO_RECORDS: 'Nenhum registro encontrado',
			},
			DETAILS: {
				TITLE_PREFIX: 'Detalhes do Processo',
				BATCH_NAME: 'Nome do Lote',
				FACILITY: 'Facility',
				UNIT: 'Unidade',
				SYSTEM: 'Sistema',
				STATUS: 'Estado',
				START_DATE_TIME: 'Data / Hora de Início',
				LAST_UPDATED: 'Última Atualização',
				OVERLAY: 'Sobreposição',
				STACKED: 'Empilhado',
				GRID: 'Grade',
				SELECT_OWNER: 'Selecionar Proprietário',
				WATCHERS_TOOLTIP: 'Observadores',
				FILTER: {
					LAB_PARAMETERS: 'Parâmetros de Laboratório',
					BATCH: 'Lote',
					OTHERS: 'Outros',
					SEARCH_BATCH: 'Pesquisar lote',
				},
				GOLDEN_BATCH_BAND: 'Faixa do Lote Padrão',
				PREDICTION: 'Predição',
			},
		},
		DYNAMIC_DASHBOARD: {
			DASHBOARD_WIZARD: 'Assistente de Painel',
			ADD_NEW_DASHBOARD: 'Adicionar Novo Painel',
			CREATE_DASHBOARD: 'Criar Painel',
			SEARCH: 'Pesquisar',
			EDIT_MODE: 'Modo de Edição',
			SAVE_DASHBOARD: 'Salvar Painel',
			PUBLIC: 'Público',
			PRIVATE: 'Privado',
			SENSOR_DATA: 'Dados de Sensor',
			NON_SENSOR_DATA: 'Dados sem Sensor',
			ENTER_DATE_RANGE: 'Insira um intervalo de datas',
			START_DATE: 'Data inicial',
			END_DATE: 'Data final',
			APPLY_TIME_CHANGE: 'Aplicar alteração de período',
			MORE: 'Mais',
			NOTHING_CREATED: "You haven't created anything yet",
			LOADING: 'Carregando...',
			NO_DATA: 'Nenhum dado disponível para os atributos selecionados',
			CONFIGURE_ATTRIBUTES: 'Configurar Atributos para Renderizar',
			SELECT_CHART_TYPE: 'Select Chart Type',
			CONFIG_ONLY_WIDGET: 'Este é um widget somente de configuração. Nenhum gráfico será exibido para este',
			TYPE_OF_CONFIG: 'Tipo de configuração:',
			GROUP_KEY: 'Chave de Grupo:',
			SPECIFICATION_LIMIT: 'Limite de Especificação',
			PLEASE_ADD_STATS: 'Por favor, adicione o Cartão de estatísticas',
			ADD_ATTRIBUTES: 'Adicionar Atributos para Exibir',
			PROCESSING_DATA: 'Processando dados — por favor, aguarde...',
			EDIT: 'Editar',
			DUPLICATE: 'Duplicar',
			REMOVE: 'Remover',
			CANCEL: 'Cancelar',
			SAVE: 'Guardar',
			BACK: 'Voltar',
			PERFORMANCE_CURVE_OF: 'Curva de Desempenho De',
			NO_WIDGETS_AVAILABLE: 'Nenhum widget disponível. Adicione um widget para começar',
			TAB_EMPTY_STATES: {
				ALL: {
					HEADING: 'Ainda não há painéis',
					CONTENT: 'Crie seu primeiro painel para monitorar métricas-chave, tendências e insights em um único lugar.',
				},
				MY_DASHBOARD: {
					HEADING: 'Nenhum painel criado por você',
					CONTENT: 'Os painéis criados por você aparecerão aqui.',
				},
				SHARED: {
					HEADING: 'Ainda não há painéis compartilhados',
					CONTENT: 'Os painéis compartilhados com você por outras pessoas aparecerão aqui.',
				},
				PRIVATE: {
					HEADING: 'Ainda não há painéis privados',
					CONTENT: 'Os painéis que você criar e mantiver privados aparecerão aqui.',
				},
				SEARCH: {
					HEADING: 'Nenhum painel encontrado',
					CONTENT: 'Tente uma palavra-chave diferente ou limpe a pesquisa.',
				},
			},
			SLICER_POPUP: {
				SELECT_ALL: 'Select All',
				PREVIEW: 'Preview',
				APPLY_AND_CLOSE: 'Apply & Close',
				APPLYING: 'Applying...',
      		},
			COLLABORATOR: {
				TITLE_SUFFIX: 'Colaboradores',
				SEARCH_PLACEHOLDER: 'Pesquisar por Nome ou E-mail',
				COLLABORATED_WITH: 'Colaborou com',
				USERS: 'Usuários',
				ALL_USERS: 'Todos os Usuários',
				OWNER: 'Proprietário',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
				CANCEL_CHANGES: 'Cancelar alterações',
				SAVE_CHANGES: 'Salvar alterações',
				ROLE: {
					FULL: 'Completo',
					FULL_DESC: 'Acesso total',
					EDIT: 'Editar',
					EDIT_DESC: 'Acesso de visualização e edição',
					VIEW: 'Visualizar',
					VIEW_DESC: 'Acesso somente de visualização',
				},
			},
			EDIT_PANEL: {
				CREATE_PANEL: 'Criar painel',
				EDIT_PANEL: 'Editar Painel',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
				SELECT_CHART_TYPE: 'Tipo de Gráfico',
				ADD_TITLE: 'Título',
				PANEL_NAME: 'Nome do Painel',
				ADDITIONAL_GRAPH_OPTIONS: 'Opções Adicionais de Gráfico',
				SETTINGS: 'Configurações',
			},
			DASHBOARD_POPUP: {
				TITLE: 'Painel',
				SELECT_TYPE: 'Selecionar Tipo de Painel',
				TYPE_DASHBOARD: 'Painel',
				TYPE_CONFIG: 'Configuração',
				TYPE_PERFORMANCE_CURVES: 'Curvas de Desempenho',
				NAME: 'Nome',
				NAME_TAKEN: 'O nome já está em uso',
				NAME_REQUIRED: 'O nome é obrigatório',
				LEVEL: 'Nível',
				SELECT_LEVEL: 'Selecionar nível',
				FACILITY: 'Instalação',
				SELECT_FACILITY: 'Selecionar Instalação',
				FACILITY_REQUIRED: 'A instalação é obrigatória',
				UNIT: 'Unidade',
				SELECT_UNIT: 'Selecionar Unidade',
				UNIT_REQUIRED: 'A unidade é obrigatória',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
			},
			TAG_PANEL: {
				ENABLE_QUICK_PLOT: 'Ativar Gráfico Rápido',
				SELECT_UNITS: 'Selecionar Unidades',
				SEARCH_UNIT: 'Pesquisar Unidade...',
				NO_UNIT_FOUND: 'Nenhuma Unidade correspondente encontrada',
				SELECT_SYSTEMS: 'Selecionar Sistemas',
				SEARCH_SYSTEM: 'Pesquisar Sistema...',
				NO_SYSTEM_FOUND: 'Nenhum Sistema correspondente encontrado',
				ADD: 'Adicionar',
				PREVIEW: 'Visualizar',
				PREVIEW_CHART: 'Pré-visualizar Gráfico',
				DRAG_AND_DROP: 'Arrastar e Soltar',
				COPY: 'Copiar',
				DELETE: 'Eliminar',
				EDIT: 'Editar',
				LABEL: 'Rótulo',
				TAG: 'Tag',
				X_TAG: 'Tag X',
				Y_TAG: 'Tag Y',
				Z_TAG: 'Tag Z',
				SEARCH_TAG: 'Search Tag...',
				NO_TAG_FOUND: 'No matching tag found',
				DESIGN_VALUE_TAG: 'Tag de Valor de Projeto',
				CALC_TYPE: 'Tipo de Cálculo',
				CALC_ORIGINAL: 'Original',
				CALC_AVERAGE: 'Média',
				CALC_MOVING_AVG: 'Média Móvel',
				CALC_MAX: 'Máx',
				CALC_MIN: 'Mín',
				CALC_SUM: 'Soma',
				CALC_MEDIAN: 'Mediana',
				CALC_MOVING_DELTA: 'Delta Móvel',
				CALC_COUNT_EVENT: 'Contar Evento',
				AGGREGATE: 'Agregar',
				AGGREGATE_WINDOW: 'Janela de Agregação',
				COUNT_WINDOW: 'Janela de Contagem',
				AGGREGATE_WINDOW_UNIT: 'Unidade da Janela de Agregação',
				COUNT_WINDOW_UNIT: 'Unidade da Janela de Contagem',
				WINDOW_SIZE: 'Tamanho da janela',
				MINUTES: 'Minuto(s)',
				HOURS: 'Hora(s)',
				DAYS: 'Dia(s)',
				WEEKS: 'Semana(s)',
				GREATER_THAN: 'Greater than',
				LESS_THAN: 'Less than',
				EQUAL_TO: 'Equal to',
				RESET_FILTER: 'Redefinir filtro',
				SELECT_AXIS: 'Selecionar Eixo',
				X_AXIS: 'Eixo X',
				Y_AXIS: 'Eixo Y',
				SPEC_LABEL: 'Rótulo (máx. 6 caracteres)',
				DESCRIPTION: 'Descrição',
				VALUE: 'Valor',
				ENABLE_TREND_CHART: 'Ativar Gráfico de Tendência',
				ADD_TITLE: 'Adicionar um título',
				ADD_SUBTITLE: 'Adicionar um subtítulo',
				UNIT: 'Unidade',
				SELECT_ICON: 'Selecionar Ícone',
				SEARCH_ICONS: 'Pesquisar Ícones...',
				FORMULA: 'Fórmula',
				FORMULA_PLACEHOLDER: 'Escreva a fórmula. ex. (A+B)*C',
				ERROR_INVALID_VARS: 'Variável(is) inválida(s) usada(s)',
				ERROR_INVALID_SYNTAX: 'Expressão matemática inválida',
				ERROR_FORMULA_REQUIRED: 'A fórmula é obrigatória',
				ERROR_LESS_THAN_THRESHOLD: "This should be less than 'Less than' threshold.",
				ERROR_GREATER_THAN_THRESHOLD: "This should be greater than 'Greater than' threshold.",
				SELECT_CHILDREN: 'Selecionar filhos',
				AT_LEAST_ONE: 'Pelo menos 1 opção deve ser selecionada',
				TITLE_REQUIRED: 'O título é obrigatório',
				TITLE_DUPLICATE: 'Este título já está sendo usado para outra fórmula',
				ADD_A_TITLE: 'Adicionar um título',
				DELETE_BUTTON: 'Eliminar',
			},
			SENSOR_TABLE_CONFIG: {
				ADD_ROW: 'Adicionar Linha',
				ADD_COLUMN: 'Adicionar Coluna',
				COLUMN_NAME: 'Nome da Coluna',
				DELETE_COLUMN: 'Excluir Coluna',
				DATE_FILTER: 'Filtro de Data',
				ROWS: 'Linhas',
				NUMBER_OF_ROWS: 'Número de Linhas',
				SELECT_TAG: 'Select Tag',
				CONFIGURE_TAG: 'Configurar Tag',
				DELETE_ROW: 'Excluir Linha',
				APPLY_DATE_FILTERS: 'Aplicar filtros de data às colunas',
				NONE: 'Nenhum',
				SELECT_FY_START: 'Selecione o 1º dia do ano fiscal',
				CANCEL: 'Cancelar',
				APPLY: 'Aplicar',
				SEARCH_TAG: 'Pesquisar Tag...',
				NO_TAG_FOUND: 'Nenhuma tag correspondente encontrada',
				GREATER_THAN: 'Maior que',
				LESS_THAN: 'Menor que',
				EQUAL_TO: 'Igual a',
				LESS_GREATER_ERROR: "'Less than' value must be greater than 'Greater than' value.",
				IGNORE_NULLS: 'Ignorar nulos',
				AGGREGATION: 'Aggregation',
				DEFINE_COLOR: 'Defina o valor da tag para definir a cor do texto',
				LESSER_THAN: 'Menor que',
				PICK_COLOR: 'Escolher Cor',
				COLOR: 'Cor',
				LESSER_THAN_ERROR: 'O valor deve ser menor que o valor maior definido.',
				GREATER_THAN_ERROR: 'O valor deve ser maior que o valor menor definido.',
				BETWEEN: 'Entre',
				AND: 'E',
				BETWEEN_RANGE_ERROR: 'Insira um intervalo válido — o valor inferior deve ser menor que o valor superior.',
			},
			RECENT: 'Recente',
			FAVOURITES: 'Favoritos',
			CREATED_BY_ME: 'Criado por mim',
			TAB_ALL: 'Todos',
			TAB_MY_DASHBOARD: 'Meu Painel',
			TAB_SHARED: 'Compartilhado',
			TAB_PRIVATE: 'Privado',
			ALL_DASHBOARDS: 'Todos os Painéis',
			MY_DASHBOARDS: 'Meus Painéis',
			SHARED_DASHBOARDS: 'Painéis Compartilhados',
			PRIVATE_DASHBOARDS: 'Painéis Privados',
			COL_NAME: 'Nome',
			COL_CREATED_ON: 'Criado em',
			COL_UPDATED_ON: 'Atualizado em',
			COL_OWNED_BY: 'Propriedade de',
			COL_SHARED: 'Compartilhado',
			COPY_LINK: 'Copiar link',
			RENAME: 'Renomear',
			OPEN_IN_NEW_TAB: 'Abrir em nova aba',
			SELECT: 'Selecionar',
			SELECT_PERFORMANCE_CURVE: 'Selecionar Curva de Desempenho',
			MENU_EDIT_DASHBOARD: 'Editar Painel',
			MENU_COPY_DASHBOARD: 'Copiar Painel',
			MENU_PUBLISH: 'Publicar',
			MENU_UNPUBLISH: 'Despublicar',
			MENU_DELETE_DASHBOARD: 'Excluir Painel',
			MONGO: {
				SELECT_GRAPH_FIRST: '*Selecione o Tipo de Gráfico primeiro',
				LABEL_USED: 'Rótulo já utilizado',
				REQUIRED: '*Obrigatório',
				DEFINE_RELATION: 'Definir Relação',
				INVALID_VARIABLE: 'Variável inválida na fórmula.',
				INVALID_RELATION: 'Relação inválida com a origem.',
				INVALID_FORMULA_SYNTAX: 'Sintaxe de fórmula inválida.',
				SOURCE: 'Origem',
				ATTRIBUTE: 'Atributo',
				DISPLAY_ATTRIBUTE: 'Atributo de Exibição',
				GROUP_BY_ATTR: 'Agrupar por',
				AGGREGATION: 'Agregação',
				OPEN_FILTERS: 'Abrir Filtros',
				REMOVE_COLUMN: 'Remover Coluna',
				ADD_ATTRIBUTE: 'Adicionar Atributo',
				RAW_ATTRIBUTE: 'Atributo Bruto',
				CALC_ATTRIBUTE: 'Atributo Calculado',
				ADD_RAW_ATTRIBUTE_COL: 'Adicionar Coluna de Atributo Bruto',
				ADD_CALC_ATTRIBUTE_COL: 'Adicionar Coluna de Atributo Calculado',
				GROUP_BY: 'Agrupar Por',
				GROUP_DISPLAY_TYPE: 'Tipo de Exibição de Grupo',
				SORT_BY: 'Ordenar Por',
				SORT_ASC: 'A → Z',
				SORT_DESC: 'Z → A',
				SIDE_BY: 'Lado a Lado Por',
				NA: 'N/D',
				STACK_BY: 'Empilhar Por',
				NO_OF_BINS: 'Nº de Faixas',
				SLICERS: 'Segmentadores (Selecione até {{limit}})',
				SELECT_UP_TO: 'Selecionar até',
				DRILL_DOWN: 'Detalhamento',
				DRILL_DOWN_ATTRS: 'Atributos para Detalhamento (Selecione até {{limit}})',
				SELECT_ATTRS: 'Selecionar Atributos',
			},
			TAG_AGG: {
				SELECT_TAG: 'Selecionar Tag',
				SELECT_AGGREGATE_TYPE: 'Selecionar Tipo de Agregação',
				ENABLE_AGGREGATE: 'Ativar Agregação',
			},
			SIDE_PANEL: {
				SETTINGS: 'Configurações',
				SAVE: 'Guardar',
				CLOSE: 'Fechar',
				PANEL: 'Painel',
				AXIS: 'Eixo',
				GRAPH_OPTIONS: 'Opções de Gráfico',
				SELECT_CONFIG_TYPE: 'Selecionar Tipo de Configuração',
				EXCEL_CONFIG: 'Configuração do Excel',
				TAG_GROUP: 'Grupo de Tags',
				PANEL_DESCRIPTION: 'Descrição do painel',
				X_AXIS_MIN: 'Mín do Eixo X',
				X_AXIS_MAX: 'Máx do Eixo X',
				X_AXIS_UNIT: 'Unidade do Eixo X',
				Y_AXIS_UNIT: 'Unidade do Eixo Y',
				SHOW_LEGEND: 'Mostrar Legenda',
				OVERLAP_LEGENDS: 'Sobrepor Legendas',
				TABLE_MODE: 'Modo Tabela',
				TITLE_COLOR: 'Cor do Título',
				BORDER_COLOR: 'Cor da Borda',
				TREND_CHART_COLOR: 'Cor do Gráfico de Tendência',
				UPLOAD: 'Carregar',
				DOWNLOAD: 'Transferir',
				UPLOAD_BASE_CURVE: 'Enviar Curva Base',
				BASE_CURVE_FORMAT: 'Formato da Curva Base',
				DELETE_CURVE_GRAPH: 'Excluir Gráfico de Curva',
			},
			SINGLE_STATS: {
				ADD_STAT: 'Adicionar Estatística',
				COLOR_PICKER: 'Seletor de Cor',
				COLOR_TITLE: 'Título',
				COLOR_BORDER: 'Borda',
				COLOR_ICON: 'Ícone',
				COLOR_ICON_OUTLINE: 'Contorno do Ícone',
				NO_ICON_FOUND: 'Nenhum Ícone correspondente encontrado',
			},
		},
		SCHEDULER: {
			LIST: {
				TITLE: 'Lista de agendamentos',
				HEADER_TITLE: 'Agendador de Relatórios',
				NEW_SCHEDULER_TOOLTIP: 'Criar novo agendamento',
				NEW_SCHEDULER: 'Novo agendamento',
				COL_TITLE: 'Título',
				COL_MEDIUM: 'Meio',
				COL_SUBJECT: 'Assunto',
				COL_RUNS: 'Execuções',
				COL_MODIFIED_ON: 'Modificado em',
				COL_CREATED_ON: 'Criado em',
				COL_ACTIONS: 'Ações',
				EDIT_TOOLTIP: 'Editar agendamento',
				DELETE_TOOLTIP: 'Excluir agendamento',
				MEDIUM_EMAIL: 'E-mail',
				MEDIUM_SMS: 'SMS',
				MEDIUM_CALL: 'Chamada',
				SCHEDULER_DELETED: 'Agendamento excluído',
				DELETE_FAILED: 'Falha ao excluir',
				OKAY: 'Ok',
				NO_REPORT: 'Nenhum relatório encontrado'
			},
			DETAILS: {
				TITLE: 'Agendamento',
				CREATE_TITLE: 'Criar Agendamento',
				EDIT_DETAILS_TITLE: 'Editar Detalhes',
				SCHEDULE_DETAILS_TITLE: 'Detalhes do Agendamento',
				CANCEL: 'Cancelar',
				SAVE: 'Salvar',
				SELECT_FACILITY: 'Selecionar Instalação',
				LOADING: 'Carregando...',
				SCHEDULE_RECURRING_REPORTS: 'Agendar Relatórios Recorrentes',
				MONTHS: 'Meses',
				ALL: 'Todos',
				DAY: 'Dia',
				EVERY: 'A cada',
				TH_DAY: 'º dia',
				WEEKDAYS: 'Dias da semana',
				TIME: 'Hora',
				SELECT_TIME: 'Selecionar hora',
				HOUR: 'Hora',
				MINUTE: 'Minuto',
				FILE_NAME_LABEL: 'Nome do Arquivo',
				REPORT_NAME_LABEL: 'Nome do Relatório',
				ENTER_NAME: 'Digite o nome',
				REPORT_TITLE: 'Título do Relatório (máx. 20 caracteres)',
				ENTER_TITLE: 'Digite o título',
				REPORTING_INTERVAL: 'Intervalo de Relatório',
				MEDIUM: 'Meio',
				TEMPLATE_NAME: 'Nome do Modelo',
				SUBJECT: 'Assunto',
				ENTER_SUBJECT: 'Digite o assunto',
				SELECT_USERS: 'Selecionar Usuários',
				SEARCH_BY_EMAIL: 'Pesquisar por endereços de e-mail',
				NO_MATCHING_EMAIL: 'Nenhum endereço de e-mail correspondente encontrado',
				ADD_EMAILS_LABEL: 'Adicionar endereços de e-mail separados por vírgula',
				OKAY: 'Ok',
				SELECT_AT_LEAST_ONE_UNIT: 'Selecione pelo menos uma unidade',
				SELECT_AT_LEAST_ONE_SYSTEM: 'Selecione pelo menos um sistema',
				SELECT_USER_OR_EMAIL: 'Selecione pelo menos um usuário ou adicione endereço(s) de e-mail',
				INVALID_EMAILS: 'Endereço(s) de e-mail inválido(s) inserido(s)',
			},
			TEMPLATES: {
				DAILY_REPORT: 'Relatório Diário',
				BIWEEKLY_REPORT: 'Relatório Quinzenal',
				KPI_REPORT_THERMAL: 'Relatório de KPI - Térmico',
				ALERT_STATUS_UPDATE_REPORT: 'Relatório de Atualização de Status de Alertas',
				DATA_QUALITY_REPORT: 'Relatório de Qualidade de Dados',
				DATA_LAG_REPORT: 'Relatório de Atraso de Dados',
				IOW_REPORT: 'Relatório IOW',
				SERVER_EXCEPTION_REPORT: 'Relatório de Exceções do Servidor',
			},
			REPORTING_INTERVALS: {
				LAST_8_HOURS: 'Últimas 8 Horas',
				LAST_12_HOURS: 'Últimas 12 Horas',
				LAST_24_HOURS: 'Últimas 24 Horas',
				TODAY: 'Hoje',
				YESTERDAY: 'Ontem',
				LAST_7_DAYS: 'Últimos 7 Dias',
				THIS_WEEK: 'Esta Semana',
				PREVIOUS_WEEK: 'Semana Anterior',
				LAST_15_DAYS: 'Últimos 15 Dias',
				LAST_30_DAYS: 'Últimos 30 Dias',
				THIS_MONTH: 'Este Mês',
				PREVIOUS_MONTH: 'Mês Anterior',
				THIS_QUARTER: 'Este Trimestre',
				PREVIOUS_QUARTER: 'Trimestre Anterior',
				LAST_3_MONTHS: 'Últimos 3 Meses',
				LAST_6_MONTHS: 'Últimos 6 Meses',
				LAST_12_MONTHS: 'Últimos 12 Meses',
				THIS_YEAR: 'Este Ano',
				PREVIOUS_YEAR: 'Ano Anterior',
			},
		},
		CASES: {
			WORK_ORDER: {
				CREATE_TITLE: 'Criar uma notificação de ordem de serviço',
				CREATE_DESC: 'Criar uma notificação de ordem de serviço para este caso',
				DESCRIPTION: 'Descrição',
				DESCRIPTION_PLACEHOLDER: 'Descreva o trabalho a ser feito (obrigatório)',
				DESCRIPTION_REQUIRED: 'A descrição é obrigatória',
				PRIORITY: 'Prioridade',
				DUE_DATE: 'Data de vencimento',
				ASSIGNED_TO: 'Atribuído a',
				ESTIMATED_HOURS: 'Horas estimadas',
				HOURS_PLACEHOLDER: 'Insira as horas',
				CANCEL: 'Cancelar',
				CONFIRM: 'Confirmar',
				UNASSIGNED: 'Não atribuído',
				CREATED: 'Ordem de serviço {{number}} criada',
				CREATED_PLAIN: 'Ordem de serviço criada',
				FAILED: 'Não foi possível criar a ordem de serviço',
				CREATE_BUTTON: 'Criar ordem de serviço',
				NONE_YET: 'Nenhuma ordem de serviço ainda',
				VIEW_TITLE: 'Ordem de serviço {{number}}',
				VIEW_SUB: 'Ordem de serviço criada a partir deste caso',
				CREATED_BY: 'Criada por {{name}}',
			},
			TRIAGE: {
				FROM_TRIAGE: 'Caso da Triagem de alertas',
				FROM_TRIAGE_DESC: 'Os alertas deste caso estão na Triagem de alertas; abra-os lá para ver a telemetria e as evidências',
				HIERARCHY: 'Hierarquia da triagem de alertas',
				NO_FLOC: 'Sem local de instalação',
				ALERTS: 'Alertas de triagem',
				ADD_ALERTS: 'Adicionar alertas',
				ADD_ALERTS_TIP: 'Pesquisar alertas de triagem e adicioná-los a este caso',
				AUTO_FIND: 'Busca automática',
				AUTO_FIND_TIP: 'Alertas agrupados com os deste caso ou no mesmo local de instalação em torno do evento',
				AUTO_FIND_DESC: 'Grupo de lote ou mesmo local de instalação na janela em torno do alerta de origem',
				EVENT_START: 'Início do evento',
				VIA_SOURCE: 'Origem',
				VIA_MANUAL: 'Adicionado',
				VIA_AUTO: 'Encontrado automaticamente',
				ALERT_MISSING: 'Não está mais na fila de triagem',
				OPEN_TRIAGE: 'Abrir na Triagem de alertas',
				REMOVE_ALERT: 'Remover do caso',
				SEARCH_PLACEHOLDER: 'Pesquisar por ID do alerta, tag, nome ou local de instalação…',
				SEARCHING: 'Pesquisando…',
				NO_MATCH: 'Nenhum alerta correspondente',
				ADD: 'Adicionar',
				NO_SUGGESTIONS: 'Nenhum outro alerta nesta janela',
				REASON_GROUP: 'Mesmo grupo de lote',
				REASON_FLOC: 'Mesmo local de instalação em ±{{hours}} h',
				SELECT_ALL: 'Selecionar tudo',
				ADD_SELECTED: 'Adicionar selecionados ({{count}})',
				EVIDENCE: 'Evidências',
				KIND_FACT: 'Fatos',
				KIND_TAG: 'Tags',
				KIND_MAINTENANCE: 'Manutenção',
				KIND_REPORT: 'Relatórios',
				KIND_NOTE: 'Notas',
				NO_EVIDENCE: 'Nenhuma evidência ainda',
				REMOVE_EVIDENCE: 'Remover evidência',
				ADD_EVIDENCE_PLACEHOLDER: 'Adicionar a {{kind}}…',
				BY_AGENT: 'Agente de triagem',
				BY_ENGINEER: 'Engenheiro',
				ALERT_REMOVED: 'Alerta removido do caso',
				ALERTS_ADDED: '{{count}} alerta(s) adicionado(s)',
				EVIDENCE_ADDED: 'Evidência adicionada',
				EVIDENCE_REMOVED: 'Evidência removida',
				ACTION_FAILED: 'A ação falhou',
				HIERARCHY_SOURCE: 'Hierarquia',
				SOURCE_TRIAGE: 'Triagem de alertas',
				SOURCE_PLATFORM: 'Sistemas da plataforma',
				SELECT_FLOC: 'Local de instalação',
				ROOT: 'Todos',
				FLOC_SEARCH: 'Pesquisar código ou nome do local de instalação…',
				FLOC_REQUIRED: 'Selecione um local de instalação',
				NO_CHILDREN: 'Nenhum nível inferior',
				RELATED_TRIAGE_ALERTS: 'Alertas de triagem (opcional)',
				SELECT_ALERTS: 'Selecionar alerta(s)',
			},
			CREATE_CASE: 'Criar caso',
			UNKNOWN: 'Desconhecido',
			GROUP_BY_OPTION: {
				NONE: 'Nenhum',
				STATUS: 'Status',
				CATEGORY: 'Categoria',
				SYSTEM: 'Sistema',
				OWNER: 'Proprietário',
				CREATOR: 'Criador'
			},
			MANAGEMENT: {
				NO_TAGS_ADDED: 'Nenhuma tag adicionada',
				ADD_TAGS_FROM_DISPLAY_TAGS: 'Use o painel Exibir Tags à direita para adicionar tags a este caso',
			},
			DETAILS: {
				LINK_ALERT_TO_ADD_ANALYSIS: 'Marque um alerta relacionado com análise salva para adicioná-la aqui',
				LINK_ALERT_TO_ADD_VIEWS: 'Marque um alerta relacionado com visualizações salvas para adicioná-las aqui',
				VALUE_IMPACT: 'Impacto de Valor',
				VALUE_CALCULATION_INPUTS: 'Entradas de Cálculo de Valor',
				LIKELIHOOD: 'Probabilidade (%)',
				IMPACT: 'Impacto',
				LIKELIHOOD_IMPACT_MATRIX: 'Matriz de Probabilidade e Impacto',
				SAVINGS: 'Economias',
				CONTRIBUTION_FACTOR: 'Fator de Contribuição',
				ESTIMATED_VALUE: 'Valor Estimado (USD)',
				AGREED_VALUE: 'Valor Acordado (USD)',
				TOTAL_PRODUCTION_LOST: 'Produção Total Perdida (KBOE)',
				TOTAL_FLARING_AVOIDED: 'Total de Queima Evitada (MT CO2)',
				PRODUCTIVITY: 'Produtividade (Horas)',
				EMISSIONS: 'Emissões (Toneladas)',
				SELECT_VALUE: 'Selecionar Valor',
				ENTER_VALUE: 'Inserir Valor',
				OPTIONAL_FIELD_SAVE_ERROR: 'Falha ao salvar as alterações dos campos opcionais'
			},
			// NOTE: pt.ts's CASES section is missing the COLUMNS/TOOLTIP/CHIP blocks that the
			// other locales have (pre-existing gap, not introduced by this change). Adding only
			// the two keys this feature needs; the rest is a separate translation backfill.
			COLUMNS: {
				ESTIMATED_VALUE: 'Valor Estimado',
				AGREED_VALUE: 'Valor Acordado'
			},
		},
		ANALYSIS_VIEWS: {
			UNABLE_TO_CREATE_ANALYSIS_TEMPLATE: 'Não é possível criar um modelo de análise a partir de múltiplas instalações',
			TITLE: 'Análise e Visualizações',
			CLOSE: 'Fechar',
			EXPORT_TO_EXTERNAL: 'Exportar tags selecionadas para sistema externo',
			SAVED_ANALYSIS: 'Análise salva',
			CREATE_NEW: 'Criar novo',
			SAVED_VIEWS: 'Visualizações salvas',
			SAVE_CURRENT_VIEW: 'Salvar visualização atual',
			SAVE_DISABLED_TOOLTIP: 'Somente o proprietário do alerta pode salvar ou modificar visualizações de tags.',
			TEMPLATE_TAG: '[Modelo]',
			SNAPSHOT_TAG: '[Instantâneo]',
			EDIT: 'Editar',
			DELETE: 'Excluir',
			SAVED_DASHBOARDS: 'Painéis salvos',
			NO_DASHBOARDS: 'Nenhum painel salvo disponível',
		},
		THRESHOLD_PANEL: {
			TITLE: 'Limite',
			CLOSE: 'Fechar',
			ONGOING: 'Em andamento',
			SHOW_LESS: 'Mostrar menos',
			SEE_MORE: 'Ver mais',
		},
		ACTIVITY_LOGS: {
			TITLE: 'Registros de atividade',
			ACTIONS: 'Ações ({{count}})',
			CLOSE: 'Fechar',
			SEARCH_PLACEHOLDER: 'Pesquisar...',
		},
		FEEDBACK_RIGHT_NAV: {
			TITLE: 'Feedback',
			CLOSE: 'Fechar',
			APPROVED: 'Aprovado',
			RELEARNED: 'Retreinado',
			QUOTE_APPROVED_HYPOTHESIS: 'Hipótese aprovada',
			QUOTE_RELEARNED_HYPOTHESIS: 'Hipótese retreinada',
			QUOTE_APPROVED_CAUSAL: 'Etapa da cadeia causal aprovada',
			QUOTE_RELEARNED_CAUSAL: 'Etapa da cadeia causal retreinada',
			QUOTE_APPROVED_RECOMMENDATION: 'Recomendação aprovada',
			QUOTE_RELEARNED_RECOMMENDATION: 'Recomendação retreinada',
			QUOTE_OTHER: 'Outro',
			FILE_ALT: 'Arquivo',
			EMPTY_HEADING: 'Nenhum feedback disponível',
			EMPTY_CONTENT: 'Aprove ou retreine para adicionar um feedback.',
		},
		DISCUSSION: {
			TITLE: 'Discussão',
			COMMENTS_COUNT: 'Comentários ({{count}})',
			CLOSE: 'Fechar',
			CREATE_CASE_TITLE: 'Crie um caso para gerenciar acompanhamentos',
			CREATE_CASE: 'Criar caso',
			BACK: 'Voltar',
			THREAD_BY: 'Tópico por',
			SEARCH_PLACEHOLDER: 'Pesquisar...',
			NO_COMMENTS_HEADING: 'Nenhum comentário aqui',
			NO_COMMENTS_BODY: 'Deixe seu primeiro comentário para iniciar a discussão sobre este tópico.',
			EDITED: 'Editado',
			RCA_VERSION_DELETED: 'Versão da RCA excluída',
			COMMENT_DELETED: 'Este comentário foi excluído.',
			COMMENT_DELETED_ALT: 'Este comentário foi excluído.',
			REPLY_SINGULAR: 'resposta',
			REPLY_PLURAL: 'respostas',
			LAST_REPLY: 'Última resposta',
			REPLY_PROMPT: 'Responder...',
			COMMENT_PLACEHOLDER: 'Adicione um comentário, use @ para marcar membros da equipe',
			REPLY_TO_COMMENT_PLACEHOLDER: 'Responder ao comentário...',
		},
		RETRAIN_MODEL: {
			TITLE: 'Retreinar Modelo',
			CLOSE: 'Fechar',
			CURRENT_MODEL_DETAILS: 'Detalhes do modelo atual',
			DEPLOYED_VERSION_LABEL: 'Versão implantada - Data / Hora',
			LAST_PREDICTION_LABEL: 'Última previsão - Data / Hora',
			FORM_ERROR: 'Ops! Altere algumas coisas e tente enviar novamente.',
			TRAINING_PERIOD: 'Período de treinamento',
			DATE_RANGE_SELECTION_METHOD: 'Método de seleção de intervalo de datas',
			SELECT_TRAINING_MODE_ARIA: 'Selecionar modo de seleção de treinamento',
			CALENDAR_SELECTION: 'Seleção por calendário',
			CHART_BASED_SELECTION: 'Seleção baseada em gráfico',
			VIEW_EDIT_NOTE: 'Ver / Editar Nota',
			ADD_NOTE: 'Adicionar Nota',
			ADD_TRAINING_RANGE: 'Adicionar intervalo de treinamento',
			DELETE_TRAINING_RANGE: 'Excluir intervalo de treinamento',
			ADVANCED_SETTINGS: 'Configurações avançadas',
			BAND_LEARNING_BEHAVIOUR: 'Comportamento de aprendizado de banda',
			SELECT_BAND_LEARNING_ARIA: 'Selecionar comportamento de aprendizado de banda',
			CONSERVATIVE_TOOLTIP: 'Cria bandas mais estreitas ao redor da região de treinamento selecionada',
			CONSERVATIVE: 'Conservador',
			MODERATE_TOOLTIP: 'Cria bandas equilibradas ao redor da região de treinamento selecionada',
			MODERATE: 'Moderado',
			AGGRESSIVE_TOOLTIP: 'Cria bandas mais amplas ao redor da região de treinamento selecionada',
			AGGRESSIVE: 'Agressivo',
			PREDICTION_SMOOTHING_SETTINGS: 'Configurações de suavização de previsão',
			SMOOTHING: 'Suavização',
			WINDOW_SIZE: 'Tamanho da janela',
			WINDOW_SIZE_PLACEHOLDER: 'Tamanho da janela (em horas)',
			VALUE_IS: 'O valor é',
			REQUIRED: 'obrigatório',
			VALUE_MIN: 'O valor deve ser maior ou igual a',
			POLYNOMIAL_ORDER: 'Ordem polinomial',
			SIGMA: 'Sigma',
			SELECT_ATTENTION_TAGS: 'Selecionar tags de atenção',
			SEARCH_PLACEHOLDER: 'Pesquisar...',
			NO_MATCHING_TAGS: 'Nenhuma tag correspondente encontrada',
			SHOW_ALL_TAGS: 'Mostrar todas as tags',
			SHOW_ATTENTION_TAGS_ONLY: 'Mostrar apenas tags de atenção',
			MODELING_TECHNIQUE: 'Técnica de modelagem',
			AUTO_ENCODER: 'Auto Encoder',
			ATTENTION_AUTO_ENCODER: 'Attention Auto Encoder',
			CANCEL_TOOLTIP: 'Cancelar alterações',
			CANCEL: 'Cancelar',
			RETRAIN_DEPLOY_TOOLTIP: 'Retreinar e Implantar',
		},
		ROOT_CAUSE_RECOMMENDATION: {
			CLOSE: 'Fechar',
			ICON_ALT: 'Ícone de causa raiz',
			NOT_GENERATED_MESSAGE: 'Você ainda não gerou a Análise de Causa Raiz. Gere-a para continuar.',
			FAILED_MESSAGE: 'Sua última Análise de Causa Raiz falhou.<br> Gere-a novamente para continuar.',
			GENERATE_NOW: 'Gerar agora',
			REFRESH: 'Atualizar',
			LAST_GENERATED: 'Última geração',
			GENERATING: 'Gerando Análise de Causa Raiz',
			LOADER_ALT: 'carregando',
			LIKE_ALT: 'Curtir',
			DISLIKE_ALT: 'Ícone de não curtir',
			MONETARY_VALUE: 'Valor monetário',
			FAILURE_HISTORY: 'Histórico de falhas',
			INFO_CARD_ARIA: 'Cartão de informações',
			PREVIOUS_FAILURE_MODES: 'Modos de falha anteriores',
			HYPOTHESIS_PREFIX: 'Hipótese',
			MOST_LIKELY: '(Mais provável)',
			CASCADES_AS_FOLLOWS: '.Esta causa raiz provavelmente se propaga da seguinte forma:',
			AGREE: 'Concordo',
			PARTIALLY_AGREE: 'Concordo parcialmente',
			DISAGREE: 'Discordo',
			TELL_US_MORE: 'Conte-nos mais:',
			FEEDBACK_PLACEHOLDER: 'Sinta-se à vontade para adicionar detalhes específicos',
			CANCEL: 'Cancelar',
			SUBMIT: 'Enviar',
		},
		RIGHT_PANEL_DOCUMENTS: {
			TITLE: 'Documentos',
			CLOSE: 'Fechar',
			SEARCH_PLACEHOLDER: 'Pesquisar...',
			FILTER_TAGS: 'Filtrar tags',
			EMPTY_HEADING: 'Nenhum documento disponível',
		},
		MONETORY_VALUE_DIALOG: {
			TITLE: 'Valores Monetários',
			CURRENCY_HINT: 'Os valores monetários são inseridos em {{currency}}',
			RELIABILITY: 'Confiabilidade',
			MAINTENANCE: 'Manutenção',
			PERFORMANCE: 'Desempenho',
			POTENTIAL_SUFFIX: ' (Potencial)',
			ENTER_VALUE: 'Digite o valor',
			COMMENT_REQUIRED_ERROR: 'O comentário não pode estar vazio.',
			AMOUNT_REQUIRED_ERROR: 'Pelo menos um valor deve ser inserido.',
			COMMENT: 'Comentário',
			COMMENT_PLACEHOLDER: 'Adicione seu comentário',
			CANCEL: 'Cancelar',
			SAVE: 'Salvar',
		},
		FAILURE_MODE_DETAILS: {
			TITLE: 'Detalhes do modo de falha',
			OPEN_ALERT: 'Abrir alerta',
			TTF_ALT: 'TTF',
			ADD_MONETARY_VALUE: 'Adicionar valor monetário',
			CMMS_NUMBER_TOOLTIP: 'Número CMMS',
			MORE_SUFFIX: 'mais',
			ADD_CMMS_NUMBER: 'Adicionar número CMMS',
			BREAKDOWN_CATEGORY: 'Categoria de detalhamento',
			BREAKDOWN_COMPONENT: 'Componente de detalhamento',
			ERROR_LABEL: 'Erro',
			TAG_CHARTS_SUFFIX: 'gráficos de tags',
		},
		DATA_QUALITY_PANEL: {
			TITLE: 'Qualidade dos Dados',
			CLOSE: 'Fechar',
			SEE_LESS: 'Ver menos',
			SEE_MORE: 'Ver mais',
		},
		FAILURE_TIMELINE_PANEL: {
			SORT_BY: 'Ordenar por:',
			ASSET: 'Ativo:',
			REASON: 'Motivo:',
			RECOMMENDATIONS: 'Recomendações:',
			NA: 'N/D',
		},
		REPORT_ISSUE_SIDEPANEL: {
			TITLE: 'Reportar um problema',
			SUBTITLE: 'Diga-nos o que deu errado com o agente de RCA.',
			CLOSE: 'Fechar',
			WARNING_BANNER: 'Isso não atualizará nem executará novamente a RCA atual. Para melhorar uma hipótese, cadeia causal ou recomendação, use as opções de feedback dentro da RCA.',
			SECTION_TITLE: 'O que deu errado?',
			SECTION_HINT: 'Selecione tudo o que se aplica.',
			ISSUES_ERROR: 'Selecione pelo menos uma opção.',
			DETAILS_ERROR: 'Adicione detalhes sobre o problema que você experimentou.',
			DETAILS_LABEL_REQUIRED: 'Detalhes adicionais (Obrigatório)',
			DETAILS_LABEL_OPTIONAL: 'Detalhes adicionais (Opcional)',
			DETAILS_PLACEHOLDER: 'Por exemplo, a RCA identificou a tendência de pressão correta, mas concluiu que a bomba causou o evento, embora o histórico de manutenção indicasse uma falha na válvula.',
			DISCLAIMER: 'Ao enviar este relatório, os dados relevantes da RCA e os registros de atividade serão compartilhados com a equipe autorizada da UptimeAI para investigação.',
			CANCEL: 'Cancelar',
			SUBMIT_REPORT: 'Enviar Relatório',
			RUN_RCA_FIRST: 'Execute uma RCA antes de reportar um problema com o agente.',
			SUBMITTED_SUCCESS: 'Problema reportado com sucesso',
			SUBMIT_FAILED: 'Falha ao reportar o problema. Tente novamente.',
			OPT_PLATFORM_DATA_LABEL: 'Dados relevantes da plataforma não foram considerados',
			OPT_PLATFORM_DATA_HINT: 'A RCA não utilizou todos os alertas, tags, tendências, eventos ou outros dados relevantes disponíveis na plataforma.',
			OPT_EVIDENCE_LABEL: 'Documentos ou evidências não foram considerados corretamente',
			OPT_EVIDENCE_HINT: 'Documentos enviados, evidências propostas ou outras informações de apoio foram ignorados ou interpretados incorretamente.',
			OPT_USER_INPUT_LABEL: 'Minha contribuição não foi considerada adequadamente',
			OPT_USER_INPUT_HINT: 'A RCA não considerou adequadamente o contexto, instruções, notas ou feedback que forneci durante esta investigação ou em execuções anteriores.',
			OPT_CAUSAL_LABEL: 'O raciocínio causal estava incorreto',
			OPT_CAUSAL_HINT: 'A RCA considerou informações relevantes, mas chegou a uma conclusão incorreta.',
			OPT_WEIGHTED_LABEL: 'As evidências foram ponderadas incorretamente',
			OPT_WEIGHTED_HINT: 'A RCA focou demais em um único ponto de dado e não considerou suficientemente outras evidências importantes.',
			OPT_UNSUPPORTED_LABEL: 'Uma conclusão não foi apoiada por evidências',
			OPT_UNSUPPORTED_HINT: 'A RCA gerou uma afirmação ou conclusão sem dados ou evidências de apoio suficientes.',
			OPT_RECOMMENDATION_LABEL: 'A recomendação não era acionável',
			OPT_RECOMMENDATION_HINT: 'A recomendação era muito genérica, impraticável ou não útil operacionalmente.',
			OPT_UNCLEAR_LABEL: 'A explicação não estava clara',
			OPT_UNCLEAR_HINT: 'O raciocínio foi difícil de entender ou não forneceu justificativa suficiente.',
			OPT_OTHER_LABEL: 'Outro',
			OPT_OTHER_HINT: 'Reporte um problema que não esteja listado acima.',
		},
		LIBRARY: {
			TITLE: 'Biblioteca',
			SUBTITLE: 'Desenhos P&ID e documentos de engenharia (manuais, folhas de dados, listas de alarmes / desarmes) num só lugar.',
			SEARCH: 'Pesquisar desenhos, documentos, equipamentos ou um tag (ex. PT-0940)…',
			TAB_PIDS: 'P&IDs',
			TAB_DOCS: 'Manuais e dados',
			PIDS: {
				LOADING: 'A carregar desenhos…',
				FAILED: 'Não foi possível carregar os desenhos.',
				LOCATED: 'Desenhos que mostram {{tag}}',
				NOT_LOCATED: '{{tag}} não está em nenhum desenho indexado.',
				NO_MATCH: 'Nenhum desenho corresponde à pesquisa.',
				TAGS: '{{count}} tags',
				PICK: 'Escolha um desenho à esquerda ou pesquise um tag para encontrar os desenhos que o mostram.',
				VIEW_DRAWING: 'Desenho',
				VIEW_PDF: 'PDF completo',
				PDF_LOADING: 'A carregar o PDF…',
				PDF_FAILED: 'O PDF deste desenho não está disponível.',
				OTHER: 'Outros desenhos',
				REFERENCE: 'Legendas e índices de desenhos',
			},
			DOCS: {
				LOADING: 'A carregar documentos…',
				FAILED: 'Não foi possível carregar os documentos.',
				EMPTY: 'Sem documentos.',
				NO_MATCH: 'Nenhum documento corresponde à pesquisa.',
				PICK: 'Escolha um documento para o ler aqui.',
				GROUP_ITEM: 'Nesta localização',
				GROUP_ABOVE: 'De {{floc}}',
				GROUP_BELOW: 'Abaixo desta localização',
				GROUP_TYPE: '{{type}}',
			},
		},
		ASSET_EXPLORER: {
			FLOC: {
				TITLE: 'Árvore de ativos de {{facility}} (locais de instalação SAP)',
				SEARCH_PLACEHOLDER: 'Pesquisar local, equipamento ou tag do historiador…',
				SEARCH_HINT: 'Os ativos correspondentes aparecem abaixo; escolha uma sugestão de tag para mostrá-la no P&ID.',
				HIDE_EMPTY: 'Ocultar locais sem tags',
				HIDE_EMPTY_HINT: 'Oculta locais de instalação sem tags do historiador na subárvore. Pacotes e grupos não atribuídos são sempre exibidos.',
				NODE_HITS: 'Ativos correspondentes ({{count}})',
				CLOSE_HITS: 'Fechar resultados',
				NODE_SEARCH_FAILED: 'A pesquisa de ativos falhou. Tente novamente.',
				NO_NODE_HITS: 'Nenhum ativo corresponde a “{{query}}”.',
				REVEAL_FAILED: 'Não foi possível abrir este ativo na árvore.',
				TREE_EMPTY: 'A árvore de ativos está vazia.',
				TREE_HIDDEN: '{{count}} locais sem tags ocultos',
				CHILDREN_FAILED: 'Não foi possível carregar os filhos deste nó.',
				CHILDREN_HIDDEN: '{{count}} locais filhos sem tags do historiador estão ocultos.',
				COUNT_TIP: '{{count}} tags do historiador nesta subárvore',
				PATH: 'Caminho do ativo',
				UNASSIGNED_NAME: 'Tags não atribuídas',
				UNASSIGNED_TIP: 'Tags do historiador sem local de instalação nem pacote, agrupadas pelo código de sistema no nome da tag',
				UNASSIGNED_NOTE: 'Estas tags do historiador não têm local de instalação SAP nem pacote de equipamentos. Estão agrupadas aqui apenas pelo código de sistema no nome da tag (ou no nível do site quando não há); o equipamento é desconhecido.',
				PACKAGE_NOTE: 'Pacote de equipamentos rotativos: as tags estão atribuídas ao pacote como um todo, não a um único local de instalação SAP.',
				LEVEL_SITE: 'Site',
				LEVEL_SYSTEM: 'Sistema',
				LEVEL_SUBSYSTEM: 'Subsistema',
				LEVEL_EQUIPMENT: 'Equipamento',
				LEVEL_PACKAGE: 'Pacote',
				LEVEL_UNASSIGNED: 'Não atribuído',
				KIND_FLOC: 'Local de instalação SAP',
				KIND_PACKAGE: 'Pacote de equipamentos',
				KIND_UNASSIGNED: 'Grupo de tags não atribuídas',
				SUBTREE_TAGS: '{{count}} tags na subárvore',
				LOOP_TAGS_BADGE: '{{count}} tags de pacote da mesma malha',
				PIDS_SHOWING: 'Em {{count}} P&ID(s)',
				PROP_FLOC: 'Código do local',
				PROP_CODE: 'Código do pacote',
				PROP_LEVEL: 'Nível',
				PROP_KIND: 'Tipo',
				PROP_LOOP: 'Número da malha',
				PROP_OWN_TAGS: 'Tags neste nó',
				PROP_SUBTREE_TAGS: 'Tags na subárvore',
				WITH_DATA: '{{count}} com dados',
				N_TAGS: '{{count}} tags',
				INCLUDE_SUBTREE: 'Incluir subárvore',
				TAGS_OWN_NOTE: 'Tags colocadas diretamente neste nó.',
				TAGS_SUBTREE_NOTE: 'Tags colocadas neste nó e em todos os nós abaixo dele.',
				DETAIL_FAILED: 'Não foi possível carregar este nó. Tente novamente.',
				NO_OWN_TAGS: 'Nenhuma tag do historiador está colocada neste nó.',
				NO_OWN_TAGS_LOOP: 'Nenhuma tag do historiador está no próprio local de instalação; as tags de pacote que compartilham o número da malha estão listadas abaixo.',
				TRUNCATED: 'Mostrando as primeiras {{shown}} de {{total}} tags.',
				FILTER_TAGS: 'Filtrar tags…',
				NO_FILTER_MATCH: 'Nenhuma tag corresponde ao filtro.',
				COL_RULE: 'Regra de colocação',
				COL_DATA: 'Dados',
				PLACED_AT: 'Em',
				LOOP_TITLE: 'Tags de pacote com este número de malha ({{count}})',
				LOOP_EXPLAIN: 'Estas tags pertencem a pacotes de equipamentos rotativos, não a este local de instalação. São listadas porque o nome traz o número de malha {{loop}}, o mesmo deste equipamento. Não entram nos totais de tags deste nó.',
				LOOP_GROUP: 'Malha {{loop}} · pacote {{package}} ({{count}})',
				OPEN_PACKAGE: 'Abrir pacote',
				PID_GROUP_NODE: 'Mostra {{name}}',
				PID_NODE_FOUND: '{{name}} (símbolo do equipamento ou suas tags) aparece em {{count}} desenho(s).',
				PID_NODE_NONE: 'Nenhum P&ID digitalizado mostra {{name}} nem suas primeiras tags.',
				CHIPS_MORE: 'Mostrando {{shown}} de {{total}} tags do nó; adicione outras pela tabela Visão geral ou pela pesquisa.',
				RULE_FLOC_CURATED: 'Local (curado)',
				RULE_FLOC_CURATED_HINT: 'Local de instalação da planilha curada de mapeamento tag–equipamento.',
				RULE_FLOC_BACKFILLED: 'Local (complementado)',
				RULE_FLOC_BACKFILLED_HINT: 'Local do mapeamento tag–ativo do historiador, usado quando a planilha curada não tem nenhum.',
				RULE_FLOC_WELL: 'Local via poço submarino',
				RULE_FLOC_WELL_HINT: 'Tag submarina colocada no local da árvore de produção do seu poço (ou no local do poço) pelo número do poço no nome.',
				RULE_FLOC_LOOP: 'Local via número da malha',
				RULE_FLOC_LOOP_HINT: 'Colocada no único local de equipamento cujo código termina no número de malha da tag.',
				RULE_PACKAGE_PREFIX: 'Pacote via prefixo',
				RULE_PACKAGE_PREFIX_HINT: 'Atribuída a um pacote de equipamentos; colocada sob o subsistema codificado no nome da tag.',
				RULE_PACKAGE_SITE: 'Pacote (site)',
				RULE_PACKAGE_SITE_HINT: 'Atribuída a um pacote de equipamentos; o nome não codifica subsistema, então fica no nível do site.',
				RULE_UNASSIGNED: 'Não atribuída (prefixo)',
				RULE_UNASSIGNED_HINT: 'Sem local nem pacote; agrupada sob o subsistema codificado no nome da tag.',
				RULE_SITE: 'Site',
				RULE_SITE_HINT: 'Sem local, pacote nem código de subsistema; mantida no nível do site.',
			},
			TITLE: 'Hierarquia de ativos de {{facility}}',
			BREADCRUMB: 'Explorador de ativos',
			RELOAD: 'Recarregar',
			LOADING_TREE: 'Carregando hierarquia de ativos…',
			LOAD_FAILED: 'Não foi possível carregar a hierarquia de ativos. Tente novamente.',
			SEARCH_PLACEHOLDER: 'Pesquisar equipamento ou tag do historiador…',
			SEARCH_HINT: 'Digitar filtra a árvore; escolha um tag para vê-lo no P&ID.',
			TREE_EMPTY: 'Nenhum ativo corresponde à pesquisa.',
			EXPAND: 'Expandir',
			COLLAPSE: 'Recolher',
			LEVEL_KICKER: 'Nível {{level}}',
			NODE_ID: 'ID',
			TAGS_MAPPED: '{{count}} tags do historiador',
			PIDS_LINKED: '{{count}} P&IDs vinculados',
			TAB_OVERVIEW: 'Visão geral',
			TAB_PID: 'P&ID',
			TAB_TELEMETRY: 'Séries temporais',
			TAB_DOCS: 'Documentos',
			DOCS: {
				VIEW: 'Documentos ({{count}})',
				HINT: 'Manuais, folhas de dados e listas de alarmes / desarmes de {{name}} e das localizações acima.',
				ALSO_PIDS: 'Também em {{count}} folhas de P&ID',
				OPEN_LIBRARY: 'Abrir a biblioteca',
				EMPTY: 'Nenhum documento está ligado a esta localização ou às localizações acima.',
			},
			OPEN_KG: 'Abrir no grafo de conhecimento',
			VIEW_ALERTS: 'Ver alertas',
			VIEW_PID: 'Ver P&ID',
			VIEW_TELEMETRY: 'Ver séries temporais',
			DESCRIPTION: 'Descrição',
			NO_DESCRIPTION: 'Nenhuma descrição registrada para este ativo.',
			CHILDREN: 'Ativos filhos ({{count}})',
			PROPERTIES: 'Propriedades',
			TAGS_TITLE: 'Tags do historiador ({{count}})',
			NO_TAGS: 'Nenhum tag do historiador está mapeado para este ativo.',
			COL_TAG: 'Tag',
			COL_COMPONENT: 'Componente',
			COL_RANGE: 'Faixa operacional',
			COL_UNIT: 'Unidade',
			COL_ACTIONS: 'Ações',
			LOCATE_ON_PID: 'Mostrar no P&ID',
			PLOT: 'Plotar',
			NO_SELECTION: 'Selecione um ativo na hierarquia ou pesquise um tag.',
			LEVEL: {
				FACILITY: 'Instalação',
				SYSTEM: 'Sistema',
				SUBSYSTEM: 'Subsistema',
				EQUIPMENT: 'Equipamento',
				COMPONENT: 'Componente',
				INSTRUMENT: 'Instrumento',
			},
			PID: {
				SHEET: 'Desenho',
				SEARCH_SHEETS: 'Pesquisar desenhos…',
				SEARCH_ON_DRAWING: 'Encontrar um tag neste desenho…',
				NO_MATCHES: 'Nenhum tag deste desenho corresponde.',
				FILTER_ALL: 'Todos',
				FILTER_INSTRUMENTS: 'Instrumentos',
				FILTER_EQUIPMENT: 'Equipamentos',
				FILTER_NONE: 'Nenhum',
				GROUP_LOCATED: 'Desenhos que mostram {{tag}}',
				GROUP_NODE: 'Vinculados a {{name}}',
				GROUP_ALL: 'Todos os desenhos ({{count}})',
				SOURCE_DIGITISED: 'digitalizado',
				SOURCE_TEXT: 'indexado por texto',
				SOURCE_NEEDS_OCR: 'requer OCR',
				SOURCE_CATALOGUED: 'catalogado',
				SOURCE_BLANK: 'sem texto',
				DETECTIONS: '{{count}} itens',
				LOCATING: 'Procurando {{tag}} nos P&IDs…',
				LOCATE_FAILED: 'Não foi possível procurar {{tag}} nos P&IDs.',
				NOT_ON_PID: '{{tag}} não aparece em nenhum P&ID digitalizado.',
				FOUND_ON: '{{tag}} está em {{count}} desenho(s)',
				CLEAR_LOCATE: 'Limpar',
				TYPE_INSTRUMENT: 'Instrumento',
				TYPE_EQUIPMENT: 'Equipamento',
				CONFIDENCE: '{{pct}}% de confiança',
				CANONICAL: 'Tag canônico',
				HISTORIAN_TAG: 'Tag do historiador',
				NOT_LINKED: 'Não vinculado a um tag do historiador',
				PLOT: 'Plotar nas séries temporais',
			},
			PID_VIEWER: {
				ZOOM_IN: 'Aproximar',
				ZOOM_OUT: 'Afastar',
				FIT: 'Ajustar à visualização',
				FOCUS_HIGHLIGHT: 'Ir para o tag destacado',
				FULLSCREEN: 'Tela cheia',
				EXIT_FULLSCREEN: 'Sair da tela cheia',
				LOADING: 'Carregando desenho…',
				NO_DRAWING: 'Nenhum desenho selecionado.',
				LOAD_FAILED: 'Não foi possível carregar este desenho.',
				NO_IMAGE: 'Sem imagem para este desenho',
				NO_IMAGE_HINT: 'O desenho está digitalizado ({{count}} itens, {{highlighted}} destacados), mas a imagem não está disponível.',
				PAN_HINT: 'Arraste para mover · role para ampliar',
				ASPECT_WARNING: 'Os tamanhos da imagem e do desenho diferem; as caixas podem estar deslocadas.',
				HISTORIAN_TAG: 'Tag do historiador',
				NOT_LINKED: 'Não vinculado',
				CLICK_HINT: 'Clique para selecionar',
				UNTAGGED: 'Item sem tag',
			},
			TAG_SEARCH: {
				SEARCHING: 'Pesquisando…',
				FAILED: 'A pesquisa de tags falhou. Tente novamente.',
				NO_RESULTS: 'Nenhum tag do historiador corresponde a “{{query}}”.',
				HAS_DATA: 'Com dados',
				NO_DATA: 'Sem dados',
				ALREADY_ADDED: 'Já selecionado',
			},
			TELEMETRY: {
				ACTIVE_TAGS: 'Tags no gráfico ({{count}} / {{max}})',
				SEARCH_PLACEHOLDER: 'Pesquisar tags do historiador para adicionar…',
				DROPPED: 'Máximo de {{max}} tags: {{tag}} foi removido para liberar espaço.',
				REMOVE: 'Remover do gráfico',
				WINDOW: 'Janela de tempo',
				WINDOW_7D: '7 d',
				WINDOW_30D: '30 d',
				WINDOW_90D: '90 d',
				WINDOW_1Y: '1 a',
				CHART_TITLE: 'Séries temporais do historiador',
				POINTS: '{{count}} pontos',
				LOADING: 'Carregando séries temporais…',
				NO_DATA: 'Sem leituras para os tags selecionados nesta janela.',
				NO_TAGS: 'Pesquise um tag ou escolha um acima para plotá-lo.',
				SUMMARY: 'Resumo',
				LATEST: 'Último',
				MIN: 'Mín',
				MAX: 'Máx',
				MEAN: 'Média',
			},
		},
		TRIAGE: {
			RULE_SIGNALS: {
				TITLE: 'What this rule measures',
				MEASURED: 'Measured',
				CONTEXT: 'Context',
				HAS_READINGS: 'Readings before the alert',
				NO_READINGS: 'No readings in the 24 h before the alert',
				SOURCE: 'Mapping from {{source}}',
				GUESSED: 'Shell\'s configuration does not list this rule\'s inputs; the charted signals were chosen by the agent from the well\'s sensors.',
			},
			BASIS: {
				NO_RESULT: 'No decision yet: run the agent on this alert.',
				RECOMMENDATIONS: 'Recommendations',
				NO_RECOMMENDATIONS: 'The agent made no recommendations for this alert.',
				FINAL_HYPOTHESES: 'Final hypotheses (adjudicator)',
				NO_FACT_SPAN: 'This run did not record which evidence it read.',
				LINK_RCA: 'Deep RCA · {{count}} verified facts',
				LINK_EVIDENCE: 'Evidence used',
			},
			PFLOW: {
				ALERT_DRAWINGS: 'Drawings the alert equipment is on (open with the alert context)',
				TAB: 'Process flow',
				TITLE: 'Block flow (process units)',
				CHECKED_LEGEND: 'Checked by the agent ({{n}})',
				OPEN_MAP: 'Open process map',
				OPEN_ON_MAP: 'Show on process map',
				ALERT_UNIT: 'Alert\'s unit',
				STATE_MOVED: 'Moved',
				STATE_HELD: 'Steady',
				STATE_NODATA: 'No data',
				TIMING_BEFORE: 'before the alert',
				TIMING_TOGETHER: 'with the alert',
				TIMING_AFTER: 'after the alert',
				TIMING_EARLIER: '> 48 h earlier',
				KEY_SENSORS: 'Key sensors (click to chart)',
				CHART_IT: 'chart it on the right',
				ON_DRAWING: 'Equipment on the alert\'s drawing',
			},
			STEP_PANEL: {
				DQ: 'Data quality of the readings before the alert',
				NO_DQ: 'No data-quality assessment was recorded for this alert.',
				STATE: 'Alert tag with the machine\'s run indicator',
				LIMITS: 'Limits of this tag and when they applied',
				RULE: 'The detector and the tags it watches',
				EQUIPMENT: 'Sensors on this equipment — click one to chart it on the right',
				PROCESS: 'Live P&ID — click a tag to chart it on the right',
				NO_ANOMALY: 'The run has no anomaly-model analysis for this alert.',
			},
			DOCPAGE: {
				MAXIMIZE: 'Maximize',
				RESTORE: 'Restore',
				MARKING: 'Finding the cited passage on this page…',
				MARKING_TERMS: 'Finding the search words on this page…',
				MARK_FAILED: 'The page is shown, but the passage could not be located on it.',
				PAGE_OF: 'page {{page}} of {{pages}}',
				PREV: 'Previous page',
				NEXT: 'Next page',
				CITED_FOUND: 'The red box marks the passage the triage relied on.',
				OCR: 'This page is a scan, read by OCR, so the box position is approximate.',
				CITED_MISSING: 'The cited words could not be found on this page image (the scan reads differently); the passage is the one quoted in the triage.',
				CITED_ON: 'The cited passage is on page {{page}}.',
				LOADING: 'Loading the page…',
				CLOSE: 'Close',
			},
			DOCS: {
				REFERRED: 'Referred documents',
				ALL: 'All documents',
				SEARCH_PLACEHOLDER: 'Filter by name — press Enter to search inside the documents',
				SEARCH_INSIDE: 'Search inside',
				WHOLE_SITE: 'Whole site',
				RESULTS: 'Pages matching “{{q}}”',
				NO_RESULTS: 'No page matches these words.',
				PAGE: 'p.{{n}}',
				USED: 'Passages the triage used',
				USED_HINT: 'Click a passage to open its page with the passage in a red box',
				CITED: 'cited',
				VIEW_PAGE: 'View page',
			},
			SEE: {
				RULE: 'Rule, delay and replay: see Source Alert',
				SENSORS: 'Sensors on this machine: see System Details',
				TAGS: 'Plot them: see Tags',
				CONNECTED: 'Upstream and downstream units: see System details › Process flow',
				PID: 'P&ID drawings: see System details',
				WORK_ORDERS: 'Open work: see Work Orders',
				ALERTS: 'Earlier alerts: see Alerts',
				REPORTS: 'Shift reports: see Reports',
				REASONING: 'How the agent reasoned: see Reasoning',
			},
			PANE_SPLIT_HINT: 'Drag to resize; double-click to reset',
			RELATED: {
				TITLE: 'Related alerts',
				HELP: 'Found by the known-issue check: earlier alerts on this equipment known before this alert\'s cut-off, and later alerts that linked to this one. Each alert keeps its own label.',
				NONE: 'No related alert found.',
				ISSUE_SIZE: 'Issue of {{n}} alerts',
				REL_COVERED_BY: 'Service already raised',
				REL_SAME_CONDITION: 'Same condition',
				REL_SAME_EVENT: 'Same event',
				DIR_EARLIER: 'earlier alert',
				DIR_LATER: 'later alert',
				SCORE: 'score {{s}}',
				STATUS_PROPOSED: 'Proposed',
				STATUS_CONFIRMED: 'Confirmed',
				STATUS_REJECTED: 'Rejected',
				CONFIRM: 'Confirm',
				REJECT: 'Reject',
				CHIP: 'Same issue as {{n}} other alert(s)',
				CHIP_TIP: 'The known-issue check found {{n}} other alert(s) on the same condition. Open the alert to see them under Related alerts, and confirm or reject the link.',
				CHIP_PROPOSED: 'Some links still await review.',
			},
			QUEUE_RUN: {
				BUTTON: 'Triage selected',
				HINT: 'Run the Triage Agent on each selected alert, one alert at a time per run (never grouped); a few run at once.',
				STARTED: 'Triaging {{n}} alerts individually',
				PROGRESS: 'Triage: {{done}} of {{total}} done, {{running}} running',
				DONE: 'Triage finished for {{n}} alerts ({{failed}} failed)',
			},
			LABEL_SETTINGS: {
				PROPOSALS_TITLE: 'Proposed mapping changes ({{n}})',
				PROPOSALS_HELP: 'Reviewers agreed with the agent\'s finding but expected another customer label. Apply moves the finding in the editor below; it is accepted when you save the new version.',
				N_ALERTS: '{{n}} alerts',
				APPLY: 'Apply to mapping',
				APPLIED: 'Applied — save to accept',
				REJECT: 'Reject',
				TAB_SETTINGS: 'Settings',
				TAB_LABELS: 'Labels',
				INTRO: 'The agent decides an internal finding; the mapping turns it into the label the customer sees. A change saves a new version (v{{v}} is in force) and relabels every alert at once, without re-running triage.',
				EXTERNAL_TITLE: 'External labels',
				EXTERNAL_HELP: 'The labels shown in the queue and reported to the customer. The outcome drives the approve button: close, act (raise the action type) or hold for review. Saved labels cannot be deleted, only retired; their keys are permanent.',
				COL_NAME: 'Name / key',
				COL_CUSTOMER: 'Customer value',
				COL_OUTCOME: 'Outcome',
				COL_ACTION: 'Action type',
				COL_COLOR: 'Colour',
				COL_SCORED: 'Scored as',
				COL_ACTIVE: 'Active',
				UP: 'Move up',
				DOWN: 'Move down',
				REMOVE: 'Remove (never saved)',
				FALLBACK: 'fallback',
				CUSTOMER_NONE: 'Not exported',
				ACTION_PH: 'e.g. service_notification',
				OUTCOME_CLOSE: 'Close',
				OUTCOME_ACTION: 'Action',
				OUTCOME_HOLD: 'Hold for review',
				NOT_SCORED: 'Not scored',
				NEW_KEY: 'New key, e.g. valid_monitor',
				NEW_NAME: 'Name shown to users',
				ADD: 'Add label',
				KEY_RULE: 'Key: 3–41 lower-case letters, digits or underscores, starting with a letter.',
				KEY_TAKEN: 'That key is already used (keys are never reused, even after retiring).',
				NAME_REQUIRED: 'Give the label a name.',
				FALLBACK_LABEL: 'Fallback label',
				FALLBACK_HELP: 'Used when a finding has no mapping. Must be active and hold for review.',
				MAPPING_TITLE: 'Mapping: external label ← internal findings',
				MAPPING_HELP: 'Each external label (left) owns the agent findings on the right. Every finding belongs to exactly one label. Click a finding to move it. Amber findings differ from the default mapping.',
				UNMAPPED: '{{n}} findings are not mapped; they would show as the fallback label.',
				N_FINDINGS: '{{n}} findings',
				NONE: 'No findings mapped',
				RETIRED_NONE: 'Retired: owns no findings',
				DEFAULT_WAS: 'default: {{x}}',
				CHECK_N: 'Check {{n}}',
				MOVE_TO: 'Move “{{x}}” to',
				BY_CHECK: 'View by triage check',
				NO_CHANGES: 'No changes.',
				PREVIEWING: 'Checking the change…',
				MOVING: '{{n}} triaged alerts would change label.',
				DISCARD: 'Discard',
				SAVE: 'Save new version',
				SAVED: 'Label mapping v{{v}} saved',
				HISTORY: 'Versions',
				IN_FORCE: 'in force',
				RESTORE: 'Load into editor',
				RESTORE_REASON: 'Restore the mapping of v{{v}}',
			},
			LABELS: {
				FINDING_TIP: 'Shown to Shell as “{{label}}” (label mapping v{{v}}, Settings → Labels).',
				FINDING: 'Finding',
				SOURCE_AGENT: 'Agent',
				SOURCE_POLICY: 'Policy',
				SOURCE_HUMAN: 'Reviewer',
				SOURCE_DERIVED: 'Derived',
				MAPPING: 'Mapping v{{v}} → {{label}}',
				MAPPING_TIP: 'The finding is turned into the customer label by the label mapping in Settings › Labels. Changing the mapping relabels alerts without re-running triage.',
				ALSO_FOUND: 'Also found',
				CHECK: 'check {{n}}',
				SECONDARY_ACTION: 'Also found: {{names}}. That finding leads to an action, but the main finding closes the alert. Review before closing.',
				INTERNAL_COLUMN: 'Finding',
			},
			ACT: {
				APPROVED_CLOSED: 'Approved and closed',
				CLOSED: 'Closed – False alert',
				CLOSED_FLAGGED: 'Closed – False alert · rule flagged for tuning',
				CLOSE_ALERT: 'Close alert',
				CLOSE_CONFIRM: 'Close alert',
				CLOSE_TITLE: 'Close as False – No Action',
				CREATE_INSTRUMENT_WO: 'Create instrument WO',
				CREATE_SERVICE: 'Create Service',
				DUE_DATE: 'Due date',
				EQUIPMENT: 'Equipment',
				EVIDENCE_ATTACHED: 'Evidence attached (click to leave one out)',
				FEED_CONFIRM: 'Report issue',
				FEED_LEAD: 'The alert was raised on values that are not measurements. The issue goes to {{owner}}; no work order is raised because no transmitter is broken.',
				FEED_REPORTED: 'Data-feed issue reported to {{owner}}',
				FEED_TITLE: 'Report data-feed issue',
				FEWER_FIELDS: 'Show fewer fields',
				FLAG_RULE: 'Flag rule for tuning',
				FROM_AGENT: 'from the agent',
				FROM_DQ_POLICY: 'from DQ policy',
				LINKED: 'Linked to {{id}} and closed',
				LINKED_ALERT: 'Linked alert',
				LINK_CLOSE: 'Link & close',
				LINK_CONFIRM: 'Link & close',
				LINK_LEAD: 'This condition is already covered by an open record. The alert is linked to it and closed as Valid – No Action.',
				LINK_TITLE: 'Link to the known issue',
				LOADING: 'Preparing the form…',
				MORE_FIELDS: 'Show more fields',
				NOTE: 'Note (optional)',
				NOTE_PLACEHOLDER: 'Add context for the SME team…',
				NO_EVIDENCE: 'Nothing cited to attach',
				NO_REPLAY: 'The detector\'s rule could not be replayed on the raw data, so no fix is suggested.',
				OPEN_CASE: 'Open case',
				OWNER: 'Owner',
				OWNER_ME: 'Me',
				PREFILLED: 'prefilled',
				PRIORITY: 'Priority',
				PROBLEM: 'Problem',
				RECOMMENDATION: 'Recommendation',
				REPORT_FEED: 'Report data-feed issue',
				ROUTE_TO: 'Route to',
				SENT_TO: 'Sent to {{owner}}.',
				SERVICE_CONFIRM: 'Create Service',
				SERVICE_CREATED: 'Service case #{{id}} created',
				SERVICE_NAME: 'Title',
				SERVICE_TITLE: 'Create Service',
				TAG: 'Tag',
				UNDO: 'Undo',
				UNDONE: 'Action undone',
				WO_CONFIRM: 'Create work order',
				WO_CREATED: 'Work order {{id}} created · {{route}}',
				WO_TITLE: 'Create instrument work order',
			},
			CHIPS: {
				UNACK_HINT: '{{n}} not yet acknowledged',
			},
			RULE: {
				FLAGGED_SHORT: 'Rule flagged',
				FLAGGED_TIP: 'The detector rule was flagged for tuning',
			},
			SETTINGS: {
				DEFAULT: 'Default',
				FROM_DEFAULT: 'default',
				FROM_FACILITY: 'facility',
				FROM_EQUIPMENT: 'this equipment',
				HISTORY: 'Change history',
				LOADING: 'Loading settings…',
				NO_HISTORY: 'No change yet: every value is the code default.',
				N_CHANGED: '{{n}} changed',
				OPEN: 'Triage settings',
				OPEN_HINT: 'Flatline, delays, HIL in memory, routing',
				READ_ONLY: 'Only an administrator can change these settings.',
				REASON: 'Reason for the change (required)',
				RESET: 'Reset',
				RE_EVAL: 'changes results',
				RE_EVAL_CHANGED: 'Run the golden set before relying on this change',
				RE_EVAL_HINT: 'Changing this changes triage results: run the golden set before relying on it',
				RE_EVAL_NOTE: 'Each change is a new version; every triage run records the version it used. Settings marked "changes results" need a golden-set run before you rely on them.',
				SAVE: 'Save',
				SAVED: 'Settings saved as version {{v}}',
				SAVE_FAILED: 'The settings could not be saved',
				SCOPE: 'Applies to',
				SCOPE_FACILITY: 'The whole facility',
				SUBTITLE: 'Version {{v}}',
				TITLE: 'Alert Triage settings',
			},
			TREE: {
				ALL_OPEN: 'All open alerts',
				CLEAR_FILTER: 'Show all nodes',
				NO_ACTION_TOTAL: 'No action',
				SHOWING_ONLY: 'Showing: {{cls}} only',
				SHOW_NODES_WITH: 'Show nodes with',
			},
			KG: {
				CLICK_TO_COLLAPSE: 'Clique para recolher',
				NO_EXACT: 'Nenhum nó se chama “{{tag}}”',
				PICK_MATCH: 'Estes correspondem em parte, um por parte da planta — escolha um para explorar:',
				BREADCRUMB_OPS: 'Operações offshore',
				BREADCRUMB_TWINS: 'Gêmeos topológicos',
				BREADCRUMB_GRAPH: 'Grafo de conhecimento Shell Vito',
				TITLE: 'Grafo de conhecimento interativo da planta',
				NODES: '{{n}} nós',
				RELATIONSHIPS: '{{n}} relações',
				LIVE: 'Neo4j ao vivo',
				CENTER_PLACEHOLDER: 'Tag central (ex. PT-1502, MTR-0900)…',
				EXPLORE: 'Explorar',
				HOPS: 'Profundidade',
				HOPS_1: '1 salto: vizinhos diretos',
				HOPS_2: '2 saltos: equipamentos vizinhos',
				HOPS_3: '3 saltos: topologia ampla',
				SHOW_TYPE: 'Mostrar este tipo',
				HIDE_TYPE: 'Ocultar este tipo',
				ZOOM_IN: 'Aproximar',
				ZOOM_OUT: 'Afastar',
				FIT: 'Ajustar à tela',
				SHOWING: 'Mostrando {{shown}} de {{total}} nós',
				SHOW_MORE: 'Mostrar mais {{n}}',
				EXPAND_ALL: 'Expandir todos os grupos',
				COLLAPSE_ALL: 'Recolher grupos',
				HINT: 'Passe o cursor para ver nomes · clique em um grupo para expandir · clique em um nó para inspecionar · arraste para mover, role para zoom',
				LOADING: 'Lendo o grafo de conhecimento…',
				LOAD_FAILED: 'Falha ao carregar o grafo de conhecimento',
				CLICK_TO_EXPAND: 'Clique para listar e expandir',
				GROUP: 'NÓS AGRUPADOS',
				COLLAPSE_GROUP: 'Recolher grupo',
				CENTER_ON_NODE: 'Centralizar o grafo neste nó',
				PROPERTIES: 'Propriedades do nó',
				LOADING_RELATIONS: 'Carregando relações…',
				OUTGOING: 'Relações de saída ({{n}})',
				INCOMING: 'Relações de entrada ({{n}})',
				TYPE: {
					Equipment: 'Equipamento',
					ControlValve: 'Válvula de controle',
					Instrument: 'Instrumento',
					Event: 'Alerta',
					Event_PostJune2026: 'Alerta (após junho 2026)',
					Alert: 'Alerta',
					TripEvent: 'Evento de desarme',
					RootCause: 'Causa raiz',
					PhaScenario: 'Cenário PHA',
					Detector: 'Detector',
					Measurement: 'Medição',
					Document: 'Documento',
					PIDDrawing: 'Desenho P&ID',
					FLOC: 'FLOC',
					ProcessLine: 'Linha de processo',
					System: 'Sistema',
				},
			},
			LIBRARY: {
				TITLE: 'Especialista de biblioteca',
				EXCERPTS_N: '{{n}} trechos · {{docs}} documentos',
				NONE: 'Nenhum manual no escopo',
				LIMITS_N: '{{n}} limites indicados',
				SCOPE: 'Pesquisado para',
				HINT: 'Manuais do fabricante, folhas de dados e listas de alarme e desarme deste equipamento (por FLOC), pesquisados por significado e palavras. O agente os cita como LIB-n.',
				QUESTIONS: 'Perguntas feitas',
				NONE_HINT: 'Nenhum manual ou folha de dados está arquivado para este equipamento ou seus FLOC superiores.',
				STATED_LIMITS: 'Limites indicados para este instrumento',
				EXCERPTS: 'Trechos',
			},
			LIMITS: {
				ROW_FOUND: 'The red box marks the row this limit was read from.',
				OPEN_PAGE: 'Open the source page',
				OPEN_ROW: 'Open the source row',
				HIDE_SOURCE: 'Hide the source',
				SHEET_TITLE: 'Source row in the Shell workbook',
				SHEET_UNAVAILABLE: 'The workbook could not be read.',
				SHEET_ROWS: '{{n}} row(s) name this tag, of {{total}}',
				SHEET_NO_ROW: 'No row in this sheet names the tag.',
				SHEET_ROW: 'Row {{n}}',
				AT_ALERT: 'In force at the alert ({{t}}) marked',
				IN_FORCE: 'in force',
				NOT_IN_FORCE: 'not in force then',
				FROM: 'from {{from}}',
				QUOTED_FROM: 'quoted {{from}} – {{to}}',
				MAPPING_REVIEW: 'instrument ↔ tag mapping under review',
				DCS: 'DCS limit tags (historian)',
				AT_ALERT_VALUE: 'at the alert: {{v}}',
				TITLE: 'Limites',
				CLOSEST: '{{kind}} {{value}} · {{headroom}}% de margem',
				NONE: 'Nenhum limite conhecido',
				RULE_BREACHED: 'Regra de variação TMP atingida',
				HINT: 'Todos os limites de engenharia conhecidos do tag (set point de PSV / DCS / PTM do TMP da Shell, SimpleLimits, valores do manual na mesma unidade) contra a última leitura e o pico ou vale de 24 h antes do alerta.',
				NONE_HINT: 'Nenhum limite TMP, SimpleLimits, de detector ou de manual é conhecido para este tag.',
				SOURCE: 'Fonte',
				LIMIT: 'Limite',
				VALUE: 'Valor',
				EXTREME_24H: 'Pico / vale 24 h',
				HEADROOM: 'Margem',
				STATUS: 'Status',
				RATE_RULES: 'Regras de variação TMP',
				LARGEST_CHANGE: 'maior variação {{value}}',
				BREACHED: 'Excedida',
				NOT_BREACHED: 'Não excedida',
				DETECTOR: 'Configuração do detector',
				CONFLICT: 'Valores TMP conflitantes:',
				REACHED: 'Atingido',
				NEAR: 'Próximo',
				CLEAR: 'Folgado',
				NO_READING: 'Sem leitura',
			},
			PREFS: {
				TITLE: 'Preferências',
				HEIGHT: 'Altura preferida dos gráficos',
				CONDENSED: 'Compacta',
				NORMAL: 'Normal',
				EXPANDED: 'Expandida',
				LIMITS_AND_VALUES: 'Limites e valores das tags',
				SHOW: 'Mostrar',
				HIDE: 'Ocultar',
				OTHER: 'Linhas de limite exibidas por padrão',
				TRIP_LINE: 'Linha de trip',
				ALARM_LINE: 'Linha de alarme',
				THRESHOLD_LINE: 'Linha de limiar',
				INSTRUMENT_LINE: 'Linha de faixa do instrumento',
				NOTE: 'Aplica-se a todos os gráficos de triagem. A faixa sombreada é o episódio do modo de falha (início do sinal até o retorno ao normal). Os limites vêm apenas de dados Shell carregados (TMP, SimpleLimits).',
				RESET: 'Redefinir para o padrão',
			},
			PLAYBOOK: {
				TITLE: 'Verificações do manual do local',
				META: '{{count}} regras avaliadas',
				META_HINT: 'Regras extraídas das notas de verificação do local para este detector, vigentes no momento do alerta, testadas com a evidência anterior ao corte',
				LEGEND: '✓ válido · ✗ não válido · ? não avaliável. Uma verificação A MENOS QUE válida bloqueia a regra; as partes não verificáveis são julgadas pelo agente.',
				OPEN_RULE: 'Abrir a regra em Aprendizados',
				DISPOSITION_HINT: 'O que a prática do local faz quando esta regra se aplica',
				UNLESS_HINT: 'Exceções: se alguma for válida, a regra não se aplica',
				JUDGED_BY_AGENT: 'Julgado pelo agente',
				JUDGED_HINT: 'Esta parte não pode ser verificada automaticamente; o agente a avalia com base na evidência',
				VALUE_YES: 'válido',
				VALUE_NO: 'não válido',
				VALUE_UNKNOWN: 'não avaliável',
				ST_MATCHED: 'Corresponde',
				ST_MATCHED_HINT: 'Todas as verificações QUANDO válidas e nenhuma exceção',
				ST_PARTLY: 'Corresponde em parte',
				ST_PARTLY_HINT: 'As verificações automáticas foram válidas; as partes julgadas pelo agente decidem se ela se aplica totalmente',
				ST_EXCEPTED: 'Excetuada',
				ST_EXCEPTED_HINT: 'Ela se aplicaria, mas uma exceção (A MENOS QUE) foi válida',
				ST_UNDETERMINED: 'Indeterminada',
				ST_UNDETERMINED_HINT: 'Uma verificação não pôde ser avaliada com a evidência anterior ao corte',
				ST_NOT_MATCHED: 'Não corresponde',
				ST_NOT_MATCHED_HINT: 'Uma verificação QUANDO não foi válida',
			},
			LEARNING_CHECK: {
				OR: 'ou',
				HOURS: '{{n}} h',
				DAYS: '{{n}} dias',
				ON_ITEM: 'neste item',
				V_STOPPED: 'parou',
				V_STARTED: 'partiu',
				V_RESTARTED: 'reiniciou',
				V_SHUTDOWN_OR_STARTUP: 'desligou ou partiu',
				V_NO_SIGNIFICANT_CHANGE: 'nenhuma mudança significativa',
				V_PROCESS_OR_OPERATING_CHANGE: 'uma mudança de processo ou de operação',
				V_SINGLE_TAG_DEPARTURE: 'uma única tag se desviando sozinha',
				V_MIXED: 'padrões mistos',
				V_CONSISTENT: 'consistente com o normal',
				V_MOVED_TOGETHER: 'moveram-se junto',
				MACHINE_EVENT: 'a máquina {{events}} em até {{window}}',
				MACHINE_EVENT_NO_WINDOW: 'a máquina {{events}}',
				MACHINE_EVENT_ANY: 'uma parada ou partida da máquina em até {{window}}',
				SINCE_RESTART: 'a máquina reiniciou no máximo {{window}} antes do alerta',
				RUNNING: 'máquina em operação no momento do alerta',
				NOT_RUNNING: 'máquina parada no momento do alerta',
				WITHIN_BASELINE: 'tag do alerta dentro da faixa normal no momento do alerta',
				OUTSIDE_BASELINE: 'tag do alerta fora da faixa normal no momento do alerta',
				SUSTAINED: 'um desvio sustentado do normal',
				NOT_SUSTAINED: 'nenhum desvio sustentado do normal',
				CHART_PATTERN: 'os gráficos mostram {{patterns}}',
				CHART_PATTERN_ANY: 'um padrão de gráfico é lido',
				MULTIVARIATE: 'o modelo multivariado indica {{values}}',
				MULTIVARIATE_ANY: 'o modelo multivariado tem um veredito',
				CONNECTED: 'sistemas conectados: {{values}}',
				CONNECTED_ANY: 'os sistemas conectados foram lidos',
				MOVED_TOGETHER: 'tags relacionadas moveram-se juntas',
				NOT_MOVED_TOGETHER: 'tags relacionadas não se moveram juntas',
				OPEN_WORK: 'nota ou ordem de serviço aberta neste item',
				NO_OPEN_WORK: 'nenhuma nota ou ordem de serviço aberta neste item',
				COHORT: 'muitos alertas no mesmo sistema ao mesmo tempo (causa comum)',
				NO_COHORT: 'nenhuma rajada de alertas no mesmo sistema',
				SENSOR_FAULT: 'o sensor está com falha ou os dados são inutilizáveis',
				SENSOR_OK: 'os dados do sensor são utilizáveis',
				RETURNED: 'o sinal voltou ao normal antes do alerta',
				NOT_RETURNED: 'o sinal não havia voltado ao normal até o alerta',
				SHIFT_LOG: 'um relatório de turno recente (janela de {{window}}) menciona “{{query}}”',
				NO_SHIFT_LOG: 'nenhum relatório de turno recente (janela de {{window}}) menciona “{{query}}”',
				RECENT_WORK: 'trabalho de manutenção recente (janela de {{window}}) correspondente a “{{query}}”',
				NO_RECENT_WORK: 'nenhum trabalho de manutenção recente (janela de {{window}}) correspondente a “{{query}}”',
				OTHER_ALERTS: 'pelo menos {{n}} outros alertas do mesmo detector em até {{window}}',
				PRIOR_ALERTS: 'pelo menos {{n}} alertas anteriores nesta tag (janela de {{window}})',
				PRIOR_ALERTS_EVER: 'pelo menos {{n}} alertas anteriores nesta tag',
			},
			LEARNING_EDIT: {
				TITLE: 'Editar aprendizado',
				ASOF_WARNING: 'Salvar grava a versão v{{next}}, vigente a partir de agora. A triagem de alertas anteriores mantém a versão vigente na época (as-of).',
				F_TITLE: 'Título',
				RECOMPILE: 'As verificações automáticas serão recompiladas a partir da nova condição.',
				ACTIVE_HINT: 'o agente o consulta',
				RETIRED_HINT: 'retirado a partir de agora',
				REASON: 'Motivo da alteração',
				REASON_HINT: 'Mantido com a nova versão e exibido no histórico.',
				NO_CHANGES: 'Nada foi alterado ainda.',
				SAVE: 'Salvar nova versão',
				SAVED: 'Salvo como v{{version}}, vigente a partir de agora; triagens anteriores mantêm a versão anterior.',
			},
			LEARNING_DETAIL: {
				TITLE: 'Aprendizado',
				EDIT: 'Editar',
				CLOSE: 'Fechar',
				EFFECTIVE: 'em vigor desde {{date}}',
				SUPPORT: 'Suporte: {{support}}',
				CONSISTENCY: 'consistência {{pct}}',
				MANUAL_FIELDS: 'definido manualmente: {{fields}}',
				CONDITION: 'Condição',
				EXCEPTIONS: 'Exceções',
				CHECKS: 'Verificações automáticas',
				CHECKS_HINT: 'A condição convertida em fatos que o agente pode testar com a evidência no momento do alerta; o restante é julgado pelo agente.',
				CHECKS_STALE: 'A condição foi editada: as verificações automáticas estão sendo recompiladas e não são usadas até lá.',
				WHEN: 'Quando',
				UNLESS: 'A menos que',
				MANUAL: 'Julgado pelo agente',
				NO_CHECKS: 'Nenhuma condição verificável automaticamente',
				GROUPS: 'Grupos de sensores a que seus alertas se referem',
				TYPICAL_TAGS: 'Tags típicas',
				QUOTES: 'Das notas de verificação',
				GRAPH: 'Vizinhança no grafo de conhecimento',
				GRAPH_MISSING: 'Ainda não está no grafo de conhecimento.',
				REL_DETECTOR: 'Para o detector',
				REL_FLOC: 'No local de instalação',
				REL_SUPERSEDES: 'Substitui',
				NO_LINKS: 'Sem vínculos com detector, local ou versões anteriores.',
				SIMILAR: 'Aprendizados semelhantes',
				NO_SIMILAR: 'Nenhum aprendizado ativo com significado próximo.',
				OPEN_SIMILAR: 'Abrir este aprendizado',
				ASOF_NOTE: 'As versões nunca são alteradas: uma triagem no momento t usa a versão vigente em t.',
				NOW: 'agora',
				CHANGED: 'Alterado:',
				SHOW_DIFF: 'Mostrar diferenças da regra',
				HIDE_DIFF: 'Ocultar diferenças',
				F_TITLE: 'título',
				F_RULE: 'regra',
				F_DISPOSITION: 'disposição',
				F_STATUS: 'status',
				F_CONDITION: 'condição',
				F_EXCEPTIONS: 'exceções',
				F_SUPPORT: 'suporte',
				SHOW_ALL_SOURCES: 'Mostrar todos os {{count}}',
			},
			PID: {
				CLICK_TO_PLOT: 'Clique para plotar',
				NO_HISTORIAN_DATA: 'Sem dados do historiador',
				MORE_TAGS: '+{{count}} tags neste item',
				NO_DATA_AT_ALERT: 'Sem leituras nas 72 h antes do alerta',
				CLICKABLE_COUNT: '{{clickable}} de {{total}} tags têm dados',
				TAGS_FAILED: 'Não foi possível carregar os tags deste desenho',
				HIDE_LEGEND: 'Ocultar legenda',
				SHOW_LEGEND: 'Mostrar legenda',
				LEGEND_DATA: 'Com dados do historiador (clique)',
				LEGEND_NO_DATA: 'Sem dados do historiador',
				LEGEND_ALERT: 'Tag do alerta',
				LEGEND_RELATED: 'Mesmo equipamento / malha do alerta',
				LEGEND_SUGGESTED: 'Sugerido para verificar',
				ONLY_WITH_DATA: 'Apenas tags com dados',
				SHEET_N: 'folha {{sheet}}',
				BACK: 'Voltar',
				BACK_TIP: 'Voltar à folha anterior ({{count}} no histórico)',
				SHOW_PANEL: 'Mostrar painel',
				HIDE_PANEL: 'Ocultar painel',
				FROM_UPSTREAM: 'De montante',
				TO_DOWNSTREAM: 'Para jusante',
				RESIZE: 'Arraste para redimensionar o painel',
				ON_DRAWING: 'No desenho',
				LOCATE_ITEM: 'Mostrar no desenho',
				FROM_OTHER_SHEET: 'Selecionado em outra folha',
				ITEM_TAGS: 'Tags deste item ({{count}})',
				SWITCH_TIP: 'clique para plotar este tag em vez disso',
				ADD_TO_CHART: 'Adicionar ao gráfico',
				REMOVE_FROM_CHART: 'Remover do gráfico',
				ON_CHART: '{{count}} / {{max}} no gráfico',
				ALERT_WINDOW: 'Alerta às {{asOf}} · 3 dias antes a 1 dia depois',
				LAST_DAYS: 'Últimos {{days}} dias de dados disponíveis',
				CHART_FULL: 'No máximo {{max}} tags podem ser plotados juntos',
				TIME_SERIES: 'Série temporal',
				LOOK_NEXT: 'Ver a seguir',
				CONTEXT_FAILED: 'Não foi possível carregar os tags relacionados',
				CONTEXT_UNKNOWN: 'Este tag não está no catálogo de sensores',
				LOOP_N: 'Malha {{loop}}',
				SAME_LOOP: 'Mesma malha',
				SAME_EQUIPMENT: 'Mesmo equipamento',
				UPSTREAM: 'Unidades a montante',
				DOWNSTREAM: 'Unidades a jusante',
				SERVICE: 'Utilidades que atendem',
				NONE_WITH_DATA: 'Nenhum com dados do historiador',
				SHOW_MORE: 'Mostrar mais {{count}}',
				NO_UNITS: 'Sem unidades conectadas',
				HOPS: '{{count}} salto(s)',
				OPEN_DRAWING: 'Abrir desenho',
				MORE_SENSORS: '+{{count}} sensores',
				TWIN: 'Trem gêmeo: {{unit}}',
				TWIN_ON_CHART: 'O tag gêmeo está no gráfico',
				COMPARE_TWIN: 'Comparar com o gêmeo',
				TWIN_NO_TAG: 'Nenhum tag na mesma posição conhecido em {{unit}}',
				TWIN_SAME_MEASURE: 'Mesma grandeza em {{unit}}',
				LOCATE_ON_SHEET: 'Mostrar nesta folha',
				OTHER_CONNECTORS: 'Utilidades e alívio ({{count}})',
				OTHER_CONNECTORS_TIP: 'Conectores de controle, utilidades e alívio desta folha',
				SIDE_BY_SIDE: 'Lado a lado',
				SIDE_BY_SIDE_TIP: 'Tela cheia: desenho e painel lado a lado',
				REL: {
					ALERT: 'Tag do alerta',
					LOOP: 'Mesma malha',
					EQUIPMENT: 'Mesmo equipamento',
				},
			},
			BATCH: {
				TOGGLE: 'Lote',
				TOGGLE_HINT: 'Modo lote: listar grupos de alertas do mesmo FLOC dentro de uma janela de tempo e triar cada grupo em conjunto',
				TOGGLE_OFF_HINT: 'Voltar à lista de alertas individuais',
				WINDOW_LABEL: 'Janela de {{hours}} h',
				WINDOW_HINT: 'Janela do lote: alertas de um FLOC dentro destas horas após o primeiro formam um grupo',
				WINDOW_TITLE: 'Janela do lote',
				WINDOW_OPTION: '{{hours}} h',
				HELP: 'Os alertas são agrupados por FLOC. A janela é ancorada no primeiro alerta do grupo; o corte é o membro mais recente, portanto cada membro é avaliado com o que se sabia naquele momento. Uma única investigação cobre o grupo e dá a cada membro sua própria disposição. Os grupos usam os filtros de data, pesquisa, FLOC, alvo e status.',
				GROUPS_TITLE: 'Lotes · janela de {{hours}} h',
				GROUPS_COUNT: '({{groups}} grupos · {{alerts}} de {{considered}} alertas)',
				NEWEST_FIRST: 'Mais recentes primeiro',
				EMPTY: 'Nenhum lote',
				EMPTY_HINT: 'Com os filtros atuais nenhum FLOC tem dois ou mais alertas dentro da janela.',
				COL_SIZE: 'Tamanho',
				COL_SPAN: 'Intervalo',
				COL_DETECTORS: 'Detectores',
				COL_CLASSES: 'Classes atuais',
				COL_TAG: 'Tag',
				COL_AS_OF: 'Em',
				TOGGLE_MEMBERS: 'Mostrar ou ocultar os alertas deste grupo',
				N_ALERTS: '{{count}} alertas',
				SPAN: '{{count}} alertas em {{span}}',
				MINUTES: '{{count}} min',
				HOURS_MINUTES: '{{hours}} h {{minutes}} min',
				CUTOFF: 'corte',
				N_UNTRIAGED: '{{count}} sem triagem',
				ALL_TRIAGED: 'Todos triados',
				RUNNING: 'Execução do lote em andamento',
				TRIAGE_BATCH: 'Triar lote ({{count}})',
				TRIAGE_SELECTED: 'Triar {{count}} selecionados',
				TRIAGE_HINT: 'Uma investigação conjunta destes alertas na data do membro mais recente; cada alerta recebe sua própria disposição',
				SELECT_MIN: 'Selecione pelo menos {{count}} alertas deste grupo',
				SELECT_MAX: 'Um lote aceita no máximo {{count}} alertas: selecione até {{count}}',
				PAGE_HINT: 'A paginação conta grupos',
				RANGE: '{{start}}–{{end}} de {{total}} grupos',
				DONE: 'Lote de {{count}} alertas triado',
				GATED: 'Lote não analisado: a verificação de qualidade de dados bloqueou a execução (veja o canvas)',
				FAILED: 'A execução do lote não foi concluída',
				ROW_CHIP: 'lote de {{count}}',
				ROW_CHIP_TIP: 'A última execução triou este alerta junto com {{count}} alertas do seu FLOC (uma investigação, uma disposição por alerta)',
				CARD_TITLE: 'Triagem em grupo',
				CARD_META: 'Lote de {{count}} · janela de {{hours}} h · corte {{time}}',
				EPISODE_CLASS: 'Episódio',
				EPISODE_HINT: 'Classificação do grupo como um todo',
				THIS_MEMBER: 'Este alerta',
				MEMBERS: 'Alertas do lote',
				THIS_ALERT: 'este alerta',
				NOW_IN_GROUP: 'Este alerta está agora em um grupo de {{count}} no seu FLOC (janela de {{hours}} h, {{span}} min, {{untriaged}} sem triagem).',
				MORE_DETECTORS: '+{{count}} mais',
				TRIAGE_WITH: 'Triar com {{count}} alertas deste FLOC',
			},
			UEV: {
				TITLE: 'Evidências e feedback',
				HINT: 'Observações de campo, notas SAP, tags do historiador e arquivos adicionados aqui vão para o agente ao reexecutar, marcados como fornecidos pelo usuário e ponderados à parte do registro na data.',
				BADGE_N: '{{count}} item(ns)',
				BADGE_CHANGED: 'mudou a resposta',
				EMPTY: 'Nenhuma evidência adicionada ainda.',
				LOAD_ERROR: 'Não foi possível carregar a evidência',
				ADD: 'Adicionar evidência',
				ADDED: 'Evidência adicionada',
				UPDATED: 'Evidência atualizada',
				REMOVED_NOTICE: 'Evidência removida',
				TYPE_OBSERVATION: 'Feedback / observação',
				TYPE_SAP: 'Nota SAP',
				TYPE_TAG: 'Tag do historiador',
				TYPE_FILE: 'Arquivo',
				TEXT_LABEL: 'O que foi observado ou medido',
				TEXT_PLACEHOLDER: 'ex.: manômetro local indica 30 scfm; válvula de dreno passando',
				CONTEXT_LABEL: 'Por que importa para este alerta',
				CONTEXT_PLACEHOLDER: 'Nota de contexto para o agente (opcional)',
				NOTIF_LABEL: 'Número da nota',
				LOOKUP: 'Consultar',
				NOTIF_NOT_FOUND: 'Nota não encontrada',
				NOTIF_AFTER: 'Criada {{hours}} h após o alerta',
				NOTIF_BEFORE: 'Criada antes do alerta',
				NOTIF_NAMES_TAG: 'Cita o tag do alerta {{tag}}',
				FLOC_EQUIPMENT: 'Mesmo equipamento',
				FLOC_UNIT: 'Mesma unidade',
				FLOC_FACILITY: 'Outro equipamento',
				RAISED: 'Criada {{time}}',
				COMPLETED: 'Concluída {{time}}',
				TAG_LABEL: 'Tag do historiador',
				TAG_PLACEHOLDER: 'Buscar tags (ex.: LIC0920)',
				TAG_HINT: 'O agente lê este tag na hora do alerta, como qualquer outro tag.',
				FILE_CHOOSE: 'Escolher arquivo',
				FILE_HINT: 'PDF, imagem, texto, CSV, Word ou Excel, até 10 MB',
				FILE_TYPE_ERROR: 'Tipo de arquivo não suportado: envie PDF, PNG, JPG, texto, CSV, Word ou Excel',
				FILE_SIZE_ERROR: 'O arquivo excede 10 MB',
				FILE_META: '{{pages}} página(s), {{size}} KB',
				FILE_NO_TEXT: 'nenhum texto extraído ({{note}})',
				OPEN_FILE: 'Abrir arquivo',
				SAVE: 'Adicionar',
				CANCEL: 'Cancelar',
				EDIT: 'Editar',
				REMOVE: 'Remover',
				REMOVE_CONFIRM: 'Remover este item? As versões anteriores são mantidas e as execuções que as usaram continuam a citá-las.',
				REASON: 'Motivo (opcional)',
				SAVE_EDIT: 'Salvar como nova versão',
				VERSIONS: 'Histórico',
				REMOVED: 'Removido',
				SHOW_REMOVED: 'Mostrar removidos',
				HIDE_REMOVED: 'Ocultar removidos',
				BY: 'Adicionado por {{name}} · {{time}}',
				EDITED_BY: 'v{{n}} por {{name}} · {{time}}',
				AFTER_CUTOFF: 'após o corte',
				RERUN: 'Reexecutar com evidência',
				RERUN_HINT: 'Executa novamente o Agente de Triagem com os {{count}} item(ns) ativos; acompanhe ao vivo no canvas',
				RERUN_BATCH: 'Reexecutar lote ({{count}} alertas)',
				RERUN_BATCH_HINT: 'Executa novamente o lote com a evidência ativa de todos os membros',
				LAST_RUN: 'A última reexecução usou {{refs}}',
				OUTCOME_CHANGED: 'Mudou a resposta: {{from}} → {{to}}',
				OUTCOME_UNCHANGED: 'Resposta inalterada',
				OUTCOME_NOT_ATTRIBUTED: 'Resposta mudou ({{from}} → {{to}}), não atribuída à evidência',
				OUTCOME_NO_BASELINE: 'O agente diz que a evidência decidiu a resposta',
				AGENT_LINE: 'Resposta de uma reexecução com evidência do usuário {{refs}}',
				NODE: 'Evidência do usuário',
				CANVAS_BADGE: 'Evidência do usuário · {{count}}',
				CANVAS_HINT: 'Reexecução com evidência fornecida pelo usuário: {{refs}}',
				PICKER: 'evidência do usuário',
				INSPECTOR_ITEMS: 'Itens usados ({{count}})',
				INSPECTOR_BASELINE: 'Resposta sem esta evidência: {{cls}}',
				INSPECTOR_NO_BASELINE: 'Nenhuma execução anterior sem evidência do usuário',
				INSPECTOR_AUDIT: 'Itens fornecidos pelo usuário ficam fora da visão na data; a verificação de vazamento cobre apenas os fatos do harness.',
				ATTRIBUTION_USER_EVIDENCE: 'Mudada pela evidência: {{from}} → {{to}}',
				ATTRIBUTION_USER_EVIDENCE_NO_BASELINE: 'Decidida pela evidência (sem execução anterior)',
				ATTRIBUTION_NOT_ATTRIBUTED: 'Mudada, não atribuída: {{from}} → {{to}}',
				ATTRIBUTION_UNCHANGED: 'Inalterada',
				EFFECT_CHANGED_ANSWER: 'mudou a resposta',
				EFFECT_SUPPORTED_ANSWER: 'apoia a resposta',
				EFFECT_CONTRADICTED: 'contradiz, não adotada',
				EFFECT_NO_BEARING: 'sem relação',
				EFFECT_NOT_ADDRESSED: 'não tratada',
			},
			WATCH: {
				STATUS_WATCHING: 'Em observação',
				ACTION: 'Observar',
				ACTION_HINT: 'Rever este alerta mais tarde, com os dados registrados após esta avaliação',
				UNWATCH: 'Deixar de observar',
				DIALOG_TITLE: 'Observar alerta',
				DIALOG_LEAD: 'O alerta fica em observação até a data prevista; depois pode ser reavaliado com tudo o que foi registrado desde esta avaliação.',
				ASSESSED_AS_OF: 'Avaliação atual em',
				ASSESSED_HINT: 'O corte da avaliação que você está vendo. As opções contam a partir deste momento, não de hoje.',
				LOOK_AGAIN: 'Rever',
				PRESET_HOURS: '+{{count}} h',
				PRESET_DAYS: '+{{count}} d',
				PRESET_CUSTOM: 'Data e hora',
				DUE_AT: 'Prevista para',
				DUE_LINE: 'Prevista {{time}}',
				DUE_BEFORE_ASSESSMENT: 'deve ser posterior à avaliação',
				SUGGESTED: 'Sugerido pelo agente',
				USE_SUGGESTION: 'Usar como motivo',
				REASON: 'Motivo',
				REASON_HINT: 'O que verificar na data prevista (obrigatório)',
				CONFIRM: 'Observar',
				SET_NOTICE: 'Alerta colocado em observação',
				BANNER_DUE: 'Observação vencida',
				BANNER_WAITING: 'Em observação',
				CHIP_DUE: 'Vencida · {{time}}',
				CHIP_WAITING: 'Em observação · prevista {{time}}',
				TIP_DUE: 'Em observação, vencida desde {{time}}: reavaliar com os novos dados',
				TIP_WAITING: 'Em observação até {{time}}',
				SET_BY: 'Definida por {{name}} em {{date}}',
				BASELINE: 'Observando a avaliação em {{time}}',
				CHECKING: 'Verificando o que foi registrado desde então…',
				NOTHING_NEW: 'Nada novo registrado desde a avaliação até agora.',
				LATER_ALERTS: 'Alertas posteriores',
				BEYOND: '+{{count}} depois',
				OPEN_LATER: 'Abrir este alerta',
				SAP_RECORDS: 'Registros SAP',
				SUPERVISOR_REPORTS: 'Relatórios do supervisor',
				HISTORIAN: 'Historian',
				HOURS: '{{count}} h',
				ON_TAGS: 'em {{count}} tags',
				WINDOW: 'Novos dados de {{from}} a {{to}}',
				REASSESS: 'Reavaliar com novos dados',
				REASSESS_HINT: 'Triar novamente com o corte movido para a data prevista (nunca depois de agora); o canvas acompanha a execução',
				REASSESS_WAIT: 'Disponível quando a observação vencer',
				NEW_DATA: 'novos dados',
				NEW_DATA_DOT: 'Vencida, com dados registrados desde a avaliação',
				FILTER_LABEL: 'Observação',
				FILTER_DUE: 'Vencida',
				FILTER_WAITING: 'Em observação (não vencida)',
				REASSESSED_HEADER: 'Reavaliado em {{time}} (primeira avaliação em {{previous}}: {{cls}})',
			},
			SHELL: {
				TOGGLE: 'Mostrar rótulos HIL',
				TOGGLE_HINT: 'Adiciona o rótulo de verificação HIL (humano no ciclo) e o comentário como colunas para comparar. Apenas dados de validação: nunca uma entrada do agente de triagem.',
				VALIDATION_ONLY: 'Os rótulos HIL (humano no ciclo) são dados de validação. Nunca são uma entrada do agente de triagem.',
				COLUMN: 'Rótulo HIL',
				NOT_VETTED: 'Não verificado',
				NOT_VETTED_TIP: 'Sem rótulo HIL para este alerta',
				STATE: 'Estado HIL',
				COMMENT: 'Comentário',
				ACTION_TAKEN: 'Ação tomada',
				RELIABILITY: 'Confiabilidade',
				INHERITED: 'Herdado do episódio pai',
				AGREES: 'Concorda com HIL',
				DIFFERS: 'Difere de HIL',
				AGREES_TIP: 'Nossa classificação concorda com o rótulo HIL',
				DIFFERS_TIP: 'Nossa: {{ours}} · HIL: {{shell}}',
				AGREEMENT: 'Concorda com HIL em {{agree}} de {{compared}} triados',
				AGREEMENT_TIP: 'Alertas filtrados triados (não pendentes) com rótulo HIL, e quantos têm a mesma classe.\nRótulos HIL são dados de validação, nunca uma entrada do agente.',
				CARD_TITLE: 'Verificação HIL',
				FILTER_LABEL: 'Rótulo HIL',
				FILTER_NONE: 'Não verificado',
				COLUMN_COMMENT: 'Comentário HIL',
			},
			FACTS: {
				TITLE: 'Evidências lidas — mais antiga → mais recente (todas antes do corte)',
				HINT: 'Intervalo dos fatos que a execução leu de cada fonte. Toda consulta para no corte.',
				CUTOFF: 'Corte {{time}}',
				COL_SOURCE: 'Fonte',
				COL_OLDEST: 'Mais antiga',
				COL_NEWEST: 'Mais recente',
				COL_GAP: 'Antes do corte',
				SOURCE_HISTORIAN: 'Historian',
				SOURCE_SAP_NOTIFICATION: 'Notas SAP',
				SOURCE_SAP_WORKORDER: 'Ordens de serviço SAP',
				SOURCE_SUPERVISOR_REPORT: 'Relatórios do supervisor',
				SOURCE_ALERTS: 'Alertas',
				SOURCE_MEMORY: 'Memória',
				NOT_READ: 'Nenhum fato lido',
				POST_ALERT: 'Registros posteriores ao alerta',
				POST_ALERT_NONE: 'nenhum obtido: toda consulta para no corte',
				AFTER_CUTOFF: 'depois do corte',
				GAP_SECONDS: '{{count}} s',
				GAP_MINUTES: '{{count}} min',
				GAP_HOURS: '{{count}} h',
				GAP_DAYS: '{{count}} d',
			},
			SENSOR: {
				MEASURE: {
					temperature: 'Temperatura',
					pressure: 'Pressão',
					differential_pressure: 'Pressão diferencial',
					level: 'Nível',
					flow: 'Vazão',
					vibration: 'Vibração',
					axial_position: 'Posição axial',
					speed: 'Velocidade',
					current: 'Corrente',
					power: 'Potência',
					voltage: 'Tensão',
					valve_position: 'Posição da válvula',
					status: 'Estado',
					composition: 'Composição',
				},
				GROUP: {
					vibration: 'Vibração',
					bearing_temperature: 'Temperatura dos mancais',
					axial_position: 'Posição axial',
					speed_run: 'Velocidade e marcha',
					lube_oil: 'Óleo lubrificante',
					seal_gas: 'Gás de selagem',
					suction: 'Sucção',
					discharge: 'Descarga',
					cooling: 'Resfriamento',
					anti_surge: 'Antissurto',
					scrubber_level: 'Nível do depurador',
					control_valve: 'Válvula de controle',
					motor_electrical: 'Motor elétrico',
					turbine: 'Turbina',
				},
				ROLE: {
					process_value: 'Valor de processo',
					setpoint: 'Setpoint',
					controller_output: 'Saída do controlador',
					limit: 'Limite',
					mode: 'Modo',
					totaliser: 'Totalizador',
				},
				GROUP_NONE: 'Outros',
				COL_SENSOR: 'Sensor',
				CONVENTION_ONLY: 'apenas convenção do tag',
				TIP_MEASURES: 'Mede: {{value}}',
				TIP_WHY: 'Por que é monitorado (Plano técnico de monitoramento)',
				TIP_NO_REASON: 'Nenhum motivo de monitoramento registrado para este sensor.',
				TIP_CONVENTION: 'Descrito apenas pela convenção de tags dos P&ID; o plano de monitoramento não o cobre.',
				TIP_ACTION: 'Ação recomendada',
				TIP_UNIT: 'Unidade: {{unit}}',
				TIP_LIMITS: 'Limites: {{value}}',
				TIP_SOURCES: 'Fontes: {{value}}',
				TIP_LOW: 'Apenas o nome do tag descreve este sensor, portanto seu significado é menos certo.',
				LIMIT_LOW: 'baixo',
				LIMIT_HIGH: 'alto',
			},
			CONNECTED: {
				USUALLY_LEADS: 'geralmente antecede em {{t}} (r {{r}})',
				USUALLY_LAGS: 'geralmente atrasa {{t}} (r {{r}})',
				USUALLY_WITH: 'geralmente se move junto (r {{r}})',
				NOT_COUPLED: 'geralmente não acoplado (r {{r}})',
				USUAL_DELAY: 'moveu-se com o atraso habitual',
				NOT_USUAL_DELAY: 'não com o atraso habitual',
				COUPLING_HINT: 'Como este sensor normalmente se relaciona com a tag do alerta na linha de base em operação: o atraso de melhor correlação e seu r. “Atraso habitual” compara o tempo desta vez com ele.',
				TITLE: 'Sistemas conectados',
				VERDICT: {
					upstream_led: 'A montante moveu-se primeiro',
					service_related: 'Uma utilidade de serviço moveu-se junto',
					downstream_followed: 'A jusante seguiu — a mudança começa aqui',
					moved_together: 'As unidades conectadas moveram-se juntas',
					isolated: 'Os sistemas conectados mantiveram-se — local a este equipamento',
					background_drift: 'Unidades conectadas fora da linha de base há dias (segundo plano)',
					moved_unordered: 'As unidades conectadas moveram-se, ordem pouco clara',
					insufficient: 'Poucos sensores para avaliar',
				},
				UPSTREAM: 'A montante',
				DOWNSTREAM: 'A jusante',
				SERVICE: 'Utilidades de serviço',
				REL_UPSTREAM: 'a montante',
				REL_DOWNSTREAM: 'a jusante',
				REL_SERVICE: 'utilidade de serviço',
				AS_OF: 'Lido no momento do alerta — nada registrado depois é usado',
				OF_SENSORS: 'de {{total}} sensores com dados',
				RATIO_HINT: 'Sensores de interface das unidades vizinhas com leituras utilizáveis antes do alerta',
				ANCHOR_ONSET: 'Início do tag do alerta',
				PLOT: 'Tag do alerta e sensores de interface',
				PLOT_TITLE: 'Gráfico de sistemas conectados',
				PLOT_CAPTION: 'Preto = tag do alerta · sombreado cinza = máquina parada · linha tracejada = início do tag do alerta · faixa cinza = dentro de ±3 sd da linha de base em operação. Clique para ampliar.',
				NEIGHBOURS: 'Unidades conectadas',
				NEIGHBOURS_META: '{{total}} unidades conectadas lidas, {{moved}} moveram-se',
				EXPAND_ALL: 'Expandir tudo',
				COLLAPSE_ALL: 'Recolher estáveis',
				NO_NEIGHBOURS: 'Nenhuma unidade conectada foi lida.',
				OPEN_UNIT: 'Abrir esta unidade na vista de processo',
				LINK_HIGH: 'ligação: alta',
				LINK_MEDIUM: 'ligação: média',
				LINK_LOW: 'ligação: baixa',
				LINK_HINT: 'Quão certos os desenhos estão de que estas duas unidades estão ligadas',
				STATE_MOVED: 'moveu-se',
				STATE_HELD: 'estável',
				STATE_NO_DATA: 'sem dados',
				SENSORS_N: '{{count}} sensores',
				COL_SENSOR: 'Sensor de interface',
				COL_STATE: 'Estado',
				COL_Z_LAST: 'z último',
				COL_Z_LAST_HINT: 'Distância da última leitura antes do alerta à linha de base em operação, em desvios-padrão',
				COL_Z_DAY: 'z 24 h',
				COL_Z_DAY_HINT: 'Distância mediana à linha de base em operação nas 24 h antes do alerta, em desvios-padrão',
				COL_ONSET: 'O desvio começou',
				NO_READINGS: 'Sem leituras utilizáveis antes do alerta',
				RELIEF: 'Coletores de alívio',
				MORE: 'Mostrar mais',
				LESS: 'Mostrar menos',
				DUR_MIN: '{{n}} min',
				DUR_H: '{{n}} h',
				DUR_D: '{{n}} dias',
				TIMING_BEFORE: 'moveu-se {{t}} antes do tag do alerta',
				TIMING_BEFORE_SHORT: '{{t}} antes',
				TIMING_AFTER: 'moveu-se {{t}} depois do tag do alerta',
				TIMING_AFTER_SHORT: '{{t}} depois',
				TIMING_TOGETHER: 'moveu-se junto com o tag do alerta',
				TIMING_TOGETHER_SHORT: 'juntos',
				TIMING_EARLIER: 'começou {{t}} antes do tag do alerta — segundo plano',
				TIMING_EARLIER_SHORT: '{{t}} antes · segundo plano',
				TIMING_EARLIER_NO_DUR: 'começou muito antes do tag do alerta — segundo plano',
				TIMING_EARLIER_NO_DUR_SHORT: 'muito antes · segundo plano',
				TIMING_HELD: 'manteve-se próximo da linha de base',
				TIMING_NO_DATA: 'sem leituras utilizáveis antes do alerta',
				TIMING_UNCLEAR: 'moveu-se, momento pouco claro',
			},
			GAPS: {
				TITLE: 'Sensores esperados sem tag ({{count}})',
				LINK: 'Sensores esperados sem tag ({{count}})',
				LINK_HINT: 'Sensores esperados pelo modelo da máquina que não têm tag no historiador',
				EXPLAIN: 'Estes são sensores que o modelo de ativo C3 espera para esta máquina, mas que não puderam ser associados a um tag do historiador, portanto não é possível ler dados deles. A lista é informativa e não pode ser editada aqui.',
				NONE: 'Nenhum sensor sem correspondência.',
				COL_MACHINE: 'Máquina',
				COL_SENSOR: 'Sensor esperado',
				COL_FAILURE_GROUP: 'Grupo de falha',
				COL_UNIT_TYPE: 'Tipo de unidade',
			},
			FLOC: {
				LEVEL_1: 'Ativo',
				LEVEL_2: 'Instalação',
				LEVEL_3: 'Sistema',
				LEVEL_4: 'Subsistema',
				LEVEL_5: 'Equipamento',
				PATH: 'Caminho FLOC',
				LEGEND_TITLE: 'Níveis FLOC',
				LEGEND_HINT: 'Cada local é identificado pelo seu código de local de instalação SAP (FLOC). Os níveis vão do ativo ao equipamento.',
				TREE_FILTER_PLACEHOLDER: 'Procurar um sistema ou equipamento (nome ou FLOC)…',
				SCOPE_N: '{{count}} FLOCs',
				SCOPE_TIP: 'A fila está filtrada por este FLOC e tudo o que está abaixo',
				SCOPE_CLEAR: 'Limpar o filtro de local',
				UNPLACED_TIP: 'Alertas sem local de instalação',
				ALERTS_TOTAL: '{{count}} alertas',
				SOURCE_ASSET_CODE: 'Posicionado pelo código do nome do ativo',
				SOURCE_WELL: 'Posicionado pelo número do poço submarino',
				SOURCE_TRAIN: 'Posicionado pelo código de trem ou pacote',
				SOURCE_TAG_MAPPING: 'Posicionado pelo mapeamento de tags do historiador',
				EXTRACT_HAD: 'a extração do alerta tinha {{floc}}',
			},
			PMAP: {
				KEY_SENSORS: 'Sensores-chave ({{count}})',
				KEY_SENSORS_HINT: 'Os sensores que melhor descrevem o estado desta unidade',
				TITLE: 'Vista de processo',
				BUTTON: 'Vista de processo',
				OPEN: 'Abrir a vista de processo',
				OPEN_HINT: 'Áreas da planta e unidades de processo, ligadas como nos P&ID',
				BACK: 'Voltar à fila',
				UNITS_META: '{{units}} unidades de processo em {{areas}} áreas',
				LAYERS: 'Camadas de ligação',
				SECONDARY: 'Mostrar ligações secundárias ({{count}})',
				RELIEF: 'Alívio / tocha ({{count}})',
				UTILITY: 'Utilidades ({{count}})',
				CONTROL: 'Sinais de controle ({{count}})',
				TARGET_ONLY: 'Somente alvo',
				LEGEND_BACKBONE: 'Ligação de processo',
				LEGEND_LINK: 'Ligação secundária',
				LEGEND_RELIEF: 'Alívio / tocha',
				LEGEND_UTILITY: 'Utilidade',
				LEGEND_CONTROL: 'Sinal de controle',
				LEGEND_UP: 'A montante',
				LEGEND_DOWN: 'A jusante',
				LEGEND_TARGET: 'Contém FLOCs alvo',
				LEGEND_LOAD: 'Carga de alertas',
				LANE_META: 'Unidades: {{units}} · Alertas: {{alerts}}',
				LANE_TIP: '{{units}} unidades, {{alerts}} alertas, {{targets}} unidades com FLOCs alvo',
				EXPAND_LANE: 'Expandir {{name}}',
				COLLAPSE_LANE: 'Recolher {{name}}',
				LINKS: 'Ligações entre unidades de processo',
				EDGE_ARIA: 'Ligação de {{from}} para {{to}}, {{medium}}',
				UNIT_ALERTS: '{{total}} alertas ({{scope}} no escopo)',
				IN_SCOPE_N: '{{count}} no escopo',
				TARGETS_N: '{{count}} FLOCs alvo',
				SHEET_N: 'folha {{sheet}}',
				CHIP: 'Processo: {{name}}',
				CHIP_HINT: 'Abrir a vista de processo nesta unidade',
				UNITS_LABEL: 'Unidades de processo',
				N_MORE: '+{{count}} mais',
				FROM_TO: '{{from}} → {{to}}',
				MEDIUM: 'Meio',
				CONFIDENCE: 'Confiança',
				CONF_HIGH: 'Alta',
				CONF_MEDIUM: 'Média',
				CONF_LOW: 'Baixa',
				WEAK: 'ligação fraca',
				ONE_END: 'visto em apenas um desenho',
				TYPE: 'Tipo',
				LAYER_BACKBONE: 'Ligação de processo',
				LAYER_LINK: 'Ligação secundária',
				LAYER_RELIEF: 'Alívio / tocha',
				LAYER_UTILITY: 'Utilidade',
				LAYER_CONTROL: 'Sinal de controle',
				CONNECTORS_N: '{{count}} conectores nos desenhos',
				EVIDENCE_LOADING: 'Lendo a evidência dos desenhos…',
				PANEL_ARIA: 'Detalhes da unidade de processo',
				LOADING: 'Carregando…',
				SHOW_ALERTS: 'Mostrar alertas desta unidade',
				OPEN_EXPLORER: 'Abrir no explorador de ativos',
				ALERTS: 'Alertas',
				NO_ALERTS: 'Sem alertas',
				DRAWINGS: 'Desenhos ({{count}})',
				NO_DRAWINGS: 'Nenhum desenho vinculado a esta unidade',
				OPEN_DRAWING: 'Abrir o P&ID',
				FLOCS: 'FLOCs ({{count}})',
				NO_FLOCS: 'Nenhum FLOC atribuído a esta unidade',
				OPEN_NODE: 'Abrir no explorador de ativos',
				SHOW_FLOC_ALERTS: 'Mostrar alertas deste FLOC',
				SHARED_FLOCS: 'Compartilhados com outras unidades ({{count}})',
				INBOUND: 'Entrada ({{count}})',
				OUTBOUND: 'Saída ({{count}})',
				NO_CONNECTIONS: 'Nenhuma ligação encontrada nos desenhos',
				SHOW_ALL: 'Mostrar todos os {{count}}',
				SHOW_FEWER: 'Mostrar menos',
			},
			SEARCH_ALERTS_PLACEHOLDER: 'Buscar alerta, ID, ID da definição, tag, FLOC…',
			CANVAS: {
				CAUSAL: {
					QUERIES: 'Perguntas ({{n}})',
					COL_HYPOTHESIS: 'Hipótese',
					COL_FACET: 'Faceta',
					COL_QUERY: 'Pergunta',
					COL_ADMITTED: 'Admitidos',
					NOTHING: 'nada admitido',
					ADMITTED: 'Trechos admitidos ({{n}})',
					EXCERPTS_FROM_TRACE: 'Trechos do rastro da etapa (os seis primeiros); resultados rejeitados aparecem quando o documento da execução for carregado.',
					REJECTED: 'Resultados rejeitados ({{n}})',
					NONE_REJECTED: 'Nenhum resultado foi rejeitado.',
					FACET_DESIGN_BASIS: 'Base de projeto / envelope',
					FACET_ORIGINATING_CHANGE: 'Mudança de origem',
					FACET_MECHANISM_SENSITIVITY: 'Sensibilidade do mecanismo',
					FACET_PROTECTION_DETECTION: 'Proteção / detecção',
					FACET_SYMPTOM_DIAGNOSTIC: 'Sintoma / diagnóstico',
					FACET_CORRECTIVE_ACTION: 'Ação corretiva',
				},
				TIER: {
					STAGE_QUICK: 'Etapa 1 · Triagem rápida (mini-agente)',
					STAGE_DEEP: 'Etapa 2 · Investigação aprofundada',
					QUICK_ANSWER: 'Resposta rápida',
					FINAL_ANSWER: 'Resposta final',
					OUTCOME: 'Resultado',
					ACCEPTED: 'Aceita',
					ESCALATED: 'Escalonada',
					ROUTE_ACCEPTED: 'Aceita → Resultado',
					ROUTE_ESCALATED: 'Escalonada → Etapa 2',
					NO_GATE: 'Sem portão (apenas triagem rápida)',
					DECIDING: 'Verificando a resposta rápida…',
					WAITING: 'Aguarda a resposta rápida',
					NOT_NEEDED: 'Não necessária — a resposta rápida passou no portão; o tempo e os tokens da investigação aprofundada foram poupados.',
					NOT_RUN: 'Não executada — esta execução foi apenas triagem rápida.',
					WOULD_HAVE_RUN: 'Teria executado',
					DEEP_SPECIALISTS: 'Especialistas lentos',
					SKIP_VERDICTS: 'Nova verificação dos veredictos',
					SKIP_ADJUDICATION: 'Verificação de completude e segunda adjudicação',
					CHECK_NO_ACTION: 'Resposta sem ação',
					CHECK_CONFIDENCE: 'Confiança',
					CHECK_NOT_CAPPED: 'Sem limite',
					CHECK_MODEL: 'O modelo respondeu',
					CHECK_NO_REAL_EVENT: 'Nenhum veredicto de evento real',
					CEILING: 'teto {{pct}}',
					RULE_FALLBACK: 'regra de recurso',
					QUICK_NODE_NOTE: 'Etapa 1 · triagem rápida: esta é a passagem do mini-agente, antes do portão.',
					ESCALATED_NOTE: 'Escalonada: pelo menos uma verificação falhou, por isso a investigação aprofundada foi executada.',
					ACCEPTED_NOTE: 'Aceita: todas as verificações passaram; a resposta rápida é o resultado.',
					CHECKS: 'Verificações do portão',
					COL_CHECK: 'Verificação',
					COL_VALUE: 'Valor',
					COL_THRESHOLD: 'Limiar',
					COL_RESULT: 'Resultado',
					PASSED: 'Aprovada',
					FAILED: 'Reprovada',
					REASONS: 'Por que foi escalonada',
					QUICK_VS_FINAL: 'Resposta rápida vs final',
				},
				TITLE: 'Canvas da execução',
				OPEN: 'Abrir canvas',
				OPEN_HINT: 'Acompanhar a execução passo a passo: cada agente, chamada ao modelo e consulta',
				BACK: 'Voltar ao alerta',
				RUN_PICKER: 'Execução',
				RUN_PICKER_EMPTY: 'Ainda não há execuções',
				LIVE: 'Ao vivo',
				LIVE_HINT: 'Acompanhando a execução em tempo real (atualiza a cada 1,5 s)',
				ELAPSED: 'Decorrido',
				DURATION: 'Duração',
				TOKENS: '{{input}} entrada / {{output}} saída tokens',
				EVALUATION: 'Avaliação',
				EVENTS_N: '{{count}} eventos',
				EVENTS_HINT: '{{llm}} chamadas ao modelo · {{lookups}} consultas',
				ZOOM_FIT: 'Ajustar à largura',
				ZOOM_100: 'Tamanho real',
				POLL_ERROR: 'Não foi possível obter novos eventos: {{error}} — tentando novamente',
				LOADING: 'Carregando a execução…',
				NO_RUNS: 'Este alerta ainda não tem execuções',
				NO_EVENTS: 'Nenhum evento foi registrado para esta execução (anterior ao canvas)',
				PICK_NODE: 'Selecione um nó para ver o que ele recebeu e produziu',
				IN_PROGRESS: 'O agente de triagem está em execução. Ela continua mesmo se você sair desta página.',
				STALLED_NOTICE: 'Contato com a execução perdido; o resultado aparecerá ao atualizar a página.',
				RECONSTRUCTED: 'Reconstruído a partir do rastreamento salvo: esta execução é anterior ao fluxo de eventos, por isso entradas, saídas, chamadas ao modelo e consultas não estão disponíveis.',
				PASS_N: 'Passagem {{n}}',
				ROUND_N: 'Rodada {{n}}',
				STATUS: {
					RUNNING: 'Em execução',
					COMPLETED: 'Concluída',
					FAILED: 'Falhou',
					GATED: 'Não analisada',
					PENDING: 'Pendente',
					NO_DATA: 'Sem dados',
					SKIPPED: 'Ignorado',
					STALLED: 'Conexão perdida',
				},
				COL: {
					PRE_RUN: 'Preparação',
					RESOLVE: 'Resolução e sinal',
					SPECIALISTS: 'Especialistas',
					VERDICTS: 'Veredictos',
					LOOP: 'Ciclo de raciocínio',
					DECISION: 'Decisão',
				},
				NODE: {
					LIBRARY_CAUSAL: 'Biblioteca · fundamentação causal',
					ESCALATION: 'Portão de escalonamento',
					LIBRARY: 'Especialista de biblioteca',
					CONNECTED: 'Sistemas conectados',
					GATE: 'Porta DQ',
					TOPOLOGY: 'Topologia',
					EVIDENCE: 'Evidências',
					VIEW: 'Visão na data',
					FINAL: 'Resultado',
					RESOLVER: 'Resolvedor',
					SIGNAL: 'Sinal',
					COHORT: 'Coorte',
					MAINTENANCE: 'Manutenção',
					MANUAL_PRECEDENT: 'Precedente de alerta',
					LEARNINGS: 'Aprendizados',
					PROFILE: 'Perfil',
					MULTIVARIATE: 'Multivariada',
					TMP: 'TMP',
					SHIFT_DPR: 'Turno e DPR',
					VISUAL: 'Analista visual',
					VERDICTS: 'Veredictos',
					HYPOTHESIZE: 'Hipóteses',
					INVESTIGATE: 'Investigação',
					COMPLETENESS: 'Completude',
					ADJUDICATOR: 'Adjudicador',
					SUPERVISOR: 'Supervisor',
				},
				BADGE: {
					CAUSAL_N: '{{admitted}} trechos · {{queries}} perguntas',
					HEADROOM: '{{kind}} {{value}} · {{pct}}%',
					LIBRARY_N: '{{n}} trechos · {{docs}} docs',
					LIBRARY_LIMITS: '{{n}} trechos · {{limits}} limites',
					GATE_PASS: 'Aprovada',
					GATE_FAIL: 'Reprovada',
					TAGS_N: '{{count}} tags',
					RECORDS_N: '{{count}} registros',
					WITHHELD_N: '{{count}} retidos',
					RESOLVED: 'Resolvido',
					NOT_RESOLVED: 'Não resolvido',
					ALERTS_N: '{{count}} alertas',
					FACTS_N: '{{count}} fatos',
					PRIOR_N: '{{count}} anteriores',
					LEARNINGS_N: '{{count}} aprendizados',
					LOADED: 'Carregado',
					NONE: 'Nenhum',
					MOVED_N: '{{moved}} de {{of}} se moveram',
					VERDICTS_N: '{{count}} veredictos',
					LOOKUPS_N: '{{count}} consultas',
					CHECKS_N: '{{ran}} de {{of}} verificações',
					SPECIALISTS_N: '{{n}} de {{of}} especialistas',
				},
				BATCH_BADGE: 'Lote de {{count}} alertas em {{floc}}',
				BATCH_HINT: 'Avaliados juntos como um episódio: {{ids}}',
				REASSESS_BADGE: 'Reavaliação na data {{t}}',
				REASSESS_HINT: 'Avaliação anterior: {{cls}}',
				ZONE: {
					EVIDENCE: 'Coleta de evidências',
					PARALLEL: 'em paralelo',
					LOOP: 'Ciclo de raciocínio',
					DECISION: 'Decisão',
				},
				LOOP: {
					CAUSAL_HINT: 'Após a primeira passagem do quadro, a Biblioteca faz perguntas de engenharia por hipótese (base de projeto, mudança, sensibilidade, proteção, diagnóstico, ação corretiva) e só admite trechos sobre este instrumento ou equipamento como evidência LIB-n',
					BOARD: 'Quadro de hipóteses',
					INVESTIGATOR: 'Investigador',
					ROUND_OF: 'Rodada {{n}} de máx. {{max}}',
					HINT: 'o quadro propõe e pede, o Investigador consulta, o quadro repondera',
					ROUNDS_USED: '{{n}} de máx. {{max}} rodadas',
					REQUESTS_N: '{{count}} pedidos',
					REWEIGH: 'resultados → reponderar',
					LEAD_HINT: 'Hipótese principal, seu peso e a mudança desde a passagem anterior',
					WEIGHING: 'Ponderando hipóteses…',
					NEXT_PASS: 'Próxima passagem: reponderação',
					CALL_NO_HINT: 'Chamada {{n}} de {{tool}} nesta execução',
					CITED_HINT: 'Citada pela próxima passagem: {{hyps}}',
					REPEAT_OF: 'igual à rodada {{n}}',
					CALLING: 'Executando consultas…',
					MOVED: 'Passagem {{n}}:',
					MOVED_HINT: 'Como o quadro mudou após ler os resultados desta rodada',
					SETTLED_FIRST: 'Decidido na passagem {{n}}: nenhuma consulta necessária',
					SETTLED_AT: 'Decidido na passagem {{n}}: nenhuma consulta adicional necessária',
					BUDGET_SPENT: 'Orçamento de rodadas esgotado ({{max}} de {{max}})',
					SHELF: 'Prateleira de ferramentas',
					SHELF_HINT: 'o Investigador pode chamar qualquer ferramenta, quantas vezes precisar, com argumentos diferentes',
					UNUSED: 'não usada nesta execução',
				},
				TOOL: {
					SEARCH_LIBRARY: 'Pesquisar biblioteca',
					SEARCH_LEARNINGS: 'Pesquisar aprendizados',
					CONNECTED_EQUIPMENT: 'Equipamentos conectados',
					UNIT_SENSORS: 'Sensores da unidade',
					FIND_SENSORS: 'Encontrar sensores',
					PARALLEL_SYSTEMS: 'Sistemas paralelos',
					SISTER_TRAIN: 'Trem gêmeo',
					UNIT_ALERTS: 'Alertas da unidade',
					TAG_WINDOW: 'Janela do tag',
					TAG_HISTORY: 'Histórico do tag',
					SEARCH_RECORDS: 'Buscar registros',
					SEARCH_REPORTS: 'Buscar relatórios',
				},
				TOOL_HINT: {
					SEARCH_LEARNINGS: 'Aprendizados e regras do manual do local vigentes no momento do alerta, ordenados por significado em relação a uma pergunta.',
					CONNECTED_EQUIPMENT: 'Unidades de processo a montante, a jusante ou irmãs (dos conectores do fluxograma), seus sensores de interface e se mudaram antes, junto ou depois do tag do alerta.',
					UNIT_SENSORS: 'Como uma unidade de processo nomeada se comportou, sensor a sensor, para as grandezas pedidas.',
					FIND_SENSORS: 'Quais sensores existem para uma pergunta e o que cada um mede.',
					PARALLEL_SYSTEMS: 'O trem gêmeo (FGC A ↔ B, GLC A ↔ B …): seus sensores e alertas nas mesmas horas — causa comum ou local?',
					SISTER_TRAIN: 'O outro trem ou a sonda redundante da mesma malha: causa comum ou local?',
					UNIT_ALERTS: 'Alertas de vigilância em uma unidade (montante, jusante, gêmea) nas horas antes do alerta.',
					TAG_WINDOW: 'Estatísticas de qualquer tag nas últimas N horas antes do alerta.',
					TAG_HISTORY: 'Com que frequência um tag saiu da sua faixa em até 180 dias e se houve trabalho em seguida.',
					SEARCH_RECORDS: 'Busca por palavras-chave em notas e ordens SAP (1 ano) e relatórios de turno (6 meses).',
					SEARCH_REPORTS: 'Relatórios de supervisão e produção de até um ano; todas as palavras devem coincidir, trechos retornados.',
				},
				CALL: {
					NTH: 'Chamada #{{n}} de {{tool}} nesta execução',
					ARGS: 'Argumentos',
					NO_ARGS: 'Sem argumentos',
					REPEAT_NOTE: 'Idêntica ao pedido da rodada {{n}}: não foi reexecutada, o resultado anterior foi reaproveitado.',
					CITED: 'Citada pela passagem {{n}}',
					CALLS_N: '{{count}} chamadas',
					ROUNDS_LIST: 'rodadas {{rounds}}',
					NOT_USED: 'O Investigador não usou esta ferramenta nesta execução.',
					GROUPED: '{{count}} consultas · ferramentas usadas: {{tools}}',
					CARRIED: '{{count}} observações de rodadas anteriores reaproveitadas',
				},
				EVO: {
					TITLE: 'Como a evidência moveu a convicção: peso de cada hipótese por passagem',
					HYPOTHESIS: 'Hipótese',
					AFTER_N: 'após a rodada {{n}} · {{count}} consultas',
					NOT_ON_BOARD: 'Fora do quadro nesta passagem',
					AFTER_ROUND: 'após a rodada {{n}} ({{count}} consultas)',
					CITES: 'a nova evidência cita {{calls}}',
					MOVE_AFTER: 'Após a rodada {{n}}:',
					PRECEDED_BY: 'consultas anteriores:',
				},
				INSPECTOR: {
					TAB_INPUT: 'Entrada',
					TAB_OUTPUT: 'Saída',
					TAB_MODEL_CALLS: 'Chamadas ao modelo',
					TAB_LOOKUPS: 'Consultas',
					TAB_TRACE: 'Rastreamento',
					EMPTY: 'vazio',
					NOT_STARTED: 'Esta etapa ainda não começou',
					NO_INPUT: 'Nenhuma entrada foi registrada para esta etapa',
					STILL_RUNNING: 'Ainda em execução — a saída aparece quando a etapa termina',
					NO_OUTPUT: 'Nenhuma saída registrada',
					HYPOTHESES_N: '{{count}} hipóteses',
					REQUESTS: 'Consultas solicitadas',
					WINDOWS: 'Leituras por janela',
					LEAK_CHECK: 'Verificação de vazamento: {{value}}',
					MACHINE_STATE: 'Estado da máquina',
					PACKAGE_TEXT: 'Pacote de sinal como o modelo o lê',
					ANOMALY_TEXT: 'Texto do modelo de anomalia',
					NO_LOOKUPS: 'Sem consultas nesta etapa',
					RAW: 'Toda a saída como dados',
					NO_MODEL_CALLS: 'Sem chamadas ao modelo nesta etapa',
					ATTEMPT_N: 'Tentativa {{n}}',
					PROMPT: 'Prompt',
					PROMPT_SIZE: '{{chars}} caracteres, {{images}} imagens',
					IMAGE_PART: 'imagem ({{kb}} KB)',
					RESPONSE: 'Resposta',
					NO_TRACE: 'Sem linha de rastreamento para este nó',
				},
			},
			VALIDATION: {
				COLUMN: 'Validação',
				FILTER: 'Validação',
				HUMAN: 'Humana',
				AGENT: 'Agente',
				NONE: 'Sem triagem',
				HUMAN_VALIDATED: 'Validada por humano',
				HUMAN_CORRECTED: 'Corrigida por humano',
				AGENT_VALIDATED: 'Validada pelo agente',
				TIP_AGENT: 'Triada pelo agente; nenhuma pessoa a revisou ainda',
				TIP_HUMAN_UNKNOWN: 'Validada por uma pessoa',
				TIP_REPLAY: 'Rótulo HIL reproduzido por {{reviewer}} em {{date}}',
				TIP_UI: 'Revisada no UptimeAI por {{reviewer}} em {{date}}',
				TIP_CORRECTED: 'Um humano corrigiu o agente: {{agent}} → {{human}}',
				TIP_ABSTAINED: 'O agente deixou para revisão humana; o humano classificou como {{human}}',
				TIP_AGREED: 'O humano concordou com o agente: {{human}}',
				CSV: {
					VALIDATED_BY: 'Validada por',
					REVIEWER: 'Revisor',
					REVIEW_SOURCE: 'Origem da revisão',
				},
			},
			REVIEW: {
				TITLE: 'Revisão SME',
				SOURCE_REPLAY: 'Rótulo HIL (reproduzido)',
				SOURCE_UI: 'Revisada no UptimeAI',
				BY: '{{reviewer}} · {{date}}',
				N_REVIEWS: '{{count}} revisões',
				LABEL: 'Rótulo',
				RELIABILITY: 'Confiabilidade: {{value}}',
				RELIABILITY_HIGH: 'alta',
				RELIABILITY_MEDIUM: 'média',
				RELIABILITY_LOW: 'baixa',
				RELIABILITY_HINT: 'Quanto o rótulo pode ser tomado como verdade — rótulos humanos podem falhar',
				ACTION_TAKEN: 'Ação tomada',
				NO_LABEL: 'Nenhum rótulo registrado',
				AGENT_VS_HUMAN: 'Agente vs. humano',
				AGREEMENT_AGREE: 'Concordam',
				AGREEMENT_DISAGREE: 'Discordam',
				AGREEMENT_ABSTAINED: 'Abstenção',
				AGENT_CONFIDENCE: 'Confiança do agente {{value}}',
				OUTCOMES: 'Notificações SAP nos 30 dias seguintes (retrospectiva)',
				REASONS: 'Motivos',
				AGENT_SAW_CHART: 'Julgamento do agente sobre o gráfico',
				AGENT_SAW_STATE: 'Estado da máquina no momento',
				LEARNINGS_CHANGED: 'Aprendizados alterados por esta revisão ({{count}})',
				EARLIER: 'Revisões anteriores',
				VERDICT: {
					CONFIRMED: 'Confirmada',
					CONFIRMED_HINT: 'O agente e o humano escolheram a mesma classe.',
					AGENT_WRONG: 'Agente errado',
					AGENT_WRONG_HINT: 'A classe do revisor prevalece sobre a do agente; o agente foi corrigido.',
					AGENT_ABSTAINED: 'Agente absteve-se',
					AGENT_ABSTAINED_HINT: 'O agente deixou para revisão humana; o rótulo humano define a classe.',
					HUMAN_LIKELY_WRONG: 'Humano provavelmente errado',
					HUMAN_LIKELY_WRONG_HINT: 'Rotulada sem ação, mas houve notificações SAP neste equipamento em 30 dias; mantida fora da memória.',
					CONTESTED: 'Contestada',
					CONTESTED_HINT: 'O agente e o humano discordam e as evidências posteriores não resolvem.',
					HUMAN_OVERRIDE: 'Substituição humana',
					HUMAN_OVERRIDE_HINT: 'Uma pessoa no UptimeAI escolheu uma classe diferente da do agente; a decisão dela prevalece.',
				},
			},
			MEMORY: {
				SIMILAR: 'similar {{sim}}',
				SIMILAR_HINT: 'Fora do escopo próprio deste alerta: adicionado porque o significado é próximo do alerta (similaridade 0–1)',
				PROFILE: 'Perfil do detector',
				TITLE: 'Memória operacional usada',
				CHIP: 'Memória: {{learnings}} aprendizados, {{precedents}} precedentes revisados',
				CHIP_HINT: 'Aprendizados e precedentes revisados por humanos, conhecidos antes deste alerta, que o agente consultou',
				NO_LEARNINGS: 'Nenhum aprendizado aplicado',
				PRECEDENTS: '{{count}} precedentes revisados',
				SHOW_TRACE: 'Ver no rastreamento',
			},
			LEARNINGS: {
				STATUS_RETIRED: 'Desativado',
				SCOPE_PLAYBOOK: 'Manual do local',
				SCOPE_PROFILE: 'Perfil do detector',
				ALL_SCOPES: 'Todos os tipos de escopo',
				MEANING_PLACEHOLDER: 'Pesquisar por significado, ex.: temperatura do mancal após reinício',
				MEANING_SEARCH: 'Pesquisar',
				MEANING_HINT: 'Ordena os aprendizados atuais pela proximidade de significado com suas palavras (embeddings), não por palavras exatas. Pressione Enter para pesquisar; limpe a caixa para listar todos.',
				RANKED_BY: 'Ordenado por significado: “{{q}}”',
				COL_SIMILARITY: 'Similaridade',
				SIMILARITY_HINT: 'Similaridade de cosseno do significado (0–1); acima de cerca de 0,8 é uma correspondência próxima',
				COL_LEARNING: 'Aprendizado',
				COL_EDITED: 'Editado por',
				EDITED_BY: 'Editado por {{name}}',
				EDIT_REASON: 'Motivo: {{reason}}',
				NO_DISPOSITION: 'nenhuma (contexto)',
				N_ALERTS: '{{count}} alertas',
				NO_MATCH: 'Nada com significado próximo',
				NO_MATCH_HINT: 'Tente outras palavras ou limpe a pesquisa para listar todos os aprendizados.',
				BUTTON: 'Aprendizados',
				BUTTON_HINT: 'Aprendizados e memória operacional de revisões humanas',
				TITLE: 'Aprendizados e memória operacional',
				SUBTITLE: 'Regras extraídas de revisões humanas de alertas comparáveis; o agente consulta apenas as conhecidas antes de cada alerta',
				REFRESH: 'Atualizar',
				STAT_REVIEWS: 'Revisões humanas',
				STAT_REPLAYED: '{{count}} rótulos HIL reproduzidos',
				STAT_IN_APP: '{{count}} no UptimeAI',
				STAT_AGREEMENT: 'Agente vs. humano',
				STAT_RECONCILIATION: 'Reconciliação',
				STAT_LEARNINGS: 'Aprendizados',
				STATUS_ACTIVE: 'Ativo',
				STATUS_CANDIDATE: 'Candidato',
				STATUS_CONTESTED: 'Contestado',
				SCOPE_SIGNAL: 'Sinal',
				SCOPE_EQUIPMENT: 'Equipamento + detector',
				SCOPE_DETECTOR: 'Detector',
				SEARCH: 'Pesquisar escopo, detector ou regra',
				N_SHOWN: '{{shown}} de {{total}}',
				EMPTY: 'Ainda não há aprendizados',
				EMPTY_HINT: 'Os aprendizados aparecem quando pessoas revisam alertas triados.',
				COL_SCOPE: 'Escopo',
				COL_SCOPE_TYPE: 'Tipo de escopo',
				COL_DISPOSITION: 'Disposição',
				COL_SUPPORT: 'Suporte',
				COL_SUPPORT_HINT: 'Revisões que concordam com a disposição / revisões no escopo · consistência',
				COL_STATUS: 'Status',
				COL_EFFECTIVE: 'Vigente desde',
				COL_CORRECTED: 'Agente corrigido',
				COL_CORRECTED_HINT: 'Revisões em que a pessoa corrigiu o agente',
				COL_VERSION: 'Versão',
				RULE: 'Regra operacional',
				AUTHOR: 'Autor: {{author}}',
				CLASS_COUNTS: 'Classes humanas',
				REASONS: 'Motivos',
				CHART_PATTERNS: 'Padrões do gráfico',
				MACHINE_STATES: 'Estados da máquina',
				SOURCE_ALERTS: 'Alertas de origem ({{count}})',
				OPEN_ALERT: 'Abrir alerta',
				VERSIONS: 'Histórico de versões',
				SUPERSEDED: 'Substituída',
				CURRENT: 'Atual',
			},
			PROCESS: {
				TITLE: 'Topologia do processo e hierarquia',
				FLOW_SUMMARY: '{{up}} a montante · {{down}} a jusante',
				FLOW_SUMMARY_UNITS: '{{up}} a montante · {{down}} a jusante (unidades de processo)',
				PROCESS_UNITS: 'Unidades de processo (PEFS)',
				NO_PID_LINE: 'Nenhuma linha traçada nos P&IDs digitalizados; ligações dos conectores do fluxograma',
				IN_UNIT: 'Unidade de processo: {{name}}',
				SERVING: 'Utilidades de apoio',
				RELIEF: 'Alívio',
				UNIT_TIP: '{{hops}} salto(s) · {{media}} · confiança {{confidence}}',
				SOURCE_PID: 'Fluxo de equipamentos dos P&IDs digitalizados (linhas traçadas num desenho).',
				SOURCE_BOTH: 'Fluxo de equipamentos dos P&IDs digitalizados (um desenho de cada vez); unidades de processo dos conectores entre folhas do PEFS, a mesma vista da análise de sistemas conectados.',
				HIERARCHY: 'Hierarquia de ativos',
				LEVEL_SITE: 'Instalação',
				LEVEL_SYSTEM: 'Sistema',
				LEVEL_SUBSYSTEM: 'Subsistema',
				LEVEL_EQUIPMENT: 'Equipamento',
				LEVEL_PACKAGE: 'Pacote',
				LEVEL_OTHER: 'Nível',
				NOT_IN_TREE: 'Fora da árvore de ativos',
				NOT_IN_TREE_HINT: 'O equipamento do alerta não tem local de instalação na árvore de ativos do SAP.',
				PARTIAL_TREE: 'Apenas parte do caminho pôde ser posicionada na árvore de ativos.',
				SIBLINGS: '{{count}} outros equipamentos em {{parent}}',
				SHOW_ALL: 'Mostrar todos os {{count}}',
				SHOW_FEWER: 'Mostrar menos',
				N_TAGS: '{{count}} tags',
				NO_TREE_TAGS: 'Nenhum tag do historiador neste nó',
				FLOW: 'Fluxo do processo',
				UPSTREAM: 'A montante',
				DOWNSTREAM: 'A jusante',
				ALERT_EQUIPMENT: 'Equipamento do alerta',
				MEASURED_BY: 'Instrumento do alerta',
				HOPS: 'A {{count}} salto(s)',
				NONE_UPSTREAM: 'Nada a montante',
				NONE_DOWNSTREAM: 'Nada a jusante',
				NO_FLOW: 'Sem ligações de fluxo de processo para este equipamento nos P&IDs digitalizados',
				NOT_IN_PIDS: 'Equipamento não encontrado nos P&IDs digitalizados',
				NOT_IN_PIDS_HINT: 'Sem correspondência nos P&IDs para o equipamento do alerta, não é possível mostrar montante e jusante.',
				CONNECTED: 'Itens conectados',
				NO_CONNECTED: 'Nenhum outro item está conectado a este equipamento nos P&IDs digitalizados.',
				EDGE_SERVES: 'Atende',
				EDGE_SENSES: 'Detecta',
				EDGE_CONTROLS: 'Controla',
				EDGE_PROTECTS: 'Protege',
				EDGE_SAME_LINE: 'Mesma linha de processo',
				EDGE_MEASURES: 'Mede',
				EDGE_FLOWS_TO: 'Flui para',
				EDGE_OTHER: 'Outras ligações',
				CHART_TAGS: 'Plotar os tags deste item na aba Tags',
				NO_TAGS_FOR_ITEM: 'Nenhum tag do historiador está ligado a este item',
				NO_DATA_TAGS: 'A árvore de ativos não atribui tags a este item',
				TAGS_FAILED: 'Não foi possível carregar os tags deste item',
				FROM_TREE: 'Contagem de tags da árvore de ativos',
				CLICK_HINT: 'Clique em um item para plotar seus tags do historiador (até 8, primeiro os que têm dados).',
			},
			ANALYSIS: {
				FOUND_BY_MEANING: 'encontrado por significado',
				FOUND_BY_MEANING_SIM: 'encontrado por significado · {{sim}}',
				FOUND_BY_MEANING_HINT: 'Pesquisa híbrida: os registros são encontrados pelas palavras e pelo significado (embeddings). Este foi adicionado pela pesquisa por significado no mesmo subsistema; o número é a similaridade com o alerta (0–1).',
				LEVEL_SHIFTS: 'Mudanças de nível',
				LEVEL_SHIFTS_HINT: 'Momentos antes do corte em que uma tag modelada passou a um novo nível e permaneceu (tamanho em desvios-padrão da linha de base, média antes → depois).',
				MODEL_CACHED: 'modelo reutilizado (treinado uma vez por máquina por dia)',
				MODEL_CACHED_HINT: 'A mesma máquina já tinha um modelo treinado para este dia, com dados que terminam antes deste corte; ele foi reutilizado em vez de retreinado.',
				REGIMES: 'Ajustado por regime de operação de {{tag}}: {{parts}} ({{sep}} sd de distância)',
				REGIMES_HINT: 'A tag de operação mostrou dois níveis de operação distintos (parcela do tempo @ nível), então o normal foi aprendido separadamente para cada um.',
				TRAINED_ON: 'Treinado em {{from}} – {{to}}',
				WINDOW_3M: '3 meses',
				WINDOW_1W: '1 semana',
				WINDOW_1D: '1 dia',
				REASONING: 'Raciocínio',
				SETTLED: 'Concluído',
				UNSETTLED: 'Não concluído',
				SETTLED_HINT: 'O quadro de hipóteses parou porque nenhuma consulta adicional poderia mudar a hipótese principal',
				UNSETTLED_HINT: 'O quadro parou no limite de passagens com consultas ainda solicitadas',
				BOARD_META: '{{passes}} passagens · {{lookups}} consultas',
				HYPOTHESES: 'Hipóteses',
				WEIGHT_HINT: 'Peso desta hipótese no quadro (todas as hipóteses somam 100%)',
				IMPLIES_HINT: 'Classificação que esta hipótese implica se for confirmada',
				STATUS_VALIDATED: 'Validada',
				STATUS_REFINED: 'Refinada',
				STATUS_DEBUNKED: 'Refutada',
				STATUS_OPEN: 'Aberta',
				FOR: 'A favor',
				AGAINST: 'Contra',
				NONE: 'Nenhum',
				CONFLICTS: 'Contradições',
				LOOKUPS: 'Consultas do investigador',
				ROUND_N: 'Rodada {{n}}',
				ROUND_OTHER: 'Outras consultas',
				WHY_ASKED: 'Por que consultou:',
				RESULT: 'Resultado',
				SIGNAL_TITLE: 'Sinal e máquina',
				N_TAGS: '{{n}} tags',
				RUNNING_AT_CUTOFF: 'Em operação no corte',
				STOPPED_AT_CUTOFF: 'Parada no corte',
				SINCE_RESTART: 'Desde a partida',
				SINCE_STOP: 'Desde a parada',
				HOURS: '{{n}} h',
				LAST_SHUTDOWN: 'Última parada',
				ONGOING: 'em andamento',
				RUN_SOURCE: 'Estado de operação: {{source}} ({{tag}})',
				RUNNING_PCT_HINT: 'Parcela da janela em que a máquina operou (verde) ou esteve parada (vermelho)',
				RUNNING: 'em operação',
				SHUTDOWNS: 'paradas',
				DOWN: 'parada',
				MACHINE_UNKNOWN: 'Estado de operação desconhecido: não há tag de status de operação para este equipamento.',
				CHARTS_READ: 'Gráficos lidos pelo modelo',
				ANOMALY_SCORE: 'Pontuação de anomalia',
				ENLARGE: 'Clique para ampliar',
				READ_ALERT_TAG: 'Tag do alerta',
				READ_RELATED: 'Tags relacionados',
				READ_MACHINE: 'Máquina',
				READ_ANOMALY: 'Leitura do modelo',
				CONSISTENT_WITH_HISTORY: 'Consistente com o histórico',
				NOT_CONSISTENT_WITH_HISTORY: 'Inconsistente com o histórico',
				STATS_TITLE: 'Estatísticas vs. referência',
				STATS_HINT: '— passe o cursor numa célula para ver p5–p95, inclinação e primeira excursão de 3 sd',
				COL_TAG: 'Tag',
				COL_MEDIAN: 'Mediana',
				COL_LAST: 'Último',
				COL_Z: 'z (med.)',
				COL_Z_HINT: 'Mediana da janela em desvios-padrão da referência',
				COL_OUT: '% fora',
				COL_OUT_HINT: 'Parcela das leituras fora da faixa de referência p5–p95',
				ALERT_TAG: 'alerta',
				RUN_TAG: 'operação',
				TIP_BASELINE: 'Referência: mediana {{median}} ± {{sd}} sd, p5–p95 {{p5}}–{{p95}} {{unit}}',
				TIP_SPIKES: 'Picos removidos: {{value}}',
				TIP_MASKED: 'Leituras com falha mascaradas: {{n}}',
				TIP_RANGE: 'p5–p95: {{p5}} – {{p95}} {{unit}}',
				TIP_SLOPE: 'Inclinação: {{value}} {{unit}}/dia',
				TIP_Z_LAST: 'z (último): {{value}} · |z| máx.: {{max}}',
				TIP_FIRST_3SD: 'Primeira vez além de 3 sd: {{value}} UTC',
				TIP_NEVER_3SD: 'Nunca além de 3 sd nesta janela',
				FOOT_SPIKES: 'Picos isolados removidos antes das estatísticas: {{value}}.',
				FOOT_MASKED: '{{n}} leituras com falha (má qualidade / fora da faixa) mascaradas.',
				ANOMALY_TITLE: 'Modelo de anomalias',
				NOT_AVAILABLE: 'Não disponível',
				VERDICT_CONSISTENT: 'Consistente',
				VERDICT_CHANGED: 'Alterado',
				VERDICT_STARTUP: 'Transiente de partida',
				VERDICT_INSUFFICIENT: 'Dados insuficientes',
				MODEL_META: 'PCA {{k}} comp. · {{pct}} de variância · {{rows}} linhas de treinamento',
				ONSET: 'Início sustentado',
				NO_ONSET: 'nenhum',
				FIRST_TO_DEVIATE: 'Primeiro tag a desviar',
				ABOVE_LIMIT_24H: 'Últimas 24 h acima do limite',
				T2_SPE_HINT: 'As pontuações são relativas ao percentil 99,5 do treinamento (1,0 = limite). T² alto = os tags se moveram juntos para um ponto de operação incomum; SPE alto = um tag não concorda mais com os outros (falha local ou de instrumento); AE = erro de reconstrução do autoencoder.',
				AT_CUTOFF: 'No corte',
				AT_PEAK: 'Pico das últimas 24 h',
				IN_TRANSIENT: 'Dentro do transiente de partida',
				SCORE: 'Pontuação',
				KIND_NORMAL: 'Dentro do normal',
				KIND_SPE: 'Relação quebrada (SPE): um tag não concorda mais com os outros',
				KIND_T2: 'Ponto de operação deslocado (T²): tags se moveram juntos, relações mantidas',
				KIND_BOTH: 'Ponto de operação incomum e relações quebradas',
				ACTUAL_VS_EXPECTED: 'Real vs. esperado pelos outros tags',
				NOT_MODELLED: 'Não modelados (pouco histórico de operação): {{tags}}',
				RECORDS_TITLE: 'Registros lidos',
				OPEN_KNOWN_ISSUE: 'Problema conhecido aberto',
				NO_OPEN_KNOWN_ISSUE: 'Nenhum problema conhecido aberto',
				OPEN_KNOWN_ISSUE_HINT: 'Se uma nota ou ordem de trabalho aberta já cobre esta condição no momento do alerta',
				RECORDS_COUNT: '{{read}} de {{total}} registros lidos · {{cited}} citados',
				RECORDS_COUNT_HINT: 'Registros existentes antes do alerta: {{work}} de manutenção, {{reports}} relatórios de turno, {{deferments}} perdas de produção; os mais bem classificados foram lidos',
				OPERATING_EVENTS: 'Eventos operacionais antes do alerta',
				FACTS: 'Fatos citados',
				NO_FACTS: 'Nenhum registro afeta este alerta.',
				RELEVANCE_DIRECT: 'Direto',
				RELEVANCE_RELATED: 'Relacionado',
				RELEVANCE_BACKGROUND: 'Contexto',
				IMPL_KNOWN_ISSUE: 'Problema conhecido aberto',
				IMPL_RECENT_WORK: 'Trabalho recente explica',
				IMPL_OPERATING_EVENT: 'Evento operacional',
				IMPL_INSTRUMENT: 'Problema de instrumento',
				IMPL_DEGRADATION: 'Sinal de degradação',
				DIR_NO_ACTION: 'A favor de nenhuma ação',
				DIR_SERVICE: 'A favor de serviço',
				DIR_NEUTRAL: 'Neutro',
				OPEN_IN_MAINTENANCE: 'Mostrar na aba Manutenção',
				OPEN_IN_REPORTS: 'Mostrar na aba Relatórios',
				DROPPED: '{{n}} lidos, mas não relevantes: {{ids}}',
			},
			VISUAL: {
				TITLE: 'Revisão dos gráficos',
				PATTERN_TOGETHER: 'Os tags se moveram juntos',
				PATTERN_DEPARTED: 'Um tag se desviou sozinho',
				PATTERN_SHUTDOWN: 'Parada / partida',
				PATTERN_NO_CHANGE: 'Sem mudança significativa',
				PATTERN_SPLIT: 'Tags relacionados divergentes',
				PATTERN_INSUFFICIENT: 'Dados insuficientes para avaliar',
				PATTERN_UNKNOWN: 'Não classificado',
				CONFIDENCE: 'Confiança de {{value}}',
				CONFIDENCE_HINT: 'Confiança do julgamento final',
				MOVED_TOGETHER_YES: 'Moveram-se juntos',
				MOVED_TOGETHER_NO: 'Não se moveram juntos',
				DISAGREE: 'As estatísticas e os gráficos divergem — revise os gráficos antes de confiar neste julgamento.',
				AGREE: 'Os gráficos concordam com as estatísticas',
				STATISTICS_SAY: 'Segundo as estatísticas',
				CHARTS_SAY: 'Segundo os gráficos',
				LED_BY: 'Liderado por',
				LED_BY_HINT: 'O tag que se moveu primeiro',
				DEPARTED_ALONE: 'Desviou-se sozinho',
				DEPARTED_ALONE_HINT: 'O tag que se moveu enquanto os tags relacionados se mantinham',
				REASONING: 'Raciocínio',
				CHARTS: 'Gráficos lidos pelo modelo ({{count}})',
				NO_CHARTS: 'Nenhuma imagem de gráfico foi salva para esta execução.',
				OPEN_CHART: 'Abrir gráfico {{n}}',
				CHART_ALT: 'Gráfico {{n}} até o horário do alerta',
				CHART_FAILED: 'Não foi possível carregar a imagem do gráfico',
				CHART_N_OF: 'Gráfico {{n}} de {{total}}',
				CHART_DIALOG_HINT: 'Os gráficos terminam logo antes do alerta. Use ← / → para navegar.',
				PREV_CHART: 'Gráfico anterior',
				NEXT_CHART: 'Próximo gráfico',
				REVIEWS: 'Revisões por tag ({{count}})',
				LEVEL: 'Nível: {{value}}',
				FLUCTUATION: 'Flutuação: {{value}}',
				MODEL: 'Revisado por {{model}}',
			},
			CONTEXT: {
				MODE_PID: 'P&ID',
				MODE_GRAPH: 'Grafo de contexto',
				CHOOSE_DRAWING: 'Escolher desenho',
				ITEMS_COUNT: '{{count}} destacados',
				HAS_INSTRUMENT: 'instrumento do alerta',
				HAS_EQUIPMENT: 'equipamento do alerta',
				TITLE_INSTRUMENT: 'Localização destacada do instrumento {{tag}}',
				TITLE_EQUIPMENT: 'Localização destacada do equipamento {{tag}}',
				LOADING: 'Carregando contexto do processo…',
				LOAD_FAILED: 'Não foi possível carregar o contexto do processo deste alerta.',
				UNRESOLVED: 'O equipamento e o instrumento do alerta não estão no grafo de conhecimento',
				UNRESOLVED_HINT: 'Não é possível mostrar a localização no P&ID nem os ativos conectados.',
				NO_DRAWING: 'Nenhum P&ID digitalizado mostra este equipamento',
				NO_DRAWING_HINT: 'Use o grafo de contexto para ver os ativos conectados.',
				SAME_LINE: 'Na mesma linha',
				SAME_LINE_EMPTY: 'Nenhum item na mesma linha de processo.',
				CONNECTED_ON_DRAWING: 'Conectados no desenho',
				CONNECTED_EMPTY: 'Nenhum item conectado neste desenho.',
				CONNECTED_ELSEWHERE: 'Conectados, fora deste desenho',
				LOCATE: 'Mostrar no desenho',
				ADD_TO_CHART: 'Adicionar {{tag}} aos gráficos',
				NOT_LINKED: 'não vinculado',
				GRAPH_EMPTY: 'Nenhum ativo conectado encontrado para este alerta.',
				GRAPH_HINT: 'Tamanho = nº de tags · clique em um nó com tag do historiador para plotá-lo',
				ROLE: {
					ALERT_EQUIPMENT: 'Equipamento do alerta',
					ALERT_INSTRUMENT: 'Instrumento do alerta',
					CONNECTED: 'Conectado',
					SAME_LINE: 'Mesma linha de processo',
					OTHER: 'Outro',
				},
				EDGE: {
					FLOWS_TO: 'Flui para',
					SERVES: 'Atende',
					SENSES: 'Detecta',
					CONTROLS: 'Controla',
					PROTECTS: 'Protege',
					SAME_LINE: 'Mesma linha',
					MEASURES: 'Mede',
					RELATED: 'Relacionado',
				},
				NODE_TYPE: {
					EQUIPMENT: 'Equipamento',
					INSTRUMENT: 'Instrumento',
					CONTROLVALVE: 'Válvula de controle',
					PROCESSLINE: 'Linha de processo',
				},
				TOOLTIP: {
					TAG: 'Tag',
					HISTORIAN_TAG: 'Tag do historiador',
					TYPE: 'Tipo',
					ROLE: 'Função',
					TAG_COUNT: 'Tags do historiador',
					LINE: 'Linha',
					DRAWING: 'Desenho',
				},
			},
			PAGE_TITLE: 'Alertas',
			ENTERPRISE: 'Shell',
			SEARCH_PLACEHOLDER: 'Pesquisar...',
			SEARCH_OWNER: 'Pesquisar responsável...',
			OWNER_FILTER: 'Filtrar por responsável',
			CHOOSE_STATUSES: 'Escolha os status a exibir',
			ALL_STATUSES: 'Todos os status',
			FILTERS: 'Filtros',
			MORE: 'Mais',
			WATCHERS: 'Observadores',
			COLLAPSE_PANEL: 'Recolher painel',
			EXPAND_PANEL: 'Expandir painel',
			RETRY: 'Tentar novamente',
			CLOSE: 'Fechar',
			PREVIOUS: 'Alerta anterior',
			NEXT: 'Próximo alerta',
			SCORE: 'Pontuação',
			SEE_MORE: 'Ver mais',
			SEE_LESS: 'Ver menos',
			CLASS: {
				FALSE_NO_ACTION: 'Falso – Sem ação',
				FALSE_DQ: 'Falso – Qualidade de dados (DQ)',
				VALID_NO_ACTION: 'Válido – Sem ação',
				CREATE_SERVICE: 'Válido – Criar serviço',
				HUMAN_REVIEW: 'Revisão SME',
				PENDING: 'Pendente',
			},
			CLASS_OPTION: {
				FALSE_DQ: 'False – DQ (raised on bad data: instrument or data feed)',
				HUMAN_REVIEW: 'Revisão SME (avaliação manual necessária)',
				CREATE_SERVICE: 'Criar caso (iniciar investigação e ação)',
				VALID_NO_ACTION: 'Válido – sem ação (encerrar evento – sem serviço)',
				FALSE_NO_ACTION: 'Falso – sem ação (encerrar evento – sem serviço)',
			},
			STATUS: {
				ACKNOWLEDGED: 'Acknowledged',
				UNACKNOWLEDGED: 'Unacknowledged',
				DEFECT_RAISED: 'Pending – Defect Raised',
				UNACTIONED: 'Sem ação',
				APPROVED: 'Aprovado',
				RELEARNED: 'Reaprendido',
			},
			STATE: {
				ACTIVE: 'Ativo',
				RETURNED_TO_NORMAL: 'Retornou ao normal',
			},
			TELEMETRY: {
				TITLE: 'Série temporal',
				AVAILABLE: 'Disponível',
				MISSING: 'Ausente',
				TIP_AVAILABLE: 'Leituras do historiador para {{tag}} nas 24 h antes do alerta',
				TIP_NO_DATA: 'Sem leituras do historiador para {{tag}} nas 24 h antes do alerta',
				TIP_NOT_IN_HISTORIAN: '{{tag}} não está no historiador',
				TIP_NO_TAG: 'O alerta não indica nenhuma tag do historiador',
				UNUSABLE: 'Não utilizável',
				TIP_UNKNOWN: 'Não foi possível verificar a disponibilidade',
			},
			TAGX: {
				THIS_EQUIPMENT: 'Este equipamento',
				ALL_EQUIPMENT: 'Todos os equipamentos relacionados ({{count}})',
				FILTER: 'Filtrar',
				HISTORIAN_RESULTS: 'Busca no historian',
				MODE_FUNCTION: 'Por função',
				MODE_RELATION: 'Por relação',
				FILTER_MEASURE: 'Filtrar pela grandeza medida',
				FILTER_GROUP: 'Filtrar por grupo funcional',
				CLEAR_FILTERS: 'Limpar filtros',
				SHOW_ALL: 'Mostrar tudo (mais {{count}})',
				NO_MATCHES_FILTERED: 'Sem resultados para os filtros selecionados',
				TITLE: 'Exibir outras tags',
				SEARCH_PLACEHOLDER: 'Pesquisar tags por nome ou descrição',
				MIN_CHARS: 'Digite pelo menos 2 caracteres',
				SEARCHING: 'Pesquisando…',
				NO_MATCHES: 'Nenhuma tag correspondente',
				HAS_DATA: 'Dados do historiador disponíveis',
				NO_DATA: 'Sem dados do historiador',
				SELECTED: '{{count}} / {{max}} selecionadas',
				MAX_REACHED: 'É possível selecionar no máximo {{max}} tags',
				CLEAR: 'Limpar seleção',
				CHART_TOGETHER: 'Plotar juntas',
				HIDE_CHART: 'Ocultar gráfico',
				IN_LIST: 'Na lista',
				VIA: 'via {{via}}',
				GROUP_ALERT: 'Tag do alerta',
				GROUP_COMPONENT: 'Mesmo componente',
				GROUP_EQUIPMENT: 'Mesmo pacote / equipamento',
				GROUP_CONNECTED: 'Equipamentos conectados',
				GROUP_PID: 'Instrumentos de P&ID',
				GROUP_OTHER: 'Outros relacionados',
				GROUP_SEARCH: 'Adicionadas pela pesquisa',
				NO_TAGS: 'Nenhuma tag relacionada encontrada',
				LOADING: 'Carregando tags relacionadas…',
				FILTER_EMPTY: 'Nenhuma tag relacionada corresponde a “{{q}}”',
			},
			QUEUE: {
				DATE_FIELD: 'Filtrar por campo de data',
				DATE_FIELD_EVENT: 'Hora do evento',
				DATE_FIELD_RAISED: 'Gerado',
				SORT_OLDEST: 'Mais antigos primeiro (clique para inverter)',
				SORT_NEWEST: 'Mais recentes primeiro (clique para inverter)',
				PAGE_SIZE: 'Linhas por página',
				RANGE: '{{start}}–{{end}} de {{total}}',
				FIRST_PAGE: 'Primeira página',
				PREV_PAGE: 'Página anterior',
				NEXT_PAGE: 'Próxima página',
				LAST_PAGE: 'Última página',
				GROUPED_PAGE_HINT: 'Os grupos são formados com os alertas desta página',
				ON_THIS_PAGE: 'nesta página',
				SIGNAL_START: 'Início do evento',
				RAISED: 'Criado em',
				RETURNED_TO_NORMAL_AT: 'Última atividade (voltou ao normal)',
				BASELINE_REF: 'Referência de linha de base',
				BASELINE_REF_TIP: 'Referência de linha de base do detector ({{time}}): o horário "last recorded on …" citado na descrição do alerta. Não é a hora do evento.',
				NOT_ANALYSED: 'Não analisado: {{reason}}',
				NOT_ON_PAGE: 'Ocorrência recorrente fora desta página. Abra para ver os detalhes.',
				COLUMNS: 'Colunas',
				RESET_COLUMNS: 'Mostrar todas as colunas',
				SET_STATUS: 'Definir o status dos alertas selecionados',
				CSV: {
					PROCESS_UNIT: 'UNIDADE_PROCESSO',
					FLOC: 'FLOC',
					POINTS: 'TAGS',
					DEFINITION_ID: 'ID_DEFINICAO',
					NUMBER: '#',
					ALERT_ID: 'ID do alerta',
					SYSTEM_NAME: 'Nome do sistema',
					SYSTEM: 'Sistema',
					STATUS: 'Status',
					CLASSIFICATION: 'Classificação',
					CONFIDENCE: 'Confiança',
					ALERT_NAME: 'Nome do alerta',
					SOURCE: 'Fonte',
					EVENT_TIME: 'Início do evento (início do sinal)',
					RAISED: 'Criado em',
					RETURNED_TO_NORMAL: 'Última atividade (retorno ao normal)',
					BASELINE_REF: 'Referência de linha de base',
					STATE: 'Estado',
					TIME_SERIES: 'Série temporal',
					ANCHOR_TAG: 'Tag de ancoragem',
					NOT_ANALYSED: 'Não analisado (controle DQ)',
					OWNER: 'Responsável',
				},
				COLUMN_NUMBER: 'Número',
				SORT_BY_COLUMN: 'Ordenar por esta coluna',
				DATE_ON_EVENT: 'O intervalo de datas aplica-se ao início do evento',
				DATE_ON_CREATED: 'O intervalo de datas aplica-se a Criado em (coluna ordenada)',
				SHOW_COLUMNS: 'Mostrar colunas',
				SEARCH_COLUMNS: 'Pesquisar...',
				SELECT_ALL_COLUMNS: 'Selecionar tudo',
				RESET_DEFAULT_COLUMNS: 'Redefinir padrão',
				RESIZE_COLUMN: 'Arraste para redimensionar',
				STILL_ACTIVE: 'Ainda ativo',
			},
			GROUP_BY: {
				TITLE: 'Agrupar por',
				EQUIPMENT: 'Equipment',
				NONE: 'Nenhum',
				SYSTEM: 'Sistema',
				FACILITY: 'Instalação',
				SOURCE: 'Origem',
				CLASSIFICATION: 'Classificação',
				ALERT_STATUS: 'Status do alerta',
			},
			MENU: {
				EXPORT: 'Exportar dados',
				COLLAPSE_GROUPS: 'Recolher todos os grupos',
				EXPAND_WITHIN_GROUP: 'Expandir todos os itens do grupo',
				AUTO_REFRESH: 'Atualização automática',
			},
			AUTO_REFRESH: {
				OFF: 'Desligado',
				LIVE: 'Ao vivo',
				MIN_5: '5 minutos',
				MIN_15: '15 minutos',
				MIN_30: '30 minutos',
				HOUR_1: '1 hora',
			},
			FILTER: {
				TITLE: 'Filtrar por',
				SEARCH_ALERT_NAME: 'Pesquisar por nome do alerta...',
				START_TYPING: 'Digite para pesquisar',
				APPLY: 'Aplicar',
				CLEAR_ALL: 'Limpar tudo',
				TARGET_ONLY: 'Somente FLOCs alvo',
				TARGET_TIP: 'Somente alertas nos FLOCs alvo listados em Hierarquias de ativos → Hierarquia FLOC',
				TARGET_COUNT: '{{count}} alertas na visualização atual',
			},
			TABLE: {
				STEP: 'Step',
				STEP_HINT: 'The triage-path step that decided the alert (amber: held for SME review)',
				TYPE: 'Type',
				PLUS_TAGS: '+{{count}} tags',
				DEFINITION_ID: 'ID da definição',
				ALERTS: 'Alertas',
				N_ALERTS: '{{count}} alertas',
				SYSTEM_NAME: 'Nome do sistema',
				STATUS: 'Status',
				CLASSIFICATION: 'Classificação',
				CONFIDENCE: 'Conf.',
				ALERT_NAME: 'Nome do alerta',
				SOURCE: 'Origem',
				EVENT_TIME: 'Início do evento',
				STATE: 'Estado',
				OWNER: 'Responsável',
				EMPTY: 'Nenhum alerta corresponde aos filtros atuais',
				RECURRING: 'Recorrente: {{count}} ocorrências neste episódio',
				TOGGLE_RECURRING: 'Mostrar alertas recorrentes',
				CREATED_ON: 'Criado em',
				LAST_ACTIVE: 'Última atividade',
			},
			BULK: {
				ITEMS: 'itens',
				ASSIGN_OWNER: 'Atribuir responsável aos alertas selecionados',
				CHANGE_CLASSIFICATION: 'Alterar classificação',
				DONE: '{{count}} alertas atualizados',
				PARTIAL: '{{ok}} alertas atualizados, {{failed}} não puderam ser atualizados',
			},
			ACTIONS: {
				APPROVE: 'Aprovar',
				APPROVED: 'Aprovado',
				RELEARN: 'Reaprender',
				RELEARNED: 'Reaprendido',
				CLASSIFY: 'Classificar',
			},
			DETECTOR: {
				POINTS_FROM_SIGNAL_TEXT: 'Tags lidos de SignalMeasurementText',
				POINTS_FROM_DESCRIPTION: 'Tags lidos da descrição do alerta',
				PRIMARY: 'principal',
				TAGS_TIP: 'Tags a que este alerta se refere ({{count}}):',
				TAGS_N: 'Tags ({{count}})',
				LABEL: 'Detector',
				MECHANISM: 'Mecanismo de detecção',
				MONITORED_TAG: 'Tag monitorada',
				CLUSTER_SIZE: 'Tamanho do grupo',
				FREQUENCY: 'Frequência',
				WINDOW_SPAN: 'Duração da janela',
				N_ALERTS: '{{count}} alertas',
				PER_HOUR: '{{value}} alertas/h',
				HOURS: '{{value}} horas',
			},
			DQ: {
				STATUS_UNUSABLE: 'Unusable',
				PENDING_DEFECT: 'Defect raised',
				PENDING_DEFECT_TIP: 'Instrument work order {{wo}}: pending',
				TITLE: 'Avaliação de qualidade de dados (DQ)',
				FROZEN: 'Linha plana',
				IMPOSSIBLE_ROC: 'Taxa de variação',
				DOMAIN_RANGE: 'Fora da faixa',
				JITTER: 'Errático',
				PASS_FROZEN: 'Aprovado (dinâmico)',
				PASS_IMPOSSIBLE_ROC: 'Aprovado',
				PASS_DOMAIN_RANGE: 'Dentro dos limites',
				PASS_JITTER: 'Sinal normal',
				FAIL_FROZEN: 'Congelado',
				FAIL_IMPOSSIBLE_ROC: 'Reprovado',
				FAIL_DOMAIN_RANGE: 'Fora da faixa',
				FAIL_JITTER: 'Sinal errático',
				NOT_ASSESSED: 'Não avaliado',
				STATUS_PASS: 'Aprovado',
				STATUS_WARN: 'Aviso',
				STATUS_FAIL: 'Reprovado',
				STATUS_NO_DATA: 'Sem dados',
				STATUS_UNKNOWN: 'Não avaliado',
				NOT_ANALYSED: 'Não analisado',
				READINGS: '{{n}} leituras · {{bad}} mascaradas',
				CHECK_INFO: 'Informativo',
				NO_GATE: 'A qualidade dos dados não foi avaliada para este alerta',
				SCORE: 'Pontuação DQ: {{status}}',
			},
			AGENT: {
				NO_RUN: 'Not triaged yet',
				TIER_ACCEPTED: 'Triagem rápida · aceita a {{pct}} ({{time}} · {{tokens}} tokens) — investigação aprofundada não necessária',
				TIER_QUICK_ONLY: 'Apenas triagem rápida · {{pct}} ({{time}} · {{tokens}} tokens)',
				TIER_ESCALATED: 'Escalonado para investigação aprofundada:',
				TIER_QUICK_WAS: 'Resposta rápida: {{cls}} {{pct}} ({{time}} · {{tokens}} tokens)',
				TIER_FINAL_IS: 'final: {{cls}} {{pct}}',
				MANUAL_CHIP: 'Manual · {{label}}',
				TITLE: 'Agente de triagem',
				RECOMMENDATION: 'Recomendação',
				NOT_RUN: 'O agente de triagem ainda não foi executado para este alerta. Clique em "Executar agente de triagem" para classificá-lo automaticamente.',
				NO_RECOMMENDATION: 'Nenhuma recomendação registrada.',
				RUN: 'Executar agente de triagem',
				RUNNING: 'Em execução…',
				RERUN: 'Executar novamente o agente de triagem',
				CREATES_CASE: 'Cria caso',
				CONFIDENCE: '{{value}} de confiança',
				CAPPED: 'limitada',
				CAPPED_HINT: 'Confiança limitada a {{value}} porque algumas verificações não puderam ser executadas',
				VERIFIED_FACTS: 'Fatos verificados e telemetria',
				N_VERIFIED: '{{count}} verificados',
				HYPOTHESIS: 'Hipótese de trabalho e mecanismo físico (por quê)',
				SUPPORTING_TAGS: 'Tags de suporte',
				FMEA: 'FMEA dinâmico',
				FAILURE_MODE: 'Modo de falha',
				MECHANISM: 'Mecanismo físico',
				IMPACT: 'Impacto sistêmico',
				REMEDIATION: 'Correção',
				DISCIPLINE: 'Disciplina',
				ACTIONABLE: 'Recomendações de engenharia acionáveis',
				WHAT_WOULD_CHANGE: 'O que mudaria isto',
				DECIDED_BY: 'Decidido por {{model}}',
				HARNESS_VERSION: 'harness {{v}}',
				STALE_RUN: "Desatualizado: execução anterior à atualização de {{date}}; execute novamente para ver o agente atual",
				DEGRADED: 'Regra de contingência',
				DEGRADED_HINT: 'O LLM de decisão estava indisponível; esta disposição veio de regras determinísticas. Revise antes de aprovar.',
			},
			DIALOG: {
				APPROVE_TITLE: 'Approve classification',
				APPROVING: 'You agree with the agent: {{x}}',
				FEEDBACK_OPTIONAL: 'Optional: anything the agent should learn from this case',
				CORRECT_FINDING: 'Correct finding',
				SELECT_FINDING: 'Select the finding…',
				MAPS_TO: 'Shown to the customer as: {{x}} (mapping in force)',
				PROPOSE_TOGGLE: 'The finding “{{x}}” is right; the customer label should be different',
				PROPOSE_HELP: 'The alert keeps its finding. An administrator sees the proposal in Settings › Labels; a mapping change relabels every alert with this finding.',
				WANTED_LABEL: 'Label the customer expects',
				PROPOSED: 'Mapping change proposed to the administrators',
				RELEARN_TITLE: 'Reaprender classificação',
				CLASSIFY_TITLE: 'Classificar',
				CORRECT_CLASSIFICATION: 'Classificação correta',
				SELECT_CLASS: 'Selecione a nova categoria...',
				FEEDBACK: 'Feedback',
				FEEDBACK_REQUIRED: 'Obrigatório para revisão',
				CANCEL: 'Cancelar',
				CONFIRM: 'Confirmar',
			},
			EVIDENCE: {
				GROUP: {
					SERIES: 'Time series',
					RECORDS: 'Plant records',
				},
				ALL_TAGS: 'All tags',
				ON_DRAWING: 'Picked on the drawing:',
				CONTEXT_GRAPH: 'Context graph',
				SEARCH_REPORTS: 'Search the reports (any word in any section)',
				SEARCH_MATCHES: '{{n}} report(s) match',
				CITED_HERE: 'cited',
				AXES_UNIT: 'Axis per unit',
				AXES_TAG: 'Axis per tag',
				AXES_HINT: 'Overlay y-axes: share one axis per unit, or give every tag its own',
				SOURCE_ALERT: 'Source Alert',
				SOURCE_ALERT_FROM: 'Source alert · {{source}}',
				SYSTEM_DETAILS: 'System Details',
				REASONING_NOT_IN_RUN: 'Não registrado nesta execução (execuções anteriores a esta seção).',
				DROP_TAGS_HINT: 'Arraste tags do painel Exibir tags para adicionar gráficos',
				TAGS: 'Tags',
				MAINTENANCE: 'Manutenção',
				REPORTS: 'Relatórios',
				ALERTS: 'Alertas',
				DOCUMENTS: 'Documentos',
				REASONING: 'Raciocínio',
				REASONING_SECTION: {
					DECISION: 'Decision',
					BOARD: 'Hypothesis board',
					EVIDENCE: 'Evidence used',
					MEMORY: 'Learnings used',
					LIBRARY: 'Biblioteca',
					LIMITS: 'Limites',
					REASONING: 'Raciocínio',
					PLAYBOOK: 'Verificações do playbook',
					SIGNAL: 'Sinal e máquina',
					CONNECTED: 'Sistemas conectados',
					ANOMALY: 'Modelo de anomalia',
					RECORDS: 'Registros lidos',
				},
				NO_TELEMETRY: 'Sem dados históricos para estas tags',
				NO_TELEMETRY_HINT: 'O historiador não cobre a janela do alerta para estas tags.',
				NO_DATA_FOR: 'Sem dados históricos para',
				NOTIFICATIONS: 'Notas',
				NOTIFICATION: 'Nota',
				WORK_ORDERS: 'Ordens de serviço',
				WORK_ORDER: 'Ordem de serviço',
				NONE: 'Nenhum registro',
				ON_THIS_ITEM: 'Neste item',
				DESCRIPTION: 'Descrição',
				NOTIFICATION_NO: 'Nº da nota',
				TYPE: 'Tipo',
				PRIORITY: 'Prioridade',
				RAISED_ON: 'Criado em',
				COMPLETED_ON: 'Concluído em',
				FLOC: 'Local de instalação',
				HIERARCHY_TIER: 'Nível hierárquico',
				SUPERVISOR_REPORTS: 'Relatórios do supervisor',
				SHIFT_LOGS: 'Registros de turno',
				RECENT_ALERTS: 'Alertas recentes',
				RELATED_ALERTS: 'Alertas relacionados',
				FIRED_AT: 'Disparado em',
				CONTEXT: 'Contexto',
				SHOW_AFTER_ALERT: 'Mostrar registros posteriores ao alerta',
				HINDSIGHT_HINT: 'Desligado: apenas o que estava registrado quando o alerta foi gerado, como o agente viu. Ligado: também os registros criados depois.',
				HINDSIGHT_ON: 'Retrospectiva ativada: registros criados após o alerta são exibidos e marcados como "Após o alerta". O agente não os viu.',
				AFTER_ALERT: 'Após o alerta',
				HIDDEN_AFTER_ALERT: '{{n}} registrados após o alerta ocultos',
				NONE_AT_ALERT: 'Nenhum registro no momento do alerta',
				NOT_ANALYSED: 'Não analisado',
				NO_TIME_SERIES: 'Sem série temporal: {{reason}}',
				TELEMETRY_NO_DATA: 'o historiador não possui leituras da tag do alerta nas 24 h anteriores',
				TELEMETRY_NOT_IN_HISTORIAN: 'a tag do alerta não está no historiador',
				TELEMETRY_NO_TAG: 'o alerta não possui tag monitorada',
				TELEMETRY_UNKNOWN: 'disponibilidade no historiador desconhecida',
				ADD_TAGS: 'Adicionar tags',
				HIDE_TAG_LIST: 'Ocultar lista de tags',
				INCLUDE_BASELINE: 'Incluir referência de linha de base',
				ALERT_WINDOW: 'Janela do alerta',
				BASELINE_REF_AT: 'Referência de linha de base do detector: {{at}}',
				CHARTED_TOGETHER: 'Tags plotadas juntas',
				NO_TAGS_CHARTED: 'Nenhuma tag plotada',
				NO_TAGS_CHARTED_HINT: 'Pesquise ou selecione tags relacionadas na lista para plotá-las.',
				TAG_LOAD_FAILED: 'Não foi possível carregar esta tag',
				OVERLAY: 'Sobreposição – valores reais, um eixo Y por unidade',
				OVERLAY_NORMALISED: 'Todas as tags em um eixo (z-score, unidades diferentes)',
				STATUS_AT_ALERT: 'Status no alerta',
				STATUS_NOW: 'agora',
				OPEN_AT_ALERT: 'Aberto no alerta',
				CLOSED_AT_ALERT: 'Fechado no alerta',
				NOT_RAISED_AT_ALERT: 'Não criado no alerta',
				SCOPE_ITEM: 'Este item',
				SCOPE_PARENT: 'Superior',
				BREAKDOWN: 'Quebra',
				NUMBER: 'Número',
				EQUIPMENT: 'Equipamento',
				REPORTED_BY: 'Reportado por',
				PLANNING_GROUP: 'Grupo de planejamento',
				WORK_CENTER: 'Centro de trabalho',
				SYMPTOM: 'Sintoma',
				CREATED_ON: 'Criado em',
				SCHEDULED_START: 'Início programado',
				SCHEDULED_FINISH: 'Término programado',
				ESTIMATED_DURATION: 'Duração estimada',
				HOURS_N: '{{n}} h',
				COST_ESTIMATE: 'Custo estimado',
				KNOWN_AT: 'Registrado desde',
				LONG_TEXT: 'Detalhes',
				STATUS_HISTORY: 'Histórico de status',
				PRODUCTION_REPORTS: 'Relatórios de produção',
				DEFERMENT_REPORTS: 'Relatórios de diferimento',
				SUPERVISOR_REPORT: 'Relatório do supervisor',
				PRODUCTION_REPORT: 'Relatório diário de produção',
				DEFERMENT_REPORT: 'Relatório de diferimento',
				FULL_SCREEN: 'Tela cheia',
				EXIT_FULL_SCREEN: 'Sair da tela cheia',
				BACK_TO_DOCUMENTS: 'Voltar aos documentos',
				DOWNLOAD: 'Baixar',
				HSSE: 'HSSE',
				PRODUCTION: 'Produção',
				HSSE_GRADE: 'Classificação HSSE',
				PRODUCTION_GRADE: 'Classificação de produção',
				REPORT_DATE: 'Data do relatório',
				SOURCE_FILE: 'Arquivo de origem',
				SUMMARY: 'Resumo',
				PRODUCTION_COMMENT: 'Comentário de produção',
				SUPERVISOR_COMMENTS: 'Comentários do supervisor',
				ACTIVITIES: 'Atividades',
				FORECAST: 'Previsão / próximas atividades',
				ALARMS: 'Alarmes',
				DEFERMENT: 'Diferimento',
				OOS: 'Equipamentos fora de serviço',
				IOW: 'Excedências DOW / IOW',
				MOCS: 'MOCs temporários',
				NO_REPORT_TEXT: 'Sem texto de relatório',
				CATEGORY: 'Categoria',
				MAIN_CAUSE: 'Causa principal',
				SUB_CAUSE: 'Subcausa',
				EQUIPMENT_SYSTEM: 'Sistema do equipamento',
				EQUIPMENT_TYPE: 'Tipo de equipamento',
				EVENT_START: 'Início do evento',
				EVENT_END: 'Fim do evento',
				ENDED_BEFORE_ALERT: 'Encerrado antes do alerta',
				ONGOING_AT_ALERT: 'Em andamento no alerta',
				RECENT_ALERTS_HINT: 'nesta tag / local de instalação',
				RELATED_ALERTS_HINT: 'em ±60 min, mesmo sistema primeiro',
				SUB_ALERTS: 'Subalertas do episódio',
				SUB_ALERTS_HINT: 'agrupados neste episódio',
				SAME_SYSTEM: 'Mesmo sistema',
				OPEN_ALERT: 'Abrir este alerta',
				NO_DOCUMENTS: 'Nenhum documento vinculado a este equipamento',
				PID: 'P&ID',
				PAGES_N: '{{n}} páginas',
				UPDATED: 'Atualizado',
				SOURCE: 'Origem',
				REVISION: 'Revisão',
				DOCUMENT_TYPE: 'Tipo de documento',
				DOCUMENT_PREVIEW: 'Pré-visualização do documento',
				FILE_NAME: 'Nome do arquivo',
				PREVIEW_UNAVAILABLE: 'Pré-visualização indisponível',
				PREVIEW_UNAVAILABLE_HINT: 'O arquivo deste documento não está no repositório de documentos.',
				SHOWING_ALL_WO: 'Showing all {{shown}} of {{total}} work orders & notifications',
				SHOWING_EVIDENCE_WO: 'Showing {{shown}} condition-evidence records (of {{total}} total)',
				SHOW_ALL_EQUIPMENT_WO: 'Show all work orders for {{equipment}}',
				CITED_IN_PATH: 'Cited',
				LINKED_WO: 'Linked WO',
				ROOT_CAUSE: 'Root Cause',
				AGENT_READ_SUMMARY: 'Na última execução o agente leu {{read}} relatórios de supervisor e citou {{cited}} — leia primeiro os citados.',
				ONLY_AGENT_READ: 'Somente relatórios lidos pelo agente',
				AGENT_CITED: 'Citado pelo agente · {{relevance}}',
				AGENT_READ: 'Lido pelo agente · não citado',
			},
			CHART: {
				JUDGED_AT: 'Judged at (raised later)',
				NO_DATA: 'No data in the historian',
				SEPARATE: 'Separate',
				OVERLAY: 'Overlay',
				SEPARATE_HINT: 'One panel per tag, sharing the time axis',
				OVERLAY_HINT: 'All tags on one panel, one y-axis per unit',
				ALL_READINGS: '*All good readings in the window',
				INSTRUMENT_RANGE: 'Instrument range',
				MEDIAN: 'Median',
				STEADY_ONLY: '*Steady running only (shutdown and start-up excluded)',
				THRESHOLD_LIMIT: 'Threshold limit',
				TRIP_LIMIT: 'Trip limit',
				LIMIT_TRIP: 'Trip',
				LIMIT_ALARM: 'Alarme',
				LIMIT_THRESHOLD: 'Limiar',
				LIMIT_INSTRUMENT: 'Instrumento',
				LIMIT: 'limite',
				LIMIT_NONE: 'Nenhum valor carregado para esta tag',
				TAG_LEGEND: 'Legenda das tags',
				MASKED_HIDDEN: '{{count}} leituras mascaradas (qualidade de dados) fora do gráfico',
				NO_UNIT: 'Sem unidade',
				HIGH: 'High',
				LOW: 'Low',
				AVERAGE: 'Average',
				ACTUAL: 'Real',
				BASELINE: 'Linha de base',
				SIGNAL_START: 'Início do sinal',
				RAISED: 'Gerado',
				RTN: 'Última atividade',
				BASELINE_REF: 'Ref. de linha de base',
				NORMAL_MIN: 'Mín. normal',
				NORMAL_MAX: 'Máx. normal',
				MASKED: 'Leituras mascaradas (DQ)',
				MASKED_HOVER: 'Leitura mascarada',
				ARTEFACT: 'Valor substituto / artefato de dados',
				ARTEFACT_HOVER: 'Artefato de dados (não é uma leitura de processo)',
				TIME_AXIS: 'Hora ({{zone}})',
				OFF_SCALE: 'fora da escala',
				MIN: 'mín.',
				MAX: 'máx.',
				RANGE_BAND: 'Mín.–máx.',
				LOADING: 'Carregando dados…',
				LOAD_ERROR: 'Não foi possível carregar dados para este intervalo',
				NO_DATA_IN_WINDOW: 'Sem leituras nesta janela',
				HISTORIAN_SPAN: 'O historiador tem dados de {{first}} a {{last}}',
				CLOSE: 'Fechar gráfico',
				ZOOM_HINT: 'Arraste para ampliar ou deslocar — mais dados são carregados automaticamente. Clique duas vezes para redefinir.',
				LAYOUT_STACKED: 'Empilhado',
				LAYOUT_OVERLAY: 'Sobreposto',
				NORM_NONE: 'Valores brutos',
				NORM_ZSCORE: 'Escore z',
				NORM_RANGE: '% do intervalo',
				NORMALISED_Z: 'Escore z (σ)',
				NORMALISED_PCT: '% do intervalo',
				REMOVE_TAG: 'Remover tag',
				NO_TAGS: 'Selecione tags para plotar juntas',
				TOGETHER_TITLE: 'Tags plotadas juntas',
			},
			DETAIL: {
				CHANGE_STATUS: 'Change status',
				ACK_HINT: 'Approve the current classification',
				REOPEN_HINT: 'Undo the last decision',
				REOPENED: 'Alert reopened',
				TARGET_FLOC: 'FLOC alvo',
				OPEN_ALERT: 'Abrir alerta',
				BACK_TO_QUEUE: 'Voltar aos alertas',
				ALERT_ANALYSIS: 'Análise do alerta',
				EVIDENCE: 'Evidências',
				EVENT_TIME: 'Hora do evento',
				EVENT_TIME_HINT: 'Quando o sinal começou (início do desvio)',
				RAISED: 'Gerado',
				RAISED_HINT: 'Quando o sistema de vigilância criou o alerta. O agente usa apenas o que era conhecido nesse momento.',
				RTN: 'Retorno ao normal',
				BASELINE_REF: 'Ref. da linha de base',
				BASELINE_REF_HINT: 'Hora de referência do detector (último registro da sua linha de base), não a hora do evento',
				CLASSIFICATION_HINT: 'Classificação atual. Escolha outra classe para classificar ou reaprender este alerta.',
				CHANGE_CLASS: 'Alterar classificação',
				CURRENT_CLASS: 'Classificação atual: {{value}}',
				PREVIOUSLY_APPROVED: 'Aprovado anteriormente',
				PREVIOUSLY_RELEARNED: 'Reaprendido anteriormente',
				HUMAN_REVIEW_REQUIRED: 'Revisão SME — avaliação manual necessária',
				NOT_CLASSIFIED: 'Ainda não classificado',
				AGENT_PROPOSED: 'Proposto pelo Agente de Triagem',
				NOT_ANALYSED_HINT: 'O Agente de Triagem não analisa este alerta: os dados não passaram nas verificações anteriores ao alerta. Classifique-o manualmente se necessário.',
				NOT_ANALYSED_REASON: 'Não analisado: {{reason}}',
				RUN_BLOCKED: 'Não analisável',
				RUN_BLOCKED_WHY: 'Não será analisado: {{reason}}',
				RUN_GATED: 'Não analisado',
				EVENT_START: 'Início do evento',
				CREATED_ON: 'Criado em',
				LAST_ACTIVE: 'Última atividade',
				LAST_ACTIVE_HINT: 'Quando o alerta voltou ao normal (última atividade); "Ativo" enquanto ainda estiver ativo',
			},
			CASE: {
				CHIP: 'Caso #{{id}}',
				CREATE: 'Criar caso',
				MANAGE_HINT: 'Crie um caso para gerenciar os acompanhamentos',
				CREATED: 'Caso #{{id}} criado',
				EXISTS: 'O caso #{{id}} já está vinculado a este alerta',
				CREATE_FAILED: 'Não foi possível criar o caso',
				BULK_CREATED: '{{count}} caso(s) criado(s).',
			},
			RAIL: {
				LIMITS: 'Limits',
				ACTIVITY: 'Registro de atividades',
				DISCUSSION: 'Discussão',
				TRACES: 'Rastros',
				PREFERENCES: 'Preferências',
				ANALYSIS: 'Análises e visualizações',
				OTHER_TAGS: 'Exibir tags',
				OTHER_TAGS_HINT: 'Clique em uma tag ou arraste-a para os gráficos para adicioná-la à aba Tags.',
				DOCUMENTS: 'Documentos',
				NO_DOCUMENTS: 'Nenhum documento vinculado a este alerta',
				NO_DOCUMENTS_HINT: 'Nenhum manual, P&ID ou relatório faz referência a este equipamento.',
				OPEN_IN_DOCUMENTS: 'Mostrar na aba Documentos',
				REVISION: 'Rev. {{value}}',
				PID: 'P&ID',
				EXPORT_TAGS: 'Exportar tags selecionadas para sistema externo',
				SAVED_ANALYSIS: 'Análises salvas',
				SAVED_VIEWS: 'Visualizações salvas',
				SAVED_DASHBOARDS: 'Painéis salvos',
				NOT_AVAILABLE: 'Ainda não disponível para alertas de triagem',
				PREFERENCES_NOTE: 'O sombreamento de regiões de parada e as linhas de trip / alarme / limite ainda não estão disponíveis para os gráficos de triagem.',
			},
			ACTIVITY: {
				N_ACTIONS: 'Ações ({{count}})',
				EMPTY: 'Nenhuma atividade ainda',
			},
			DISCUSSION: {
				N_COMMENTS: 'Comentários ({{count}})',
				EMPTY: 'Nenhum comentário ainda',
				PLACEHOLDER: 'Escreva um comentário...',
				REPLY: 'Responder',
				REPLY_PLACEHOLDER: 'Escreva uma resposta...',
				SEND: 'Enviar',
			},
			TRACE: {
				SEARCH: 'Search the trace (agent, finding, record id…)',
				SEARCH_MATCHES: '{{n}} agent(s) match',
				TMP_NOT_APPLIED: 'Linha do TMP registrada em {{component}}, não aplicada',
				TITLE: 'Rastro do pipeline de agentes',
				EXPAND_ALL: 'Expandir tudo',
				COLLAPSE_ALL: 'Recolher tudo',
				COMPLETED: 'Concluído',
				FAILED: 'Falhou',
				N_AGENTS: '{{count}} agentes',
				NO_RUN: 'Nenhuma execução do pipeline ainda',
				NO_RUN_HINT: 'Execute o agente de triagem para ver o rastro passo a passo dos 14 agentes.',
				STATUS_COMPLETED: 'Concluído',
				STATUS_NO_DATA: 'Sem dados disponíveis',
				STATUS_FAILED: 'Falhou',
				STATUS_SKIPPED: 'Ignorado',
				TOKENS: 'Tokens LLM: {{input}} entrada / {{output}} saída',
			},
			ERRORS: {
				LOAD: 'Não foi possível carregar os dados de triagem',
				ACTION: 'Não foi possível concluir a ação',
				RUN_FAILED: 'A execução do agente de triagem falhou',
			},
			TIMELINE: {
				TITLE: 'Linha do tempo de eventos',
				N_EVENTS: '{{n}} eventos',
				RELATED_ALERTS: 'Alertas recentes e relacionados',
				RANGE_ALL: 'Tudo',
				RANGE_90D: '90 d',
				RANGE_30D: '30 d',
				RANGE_7D: '7 d',
				RANGE_1D: '24 h',
				RESET_ZOOM: 'Redefinir zoom',
				ZOOM_IN: 'Ampliar',
				N_MORE: '+{{n}} mais',
				EMPTY: 'Nenhuma ordem de serviço, nota, relatório ou diferimento registrado para este alerta.',
				CLICK_TO_OPEN: 'Clique para abrir abaixo',
				MINUTES: '{{n}} min',
				HOURS: '{{n}} h',
				DAYS: '{{n}} dias',
				N_ALERTS_IN: '{{n}} alertas em {{span}}',
				N_EVENTS_IN: '{{n}} eventos em {{span}}',
				KIND_SELF: 'Este alerta',
				KIND_ALERT: 'Alerta',
				KIND_WORK_ORDER: 'Ordem de serviço',
				KIND_NOTIFICATION: 'Nota',
				KIND_SUPERVISOR: 'Relatório de supervisor',
				KIND_PRODUCTION: 'Relatório de produção',
				KIND_DEFERMENT: 'Diferimento',
			},
			CANCEL: 'Cancel',
			SAVE: 'Save',
			PATH: {
				CITE_HINT: 'Open this record on the right',
				LAST_RECORDED: 'Detector: last recorded',
				LAST_RECORDED_TIP: 'The time the detector states in its text ("last recorded on …"); its meaning depends on the detector.',
				PLAIN_PENDING: 'A plain-language explanation is being written; reopen in a moment.',
				WHY: 'Why',
				STEP: 'Decided at',
				SHOW_DATA: 'Show data',
				HIDE_DATA: 'Hide data',
				DATA: 'Data',
				DETECTOR_CROSSED: 'crossed: why the alert fired',
				DETECTOR_OWN: 'the detector\'s rule',
				DETECTOR_OWN_TIP: 'The detector\'s own threshold. Crossing it is what raised the alert, so it is not evidence for a service; only an independent engineering limit is.',
				AGENT_DECIDED: 'agent decided',
				AGENT_DECISION: 'Agent decision',
				BASELINE: 'Baseline',
				CHECK: {
					FROZEN: 'Frozen',
					IMPOSSIBLE_ROC: 'Spikes',
					DOMAIN_RANGE: 'Out of range / codes',
					JITTER: 'Jitter',
					NODE_SUBSTITUTION: 'Feed substitution',
					TRIGGER_READINGS: 'Trigger readings',
				},
				CLEAR: 'clear',
				CONF_HIGH: 'High',
				CONF_LOW: 'Low',
				CONF_MEDIUM: 'Medium',
				DECIDED_AT: 'Decided at step {{n}} · {{title}}',
				DELAY: 'Delay',
				DISAGREE: 'The first check that matched (step {{n}}) points to {{outcome}}; the agent chose {{agent}}.',
				DISAGREE_SHORT: 'differs from path',
				DISAGREE_SHORT_TIP: 'The first matching check (step {{n}}) gives another class than the agent chose',
				DQ_ROUTE_FEED: 'Route: data-feed issue for the PI / historian owner (no work order)',
				DQ_ROUTE_INSTRUMENT: 'Route: instrument work order (I&E)',
				EXPORT_PDF: 'Export as PDF',
				FIRST_MATCH_AT: 'First match at step {{n}} · {{title}}',
				HELD_AT: 'Held at step {{n}} · {{title}}',
				JUSTIFICATION_STEP: 'Agent justification · step {{n}}',
				LIMIT: 'Limit',
				LINK_CLOSE: 'Valid – No Action (link)',
				MACHINE_SENSORS: 'Sensors on the machine',
				MATCHED: 'matched',
				NEAR: 'near',
				NONE: 'none',
				NOT_RUNNING: 'Not running steadily:',
				NO_FINDING: 'No finding recorded for this check',
				NO_LIMITS: 'No engineering limit is known for this tag',
				PEAK_24H: '24 h peak',
				PILL_ABNORMAL: 'Abnormal → continue',
				PILL_DECIDED: 'Decided',
				PILL_HELD: 'Held: not enough evidence',
				PILL_MATCHED: 'Matched',
				PILL_NOT_REACHED: 'Not reached',
				PILL_NO_MATCH: 'No match → continue',
				PROCESS_TOPOLOGY: 'Process topology',
				REACHED: 'reached',
				RECOMMENDATIONS: 'Recommendations ({{n}})',
				REPLAY_NO: 'Rule did not reproduce on raw data',
				REPLAY_YES: 'Rule reproduced on raw data',
				RULE: 'Rule',
				RUN_AT: 'Run {{at}}',
				RUN_INDICATOR: 'Run indicator',
				SELECT_SENSOR: 'select a sensor to chart it',
				SME_INTERNAL: 'SME / HIL label (internal, validation only; never an agent input)',
				STEP_AGREE: 'This check is right',
				STEP_DISAGREE: 'This check is wrong',
				STEP_EVIDENCE: '{{tags}} tags, {{records}} records, {{docs}} docs',
				SUBTITLE: '{{n}} checks · select a step',
				TITLE: 'Triage path',
				TRUST: 'Status',
				UNTRUSTED: 'not trusted',
				VALUE: 'Value',
				DECISION_TITLE: 'Decision',
				RCA_TITLE: 'Decision & Triage Path',
				RCA_PANE_TITLE: 'Decision & Triage Path',
				PROPOSED_EVIDENCE_TITLE: 'Proposed Evidence',
				MINI_TITLE: '8-Step Triage Path',
				JUSTIFICATION: 'Justification',
				ORDERED_TITLE: 'Ordered 8-Step Triage Path',
				ORDERED_SUBTITLE: '7 checks in order — the first check that matches decides the outcome',
				STEP_PASSED: 'Passed',
				STEP_NOT_REACHED: 'Not Reached',
				RULE_FLAGGED: 'Rule Flagged for Tuning',
				RULE_FLAGGED_NOTICE: 'Alert approved & detector rule flagged for tuning',
				FLAG_RULE_CTA: 'Close & Flag Rule for Tuning',
				CREATE_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_TITLE: 'Create Instrument Work Order (Data Quality Policy)',
				INSTRUMENT_WO_POLICY: 'Routed to I&E Discipline',
				INSTRUMENT_TAG: 'Instrument Tag',
				DEFECT_DESCRIPTION: 'Defect Description',
				SUBMIT_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_CREATED: 'Instrument Work Order {{id}} raised — Status moved to Pending – Defect Raised',
				ROOTY: 'Rooty',
				ROOTY_HINT: 'Ask Rooty or open discussion on this alert',
				ASK_ROOTY_STEP: 'Ask Rooty about this step',
				STEP_COMMENT: 'Comment on this step',
				STEP_COMMENT_PLACEHOLDER: 'Add a note on this triage step…',
				PLOT_TAG_HINT: 'Plot this tag in Proposed Evidence',
				PLOT_ALL_STEP_TAGS: 'Plot all {{count}} step tags',
				OPEN_WO_HINT: 'Open this Work Order in the Work Orders tab',
				OPEN_ALERT_EVIDENCE_HINT: 'Open this alert in the Alerts tab',
				STEP3_VISUAL_TITLE: 'Machine Diagram & Operating State',
				STEP3_VISUAL_HINT: 'Click any sensor to plot it on the right',
				STEP4_VISUAL_TITLE: 'P&ID Process Flow & Event Timeline',
				STEP4_VISUAL_HINT: 'Driver and response tags are plotted on the right',
				STEP5_VISUAL_TITLE: 'Event Timeline — Cited Work Orders & Open Alerts',
				STEP5_VISUAL_HINT: 'Click a marker or chip to inspect the Work Order or Alert on the right',
				DEEP_DETAILS: 'Deep RCA Details (Verified Facts, Hypotheses & FMEA)',
			},
		},
	}
};
